/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';
export const HOST = "https://server1.depoto.cz/graphql"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export const Thunder =
  <SCLR extends ScalarDefinition>(fn: FetchFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    return fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (options?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: options.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, UnionOverrideKeys<SCLR, OVERRIDESCLR>>>;
  };

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: ExtractVariables<Z> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z,
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

type BaseSymbol = number | string | undefined | boolean | null;

type ScalarsSelector<T, V> = {
  [X in Required<{
    [P in keyof T]: P extends keyof V
      ? V[P] extends Array<any> | undefined
        ? never
        : T[P] extends BaseSymbol | Array<BaseSymbol>
        ? P
        : never
      : never;
  }>[keyof T]]: true;
};

export const fields = <T extends keyof ModelTypes>(k: T) => {
  const t = ReturnTypes[k];
  const fnType = k in AllTypesProps ? AllTypesProps[k as keyof typeof AllTypesProps] : undefined;
  const hasFnTypes = typeof fnType === 'object' ? fnType : undefined;
  const o = Object.fromEntries(
    Object.entries(t)
      .filter(([k, value]) => {
        const isFunctionType = hasFnTypes && k in hasFnTypes && !!hasFnTypes[k as keyof typeof hasFnTypes];
        if (isFunctionType) return false;
        const isReturnType = ReturnTypes[value as string];
        if (!isReturnType) return true;
        if (typeof isReturnType !== 'string') return false;
        if (isReturnType.startsWith('scalar.')) {
          return true;
        }
        return false;
      })
      .map(([key]) => [key, true as const]),
  );
  return o as ScalarsSelector<ModelTypes[T], T extends keyof ValueTypes ? ValueTypes[T] : never>;
};

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S;
type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <Z extends V>(
  t: Z & {
    [P in keyof Z]: P extends keyof V ? Z[P] : never;
  },
) => Z;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = never
export type ScalarCoders = {
	DateTime?: ScalarResolver;
	DateTimeAsString?: ScalarResolver;
	StringOrArray?: ScalarResolver;
	ID?: ScalarResolver;
}
type ZEUS_UNIONS = never

export type ValueTypes = {
    ["RootSchemaQuery"]: AliasType<{
user?: [{	id: number | Variable<any, string>},ValueTypes["user"]],
	userMyProfile?:ValueTypes["userMyProfile"],
users?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["userFilters"] | undefined | null | Variable<any, string>},ValueTypes["users"]],
isUserEmailUnique?: [{	email: string | Variable<any, string>},ValueTypes["isUserEmailUnique"]],
userGroup?: [{	id: number | Variable<any, string>},ValueTypes["userGroup"]],
userGroups?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["userGroupFilters"] | undefined | null | Variable<any, string>},ValueTypes["userGroups"]],
	roles?:ValueTypes["Role"],
product?: [{	id: number | Variable<any, string>},ValueTypes["product"]],
products?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["productFilters"] | undefined | null | Variable<any, string>,	currency?: string | undefined | null | Variable<any, string>,	currencyDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>},ValueTypes["products"]],
productPurchasePrice?: [{	id: number | Variable<any, string>,	depot: number | Variable<any, string>,	quantity: number | Variable<any, string>},ValueTypes["productPurchasePrice"]],
productSellItems?: [{	product: number | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>},ValueTypes["productSellItems"]],
productMovePacks?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["productMovePackFilters"] | undefined | null | Variable<any, string>},ValueTypes["productMovePacks"]],
productMoves?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["productMoveFilters"] | undefined | null | Variable<any, string>},ValueTypes["productMoves"]],
productMovePack?: [{	id: number | Variable<any, string>},ValueTypes["productMovePack"]],
institution?: [{	id: number | Variable<any, string>},ValueTypes["institution"]],
institutions?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["institutionFilters"] | undefined | null | Variable<any, string>},ValueTypes["institutions"]],
order?: [{	id: number | Variable<any, string>},ValueTypes["order"]],
orders?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["orderFilters"] | undefined | null | Variable<any, string>},ValueTypes["orders"]],
soldItems?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["soldItemFilters"] | undefined | null | Variable<any, string>},ValueTypes["soldItems"]],
orderItems?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["orderItemFilters"] | undefined | null | Variable<any, string>},ValueTypes["orderItems"]],
orderItem?: [{	id: number | Variable<any, string>},ValueTypes["orderItem"]],
customer?: [{	id: string | Variable<any, string>},ValueTypes["customer"]],
customers?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["customerFilters"] | undefined | null | Variable<any, string>},ValueTypes["customers"]],
address?: [{	id: number | Variable<any, string>},ValueTypes["address"]],
addresses?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["addressesFilters"] | undefined | null | Variable<any, string>},ValueTypes["addresses"]],
checkout?: [{	id: number | Variable<any, string>},ValueTypes["checkout"]],
checkouts?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["checkoutFilters"] | undefined | null | Variable<any, string>},ValueTypes["checkouts"]],
	eventTypes?:ValueTypes["eventTypes"],
consent?: [{	id: number | Variable<any, string>},ValueTypes["consent"]],
consents?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["consentsFilters"] | undefined | null | Variable<any, string>},ValueTypes["consents"]],
checkoutExtraOperation?: [{	id: number | Variable<any, string>},ValueTypes["checkoutExtraOperation"]],
checkoutExtraOperations?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["checkoutExtraOperationFilters"] | undefined | null | Variable<any, string>},ValueTypes["checkoutExtraOperations"]],
checkoutClosing?: [{	id: number | Variable<any, string>},ValueTypes["checkoutClosing"]],
checkoutClosings?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["checkoutClosingFilters"] | undefined | null | Variable<any, string>},ValueTypes["checkoutClosings"]],
vat?: [{	id: number | Variable<any, string>},ValueTypes["vat"]],
vats?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["vatFilters"] | undefined | null | Variable<any, string>},ValueTypes["vats"]],
depot?: [{	id: number | Variable<any, string>},ValueTypes["depot"]],
depots?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["depotFilters"] | undefined | null | Variable<any, string>},ValueTypes["depots"]],
supplier?: [{	id: number | Variable<any, string>},ValueTypes["supplier"]],
suppliers?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["supplierFilters"] | undefined | null | Variable<any, string>},ValueTypes["suppliers"]],
producer?: [{	id: number | Variable<any, string>},ValueTypes["producer"]],
producers?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["producerFilters"] | undefined | null | Variable<any, string>},ValueTypes["producers"]],
exportStocks?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["exportStockFilters"] | undefined | null | Variable<any, string>},ValueTypes["exportStocks"]],
exportSales?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["exportSaleFilters"] | undefined | null | Variable<any, string>},ValueTypes["exportSales"]],
exportPurchases?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["exportPurchaseFilters"] | undefined | null | Variable<any, string>},ValueTypes["exportPurchases"]],
exportOrders?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["exportOrderFilters"] | undefined | null | Variable<any, string>},ValueTypes["exportOrders"]],
exportInventory?: [{	id: number | Variable<any, string>},ValueTypes["exportInventory"]],
exportInventories?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["exportInventoryFilters"] | undefined | null | Variable<any, string>},ValueTypes["exportInventories"]],
export?: [{	id: number | Variable<any, string>},ValueTypes["export"]],
exports?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["exportFilters"] | undefined | null | Variable<any, string>},ValueTypes["exports"]],
exportTypes?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["exportTypeFilters"] | undefined | null | Variable<any, string>},ValueTypes["exportTypes"]],
shop?: [{	id: number | Variable<any, string>},ValueTypes["shop"]],
shops?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["shopFilters"] | undefined | null | Variable<any, string>},ValueTypes["shops"]],
cert?: [{	id: number | Variable<any, string>},ValueTypes["cert"]],
certs?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["filters"] | undefined | null | Variable<any, string>},ValueTypes["certs"]],
eetReceipts?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["eetReceiptFilters"] | undefined | null | Variable<any, string>},ValueTypes["eetReceipts"]],
payment?: [{	id: number | Variable<any, string>},ValueTypes["payment"]],
payments?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["paymentFilters"] | undefined | null | Variable<any, string>},ValueTypes["payments"]],
paymentItem?: [{	id: number | Variable<any, string>},ValueTypes["paymentItem"]],
paymentItems?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["paymentItemsFilters"] | undefined | null | Variable<any, string>},ValueTypes["paymentItems"]],
paymentTypes?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["paymentTypeFilters"] | undefined | null | Variable<any, string>},ValueTypes["paymentTypes"]],
processStatuses?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["processStatusesFilters"] | undefined | null | Variable<any, string>},ValueTypes["processStatuses"]],
carriers?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["carriersFilters"] | undefined | null | Variable<any, string>},ValueTypes["carriers"]],
currencies?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["currenciesFilters"] | undefined | null | Variable<any, string>},ValueTypes["currencies"]],
package?: [{	id: string | Variable<any, string>},ValueTypes["package"]],
packages?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["packageFilters"] | undefined | null | Variable<any, string>},ValueTypes["packages"]],
stats?: [{	filters?: ValueTypes["packageStatsFilters"] | undefined | null | Variable<any, string>},ValueTypes["packageStats"]],
disposal?: [{	id: string | Variable<any, string>},ValueTypes["disposal"]],
disposals?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["disposalFilters"] | undefined | null | Variable<any, string>},ValueTypes["disposals"]],
productDepotMetric?: [{	id: number | Variable<any, string>},ValueTypes["productDepotMetric"]],
productDepotMetrics?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["productDepotMetricFilters"] | undefined | null | Variable<any, string>},ValueTypes["productDepotMetrics"]],
file?: [{	id: number | Variable<any, string>},ValueTypes["file"]],
files?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["fileFilters"] | undefined | null | Variable<any, string>},ValueTypes["files"]],
	nextEan?:ValueTypes["nextEan"],
statsCarrierUsage?: [{	from: ValueTypes["DateTimeAsString"] | Variable<any, string>,	to: ValueTypes["DateTimeAsString"] | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	status?: string | undefined | null | Variable<any, string>},ValueTypes["statsCarrierUsage"]],
statsPaymentSales?: [{	from: ValueTypes["DateTimeAsString"] | Variable<any, string>,	to: ValueTypes["DateTimeAsString"] | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	status?: string | undefined | null | Variable<any, string>},ValueTypes["statsPaymentSales"]],
statsBestsellers?: [{	from: ValueTypes["DateTimeAsString"] | Variable<any, string>,	to: ValueTypes["DateTimeAsString"] | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	status?: string | undefined | null | Variable<any, string>,	results?: number | undefined | null | Variable<any, string>,	sort?: ValueTypes["statsBestsellersSort"] | undefined | null | Variable<any, string>},ValueTypes["statsBestsellers"]],
companyCarrier?: [{	id: string | Variable<any, string>},ValueTypes["companyCarrier"]],
companyCarriers?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["companyCarrierFilters"] | undefined | null | Variable<any, string>},ValueTypes["companyCarriers"]],
category?: [{	id: number | Variable<any, string>},ValueTypes["category"]],
categories?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["categoryFilters"] | undefined | null | Variable<any, string>},ValueTypes["categories"]],
parameter?: [{	id: number | Variable<any, string>},ValueTypes["parameter"]],
parameters?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["parametersFilters"] | undefined | null | Variable<any, string>},ValueTypes["parameters"]],
orderGroup?: [{	id: number | Variable<any, string>},ValueTypes["orderGroup"]],
orderGroups?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["orderGroupFilters"] | undefined | null | Variable<any, string>},ValueTypes["orderGroups"]],
voucher?: [{	id: number | Variable<any, string>},ValueTypes["voucher"]],
vouchers?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["voucherFilters"] | undefined | null | Variable<any, string>},ValueTypes["vouchers"]],
productPrices?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["productPriceFilters"] | undefined | null | Variable<any, string>},ValueTypes["productPrices"]],
priceLevel?: [{	id: number | Variable<any, string>},ValueTypes["priceLevel"]],
priceLevels?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["priceLevelFilters"] | undefined | null | Variable<any, string>},ValueTypes["priceLevels"]],
productParameter?: [{	id: number | Variable<any, string>},ValueTypes["productParameter"]],
productParameters?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["productParameterFilters"] | undefined | null | Variable<any, string>},ValueTypes["productParameters"]],
productPriceLevel?: [{	id: number | Variable<any, string>},ValueTypes["productPriceLevel"]],
productPriceLevels?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["productPriceLevelFilters"] | undefined | null | Variable<any, string>},ValueTypes["productPriceLevels"]],
tag?: [{	id: number | Variable<any, string>},ValueTypes["tag"]],
tags?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["tagFilters"] | undefined | null | Variable<any, string>},ValueTypes["tags"]],
tagTypes?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["tagTypeFilters"] | undefined | null | Variable<any, string>},ValueTypes["tagTypes"]],
productPack?: [{	id: number | Variable<any, string>},ValueTypes["productPack"]],
productPacks?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["productPackFilters"] | undefined | null | Variable<any, string>},ValueTypes["productPacks"]],
purchaseOrder?: [{	id: number | Variable<any, string>},ValueTypes["purchaseOrder"]],
purchaseOrders?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["purchaseOrderFilters"] | undefined | null | Variable<any, string>},ValueTypes["purchaseOrders"]],
purchaseOrderItem?: [{	id: number | Variable<any, string>},ValueTypes["purchaseOrderItem"]],
purchaseOrderItems?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["purchaseOrderItemFilters"] | undefined | null | Variable<any, string>},ValueTypes["purchaseOrderItems"]],
purchaseOrderStatuses?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["purchaseOrderStatusesFilters"] | undefined | null | Variable<any, string>},ValueTypes["purchaseOrderStatuses"]],
modules?: [{	page?: number | undefined | null | Variable<any, string>,	sort?: string | undefined | null | Variable<any, string>,	direction?: string | undefined | null | Variable<any, string>,	filters?: ValueTypes["modulesFilters"] | undefined | null | Variable<any, string>},ValueTypes["modules"]],
		__typename?: boolean | `@${string}`
}>;
	["user"]: AliasType<{
	data?:ValueTypes["User"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["User"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	groups?:ValueTypes["UserGroup"],
	roles?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	pin?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	customers?:ValueTypes["Customer"],
	checkouts?:ValueTypes["Checkout"],
	depots?:ValueTypes["Depot"],
	locale?:boolean | `@${string}`,
	deletable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserGroup"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["Company"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	ic?:boolean | `@${string}`,
	dic?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	zip?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	currency?:ValueTypes["Currency"],
	registrationNote?:boolean | `@${string}`,
	nextEan?:boolean | `@${string}`,
	billLogo?:boolean | `@${string}`,
	parent?:ValueTypes["Company"],
	children?:ValueTypes["Company"],
	carrierRelations?:ValueTypes["CompanyCarrier"],
	moduleRelations?:ValueTypes["CompanyModule"],
	payments?:ValueTypes["Payment"],
	defaultVoucherValidity?:boolean | `@${string}`,
	pickingOnlyOneDepot?:boolean | `@${string}`,
	customOptions?:boolean | `@${string}`,
	batchExpirationMode?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	purchasePriceWithVat?:boolean | `@${string}`,
	tariff?:ValueTypes["Tariff"],
	tariffExpirationDate?:boolean | `@${string}`,
	enabledLocking?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Currency"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	ratio?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompanyCarrier"]: AliasType<{
	id?:boolean | `@${string}`,
	enable?:boolean | `@${string}`,
	options?:boolean | `@${string}`,
	carrier?:ValueTypes["Carrier"],
	checkout?:ValueTypes["Checkout"],
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Carrier"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	tariffs?:ValueTypes["CarrierTariff"],
	requiredShippingAddress?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CarrierTariff"]: AliasType<{
	id?:boolean | `@${string}`,
	const?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	cod?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Checkout"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	nextReservationNumber?:boolean | `@${string}`,
	nextBillNumber?:boolean | `@${string}`,
	billFooter?:boolean | `@${string}`,
	payments?:ValueTypes["Payment"],
	depots?:ValueTypes["Depot"],
	returnsDepot?:ValueTypes["Depot"],
	currentClosing?:ValueTypes["CheckoutClosing"],
	eetId?:boolean | `@${string}`,
	eetEnable?:boolean | `@${string}`,
	eetPlayground?:boolean | `@${string}`,
	eetVerificationMode?:boolean | `@${string}`,
	billWidth?:boolean | `@${string}`,
	billFontSize?:boolean | `@${string}`,
	billFontWeight?:boolean | `@${string}`,
	eventUrl?:boolean | `@${string}`,
	eventTypes?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	negativeReservation?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	users?:ValueTypes["User"],
	autoPicking?:boolean | `@${string}`,
	autoPacking?:boolean | `@${string}`,
	autoDispatched?:boolean | `@${string}`,
	institution?:ValueTypes["Institution"],
	position?:boolean | `@${string}`,
	deletable?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Payment"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	eetEnable?:boolean | `@${string}`,
	/** Expedovat i nezaplacené objednávky */
	dispatchUnpaid?:boolean | `@${string}`,
	type?:ValueTypes["PaymentType"],
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["PaymentType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Depot"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	emailIn?:boolean | `@${string}`,
	unavailablesUrl?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	companyCarriers?:ValueTypes["CompanyCarrier"],
	checkouts?:ValueTypes["Checkout"],
	institution?:ValueTypes["Institution"],
	users?:ValueTypes["User"],
	position?:boolean | `@${string}`,
	deletable?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Institution"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	checkouts?:ValueTypes["Checkout"],
	depots?:ValueTypes["Depot"],
		__typename?: boolean | `@${string}`
}>;
	/** Representation of date and time in "Y-m-d H:i:s" format */
["DateTime"]:unknown;
	["CheckoutClosing"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	checkout?:ValueTypes["Checkout"],
	dateOpen?:boolean | `@${string}`,
	amountOpen?:boolean | `@${string}`,
	amountRealOpen?:boolean | `@${string}`,
	userOpen?:ValueTypes["User"],
	noteOpen?:boolean | `@${string}`,
	dateClosed?:boolean | `@${string}`,
	amountClosed?:boolean | `@${string}`,
	amountRealClosed?:boolean | `@${string}`,
	userClosed?:ValueTypes["User"],
	noteClosed?:boolean | `@${string}`,
	orders?:ValueTypes["Order"],
	profit?:boolean | `@${string}`,
	vatAllocations?:ValueTypes["VatAllocation"],
	extraOperations?:ValueTypes["CheckoutExtraOperation"],
	billUrl?:boolean | `@${string}`,
	enumeration?:boolean | `@${string}`,
	paymentSum?:ValueTypes["paymentSum"],
		__typename?: boolean | `@${string}`
}>;
	["Order"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	status?:ValueTypes["OrderStatus"],
	reservationNumber?:boolean | `@${string}`,
	billNumber?:boolean | `@${string}`,
	vs?:boolean | `@${string}`,
	dateCreated?:boolean | `@${string}`,
	dateBill?:boolean | `@${string}`,
	dateExpedition?:boolean | `@${string}`,
	dateDue?:boolean | `@${string}`,
	dateTax?:boolean | `@${string}`,
	items?:ValueTypes["OrderItem"],
	paymentItems?:ValueTypes["PaymentItem"],
	checkout?:ValueTypes["Checkout"],
	checkoutClosing?:ValueTypes["CheckoutClosing"],
	customer?:ValueTypes["Customer"],
	note?:boolean | `@${string}`,
	privateNote?:boolean | `@${string}`,
	invoiceAddress?:ValueTypes["Address"],
	shippingAddress?:ValueTypes["Address"],
	relatedParent?:ValueTypes["Order"],
	rounding?:boolean | `@${string}`,
	eetReceipt?:ValueTypes["Receipt"],
	deleted?:boolean | `@${string}`,
	priceAll?:boolean | `@${string}`,
	priceAllWithoutVat?:boolean | `@${string}`,
	profit?:boolean | `@${string}`,
	vatAllocations?:ValueTypes["VatAllocation"],
	/** DEPRECATED - Url PDF účtenky */
	billUrl?:boolean | `@${string}`,
	/** Url PDF faktury */
	invoiceUrl?:boolean | `@${string}`,
	/** Url PDF objednávky */
	reservationUrl?:boolean | `@${string}`,
	/** Url PDF účtenky */
	invoiceReceiptUrl?:boolean | `@${string}`,
	/** Url PDF účtenky-rezervace */
	reservationReceiptUrl?:boolean | `@${string}`,
	processStatus?:ValueTypes["ProcessStatus"],
	processStatusUpdated?:boolean | `@${string}`,
	processStatusRelation?:ValueTypes["OrderProcessStatus"],
	processStatusRelations?:ValueTypes["OrderProcessStatus"],
	carrier?:ValueTypes["Carrier"],
	packages?:ValueTypes["Package"],
	boxes?:boolean | `@${string}`,
	isPaid?:boolean | `@${string}`,
	currency?:ValueTypes["Currency"],
	files?:ValueTypes["File"],
	quantityUnavailable?:boolean | `@${string}`,
	createdBy?:ValueTypes["User"],
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
	movePacks?:ValueTypes["ProductMovePack"],
	depots?:ValueTypes["Depot"],
	isEditable?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Externí číslo */
	externalReference?:boolean | `@${string}`,
	group?:ValueTypes["OrderGroup"],
	groupPosition?:boolean | `@${string}`,
	clearanceItems?:ValueTypes["ClearanceItem"],
	/** Tagy */
	tags?:ValueTypes["Tag"],
	/** Priorita */
	priority?:boolean | `@${string}`,
	/** Uzamčena */
	locked?:boolean | `@${string}`,
	/** Od kdy uzamčena */
	dateLocked?:boolean | `@${string}`,
	/** Kým uzamčena */
	lockedBy?:ValueTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["OrderStatus"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OrderItem"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	ean?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
	sale?:boolean | `@${string}`,
	price?:boolean | `@${string}`,
	priceWithoutVat?:boolean | `@${string}`,
	priceAll?:boolean | `@${string}`,
	priceAllWithoutVat?:boolean | `@${string}`,
	vat?:ValueTypes["Vat"],
	product?:ValueTypes["Product"],
	serial?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	batch?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	profit?:boolean | `@${string}`,
	isForSubsequentSettlement?:boolean | `@${string}`,
	picked?:boolean | `@${string}`,
	packed?:boolean | `@${string}`,
	quantityUnavailable?:boolean | `@${string}`,
	moves?:ValueTypes["ProductMove"],
	clearanceItems?:ValueTypes["ClearanceItem"],
	voucher?:ValueTypes["Voucher"],
	order?:ValueTypes["Order"],
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Vat"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	percent?:boolean | `@${string}`,
	default?:boolean | `@${string}`,
	coefficient?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Representation of date and time in same string format as PHP DateTime class. */
["DateTimeAsString"]:unknown;
	["Product"]: AliasType<{
	id?:boolean | `@${string}`,
	/** Název */
	name?:boolean | `@${string}`,
	/** Název včetně názvu rodičovského produktu */
	fullName?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean2?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean3?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean4?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean5?:boolean | `@${string}`,
	/** Kód */
	code?:boolean | `@${string}`,
	/** Kód2 */
	code2?:boolean | `@${string}`,
	/** Kód3 */
	code3?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Prodejní cena */
	sellPrice?:boolean | `@${string}`,
	/** Prodejní cena bez DPH */
	sellPriceWithoutVat?:boolean | `@${string}`,
	/** Cena před slevou */
	beforeSellPrice?:boolean | `@${string}`,
	/** Aktuální prodejní cena - včetně započtených akčních cen */
	actualSellPrice?:boolean | `@${string}`,
	/** Aktuální prodejní cena bez DPH */
	actualSellPriceWithoutVat?:boolean | `@${string}`,
	/** Aktuální cena před slevou - včetně započtených akčních cen */
	actualBeforeSellPrice?:boolean | `@${string}`,
	/** Výchozí nákupní cena */
	purchasePrice?:boolean | `@${string}`,
	/** Výchozí nákupní měna */
	purchaseCurrency?:ValueTypes["Currency"],
	/** Váha */
	weight?:boolean | `@${string}`,
	/** Rozměr X */
	dimensionX?:boolean | `@${string}`,
	/** Rozměr Y */
	dimensionY?:boolean | `@${string}`,
	/** Rozměr Z */
	dimensionZ?:boolean | `@${string}`,
	/** Země výroby */
	originCountry?:boolean | `@${string}`,
	/** HS kod */
	hsCode?:boolean | `@${string}`,
	/** Je produkt aktnivní? */
	enabled?:boolean | `@${string}`,
	/** DPH */
	vat?:ValueTypes["Vat"],
	/** Výrobce */
	producer?:ValueTypes["Producer"],
	/** Výchozí dodavatel */
	supplier?:ValueTypes["Supplier"],
	/** Rodičovský produkt */
	parent?:ValueTypes["Product"],
	/** Potomci / varianty produktu */
	children?:ValueTypes["Product"],
	/** Deprecated: používejte productDepots */
	depots?:ValueTypes["ProductDepot"],
	/** Skladové zásoby */
	productDepots?:ValueTypes["ProductDepot"],
	/** Produkt je položka pro následné uplatnění (např. kupón) - pro EET */
	isForSubsequentSettlement?:boolean | `@${string}`,
	/** Hlavní obrázek */
	mainImage?:ValueTypes["File"],
	/** Obrázky */
	images?:ValueTypes["File"],
	/** Soubory (mimo obrázků) */
	files?:ValueTypes["File"],
	/** Jedná se o set produktů (virtuální produkt) */
	isBundle?:boolean | `@${string}`,
	/** Křehký */
	isFragile?:boolean | `@${string}`,
	/** Nadrozměrný */
	isOversize?:boolean | `@${string}`,
	bundleParents?:ValueTypes["ProductBundle"],
	bundleChildren?:ValueTypes["ProductBundle"],
	/** Poznámka */
	note?:boolean | `@${string}`,
	/** Popis */
	description?:boolean | `@${string}`,
	/** Krátký popis */
	perex?:boolean | `@${string}`,
	/** Cokoli... */
	customData?:boolean | `@${string}`,
	/** Akční ceny */
	advancedPrices?:ValueTypes["ProductPrice"],
	/** Počet nedostupných kusů v rezervaci */
	quantityUnavailable?:boolean | `@${string}`,
	/** Počet kusů skladem a všech skladech */
	quantityStock?:boolean | `@${string}`,
	/** Počet dostupných kusů a všech skladech */
	quantityAvailable?:boolean | `@${string}`,
	/** Počet kusů v rezervaci na všech skladech */
	quantityReservation?:boolean | `@${string}`,
	/** Počet kusů objednaný od dodavatele */
	quantityPurchase?:boolean | `@${string}`,
	/** Kategorie */
	categories?:ValueTypes["Category"],
	/** Hlavní kategorie */
	mainCategory?:ValueTypes["Category"],
	company?:ValueTypes["Company"],
	/** Počty */
	quantities?:ValueTypes["Quantity"],
	/** Metriky */
	metrics?:ValueTypes["ProductDepotMetric"],
	/** Balení/Kartony */
	packs?:ValueTypes["ProductPack"],
	/** Relace ProductParameter */
	productParameters?:ValueTypes["ProductParameter"],
	/** Relace ProductPriceLevel */
	productPriceLevels?:ValueTypes["ProductPriceLevel"],
	/** Tagy */
	tags?:ValueTypes["Tag"],
	/** Položky k prodeji: jednotlivé expirace a šarže */
	sellItems?:ValueTypes["SellItem"],
	/** Deprectable - use deletable. */
	isDeletable?:boolean | `@${string}`,
	/** Lze smazat */
	deletable?:boolean | `@${string}`,
	/** Eviduje expirace a šarže */
	enabledBatchExpiration?:boolean | `@${string}`,
	/** Eviduje sériová čísla */
	requiredSerialNumbers?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Producer"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["Supplier"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	deletable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductDepot"]: AliasType<{
	id?:boolean | `@${string}`,
	depot?:ValueTypes["Depot"],
	product?:ValueTypes["Product"],
	supplier?:ValueTypes["Supplier"],
	purchasePrice?:boolean | `@${string}`,
	quantityStock?:boolean | `@${string}`,
	quantityReservation?:boolean | `@${string}`,
	quantityAvailable?:boolean | `@${string}`,
	quantityUnavailable?:boolean | `@${string}`,
	inventoryQuantityStock?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	batch?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	position1?:boolean | `@${string}`,
	position2?:boolean | `@${string}`,
	position3?:boolean | `@${string}`,
	clearanceItemId?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["File"]: AliasType<{
	id?:boolean | `@${string}`,
	originalFilename?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	main?:boolean | `@${string}`,
	mimeType?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	product?:ValueTypes["Product"],
	order?:ValueTypes["Order"],
	thumbnails?:ValueTypes["FileThumbnail"],
		__typename?: boolean | `@${string}`
}>;
	["FileThumbnail"]: AliasType<{
	format?:boolean | `@${string}`,
	mimeType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductBundle"]: AliasType<{
	id?:boolean | `@${string}`,
	parent?:ValueTypes["Product"],
	child?:ValueTypes["Product"],
	/** Množství */
	quantity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductPrice"]: AliasType<{
	id?:boolean | `@${string}`,
	product?:ValueTypes["Product"],
	sellPrice?:boolean | `@${string}`,
	available?:boolean | `@${string}`,
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	isActual?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Category"]: AliasType<{
	id?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	parent?:ValueTypes["Category"],
	children?:ValueTypes["Category"],
	hasChildren?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	treePath?:boolean | `@${string}`,
	/** Tagy */
	tags?:ValueTypes["Tag"],
		__typename?: boolean | `@${string}`
}>;
	["Tag"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Quantity"]: AliasType<{
	depot?:ValueTypes["Depot"],
	quantityAvailable?:boolean | `@${string}`,
	quantityReservation?:boolean | `@${string}`,
	quantityStock?:boolean | `@${string}`,
	quantityPurchase?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductDepotMetric"]: AliasType<{
	id?:boolean | `@${string}`,
	depot?:ValueTypes["Depot"],
	product?:ValueTypes["Product"],
	quantityMinimum?:boolean | `@${string}`,
	quantityOptimum?:boolean | `@${string}`,
	quantityMaximum?:boolean | `@${string}`,
	quantityStock?:boolean | `@${string}`,
	quantityPurchase?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductPack"]: AliasType<{
	id?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean?:boolean | `@${string}`,
	/** Kód */
	code?:boolean | `@${string}`,
	/** Poznámka */
	note?:boolean | `@${string}`,
	/** Množství */
	quantity?:boolean | `@${string}`,
	/** Produkt.id */
	product?:ValueTypes["Product"],
	/** Externí ID */
	externalId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductParameter"]: AliasType<{
	id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	product?:ValueTypes["Product"],
	parameter?:ValueTypes["Parameter"],
		__typename?: boolean | `@${string}`
}>;
	/** String or Array */
["StringOrArray"]:unknown;
	["Parameter"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	enumValues?:boolean | `@${string}`,
	unit?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPriceLevel"]: AliasType<{
	id?:boolean | `@${string}`,
	sellPrice?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	product?:ValueTypes["Product"],
	priceLevel?:ValueTypes["PriceLevel"],
		__typename?: boolean | `@${string}`
}>;
	["PriceLevel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	isPercentage?:boolean | `@${string}`,
	percent?:boolean | `@${string}`,
	withVat?:boolean | `@${string}`,
	currency?:ValueTypes["Currency"],
	externalId?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["SellItem"]: AliasType<{
	id?:boolean | `@${string}`,
	product?:ValueTypes["Product"],
	quantityStock?:boolean | `@${string}`,
	quantityReservation?:boolean | `@${string}`,
	quantityAvailable?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	batch?:boolean | `@${string}`,
	productDepots?:ValueTypes["ProductDepot"],
		__typename?: boolean | `@${string}`
}>;
	["ProductMove"]: AliasType<{
	id?:boolean | `@${string}`,
	pack?:ValueTypes["ProductMovePack"],
	productDepotFrom?:ValueTypes["ProductDepot"],
	productDepotFromQuantityStock?:boolean | `@${string}`,
	productDepotTo?:ValueTypes["ProductDepot"],
	productDepotToQuantityStock?:boolean | `@${string}`,
	product?:ValueTypes["Product"],
	amount?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
	deleted?:boolean | `@${string}`,
	quantityUnavailable?:boolean | `@${string}`,
	createdBy?:ValueTypes["User"],
	orderItem?:ValueTypes["OrderItem"],
	picked?:boolean | `@${string}`,
	packed?:boolean | `@${string}`,
	locked?:boolean | `@${string}`,
	purchasePrice?:boolean | `@${string}`,
	purchasePriceAll?:boolean | `@${string}`,
	purchasePriceWithVat?:boolean | `@${string}`,
	purchasePriceAllWithVat?:boolean | `@${string}`,
	purchaseOrderItem?:ValueTypes["PurchaseOrderItem"],
	deletable?:boolean | `@${string}`,
	serialNumbers?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductMovePack"]: AliasType<{
	id?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	externalReference?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	type?:ValueTypes["ProductMoveType"],
	purpose?:ValueTypes["ProductMovePurpose"],
	moves?:ValueTypes["ProductMove"],
	note?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	pdfWOPricesUrl?:boolean | `@${string}`,
	dateCreated?:boolean | `@${string}`,
	order?:ValueTypes["Order"],
	checkout?:ValueTypes["Checkout"],
	depotFrom?:ValueTypes["Depot"],
	depotTo?:ValueTypes["Depot"],
	incidentalCosts?:boolean | `@${string}`,
	purchasePrice?:boolean | `@${string}`,
	purchasePriceWithVat?:boolean | `@${string}`,
	purchaseOrder?:ValueTypes["PurchaseOrder"],
	createdBy?:ValueTypes["User"],
	files?:ValueTypes["File"],
	/** Tagy */
	tags?:ValueTypes["Tag"],
	company?:ValueTypes["Company"],
	deletable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductMoveType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductMovePurpose"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PurchaseOrder"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	status?:ValueTypes["PurchaseOrderStatus"],
	supplier?:ValueTypes["Supplier"],
	depot?:ValueTypes["Depot"],
	items?:ValueTypes["PurchaseOrderItem"],
	files?:ValueTypes["File"],
	/** Tagy */
	tags?:ValueTypes["Tag"],
	number?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	privateNote?:boolean | `@${string}`,
	dateEstimatedArrival?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Externí reference */
	externalReference?:boolean | `@${string}`,
	/** Reference dodavatele */
	supplierReference?:boolean | `@${string}`,
	purchasePriceAll?:boolean | `@${string}`,
	purchasePriceAllWithVat?:boolean | `@${string}`,
	productMovePacks?:ValueTypes["ProductMovePack"],
	pdfUrl?:boolean | `@${string}`,
	pdfWOPricesUrl?:boolean | `@${string}`,
	excelUrl?:boolean | `@${string}`,
	excelWOPricesUrl?:boolean | `@${string}`,
	createdBy?:ValueTypes["User"],
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PurchaseOrderStatus"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PurchaseOrderItem"]: AliasType<{
	id?:boolean | `@${string}`,
	purchaseOrder?:ValueTypes["PurchaseOrder"],
	currency?:ValueTypes["Currency"],
	product?:ValueTypes["Product"],
	status?:ValueTypes["PurchaseOrderStatus"],
	quantity?:boolean | `@${string}`,
	purchasePrice?:boolean | `@${string}`,
	purchasePriceAll?:boolean | `@${string}`,
	purchasePriceWithVat?:boolean | `@${string}`,
	purchasePriceAllWithVat?:boolean | `@${string}`,
	productMoves?:ValueTypes["ProductMove"],
	note?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Již naskladněný počet kusů */
	quantityIn?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ClearanceItem"]: AliasType<{
	id?:boolean | `@${string}`,
	product?:ValueTypes["Product"],
	amount?:boolean | `@${string}`,
	quantityStock?:boolean | `@${string}`,
	quantityReservation?:boolean | `@${string}`,
	quantityAvailable?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	batch?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	position1?:boolean | `@${string}`,
	position2?:boolean | `@${string}`,
	position3?:boolean | `@${string}`,
	picked?:boolean | `@${string}`,
	packed?:boolean | `@${string}`,
	productMoves?:ValueTypes["ProductMove"],
	productDepots?:ValueTypes["ProductDepot"],
	orderItems?:ValueTypes["OrderItem"],
	locked?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Voucher"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	product?:ValueTypes["Product"],
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	discountType?:boolean | `@${string}`,
	discountPercent?:boolean | `@${string}`,
	discountValue?:boolean | `@${string}`,
	maxUse?:boolean | `@${string}`,
	validFrom?:boolean | `@${string}`,
	validTo?:boolean | `@${string}`,
	isValid?:boolean | `@${string}`,
	used?:boolean | `@${string}`,
	paymentItems?:ValueTypes["Product"],
	orderItems?:ValueTypes["Product"],
	enabled?:boolean | `@${string}`,
	isPayment?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PaymentItem"]: AliasType<{
	id?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	checkout?:ValueTypes["Checkout"],
	payment?:ValueTypes["Payment"],
	voucher?:ValueTypes["Voucher"],
	dateCreated?:boolean | `@${string}`,
	dateCancelled?:boolean | `@${string}`,
	isPaid?:boolean | `@${string}`,
	datePaid?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Customer"]: AliasType<{
	id?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	companyName?:boolean | `@${string}`,
	addresses?:ValueTypes["Address"],
	wholesale?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	consentRelations?:ValueTypes["CustomerConsent"],
	birthday?:boolean | `@${string}`,
	users?:ValueTypes["User"],
	minExpirationDays?:boolean | `@${string}`,
	priceLevel?:ValueTypes["PriceLevel"],
	/** Tagy */
	tags?:ValueTypes["Tag"],
	/** Cokoli... */
	customData?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Address"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	customer?:ValueTypes["Customer"],
	companyName?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	zip?:boolean | `@${string}`,
	ic?:boolean | `@${string}`,
	dic?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	isStored?:boolean | `@${string}`,
	isBilling?:boolean | `@${string}`,
	zasilkovnaAddressId?:boolean | `@${string}`,
	branchId?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Poznámka */
	note?:boolean | `@${string}`,
	/** Cokoli... */
	customData?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerConsent"]: AliasType<{
	id?:boolean | `@${string}`,
	customer?:ValueTypes["Customer"],
	consent?:ValueTypes["Consent"],
	name?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Consent"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["Receipt"]: AliasType<{
	id?:boolean | `@${string}`,
	dic?:boolean | `@${string}`,
	checkoutEetId?:boolean | `@${string}`,
	shopEetId?:boolean | `@${string}`,
	playground?:boolean | `@${string}`,
	verificationMode?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	dateCreated?:boolean | `@${string}`,
	totalPrice?:boolean | `@${string}`,
	priceZeroVat?:boolean | `@${string}`,
	priceStandardVat?:boolean | `@${string}`,
	vatStandard?:boolean | `@${string}`,
	priceFirstReducedVat?:boolean | `@${string}`,
	vatFirstReduced?:boolean | `@${string}`,
	priceSecondReducedVat?:boolean | `@${string}`,
	vatSecondReduced?:boolean | `@${string}`,
	priceForSubsequentSettlement?:boolean | `@${string}`,
	priceUsedSubsequentSettlement?:boolean | `@${string}`,
	fik?:boolean | `@${string}`,
	bkp?:boolean | `@${string}`,
	pkp?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VatAllocation"]: AliasType<{
	vat?:ValueTypes["Vat"],
	priceWithoutVat?:boolean | `@${string}`,
	vatPrice?:boolean | `@${string}`,
	price?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProcessStatus"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OrderProcessStatus"]: AliasType<{
	status?:ValueTypes["ProcessStatus"],
	note?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	createdBy?:ValueTypes["User"],
	actual?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Package"]: AliasType<{
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	carrier?:ValueTypes["Carrier"],
	tariff?:ValueTypes["CarrierTariff"],
	items?:ValueTypes["OrderItem"],
	statuses?:ValueTypes["PackageStatus"],
	ticketUrl?:boolean | `@${string}`,
	sent?:boolean | `@${string}`,
	order?:ValueTypes["Order"],
	disposal?:ValueTypes["PackageDisposal"],
	weight?:boolean | `@${string}`,
	weightRequired?:boolean | `@${string}`,
	dimensionsRequired?:boolean | `@${string}`,
	dimensionX?:boolean | `@${string}`,
	dimensionY?:boolean | `@${string}`,
	dimensionZ?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	clearanceItems?:ValueTypes["ClearanceItem"],
		__typename?: boolean | `@${string}`
}>;
	["PackageStatus"]: AliasType<{
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	package?:ValueTypes["Package"],
	created?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PackageDisposal"]: AliasType<{
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	carrier?:ValueTypes["Carrier"],
	packages?:ValueTypes["Package"],
	ticketUrl?:boolean | `@${string}`,
	sent?:boolean | `@${string}`,
	files?:ValueTypes["File"],
		__typename?: boolean | `@${string}`
}>;
	["OrderGroup"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
	orders?:ValueTypes["Order"],
	user?:ValueTypes["User"],
	userPosition?:boolean | `@${string}`,
	clearanceItems?:ValueTypes["ClearanceItem"],
	/** Tagy */
	tags?:ValueTypes["Tag"],
		__typename?: boolean | `@${string}`
}>;
	["CheckoutExtraOperation"]: AliasType<{
	id?:boolean | `@${string}`,
	dateCreated?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	user?:ValueTypes["User"],
	checkout?:ValueTypes["Checkout"],
	checkoutClosing?:ValueTypes["CheckoutClosing"],
		__typename?: boolean | `@${string}`
}>;
	["paymentSum"]: AliasType<{
	payment?:ValueTypes["Payment"],
	count?:boolean | `@${string}`,
	sum?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompanyModule"]: AliasType<{
	id?:boolean | `@${string}`,
	module?:ValueTypes["Module"],
		__typename?: boolean | `@${string}`
}>;
	["Module"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Tariff"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["userMyProfile"]: AliasType<{
	data?:ValueTypes["User"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["userFilters"]: {
	pin?: string | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	fulltext?: string | undefined | null | Variable<any, string>,
	groups?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	roles?: Array<string | undefined | null> | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	enabled?: boolean | undefined | null | Variable<any, string>
};
	["users"]: AliasType<{
	items?:ValueTypes["User"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Paginator"]: AliasType<{
	current?:boolean | `@${string}`,
	currentItemCount?:boolean | `@${string}`,
	endPage?:boolean | `@${string}`,
	first?:boolean | `@${string}`,
	firstItemNumber?:boolean | `@${string}`,
	firstPageInRange?:boolean | `@${string}`,
	last?:boolean | `@${string}`,
	lastItemNumber?:boolean | `@${string}`,
	lastPageInRange?:boolean | `@${string}`,
	next?:boolean | `@${string}`,
	numItemsPerPage?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	pageRange?:boolean | `@${string}`,
	startPage?:boolean | `@${string}`,
	totalCount?:boolean | `@${string}`,
	pagesInRange?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["isUserEmailUnique"]: AliasType<{
	data?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["userGroup"]: AliasType<{
	data?:ValueTypes["UserGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["userGroupFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["userGroups"]: AliasType<{
	items?:ValueTypes["UserGroup"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Role"]: AliasType<{
	name?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["product"]: AliasType<{
	data?:ValueTypes["Product"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productFilters"]: {
	id?: number | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	ean?: string | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	codes?: Array<string | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	fulltext?: string | undefined | null | Variable<any, string>,
	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	metricDepots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	defaultSuppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	listType?: string | undefined | null | Variable<any, string>,
	availability?: string | undefined | null | Variable<any, string>,
	enabled?: boolean | undefined | null | Variable<any, string>,
	isBundle?: boolean | undefined | null | Variable<any, string>,
	expirationDateTo?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	position1?: string | undefined | null | Variable<any, string>,
	position2?: string | undefined | null | Variable<any, string>,
	position3?: string | undefined | null | Variable<any, string>,
	hasBeforeSellPrice?: boolean | undefined | null | Variable<any, string>,
	hasHsCode?: boolean | undefined | null | Variable<any, string>,
	createdFrom?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	updatedFrom?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	categories?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	metrics?: string | undefined | null | Variable<any, string>,
	enabledBatchExpiration?: boolean | undefined | null | Variable<any, string>,
	requiredSerialNumbers?: boolean | undefined | null | Variable<any, string>,
	company?: number | undefined | null | Variable<any, string>
};
	["products"]: AliasType<{
	items?:ValueTypes["Product"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productPurchasePrice"]: AliasType<{
	items?:ValueTypes["ProductPurchasePrice"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductPurchasePrice"]: AliasType<{
	productDepot?:ValueTypes["Depot"],
	quantity?:boolean | `@${string}`,
	purchasePrice?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productSellItems"]: AliasType<{
	items?:ValueTypes["SellItem"],
		__typename?: boolean | `@${string}`
}>;
	["productMovePackFilters"]: {
	fulltext?: string | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	depot?: number | undefined | null | Variable<any, string>,
	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	depotFrom?: number | undefined | null | Variable<any, string>,
	depotTo?: number | undefined | null | Variable<any, string>,
	depotsFrom?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	depotsTo?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	number?: number | undefined | null | Variable<any, string>,
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	withoutCheckout?: boolean | undefined | null | Variable<any, string>,
	product?: number | undefined | null | Variable<any, string>,
	productFulltext?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	orderFulltext?: string | undefined | null | Variable<any, string>,
	withOrder?: boolean | undefined | null | Variable<any, string>,
	createdBy?: number | undefined | null | Variable<any, string>,
	created?: ValueTypes["created"] | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	externalReference?: string | undefined | null | Variable<any, string>,
	purchaseOrder?: number | undefined | null | Variable<any, string>,
	incidentalCosts?: number | undefined | null | Variable<any, string>,
	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["created"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["productMovePacks"]: AliasType<{
	items?:ValueTypes["ProductMovePack"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productMoveFilters"]: {
	product?: number | undefined | null | Variable<any, string>,
	products?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	depotFrom?: number | undefined | null | Variable<any, string>,
	depotTo?: number | undefined | null | Variable<any, string>,
	createdBy?: number | undefined | null | Variable<any, string>,
	created?: ValueTypes["created"] | undefined | null | Variable<any, string>,
	expirationDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	batch?: string | undefined | null | Variable<any, string>,
	withoutCheckout?: boolean | undefined | null | Variable<any, string>
};
	["productMoves"]: AliasType<{
	items?:ValueTypes["ProductMove"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productMovePack"]: AliasType<{
	data?:ValueTypes["ProductMovePack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["institution"]: AliasType<{
	data?:ValueTypes["Institution"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["institutionFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["institutions"]: AliasType<{
	items?:ValueTypes["Institution"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["order"]: AliasType<{
	data?:ValueTypes["Order"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["orderFilters"]: {
	fulltext?: string | undefined | null | Variable<any, string>,
	reservationNumber?: number | undefined | null | Variable<any, string>,
	billNumber?: number | undefined | null | Variable<any, string>,
	notes?: string | undefined | null | Variable<any, string>,
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	onlyDepots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	payments?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	status?: string | undefined | null | Variable<any, string>,
	processStatus?: string | undefined | null | Variable<any, string>,
	processStatusChange?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	processStatusUpdated?: ValueTypes["processStatusUpdated"] | undefined | null | Variable<any, string>,
	isPaid?: boolean | undefined | null | Variable<any, string>,
	carrier?: string | undefined | null | Variable<any, string>,
	carriers?: Array<string | undefined | null> | undefined | null | Variable<any, string>,
	deleted?: boolean | undefined | null | Variable<any, string>,
	dateCreated?: ValueTypes["dateCreated"] | undefined | null | Variable<any, string>,
	dateBill?: ValueTypes["dateBill"] | undefined | null | Variable<any, string>,
	dateExpedition?: ValueTypes["dateExpedition"] | undefined | null | Variable<any, string>,
	dateDue?: ValueTypes["dateDue"] | undefined | null | Variable<any, string>,
	dateTax?: ValueTypes["dateTax"] | undefined | null | Variable<any, string>,
	updated?: ValueTypes["updated"] | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	box?: string | undefined | null | Variable<any, string>,
	item?: string | undefined | null | Variable<any, string>,
	package?: string | undefined | null | Variable<any, string>,
	customer?: number | undefined | null | Variable<any, string>,
	customerFulltext?: string | undefined | null | Variable<any, string>,
	shippingCountries?: Array<string | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	user?: number | undefined | null | Variable<any, string>,
	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	hasAvailableProducts?: boolean | undefined | null | Variable<any, string>,
	hasGroup?: boolean | undefined | null | Variable<any, string>,
	group?: number | undefined | null | Variable<any, string>,
	groups?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	createdBy?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	locked?: boolean | undefined | null | Variable<any, string>,
	dateLocked?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	lockedBy?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	priority?: number | undefined | null | Variable<any, string>
};
	["processStatusUpdated"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["dateCreated"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["dateBill"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["dateExpedition"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["dateDue"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["dateTax"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["updated"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["orders"]: AliasType<{
	items?:ValueTypes["Order"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["soldItemFilters"]: {
	productFulltext?: string | undefined | null | Variable<any, string>,
	customerFulltext?: string | undefined | null | Variable<any, string>,
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	payments?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	status?: string | undefined | null | Variable<any, string>,
	processStatus?: string | undefined | null | Variable<any, string>,
	processStatusUpdated?: ValueTypes["processStatusUpdated"] | undefined | null | Variable<any, string>,
	carriers?: Array<string | undefined | null> | undefined | null | Variable<any, string>,
	dateCreated?: ValueTypes["dateCreated"] | undefined | null | Variable<any, string>,
	dateBill?: ValueTypes["dateBill"] | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	customer?: number | undefined | null | Variable<any, string>,
	product?: number | undefined | null | Variable<any, string>,
	shippingCountries?: Array<string | undefined | null> | undefined | null | Variable<any, string>,
	orderTags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	productTags?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["soldItems"]: AliasType<{
	items?:ValueTypes["SoldItem"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["SoldItem"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	ean?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
	priceAll?:boolean | `@${string}`,
	priceAllWithoutVat?:boolean | `@${string}`,
	product?:ValueTypes["Product"],
	profit?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["orderItemFilters"]: {
	status?: string | undefined | null | Variable<any, string>,
	processStatus?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	productDepot?: number | undefined | null | Variable<any, string>,
	carrier?: string | undefined | null | Variable<any, string>
};
	["orderItems"]: AliasType<{
	items?:ValueTypes["OrderItem"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["orderItem"]: AliasType<{
	data?:ValueTypes["OrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["customer"]: AliasType<{
	data?:ValueTypes["Customer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["customerFilters"]: {
	externalId?: string | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	fulltext?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	user?: number | undefined | null | Variable<any, string>,
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	priceLevel?: number | undefined | null | Variable<any, string>,
	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["customers"]: AliasType<{
	items?:ValueTypes["Customer"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["address"]: AliasType<{
	data?:ValueTypes["Address"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["addressesFilters"]: {
	customer?: number | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	isStored?: boolean | undefined | null | Variable<any, string>,
	isBilling?: boolean | undefined | null | Variable<any, string>,
	ic?: string | undefined | null | Variable<any, string>,
	dic?: string | undefined | null | Variable<any, string>,
	phone?: string | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>
};
	["addresses"]: AliasType<{
	items?:ValueTypes["Address"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["checkout"]: AliasType<{
	data?:ValueTypes["Checkout"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["checkoutFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	user?: number | undefined | null | Variable<any, string>
};
	["checkouts"]: AliasType<{
	items?:ValueTypes["Checkout"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["eventTypes"]: AliasType<{
	items?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["consent"]: AliasType<{
	data?:ValueTypes["Consent"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["consentsFilters"]: {
	name?: string | undefined | null | Variable<any, string>
};
	["consents"]: AliasType<{
	items?:ValueTypes["Consent"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["checkoutExtraOperation"]: AliasType<{
	data?:ValueTypes["CheckoutExtraOperation"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["checkoutExtraOperationFilters"]: {
	checkout?: number | undefined | null | Variable<any, string>,
	checkoutClosing?: number | undefined | null | Variable<any, string>,
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["checkoutExtraOperations"]: AliasType<{
	items?:ValueTypes["CheckoutExtraOperation"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["checkoutClosing"]: AliasType<{
	data?:ValueTypes["CheckoutClosing"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["checkoutClosingFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["checkoutClosings"]: AliasType<{
	items?:ValueTypes["CheckoutClosing"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["vat"]: AliasType<{
	data?:ValueTypes["Vat"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["vatFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	percent?: number | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["vats"]: AliasType<{
	items?:ValueTypes["Vat"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["depot"]: AliasType<{
	data?:ValueTypes["Depot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["depotFilters"]: {
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	user?: number | undefined | null | Variable<any, string>
};
	["depots"]: AliasType<{
	items?:ValueTypes["Depot"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["supplier"]: AliasType<{
	data?:ValueTypes["Supplier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["supplierFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["suppliers"]: AliasType<{
	items?:ValueTypes["Supplier"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["producer"]: AliasType<{
	data?:ValueTypes["Producer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["producerFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["producers"]: AliasType<{
	items?:ValueTypes["Producer"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["exportStockFilters"]: {
	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["exportStocks"]: AliasType<{
	items?:ValueTypes["Stock"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Stock"]: AliasType<{
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	depots?:ValueTypes["Depot"],
	suppliers?:ValueTypes["Supplier"],
	producers?:ValueTypes["Producer"],
	url?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportSaleFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["exportSales"]: AliasType<{
	items?:ValueTypes["Sale"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Sale"]: AliasType<{
	id?:boolean | `@${string}`,
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	checkouts?:ValueTypes["Checkout"],
	suppliers?:ValueTypes["Supplier"],
	producers?:ValueTypes["Producer"],
	url?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportPurchaseFilters"]: {
	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["exportPurchases"]: AliasType<{
	items?:ValueTypes["Purchase"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Purchase"]: AliasType<{
	id?:boolean | `@${string}`,
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	depots?:ValueTypes["Depot"],
	checkouts?:ValueTypes["Checkout"],
	suppliers?:ValueTypes["Supplier"],
	producers?:ValueTypes["Producer"],
	url?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportOrderFilters"]: {
	status?: string | undefined | null | Variable<any, string>,
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["exportOrders"]: AliasType<{
	items?:ValueTypes["exportOrder"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["exportOrder"]: AliasType<{
	id?:boolean | `@${string}`,
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	status?:ValueTypes["OrderStatus"],
	checkouts?:ValueTypes["Checkout"],
	url?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportInventory"]: AliasType<{
	data?:ValueTypes["Inventory"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Inventory"]: AliasType<{
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	depots?:ValueTypes["Depot"],
	suppliers?:ValueTypes["Supplier"],
	producers?:ValueTypes["Producer"],
	url?:boolean | `@${string}`,
	files?:ValueTypes["File"],
	approved?:boolean | `@${string}`,
	rejected?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	pmpIn?:ValueTypes["ProductMovePack"],
	pmpOut?:ValueTypes["ProductMovePack"],
		__typename?: boolean | `@${string}`
}>;
	["exportInventoryFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	approved?: boolean | undefined | null | Variable<any, string>,
	rejected?: boolean | undefined | null | Variable<any, string>,
	finished?: boolean | undefined | null | Variable<any, string>
};
	["exportInventories"]: AliasType<{
	items?:ValueTypes["Inventory"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["export"]: AliasType<{
	data?:ValueTypes["Export"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Export"]: AliasType<{
	id?:boolean | `@${string}`,
	file?:ValueTypes["File"],
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	type?:ValueTypes["ExportType"],
	filter?:boolean | `@${string}`,
	createdBy?:ValueTypes["User"],
	note?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ExportType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
	group?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportFilters"]: {
	types?: Array<string | undefined | null> | undefined | null | Variable<any, string>,
	group?: string | undefined | null | Variable<any, string>
};
	["exports"]: AliasType<{
	items?:ValueTypes["Export"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["exportTypeFilters"]: {
	group?: string | undefined | null | Variable<any, string>
};
	["exportTypes"]: AliasType<{
	items?:ValueTypes["ExportType"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["shop"]: AliasType<{
	data?:ValueTypes["Shop"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Shop"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	zip?:boolean | `@${string}`,
	eetId?:boolean | `@${string}`,
	cert?:ValueTypes["Cert"],
	checkouts?:ValueTypes["Checkout"],
	company?:ValueTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["Cert"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	publicKey?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	company?:ValueTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["shopFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["shops"]: AliasType<{
	items?:ValueTypes["Shop"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["cert"]: AliasType<{
	data?:ValueTypes["Cert"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["filters"]: {
	name?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["certs"]: AliasType<{
	items?:ValueTypes["Cert"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["eetReceiptFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	number?: number | undefined | null | Variable<any, string>,
	hasFik?: boolean | undefined | null | Variable<any, string>,
	playground?: boolean | undefined | null | Variable<any, string>,
	verificationMode?: boolean | undefined | null | Variable<any, string>
};
	["eetReceipts"]: AliasType<{
	items?:ValueTypes["Receipt"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["payment"]: AliasType<{
	data?:ValueTypes["Payment"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["paymentFilters"]: {
	company?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["payments"]: AliasType<{
	items?:ValueTypes["Payment"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["paymentItem"]: AliasType<{
	data?:ValueTypes["PaymentItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["paymentItemsFilters"]: {
	order?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	payment?: number | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["paymentItems"]: AliasType<{
	items?:ValueTypes["PaymentItem"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["paymentTypeFilters"]: {
	const?: string | undefined | null | Variable<any, string>
};
	["paymentTypes"]: AliasType<{
	items?:ValueTypes["PaymentType"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["processStatusesFilters"]: {
	name?: string | undefined | null | Variable<any, string>
};
	["processStatuses"]: AliasType<{
	items?:ValueTypes["ProcessStatus"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["carriersFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["carriers"]: AliasType<{
	items?:ValueTypes["Carrier"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["currenciesFilters"]: {
	name?: string | undefined | null | Variable<any, string>
};
	["currencies"]: AliasType<{
	items?:ValueTypes["Currency"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["package"]: AliasType<{
	data?:ValueTypes["Package"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["packageFilters"]: {
	code?: string | undefined | null | Variable<any, string>,
	carrier?: string | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	disposal?: number | undefined | null | Variable<any, string>,
	hasDisposal?: boolean | undefined | null | Variable<any, string>,
	isSent?: boolean | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	sent?: string | undefined | null | Variable<any, string>
};
	["packages"]: AliasType<{
	items?:ValueTypes["Package"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["packageStatsFilters"]: {
	carrier?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	fromDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	toDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["packageStats"]: AliasType<{
	items?:ValueTypes["PackageStats"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["PackageStats"]: AliasType<{
	company?:ValueTypes["Company"],
	processStatus?:ValueTypes["ProcessStatus"],
	packageAmount?:boolean | `@${string}`,
	orderAmount?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["disposal"]: AliasType<{
	data?:ValueTypes["PackageDisposal"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["disposalFilters"]: {
	carrier?: string | undefined | null | Variable<any, string>
};
	["disposals"]: AliasType<{
	items?:ValueTypes["PackageDisposal"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productDepotMetric"]: AliasType<{
	data?:ValueTypes["ProductDepotMetric"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productDepotMetricFilters"]: {
	product?: number | undefined | null | Variable<any, string>,
	depot?: number | undefined | null | Variable<any, string>
};
	["productDepotMetrics"]: AliasType<{
	items?:ValueTypes["ProductDepotMetric"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["file"]: AliasType<{
	data?:ValueTypes["File"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["fileFilters"]: {
	product?: number | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>
};
	["files"]: AliasType<{
	items?:ValueTypes["File"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["nextEan"]: AliasType<{
	data?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["statsCarrierUsage"]: AliasType<{
	items?:ValueTypes["CarrierUsage"],
		__typename?: boolean | `@${string}`
}>;
	["CarrierUsage"]: AliasType<{
	amount?:boolean | `@${string}`,
	carrier?:ValueTypes["Carrier"],
		__typename?: boolean | `@${string}`
}>;
	["statsPaymentSales"]: AliasType<{
	items?:ValueTypes["PaymentSales"],
		__typename?: boolean | `@${string}`
}>;
	["PaymentSales"]: AliasType<{
	amount?:boolean | `@${string}`,
	sales?:ValueTypes["Price"],
	payment?:ValueTypes["Payment"],
		__typename?: boolean | `@${string}`
}>;
	["Price"]: AliasType<{
	value?:boolean | `@${string}`,
	currency?:ValueTypes["Currency"],
		__typename?: boolean | `@${string}`
}>;
	["statsBestsellersSort"]:statsBestsellersSort;
	["statsBestsellers"]: AliasType<{
	items?:ValueTypes["Bestsellers"],
		__typename?: boolean | `@${string}`
}>;
	["Bestsellers"]: AliasType<{
	amount?:boolean | `@${string}`,
	sales?:ValueTypes["Price"],
	product?:ValueTypes["Product"],
		__typename?: boolean | `@${string}`
}>;
	["companyCarrier"]: AliasType<{
	data?:ValueTypes["CompanyCarrier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["companyCarrierFilters"]: {
	carrier?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["companyCarriers"]: AliasType<{
	items?:ValueTypes["CompanyCarrier"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["category"]: AliasType<{
	data?:ValueTypes["Category"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["categoryFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	parent?: number | undefined | null | Variable<any, string>,
	hasParent?: boolean | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["categories"]: AliasType<{
	items?:ValueTypes["Category"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["parameter"]: AliasType<{
	data?:ValueTypes["Parameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["parametersFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["parameters"]: AliasType<{
	items?:ValueTypes["Parameter"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["orderGroup"]: AliasType<{
	data?:ValueTypes["OrderGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["orderGroupFilters"]: {
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	hasUser?: boolean | undefined | null | Variable<any, string>,
	user?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	processStatus?: string | undefined | null | Variable<any, string>,
	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["orderGroups"]: AliasType<{
	items?:ValueTypes["OrderGroup"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["voucher"]: AliasType<{
	data?:ValueTypes["Voucher"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["voucherFilters"]: {
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	discountType?: string | undefined | null | Variable<any, string>,
	enabled?: boolean | undefined | null | Variable<any, string>,
	isPayment?: boolean | undefined | null | Variable<any, string>,
	isValid?: boolean | undefined | null | Variable<any, string>,
	isUsed?: boolean | undefined | null | Variable<any, string>,
	validDate?: ValueTypes["voucherValidFilter"] | undefined | null | Variable<any, string>,
	created?: ValueTypes["voucherCreatedFilter"] | undefined | null | Variable<any, string>
};
	["voucherValidFilter"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["voucherCreatedFilter"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["vouchers"]: AliasType<{
	items?:ValueTypes["Voucher"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productPriceFilters"]: {
	product?: number | undefined | null | Variable<any, string>
};
	["productPrices"]: AliasType<{
	items?:ValueTypes["ProductPrice"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["priceLevel"]: AliasType<{
	data?:ValueTypes["PriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["priceLevelFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	isPercentage?: boolean | undefined | null | Variable<any, string>,
	withVat?: boolean | undefined | null | Variable<any, string>,
	currency?: string | undefined | null | Variable<any, string>
};
	["priceLevels"]: AliasType<{
	items?:ValueTypes["PriceLevel"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productParameter"]: AliasType<{
	data?:ValueTypes["ProductParameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productParameterFilters"]: {
	product?: number | undefined | null | Variable<any, string>,
	parameter?: number | undefined | null | Variable<any, string>,
	value?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["productParameters"]: AliasType<{
	items?:ValueTypes["ProductParameter"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productPriceLevel"]: AliasType<{
	data?:ValueTypes["ProductPriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productPriceLevelFilters"]: {
	product?: number | undefined | null | Variable<any, string>,
	priceLevel?: number | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["productPriceLevels"]: AliasType<{
	items?:ValueTypes["ProductPriceLevel"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["tag"]: AliasType<{
	data?:ValueTypes["Tag"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["tagFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["tags"]: AliasType<{
	items?:ValueTypes["Tag"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["tagTypeFilters"]: {
	const?: string | undefined | null | Variable<any, string>
};
	["tagTypes"]: AliasType<{
	items?:ValueTypes["TagType"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["TagType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productPack"]: AliasType<{
	data?:ValueTypes["ProductPack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productPackFilters"]: {
	product?: number | undefined | null | Variable<any, string>,
	quantity?: number | undefined | null | Variable<any, string>,
	ean?: string | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["productPacks"]: AliasType<{
	items?:ValueTypes["ProductPack"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrder"]: AliasType<{
	data?:ValueTypes["PurchaseOrder"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrderFilters"]: {
	fulltext?: string | undefined | null | Variable<any, string>,
	status?: string | undefined | null | Variable<any, string>,
	showStocked?: boolean | undefined | null | Variable<any, string>,
	supplier?: number | undefined | null | Variable<any, string>,
	depot?: number | undefined | null | Variable<any, string>,
	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	number?: number | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	externalReference?: string | undefined | null | Variable<any, string>,
	supplierReference?: string | undefined | null | Variable<any, string>,
	createdBy?: number | undefined | null | Variable<any, string>,
	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,
	updated?: ValueTypes["updated"] | undefined | null | Variable<any, string>,
	created?: ValueTypes["created"] | undefined | null | Variable<any, string>,
	dateEstimatedArrival?: ValueTypes["dateEstimatedArrival"] | undefined | null | Variable<any, string>,
	company?: number | undefined | null | Variable<any, string>
};
	["dateEstimatedArrival"]: {
	left_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	right_date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["purchaseOrders"]: AliasType<{
	items?:ValueTypes["PurchaseOrder"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrderItem"]: AliasType<{
	data?:ValueTypes["PurchaseOrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrderItemFilters"]: {
	fulltext?: string | undefined | null | Variable<any, string>,
	purchaseOrder?: number | undefined | null | Variable<any, string>,
	depot?: number | undefined | null | Variable<any, string>,
	product?: number | undefined | null | Variable<any, string>,
	currency?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	status?: string | undefined | null | Variable<any, string>,
	supplier?: number | undefined | null | Variable<any, string>,
	company?: number | undefined | null | Variable<any, string>
};
	["purchaseOrderItems"]: AliasType<{
	items?:ValueTypes["PurchaseOrderItem"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrderStatusesFilters"]: {
	name?: string | undefined | null | Variable<any, string>
};
	["purchaseOrderStatuses"]: AliasType<{
	items?:ValueTypes["PurchaseOrderStatus"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["modulesFilters"]: {
	name?: string | undefined | null | Variable<any, string>,
	companies?: Array<number | undefined | null> | undefined | null | Variable<any, string>
};
	["modules"]: AliasType<{
	items?:ValueTypes["Module"],
	paginator?:ValueTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["RootSchemaMutation"]: AliasType<{
createProduct?: [{	name: string | Variable<any, string>,	parent?: number | undefined | null | Variable<any, string>,	children?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	producer?: number | undefined | null | Variable<any, string>,	supplier?: number | undefined | null | Variable<any, string>,	ean?: string | undefined | null | Variable<any, string>,	ean2?: string | undefined | null | Variable<any, string>,	ean3?: string | undefined | null | Variable<any, string>,	ean4?: string | undefined | null | Variable<any, string>,	ean5?: string | undefined | null | Variable<any, string>,	code?: string | undefined | null | Variable<any, string>,	code2?: string | undefined | null | Variable<any, string>,	code3?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	sellPrice?: string | undefined | null | Variable<any, string>,	purchasePrice?: string | undefined | null | Variable<any, string>,	purchaseCurrency?: string | undefined | null | Variable<any, string>,	beforeSellPrice?: string | undefined | null | Variable<any, string>,	weight?: string | undefined | null | Variable<any, string>,	dimensionX?: number | undefined | null | Variable<any, string>,	dimensionY?: number | undefined | null | Variable<any, string>,	dimensionZ?: number | undefined | null | Variable<any, string>,	originCountry?: string | undefined | null | Variable<any, string>,	hsCode?: string | undefined | null | Variable<any, string>,	enabled?: boolean | undefined | null | Variable<any, string>,	vat?: number | undefined | null | Variable<any, string>,	isForSubsequentSettlement?: boolean | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	description?: string | undefined | null | Variable<any, string>,	perex?: string | undefined | null | Variable<any, string>,	isBundle?: boolean | undefined | null | Variable<any, string>,	isFragile?: boolean | undefined | null | Variable<any, string>,	isOversize?: boolean | undefined | null | Variable<any, string>,	customData?: string | undefined | null | Variable<any, string>,	mainCategory?: number | undefined | null | Variable<any, string>,	mainImage?: number | undefined | null | Variable<any, string>,	categories?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	enabledBatchExpiration?: boolean | undefined | null | Variable<any, string>,	requiredSerialNumbers?: boolean | undefined | null | Variable<any, string>},ValueTypes["createProduct"]],
updateProduct?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	parent?: number | undefined | null | Variable<any, string>,	children?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	producer?: number | undefined | null | Variable<any, string>,	supplier?: number | undefined | null | Variable<any, string>,	ean?: string | undefined | null | Variable<any, string>,	ean2?: string | undefined | null | Variable<any, string>,	ean3?: string | undefined | null | Variable<any, string>,	ean4?: string | undefined | null | Variable<any, string>,	ean5?: string | undefined | null | Variable<any, string>,	code?: string | undefined | null | Variable<any, string>,	code2?: string | undefined | null | Variable<any, string>,	code3?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	sellPrice?: string | undefined | null | Variable<any, string>,	purchasePrice?: string | undefined | null | Variable<any, string>,	purchaseCurrency?: string | undefined | null | Variable<any, string>,	beforeSellPrice?: string | undefined | null | Variable<any, string>,	weight?: string | undefined | null | Variable<any, string>,	dimensionX?: number | undefined | null | Variable<any, string>,	dimensionY?: number | undefined | null | Variable<any, string>,	dimensionZ?: number | undefined | null | Variable<any, string>,	originCountry?: string | undefined | null | Variable<any, string>,	hsCode?: string | undefined | null | Variable<any, string>,	enabled?: boolean | undefined | null | Variable<any, string>,	vat?: number | undefined | null | Variable<any, string>,	isForSubsequentSettlement?: boolean | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	description?: string | undefined | null | Variable<any, string>,	perex?: string | undefined | null | Variable<any, string>,	isBundle?: boolean | undefined | null | Variable<any, string>,	isFragile?: boolean | undefined | null | Variable<any, string>,	isOversize?: boolean | undefined | null | Variable<any, string>,	customData?: string | undefined | null | Variable<any, string>,	mainCategory?: number | undefined | null | Variable<any, string>,	mainImage?: number | undefined | null | Variable<any, string>,	categories?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	enabledBatchExpiration?: boolean | undefined | null | Variable<any, string>,	requiredSerialNumbers?: boolean | undefined | null | Variable<any, string>},ValueTypes["updateProduct"]],
deleteProduct?: [{	id: number | Variable<any, string>},ValueTypes["deleteProduct"]],
refreshProductDepots?: [{	id: number | Variable<any, string>},ValueTypes["refreshProductDepots"]],
createProductMovePack?: [{	type: string | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	externalReference?: string | undefined | null | Variable<any, string>,	purpose?: string | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	order?: number | undefined | null | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	purchaseOrder?: number | undefined | null | Variable<any, string>,	incidentalCosts?: number | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	moves?: Array<ValueTypes["createProductMove"] | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["createProductMovePack"]],
updateProductMovePack?: [{	id: number | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	externalReference?: string | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["updateProductMovePack"]],
deleteProductMovePack?: [{	id: number | Variable<any, string>},ValueTypes["deleteProductMovePack"]],
updateProductMove?: [{	id: number | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	serialNumbers?: Array<string | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["updateProductMove"]],
deleteProductMove?: [{	id: number | Variable<any, string>},ValueTypes["deleteProductMove"]],
createProductPrice?: [{	product: number | Variable<any, string>,	sellPrice?: number | undefined | null | Variable<any, string>,	available?: number | undefined | null | Variable<any, string>,	dateFrom?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateTo?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>},ValueTypes["createProductPrice"]],
updateProductPrice?: [{	id: number | Variable<any, string>,	product: number | Variable<any, string>,	sellPrice?: number | undefined | null | Variable<any, string>,	available?: number | undefined | null | Variable<any, string>,	dateFrom?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateTo?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>},ValueTypes["updateProductPrice"]],
deleteProductPrice?: [{	id: number | Variable<any, string>},ValueTypes["deleteProductPrice"]],
createProductBundle?: [{	parent: number | Variable<any, string>,	child: number | Variable<any, string>,	quantity: number | Variable<any, string>},ValueTypes["createProductBundle"]],
updateProductBundle?: [{	id: number | Variable<any, string>,	parent?: number | undefined | null | Variable<any, string>,	child?: number | undefined | null | Variable<any, string>,	quantity?: number | undefined | null | Variable<any, string>},ValueTypes["updateProductBundle"]],
deleteProductBundle?: [{	id: number | Variable<any, string>},ValueTypes["deleteProductBundle"]],
createProductDepotMetric?: [{	product: number | Variable<any, string>,	depot: number | Variable<any, string>,	quantityMinimum?: number | undefined | null | Variable<any, string>,	quantityOptimum?: number | undefined | null | Variable<any, string>,	quantityMaximum?: number | undefined | null | Variable<any, string>},ValueTypes["createProductDepotMetric"]],
updateProductDepotMetric?: [{	id: number | Variable<any, string>,	quantityMinimum?: number | undefined | null | Variable<any, string>,	quantityOptimum?: number | undefined | null | Variable<any, string>,	quantityMaximum?: number | undefined | null | Variable<any, string>},ValueTypes["updateProductDepotMetric"]],
deleteProductDepotMetric?: [{	id: number | Variable<any, string>},ValueTypes["deleteProductDepotMetric"]],
createInstitution?: [{	name: string | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["createInstitution"]],
updateInstitution?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["updateInstitution"]],
deleteInstitution?: [{	id: number | Variable<any, string>},ValueTypes["deleteInstitution"]],
createOrder?: [{	reservationNumber?: number | undefined | null | Variable<any, string>,	billNumber?: number | undefined | null | Variable<any, string>,	vs?: number | undefined | null | Variable<any, string>,	status?: string | undefined | null | Variable<any, string>,	dateCreated?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateBill?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateExpedition?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateDue?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateTax?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	privateNote?: string | undefined | null | Variable<any, string>,	checkout: number | Variable<any, string>,	customer?: number | undefined | null | Variable<any, string>,	currency?: string | undefined | null | Variable<any, string>,	invoiceAddress?: number | undefined | null | Variable<any, string>,	shippingAddress?: number | undefined | null | Variable<any, string>,	items?: Array<ValueTypes["createOrderItem_"] | undefined | null> | undefined | null | Variable<any, string>,	paymentItems?: Array<ValueTypes["createPaymentItem_"] | undefined | null> | undefined | null | Variable<any, string>,	relatedParent?: number | undefined | null | Variable<any, string>,	rounding?: number | undefined | null | Variable<any, string>,	processStatusRelation?: ValueTypes["processStatusRelation"] | undefined | null | Variable<any, string>,	carrier?: string | undefined | null | Variable<any, string>,	boxes?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	group?: number | undefined | null | Variable<any, string>,	groupPosition?: number | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	priority?: number | undefined | null | Variable<any, string>,	externalReference?: string | undefined | null | Variable<any, string>,	locked?: boolean | undefined | null | Variable<any, string>},ValueTypes["createOrder"]],
updateOrder?: [{	id: number | Variable<any, string>,	reservationNumber?: number | undefined | null | Variable<any, string>,	billNumber?: number | undefined | null | Variable<any, string>,	vs?: number | undefined | null | Variable<any, string>,	status?: string | undefined | null | Variable<any, string>,	dateCreated?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateBill?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateExpedition?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateDue?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateTax?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	privateNote?: string | undefined | null | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	customer?: number | undefined | null | Variable<any, string>,	currency?: string | undefined | null | Variable<any, string>,	invoiceAddress?: number | undefined | null | Variable<any, string>,	shippingAddress?: number | undefined | null | Variable<any, string>,	items?: Array<ValueTypes["updateOrderItem_"] | undefined | null> | undefined | null | Variable<any, string>,	paymentItems?: Array<ValueTypes["updatePaymentItem_"] | undefined | null> | undefined | null | Variable<any, string>,	relatedParent?: number | undefined | null | Variable<any, string>,	rounding?: number | undefined | null | Variable<any, string>,	processStatusRelation?: ValueTypes["processStatusRelation"] | undefined | null | Variable<any, string>,	carrier?: string | undefined | null | Variable<any, string>,	boxes?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	group?: number | undefined | null | Variable<any, string>,	groupPosition?: number | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	priority?: number | undefined | null | Variable<any, string>,	externalReference?: string | undefined | null | Variable<any, string>,	locked?: boolean | undefined | null | Variable<any, string>},ValueTypes["updateOrder"]],
deleteReservation?: [{	id: number | Variable<any, string>},ValueTypes["deleteReservation"]],
createOrderItem?: [{	order?: number | undefined | null | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	type?: string | undefined | null | Variable<any, string>,	ean?: string | undefined | null | Variable<any, string>,	code?: string | undefined | null | Variable<any, string>,	quantity?: number | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	price?: number | undefined | null | Variable<any, string>,	sale?: number | undefined | null | Variable<any, string>,	vat?: number | undefined | null | Variable<any, string>,	product?: number | undefined | null | Variable<any, string>,	serial?: string | undefined | null | Variable<any, string>,	expirationDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	batch?: string | undefined | null | Variable<any, string>,	isForSubsequentSettlement?: boolean | undefined | null | Variable<any, string>,	picked?: boolean | undefined | null | Variable<any, string>,	packed?: boolean | undefined | null | Variable<any, string>,	voucher?: number | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createOrderItem"]],
updateOrderItem?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	type?: string | undefined | null | Variable<any, string>,	ean?: string | undefined | null | Variable<any, string>,	code?: string | undefined | null | Variable<any, string>,	quantity?: number | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	price?: number | undefined | null | Variable<any, string>,	sale?: number | undefined | null | Variable<any, string>,	vat?: number | undefined | null | Variable<any, string>,	product?: number | undefined | null | Variable<any, string>,	serial?: string | undefined | null | Variable<any, string>,	expirationDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	batch?: string | undefined | null | Variable<any, string>,	isForSubsequentSettlement?: boolean | undefined | null | Variable<any, string>,	picked?: boolean | undefined | null | Variable<any, string>,	packed?: boolean | undefined | null | Variable<any, string>,	voucher?: number | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateOrderItem"]],
deleteOrderItem?: [{	id: number | Variable<any, string>},ValueTypes["deleteOrderItem"]],
updateClearanceItem?: [{	id: string | Variable<any, string>,	orderItem?: number | undefined | null | Variable<any, string>,	orderGroup?: number | undefined | null | Variable<any, string>,	package?: number | undefined | null | Variable<any, string>,	order?: number | undefined | null | Variable<any, string>,	picked?: number | undefined | null | Variable<any, string>,	packed?: number | undefined | null | Variable<any, string>,	locations?: Array<ValueTypes["updateClearanceItemLocations"] | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["updateClearanceItem"]],
createUser?: [{	email: string | Variable<any, string>,	plainPassword?: string | undefined | null | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>,	phone?: string | undefined | null | Variable<any, string>,	enabled?: boolean | undefined | null | Variable<any, string>,	groups?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	roles?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	pin?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	locale?: string | undefined | null | Variable<any, string>},ValueTypes["createUser"]],
updateUser?: [{	id: number | Variable<any, string>,	email?: string | undefined | null | Variable<any, string>,	plainPassword?: string | undefined | null | Variable<any, string>,	firstName?: string | undefined | null | Variable<any, string>,	lastName?: string | undefined | null | Variable<any, string>,	phone?: string | undefined | null | Variable<any, string>,	enabled?: boolean | undefined | null | Variable<any, string>,	groups?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	roles?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	pin?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	locale?: string | undefined | null | Variable<any, string>},ValueTypes["updateUser"]],
deleteUser?: [{	id: number | Variable<any, string>},ValueTypes["deleteUser"]],
createUserGroup?: [{	name: string | Variable<any, string>,	roles?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createUserGroup"]],
updateUserGroup?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	roles?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateUserGroup"]],
deleteUserGroup?: [{	id: number | Variable<any, string>},ValueTypes["deleteUserGroup"]],
createCustomer?: [{	externalId?: string | undefined | null | Variable<any, string>,	email: string | Variable<any, string>,	plainPassword?: string | undefined | null | Variable<any, string>,	firstName?: string | undefined | null | Variable<any, string>,	lastName?: string | undefined | null | Variable<any, string>,	companyName?: string | undefined | null | Variable<any, string>,	phone?: string | undefined | null | Variable<any, string>,	wholesale?: boolean | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	birthday?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	users?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	minExpirationDays?: number | undefined | null | Variable<any, string>,	priceLevel?: number | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	customData?: string | undefined | null | Variable<any, string>},ValueTypes["createCustomer"]],
updateCustomer?: [{	id: number | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	email?: string | undefined | null | Variable<any, string>,	plainPassword?: string | undefined | null | Variable<any, string>,	firstName?: string | undefined | null | Variable<any, string>,	lastName?: string | undefined | null | Variable<any, string>,	companyName?: string | undefined | null | Variable<any, string>,	phone?: string | undefined | null | Variable<any, string>,	wholesale?: boolean | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	birthday?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	users?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	minExpirationDays?: number | undefined | null | Variable<any, string>,	priceLevel?: number | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	customData?: string | undefined | null | Variable<any, string>},ValueTypes["updateCustomer"]],
deleteCustomer?: [{	id: number | Variable<any, string>},ValueTypes["deleteCustomer"]],
createAddress?: [{	customer?: number | undefined | null | Variable<any, string>,	companyName?: string | undefined | null | Variable<any, string>,	firstName?: string | undefined | null | Variable<any, string>,	lastName?: string | undefined | null | Variable<any, string>,	street?: string | undefined | null | Variable<any, string>,	city?: string | undefined | null | Variable<any, string>,	country: string | Variable<any, string>,	state?: string | undefined | null | Variable<any, string>,	zip?: string | undefined | null | Variable<any, string>,	ic?: string | undefined | null | Variable<any, string>,	dic?: string | undefined | null | Variable<any, string>,	phone?: string | undefined | null | Variable<any, string>,	email?: string | undefined | null | Variable<any, string>,	zasilkovnaAddressId?: string | undefined | null | Variable<any, string>,	branchId?: string | undefined | null | Variable<any, string>,	isStored?: boolean | undefined | null | Variable<any, string>,	isBilling?: boolean | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	customData?: string | undefined | null | Variable<any, string>},ValueTypes["createAddress"]],
updateAddress?: [{	id: number | Variable<any, string>,	customer?: number | undefined | null | Variable<any, string>,	companyName?: string | undefined | null | Variable<any, string>,	firstName?: string | undefined | null | Variable<any, string>,	lastName?: string | undefined | null | Variable<any, string>,	street?: string | undefined | null | Variable<any, string>,	city?: string | undefined | null | Variable<any, string>,	country?: string | undefined | null | Variable<any, string>,	state?: string | undefined | null | Variable<any, string>,	zip?: string | undefined | null | Variable<any, string>,	ic?: string | undefined | null | Variable<any, string>,	dic?: string | undefined | null | Variable<any, string>,	phone?: string | undefined | null | Variable<any, string>,	email?: string | undefined | null | Variable<any, string>,	zasilkovnaAddressId?: string | undefined | null | Variable<any, string>,	branchId?: string | undefined | null | Variable<any, string>,	isStored?: boolean | undefined | null | Variable<any, string>,	isBilling?: boolean | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	customData?: string | undefined | null | Variable<any, string>},ValueTypes["updateAddress"]],
deleteAddress?: [{	id: number | Variable<any, string>},ValueTypes["deleteAddress"]],
createCheckout?: [{	name: string | Variable<any, string>,	amount?: string | undefined | null | Variable<any, string>,	nextReservationNumber?: number | undefined | null | Variable<any, string>,	nextBillNumber?: number | undefined | null | Variable<any, string>,	billFooter?: string | undefined | null | Variable<any, string>,	payments?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	returnsDepot?: number | undefined | null | Variable<any, string>,	shop?: number | undefined | null | Variable<any, string>,	eetId?: number | undefined | null | Variable<any, string>,	eetEnable?: boolean | undefined | null | Variable<any, string>,	eetPlayground?: boolean | undefined | null | Variable<any, string>,	eetVerificationMode?: boolean | undefined | null | Variable<any, string>,	eventUrl?: string | undefined | null | Variable<any, string>,	eventTypes?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	negativeReservation?: boolean | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	users?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	autoPicking?: boolean | undefined | null | Variable<any, string>,	autoPacking?: boolean | undefined | null | Variable<any, string>,	autoDispatched?: boolean | undefined | null | Variable<any, string>,	institution?: number | undefined | null | Variable<any, string>,	position?: number | undefined | null | Variable<any, string>},ValueTypes["createCheckout"]],
updateCheckout?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	amount?: string | undefined | null | Variable<any, string>,	nextReservationNumber?: number | undefined | null | Variable<any, string>,	nextBillNumber?: number | undefined | null | Variable<any, string>,	billFooter?: string | undefined | null | Variable<any, string>,	payments?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	returnsDepot?: number | undefined | null | Variable<any, string>,	shop?: number | undefined | null | Variable<any, string>,	eetId?: number | undefined | null | Variable<any, string>,	eetEnable?: boolean | undefined | null | Variable<any, string>,	eetPlayground?: boolean | undefined | null | Variable<any, string>,	eetVerificationMode?: boolean | undefined | null | Variable<any, string>,	eventUrl?: string | undefined | null | Variable<any, string>,	eventTypes?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	negativeReservation?: boolean | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	users?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	autoPicking?: boolean | undefined | null | Variable<any, string>,	autoPacking?: boolean | undefined | null | Variable<any, string>,	autoDispatched?: boolean | undefined | null | Variable<any, string>,	institution?: number | undefined | null | Variable<any, string>,	position?: number | undefined | null | Variable<any, string>},ValueTypes["updateCheckout"]],
deleteCheckout?: [{	id: number | Variable<any, string>},ValueTypes["deleteCheckout"]],
createCheckoutExtraOperation?: [{	checkout: number | Variable<any, string>,	dateCreated?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	amount: string | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>},ValueTypes["createCheckoutExtraOperation"]],
updateCheckoutExtraOperation?: [{	id: number | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	dateCreated?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	amount?: string | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>},ValueTypes["updateCheckoutExtraOperation"]],
deleteCheckoutExtraOperation?: [{	id: number | Variable<any, string>},ValueTypes["deleteCheckoutExtraOperation"]],
createCheckoutClosing?: [{	checkout: number | Variable<any, string>,	dateOpen: ValueTypes["DateTimeAsString"] | Variable<any, string>,	amountOpen: string | Variable<any, string>,	amountRealOpen?: string | undefined | null | Variable<any, string>,	userOpen?: number | undefined | null | Variable<any, string>,	noteOpen?: string | undefined | null | Variable<any, string>,	dateClosed?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	amountClosed?: string | undefined | null | Variable<any, string>,	amountRealClosed?: string | undefined | null | Variable<any, string>,	userClosed?: number | undefined | null | Variable<any, string>,	noteClosed?: string | undefined | null | Variable<any, string>,	enumeration?: string | undefined | null | Variable<any, string>},ValueTypes["createCheckoutClosing"]],
updateCheckoutClosing?: [{	id: number | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	dateOpen?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	amountOpen?: string | undefined | null | Variable<any, string>,	amountRealOpen?: string | undefined | null | Variable<any, string>,	userOpen?: number | undefined | null | Variable<any, string>,	noteOpen?: string | undefined | null | Variable<any, string>,	dateClosed?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	amountClosed?: string | undefined | null | Variable<any, string>,	amountRealClosed?: string | undefined | null | Variable<any, string>,	userClosed?: number | undefined | null | Variable<any, string>,	noteClosed?: string | undefined | null | Variable<any, string>,	enumeration?: string | undefined | null | Variable<any, string>},ValueTypes["updateCheckoutClosing"]],
deleteCheckoutClosing?: [{	id: number | Variable<any, string>},ValueTypes["deleteCheckoutClosing"]],
createVat?: [{	name: string | Variable<any, string>,	percent: string | Variable<any, string>,	default: boolean | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createVat"]],
updateVat?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	percent?: string | undefined | null | Variable<any, string>,	default?: boolean | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateVat"]],
deleteVat?: [{	id: number | Variable<any, string>},ValueTypes["deleteVat"]],
createDepot?: [{	name: string | Variable<any, string>,	emailIn?: string | undefined | null | Variable<any, string>,	position?: number | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	institution?: number | undefined | null | Variable<any, string>,	users?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["createDepot"]],
updateDepot?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	emailIn?: string | undefined | null | Variable<any, string>,	position?: number | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	institution?: number | undefined | null | Variable<any, string>,	users?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["updateDepot"]],
deleteDepot?: [{	id: number | Variable<any, string>},ValueTypes["deleteDepot"]],
createSupplier?: [{	name: string | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createSupplier"]],
updateSupplier?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateSupplier"]],
deleteSupplier?: [{	id: number | Variable<any, string>},ValueTypes["deleteSupplier"]],
createProducer?: [{	name: string | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createProducer"]],
updateProducer?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateProducer"]],
deleteProducer?: [{	id: number | Variable<any, string>},ValueTypes["deleteProducer"]],
createExportStock?: [{	date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	format?: string | undefined | null | Variable<any, string>},ValueTypes["createExportStock"]],
createExportSale?: [{	dateFrom: ValueTypes["DateTimeAsString"] | Variable<any, string>,	dateTo: ValueTypes["DateTimeAsString"] | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	format?: string | undefined | null | Variable<any, string>},ValueTypes["createExportSale"]],
createExportPurchase?: [{	dateFrom: ValueTypes["DateTimeAsString"] | Variable<any, string>,	dateTo: ValueTypes["DateTimeAsString"] | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	format?: string | undefined | null | Variable<any, string>},ValueTypes["createExportPurchase"]],
createExportOrder?: [{	dateFrom: ValueTypes["DateTimeAsString"] | Variable<any, string>,	dateTo: ValueTypes["DateTimeAsString"] | Variable<any, string>,	status?: string | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	format?: string | undefined | null | Variable<any, string>},ValueTypes["createExportOrder"]],
createExportInventory?: [{	date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	approved?: string | undefined | null | Variable<any, string>,	rejected?: string | undefined | null | Variable<any, string>},ValueTypes["createExportInventory"]],
updateExportInventory?: [{	id: number | Variable<any, string>,	date?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	depots?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	suppliers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	producers?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	approved?: string | undefined | null | Variable<any, string>,	rejected?: string | undefined | null | Variable<any, string>},ValueTypes["updateExportInventory"]],
refreshExportInventory?: [{	id: number | Variable<any, string>},ValueTypes["refreshExportInventory"]],
createExport?: [{	type: string | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	filter?: string | undefined | null | Variable<any, string>},ValueTypes["createExport"]],
updateCompany?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	ic?: string | undefined | null | Variable<any, string>,	dic?: string | undefined | null | Variable<any, string>,	phone?: string | undefined | null | Variable<any, string>,	email?: string | undefined | null | Variable<any, string>,	street?: string | undefined | null | Variable<any, string>,	city?: string | undefined | null | Variable<any, string>,	zip?: string | undefined | null | Variable<any, string>,	country?: string | undefined | null | Variable<any, string>,	registrationNote?: string | undefined | null | Variable<any, string>,	nextEan?: number | undefined | null | Variable<any, string>,	defaultVoucherValidity?: number | undefined | null | Variable<any, string>,	batchExpirationMode?: string | undefined | null | Variable<any, string>},ValueTypes["updateCompany"]],
createShop?: [{	name: string | Variable<any, string>,	street?: string | undefined | null | Variable<any, string>,	city?: string | undefined | null | Variable<any, string>,	country?: string | undefined | null | Variable<any, string>,	zip?: string | undefined | null | Variable<any, string>,	eetId?: number | undefined | null | Variable<any, string>,	cert?: number | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["createShop"]],
updateShop?: [{	id: number | Variable<any, string>,	name: string | Variable<any, string>,	street?: string | undefined | null | Variable<any, string>,	city?: string | undefined | null | Variable<any, string>,	country?: string | undefined | null | Variable<any, string>,	zip?: string | undefined | null | Variable<any, string>,	eetId?: number | undefined | null | Variable<any, string>,	cert?: number | undefined | null | Variable<any, string>,	checkouts?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["updateShop"]],
deleteShop?: [{	id: number | Variable<any, string>},ValueTypes["deleteShop"]],
createCert?: [{	name: string | Variable<any, string>,	password: string | Variable<any, string>,	pkcs12: string | Variable<any, string>},ValueTypes["createCert"]],
updateCert?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>},ValueTypes["updateCert"]],
deleteCert?: [{	id: number | Variable<any, string>},ValueTypes["deleteCert"]],
createEetReceipt?: [{	checkout: number | Variable<any, string>,	number: number | Variable<any, string>,	dateCreated: string | Variable<any, string>,	currency: string | Variable<any, string>,	totalPrice: number | Variable<any, string>,	priceZeroVat?: number | undefined | null | Variable<any, string>,	priceStandardVat?: number | undefined | null | Variable<any, string>,	vatStandard?: number | undefined | null | Variable<any, string>,	priceFirstReducedVat?: number | undefined | null | Variable<any, string>,	vatFirstReduced?: number | undefined | null | Variable<any, string>,	priceSecondReducedVat?: number | undefined | null | Variable<any, string>,	vatSecondReduced?: number | undefined | null | Variable<any, string>,	priceForSubsequentSettlement?: number | undefined | null | Variable<any, string>,	priceUsedSubsequentSettlement?: number | undefined | null | Variable<any, string>},ValueTypes["createEetReceipt"]],
sendEetReceipt?: [{	id: number | Variable<any, string>},ValueTypes["sendEetReceipt"]],
createPayment?: [{	name: string | Variable<any, string>,	type?: string | undefined | null | Variable<any, string>,	eetEnable?: boolean | undefined | null | Variable<any, string>,	dispatchUnpaid?: boolean | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createPayment"]],
updatePayment?: [{	id: number | Variable<any, string>,	name: string | Variable<any, string>,	type?: string | undefined | null | Variable<any, string>,	eetEnable?: boolean | undefined | null | Variable<any, string>,	dispatchUnpaid?: boolean | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updatePayment"]],
deletePayment?: [{	id: number | Variable<any, string>},ValueTypes["deletePayment"]],
createPaymentItem?: [{	payment: number | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	voucher?: number | undefined | null | Variable<any, string>,	amount?: number | undefined | null | Variable<any, string>,	dateCreated?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateCancelled?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	isPaid?: boolean | undefined | null | Variable<any, string>,	datePaid?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>},ValueTypes["createPaymentItem"]],
updatePaymentItem?: [{	id: number | Variable<any, string>,	payment?: number | undefined | null | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	voucher?: number | undefined | null | Variable<any, string>,	amount?: number | undefined | null | Variable<any, string>,	dateCreated?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	dateCancelled?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	isPaid?: boolean | undefined | null | Variable<any, string>,	datePaid?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>},ValueTypes["updatePaymentItem"]],
deletePaymentItem?: [{	id: number | Variable<any, string>},ValueTypes["deletePaymentItem"]],
createDevLog?: [{	name?: string | undefined | null | Variable<any, string>,	content?: string | undefined | null | Variable<any, string>},ValueTypes["createDevLog"]],
createPackage?: [{	carrier?: string | undefined | null | Variable<any, string>,	order?: number | undefined | null | Variable<any, string>,	items?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	weight?: number | undefined | null | Variable<any, string>,	dimensionX?: number | undefined | null | Variable<any, string>,	dimensionY?: number | undefined | null | Variable<any, string>,	dimensionZ?: number | undefined | null | Variable<any, string>,	tariff?: number | undefined | null | Variable<any, string>},ValueTypes["createPackage"]],
updatePackage?: [{	id: number | Variable<any, string>,	carrier?: string | undefined | null | Variable<any, string>,	order?: number | undefined | null | Variable<any, string>,	items?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	weight?: number | undefined | null | Variable<any, string>,	dimensionX?: number | undefined | null | Variable<any, string>,	dimensionY?: number | undefined | null | Variable<any, string>,	dimensionZ?: number | undefined | null | Variable<any, string>,	tariff?: number | undefined | null | Variable<any, string>},ValueTypes["updatePackage"]],
deletePackage?: [{	id: number | Variable<any, string>},ValueTypes["deletePackage"]],
resetPackage?: [{	id: number | Variable<any, string>},ValueTypes["resetPackage"]],
sendPackage?: [{	id: number | Variable<any, string>},ValueTypes["sendPackage"]],
createDisposal?: [{	company?: number | undefined | null | Variable<any, string>,	carrier?: string | undefined | null | Variable<any, string>,	packages?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["createDisposal"]],
updateDisposal?: [{	id: number | Variable<any, string>,	company?: number | undefined | null | Variable<any, string>,	carrier?: string | undefined | null | Variable<any, string>,	packages?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["updateDisposal"]],
deleteDisposal?: [{	id: number | Variable<any, string>},ValueTypes["deleteDisposal"]],
sendDisposal?: [{	id: string | Variable<any, string>},ValueTypes["sendDisposal"]],
createFile?: [{	text: string | Variable<any, string>,	originalFilename: string | Variable<any, string>,	mimeType: string | Variable<any, string>,	base64Data: string | Variable<any, string>,	product?: number | undefined | null | Variable<any, string>,	order?: number | undefined | null | Variable<any, string>,	inventory?: number | undefined | null | Variable<any, string>,	productMovePack?: number | undefined | null | Variable<any, string>,	disposal?: number | undefined | null | Variable<any, string>,	purchaseOrder?: number | undefined | null | Variable<any, string>},ValueTypes["createFile"]],
updateFile?: [{	id: number | Variable<any, string>,	text?: string | undefined | null | Variable<any, string>,	originalFilename?: string | undefined | null | Variable<any, string>,	mimeType?: string | undefined | null | Variable<any, string>,	base64Data?: string | undefined | null | Variable<any, string>,	product?: number | undefined | null | Variable<any, string>,	order?: number | undefined | null | Variable<any, string>,	inventory?: number | undefined | null | Variable<any, string>,	productMovePack?: number | undefined | null | Variable<any, string>,	disposal?: number | undefined | null | Variable<any, string>,	purchaseOrder?: number | undefined | null | Variable<any, string>},ValueTypes["updateFile"]],
deleteFile?: [{	id: number | Variable<any, string>},ValueTypes["deleteFile"]],
createCompanyCarrier?: [{	carrier: string | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	options?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	enable?: boolean | undefined | null | Variable<any, string>},ValueTypes["createCompanyCarrier"]],
updateCompanyCarrier?: [{	id: number | Variable<any, string>,	carrier?: string | undefined | null | Variable<any, string>,	checkout?: number | undefined | null | Variable<any, string>,	options?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	enable?: boolean | undefined | null | Variable<any, string>},ValueTypes["updateCompanyCarrier"]],
deleteCompanyCarrier?: [{	id: number | Variable<any, string>},ValueTypes["deleteCompanyCarrier"]],
createConsent?: [{	name: string | Variable<any, string>,	body?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createConsent"]],
updateConsent?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	body?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateConsent"]],
deleteConsent?: [{	id: number | Variable<any, string>},ValueTypes["deleteConsent"]],
createCustomerConsent?: [{	customer: number | Variable<any, string>,	consent: number | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createCustomerConsent"]],
deleteCustomerConsent?: [{	id: number | Variable<any, string>},ValueTypes["deleteCustomerConsent"]],
updateProductDepot?: [{	id: number | Variable<any, string>,	position1?: string | undefined | null | Variable<any, string>,	position2?: string | undefined | null | Variable<any, string>,	position3?: string | undefined | null | Variable<any, string>,	purchasePrice?: number | undefined | null | Variable<any, string>,	supplier?: number | undefined | null | Variable<any, string>,	batch?: string | undefined | null | Variable<any, string>,	expirationDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	inventoryQuantityStock?: number | undefined | null | Variable<any, string>},ValueTypes["updateProductDepot"]],
createCategory?: [{	name: string | Variable<any, string>,	text?: string | undefined | null | Variable<any, string>,	parent?: number | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	position?: number | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["createCategory"]],
updateCategory?: [{	id: number | Variable<any, string>,	name: string | Variable<any, string>,	text?: string | undefined | null | Variable<any, string>,	parent?: number | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	position?: number | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["updateCategory"]],
deleteCategory?: [{	id: number | Variable<any, string>},ValueTypes["deleteCategory"]],
createParameter?: [{	name: string | Variable<any, string>,	type?: string | undefined | null | Variable<any, string>,	enumValues?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	unit?: string | undefined | null | Variable<any, string>,	text?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createParameter"]],
updateParameter?: [{	id: number | Variable<any, string>,	name: string | Variable<any, string>,	type?: string | undefined | null | Variable<any, string>,	enumValues?: Array<string | undefined | null> | undefined | null | Variable<any, string>,	unit?: string | undefined | null | Variable<any, string>,	text?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateParameter"]],
deleteParameter?: [{	id: number | Variable<any, string>},ValueTypes["deleteParameter"]],
createOrderGroup?: [{	name: string | Variable<any, string>,	user?: number | undefined | null | Variable<any, string>,	userPosition?: number | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["createOrderGroup"]],
updateOrderGroup?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	user?: number | undefined | null | Variable<any, string>,	userPosition?: number | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["updateOrderGroup"]],
deleteOrderGroup?: [{	id: number | Variable<any, string>},ValueTypes["deleteOrderGroup"]],
createVoucher?: [{	name: string | Variable<any, string>,	code: string | Variable<any, string>,	discountType: string | Variable<any, string>,	discountPercent?: number | undefined | null | Variable<any, string>,	discountValue?: number | undefined | null | Variable<any, string>,	maxUse?: number | undefined | null | Variable<any, string>,	validFrom?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	validTo?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	enabled?: boolean | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	isPayment?: boolean | undefined | null | Variable<any, string>},ValueTypes["createVoucher"]],
updateVoucher?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	code?: string | undefined | null | Variable<any, string>,	discountType?: string | undefined | null | Variable<any, string>,	discountPercent?: number | undefined | null | Variable<any, string>,	discountValue?: number | undefined | null | Variable<any, string>,	maxUse?: number | undefined | null | Variable<any, string>,	validFrom?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	validTo?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	enabled?: boolean | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	isPayment?: boolean | undefined | null | Variable<any, string>},ValueTypes["updateVoucher"]],
deleteVoucher?: [{	id: number | Variable<any, string>},ValueTypes["deleteVoucher"]],
createPriceLevel?: [{	name: string | Variable<any, string>,	isPercentage?: boolean | undefined | null | Variable<any, string>,	percent?: number | undefined | null | Variable<any, string>,	withVat?: boolean | undefined | null | Variable<any, string>,	currency?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createPricePriceLevel"]],
updatePriceLevel?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	isPercentage?: boolean | undefined | null | Variable<any, string>,	percent?: number | undefined | null | Variable<any, string>,	withVat?: boolean | undefined | null | Variable<any, string>,	currency?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updatePriceLevel"]],
deletePriceLevel?: [{	id: number | Variable<any, string>},ValueTypes["deletePriceLevel"]],
createProductParameter?: [{	product: number | Variable<any, string>,	parameter: number | Variable<any, string>,	value: ValueTypes["StringOrArray"] | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createProductParameter"]],
updateProductParameter?: [{	id: number | Variable<any, string>,	product: number | Variable<any, string>,	parameter: number | Variable<any, string>,	value?: ValueTypes["StringOrArray"] | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateProductParameter"]],
deleteProductParameter?: [{	id: number | Variable<any, string>},ValueTypes["deleteProductParameter"]],
createProductPriceLevel?: [{	product: number | Variable<any, string>,	priceLevel: number | Variable<any, string>,	sellPrice?: number | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createProductPriceLevel"]],
updateProductPriceLevel?: [{	id: number | Variable<any, string>,	product: number | Variable<any, string>,	priceLevel: number | Variable<any, string>,	sellPrice?: number | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateProductPriceLevel"]],
deleteProductPriceLevel?: [{	id: number | Variable<any, string>},ValueTypes["deleteProductPriceLevel"]],
createTag?: [{	name: string | Variable<any, string>,	type: string | Variable<any, string>,	color?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createTag"]],
updateTag?: [{	id: number | Variable<any, string>,	name?: string | undefined | null | Variable<any, string>,	type?: string | undefined | null | Variable<any, string>,	color?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateTag"]],
deleteTag?: [{	id: number | Variable<any, string>},ValueTypes["deleteTag"]],
createProductPack?: [{	product: number | Variable<any, string>,	quantity: number | Variable<any, string>,	ean?: string | undefined | null | Variable<any, string>,	code?: string | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createProductPack"]],
updateProductPack?: [{	id: number | Variable<any, string>,	product: number | Variable<any, string>,	quantity: number | Variable<any, string>,	ean?: string | undefined | null | Variable<any, string>,	code?: string | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["updateProductPack"]],
deleteProductPack?: [{	id: number | Variable<any, string>},ValueTypes["deleteProductPack"]],
createPurchaseOrder?: [{	supplier: number | Variable<any, string>,	depot: number | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	privateNote?: string | undefined | null | Variable<any, string>,	dateEstimatedArrival?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	items: Array<ValueTypes["createPurchaseOrderItem_"] | undefined | null> | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	files?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	externalReference?: string | undefined | null | Variable<any, string>,	supplierReference?: string | undefined | null | Variable<any, string>},ValueTypes["createPurchaseOrder"]],
updatePurchaseOrder?: [{	id: number | Variable<any, string>,	supplier?: number | undefined | null | Variable<any, string>,	depot?: number | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	privateNote?: string | undefined | null | Variable<any, string>,	dateEstimatedArrival?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,	items?: Array<ValueTypes["createPurchaseOrderItem_"] | undefined | null> | undefined | null | Variable<any, string>,	tags?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	files?: Array<number | undefined | null> | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	externalReference?: string | undefined | null | Variable<any, string>,	supplierReference?: string | undefined | null | Variable<any, string>,	status?: string | undefined | null | Variable<any, string>},ValueTypes["updatePurchaseOrder"]],
deletePurchaseOrder?: [{	id: number | Variable<any, string>},ValueTypes["deletePurchaseOrder"]],
createPurchaseOrderItem?: [{	purchaseOrder: number | Variable<any, string>,	currency: string | Variable<any, string>,	product: number | Variable<any, string>,	quantity: number | Variable<any, string>,	purchasePrice?: number | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>},ValueTypes["createPurchaseOrderItem"]],
updatePurchaseOrderItem?: [{	id: number | Variable<any, string>,	currency?: string | undefined | null | Variable<any, string>,	product?: number | undefined | null | Variable<any, string>,	quantity?: number | undefined | null | Variable<any, string>,	purchasePrice?: number | undefined | null | Variable<any, string>,	note?: string | undefined | null | Variable<any, string>,	externalId?: string | undefined | null | Variable<any, string>,	status?: string | undefined | null | Variable<any, string>},ValueTypes["updatePurchaseOrderItem"]],
deletePurchaseOrderItem?: [{	id: number | Variable<any, string>},ValueTypes["deletePurchaseOrderItem"]],
		__typename?: boolean | `@${string}`
}>;
	["createProduct"]: AliasType<{
	data?:ValueTypes["Product"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProduct"]: AliasType<{
	data?:ValueTypes["Product"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProduct"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["refreshProductDepots"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductMove"]: {
	product?: number | undefined | null | Variable<any, string>,
	depotFrom?: number | undefined | null | Variable<any, string>,
	depotTo?: number | undefined | null | Variable<any, string>,
	productDepot?: number | undefined | null | Variable<any, string>,
	supplier?: number | undefined | null | Variable<any, string>,
	amount: number | Variable<any, string>,
	purchasePrice?: number | undefined | null | Variable<any, string>,
	purchaseCurrency?: string | undefined | null | Variable<any, string>,
	purchaseCurrencyDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	purchaseOrderItem?: number | undefined | null | Variable<any, string>,
	expirationDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	batch?: string | undefined | null | Variable<any, string>,
	position1?: string | undefined | null | Variable<any, string>,
	position2?: string | undefined | null | Variable<any, string>,
	position3?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	orderItem?: number | undefined | null | Variable<any, string>,
	serialNumbers?: Array<string | undefined | null> | undefined | null | Variable<any, string>
};
	["createProductMovePack"]: AliasType<{
	data?:ValueTypes["ProductMovePack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductMovePack"]: AliasType<{
	data?:ValueTypes["ProductMovePack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductMovePack"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductMove"]: AliasType<{
	data?:ValueTypes["ProductMove"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductMove"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductPrice"]: AliasType<{
	data?:ValueTypes["ProductPrice"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductPrice"]: AliasType<{
	data?:ValueTypes["ProductPrice"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductPrice"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductBundle"]: AliasType<{
	data?:ValueTypes["ProductBundle"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductBundle"]: AliasType<{
	data?:ValueTypes["ProductBundle"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductBundle"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductDepotMetric"]: AliasType<{
	data?:ValueTypes["ProductDepotMetric"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductDepotMetric"]: AliasType<{
	data?:ValueTypes["ProductDepotMetric"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductDepotMetric"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createInstitution"]: AliasType<{
	data?:ValueTypes["Institution"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateInstitution"]: AliasType<{
	data?:ValueTypes["Institution"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteInstitution"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createOrderItem_"]: {
	name?: string | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	ean?: string | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	quantity?: number | undefined | null | Variable<any, string>,
	price?: number | undefined | null | Variable<any, string>,
	sale?: number | undefined | null | Variable<any, string>,
	vat?: number | undefined | null | Variable<any, string>,
	product?: number | undefined | null | Variable<any, string>,
	serial?: string | undefined | null | Variable<any, string>,
	expirationDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	batch?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	isForSubsequentSettlement?: boolean | undefined | null | Variable<any, string>,
	picked?: boolean | undefined | null | Variable<any, string>,
	packed?: boolean | undefined | null | Variable<any, string>,
	voucher?: number | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["createPaymentItem_"]: {
	payment: number | Variable<any, string>,
	checkout?: number | undefined | null | Variable<any, string>,
	voucher?: number | undefined | null | Variable<any, string>,
	amount: number | Variable<any, string>,
	dateCreated?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	dateCancelled?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	isPaid?: boolean | undefined | null | Variable<any, string>,
	datePaid?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["processStatusRelation"]: {
	status?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>
};
	["createOrder"]: AliasType<{
	data?:ValueTypes["Order"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateOrderItem_"]: {
	id?: number | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	ean?: string | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	quantity?: number | undefined | null | Variable<any, string>,
	price?: string | undefined | null | Variable<any, string>,
	sale?: string | undefined | null | Variable<any, string>,
	vat?: number | undefined | null | Variable<any, string>,
	product?: number | undefined | null | Variable<any, string>,
	serial?: string | undefined | null | Variable<any, string>,
	expirationDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	batch?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	isForSubsequentSettlement?: boolean | undefined | null | Variable<any, string>,
	picked?: boolean | undefined | null | Variable<any, string>,
	packed?: boolean | undefined | null | Variable<any, string>,
	voucher?: number | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["updatePaymentItem_"]: {
	payment?: number | undefined | null | Variable<any, string>,
	checkout?: number | undefined | null | Variable<any, string>,
	voucher?: number | undefined | null | Variable<any, string>,
	amount?: string | undefined | null | Variable<any, string>,
	dateCreated?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	dateCancelled?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>,
	isPaid?: boolean | undefined | null | Variable<any, string>,
	datePaid?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>
};
	["updateOrder"]: AliasType<{
	data?:ValueTypes["Order"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteReservation"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createOrderItem"]: AliasType<{
	data?:ValueTypes["OrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateOrderItem"]: AliasType<{
	data?:ValueTypes["OrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteOrderItem"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateClearanceItemLocations"]: {
	amount: number | Variable<any, string>,
	depot?: number | undefined | null | Variable<any, string>,
	productDepot?: number | undefined | null | Variable<any, string>,
	position1?: string | undefined | null | Variable<any, string>,
	position2?: string | undefined | null | Variable<any, string>,
	position3?: string | undefined | null | Variable<any, string>,
	expirationDate?: ValueTypes["DateTimeAsString"] | undefined | null | Variable<any, string>,
	batch?: string | undefined | null | Variable<any, string>,
	locked?: boolean | undefined | null | Variable<any, string>
};
	["updateClearanceItem"]: AliasType<{
	data?:ValueTypes["ClearanceItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createUser"]: AliasType<{
	data?:ValueTypes["User"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateUser"]: AliasType<{
	data?:ValueTypes["User"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteUser"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createUserGroup"]: AliasType<{
	data?:ValueTypes["UserGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateUserGroup"]: AliasType<{
	data?:ValueTypes["UserGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteUserGroup"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCustomer"]: AliasType<{
	data?:ValueTypes["Customer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCustomer"]: AliasType<{
	data?:ValueTypes["Customer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCustomer"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createAddress"]: AliasType<{
	data?:ValueTypes["Address"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateAddress"]: AliasType<{
	data?:ValueTypes["Address"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteAddress"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCheckout"]: AliasType<{
	data?:ValueTypes["Checkout"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCheckout"]: AliasType<{
	data?:ValueTypes["Checkout"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCheckout"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCheckoutExtraOperation"]: AliasType<{
	data?:ValueTypes["CheckoutExtraOperation"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCheckoutExtraOperation"]: AliasType<{
	data?:ValueTypes["CheckoutExtraOperation"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCheckoutExtraOperation"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCheckoutClosing"]: AliasType<{
	data?:ValueTypes["CheckoutClosing"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCheckoutClosing"]: AliasType<{
	data?:ValueTypes["CheckoutClosing"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCheckoutClosing"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createVat"]: AliasType<{
	data?:ValueTypes["Vat"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateVat"]: AliasType<{
	data?:ValueTypes["Vat"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteVat"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createDepot"]: AliasType<{
	data?:ValueTypes["Depot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateDepot"]: AliasType<{
	data?:ValueTypes["Depot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteDepot"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createSupplier"]: AliasType<{
	data?:ValueTypes["Supplier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateSupplier"]: AliasType<{
	data?:ValueTypes["Supplier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteSupplier"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProducer"]: AliasType<{
	data?:ValueTypes["Producer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProducer"]: AliasType<{
	data?:ValueTypes["Producer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProducer"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportStock"]: AliasType<{
	data?:ValueTypes["Stock"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportSale"]: AliasType<{
	data?:ValueTypes["Sale"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportPurchase"]: AliasType<{
	data?:ValueTypes["Purchase"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportOrder"]: AliasType<{
	data?:ValueTypes["exportOrder"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportInventory"]: AliasType<{
	data?:ValueTypes["Inventory"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateExportInventory"]: AliasType<{
	data?:ValueTypes["Inventory"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["refreshExportInventory"]: AliasType<{
	data?:ValueTypes["Inventory"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExport"]: AliasType<{
	data?:ValueTypes["Export"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCompany"]: AliasType<{
	data?:ValueTypes["Company"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createShop"]: AliasType<{
	data?:ValueTypes["Shop"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateShop"]: AliasType<{
	data?:ValueTypes["Shop"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteShop"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCert"]: AliasType<{
	data?:ValueTypes["Cert"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCert"]: AliasType<{
	data?:ValueTypes["Depot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCert"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createEetReceipt"]: AliasType<{
	data?:ValueTypes["Receipt"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["sendEetReceipt"]: AliasType<{
	data?:ValueTypes["Receipt"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPayment"]: AliasType<{
	data?:ValueTypes["Payment"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePayment"]: AliasType<{
	data?:ValueTypes["Payment"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePayment"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPaymentItem"]: AliasType<{
	data?:ValueTypes["PaymentItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePaymentItem"]: AliasType<{
	data?:ValueTypes["PaymentItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePaymentItem"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createDevLog"]: AliasType<{
	data?:ValueTypes["DevLog"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DevLog"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	content?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPackage"]: AliasType<{
	data?:ValueTypes["Package"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePackage"]: AliasType<{
	data?:ValueTypes["Package"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePackage"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["resetPackage"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["sendPackage"]: AliasType<{
	data?:ValueTypes["Package"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createDisposal"]: AliasType<{
	data?:ValueTypes["PackageDisposal"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateDisposal"]: AliasType<{
	data?:ValueTypes["PackageDisposal"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteDisposal"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["sendDisposal"]: AliasType<{
	data?:ValueTypes["PackageDisposal"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createFile"]: AliasType<{
	data?:ValueTypes["File"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateFile"]: AliasType<{
	data?:ValueTypes["File"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteFile"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCompanyCarrier"]: AliasType<{
	data?:ValueTypes["CompanyCarrier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCompanyCarrier"]: AliasType<{
	data?:ValueTypes["CompanyCarrier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCompanyCarrier"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createConsent"]: AliasType<{
	data?:ValueTypes["Consent"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateConsent"]: AliasType<{
	data?:ValueTypes["Consent"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteConsent"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCustomerConsent"]: AliasType<{
	data?:ValueTypes["CustomerConsent"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCustomerConsent"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductDepot"]: AliasType<{
	data?:ValueTypes["ProductDepot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCategory"]: AliasType<{
	data?:ValueTypes["Category"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCategory"]: AliasType<{
	data?:ValueTypes["Category"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCategory"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createParameter"]: AliasType<{
	data?:ValueTypes["Parameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateParameter"]: AliasType<{
	data?:ValueTypes["Parameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteParameter"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createOrderGroup"]: AliasType<{
	data?:ValueTypes["OrderGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateOrderGroup"]: AliasType<{
	data?:ValueTypes["OrderGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteOrderGroup"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createVoucher"]: AliasType<{
	data?:ValueTypes["Voucher"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateVoucher"]: AliasType<{
	data?:ValueTypes["Voucher"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteVoucher"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPricePriceLevel"]: AliasType<{
	data?:ValueTypes["PriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePriceLevel"]: AliasType<{
	data?:ValueTypes["PriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePriceLevel"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductParameter"]: AliasType<{
	data?:ValueTypes["ProductParameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductParameter"]: AliasType<{
	data?:ValueTypes["ProductParameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductParameter"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductPriceLevel"]: AliasType<{
	data?:ValueTypes["ProductPriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductPriceLevel"]: AliasType<{
	data?:ValueTypes["ProductPriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductPriceLevel"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createTag"]: AliasType<{
	data?:ValueTypes["Tag"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateTag"]: AliasType<{
	data?:ValueTypes["Tag"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteTag"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductPack"]: AliasType<{
	data?:ValueTypes["ProductPack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductPack"]: AliasType<{
	data?:ValueTypes["ProductPack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductPack"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPurchaseOrderItem_"]: {
	product: number | Variable<any, string>,
	currency: string | Variable<any, string>,
	quantity: number | Variable<any, string>,
	purchasePrice?: number | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	externalId?: string | undefined | null | Variable<any, string>
};
	["createPurchaseOrder"]: AliasType<{
	data?:ValueTypes["PurchaseOrder"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePurchaseOrder"]: AliasType<{
	data?:ValueTypes["PurchaseOrder"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePurchaseOrder"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPurchaseOrderItem"]: AliasType<{
	data?:ValueTypes["PurchaseOrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePurchaseOrderItem"]: AliasType<{
	data?:ValueTypes["PurchaseOrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePurchaseOrderItem"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ID"]:unknown
  }

export type ResolverInputTypes = {
    ["schema"]: AliasType<{
	query?:ResolverInputTypes["RootSchemaQuery"],
	mutation?:ResolverInputTypes["RootSchemaMutation"],
		__typename?: boolean | `@${string}`
}>;
	["RootSchemaQuery"]: AliasType<{
user?: [{	id: number},ResolverInputTypes["user"]],
	userMyProfile?:ResolverInputTypes["userMyProfile"],
users?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["userFilters"] | undefined | null},ResolverInputTypes["users"]],
isUserEmailUnique?: [{	email: string},ResolverInputTypes["isUserEmailUnique"]],
userGroup?: [{	id: number},ResolverInputTypes["userGroup"]],
userGroups?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["userGroupFilters"] | undefined | null},ResolverInputTypes["userGroups"]],
	roles?:ResolverInputTypes["Role"],
product?: [{	id: number},ResolverInputTypes["product"]],
products?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["productFilters"] | undefined | null,	currency?: string | undefined | null,	currencyDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null},ResolverInputTypes["products"]],
productPurchasePrice?: [{	id: number,	depot: number,	quantity: number},ResolverInputTypes["productPurchasePrice"]],
productSellItems?: [{	product: number,	depots?: Array<number | undefined | null> | undefined | null,	checkout?: number | undefined | null},ResolverInputTypes["productSellItems"]],
productMovePacks?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["productMovePackFilters"] | undefined | null},ResolverInputTypes["productMovePacks"]],
productMoves?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["productMoveFilters"] | undefined | null},ResolverInputTypes["productMoves"]],
productMovePack?: [{	id: number},ResolverInputTypes["productMovePack"]],
institution?: [{	id: number},ResolverInputTypes["institution"]],
institutions?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["institutionFilters"] | undefined | null},ResolverInputTypes["institutions"]],
order?: [{	id: number},ResolverInputTypes["order"]],
orders?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["orderFilters"] | undefined | null},ResolverInputTypes["orders"]],
soldItems?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["soldItemFilters"] | undefined | null},ResolverInputTypes["soldItems"]],
orderItems?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["orderItemFilters"] | undefined | null},ResolverInputTypes["orderItems"]],
orderItem?: [{	id: number},ResolverInputTypes["orderItem"]],
customer?: [{	id: string},ResolverInputTypes["customer"]],
customers?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["customerFilters"] | undefined | null},ResolverInputTypes["customers"]],
address?: [{	id: number},ResolverInputTypes["address"]],
addresses?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["addressesFilters"] | undefined | null},ResolverInputTypes["addresses"]],
checkout?: [{	id: number},ResolverInputTypes["checkout"]],
checkouts?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["checkoutFilters"] | undefined | null},ResolverInputTypes["checkouts"]],
	eventTypes?:ResolverInputTypes["eventTypes"],
consent?: [{	id: number},ResolverInputTypes["consent"]],
consents?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["consentsFilters"] | undefined | null},ResolverInputTypes["consents"]],
checkoutExtraOperation?: [{	id: number},ResolverInputTypes["checkoutExtraOperation"]],
checkoutExtraOperations?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["checkoutExtraOperationFilters"] | undefined | null},ResolverInputTypes["checkoutExtraOperations"]],
checkoutClosing?: [{	id: number},ResolverInputTypes["checkoutClosing"]],
checkoutClosings?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["checkoutClosingFilters"] | undefined | null},ResolverInputTypes["checkoutClosings"]],
vat?: [{	id: number},ResolverInputTypes["vat"]],
vats?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["vatFilters"] | undefined | null},ResolverInputTypes["vats"]],
depot?: [{	id: number},ResolverInputTypes["depot"]],
depots?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["depotFilters"] | undefined | null},ResolverInputTypes["depots"]],
supplier?: [{	id: number},ResolverInputTypes["supplier"]],
suppliers?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["supplierFilters"] | undefined | null},ResolverInputTypes["suppliers"]],
producer?: [{	id: number},ResolverInputTypes["producer"]],
producers?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["producerFilters"] | undefined | null},ResolverInputTypes["producers"]],
exportStocks?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["exportStockFilters"] | undefined | null},ResolverInputTypes["exportStocks"]],
exportSales?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["exportSaleFilters"] | undefined | null},ResolverInputTypes["exportSales"]],
exportPurchases?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["exportPurchaseFilters"] | undefined | null},ResolverInputTypes["exportPurchases"]],
exportOrders?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["exportOrderFilters"] | undefined | null},ResolverInputTypes["exportOrders"]],
exportInventory?: [{	id: number},ResolverInputTypes["exportInventory"]],
exportInventories?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["exportInventoryFilters"] | undefined | null},ResolverInputTypes["exportInventories"]],
export?: [{	id: number},ResolverInputTypes["export"]],
exports?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["exportFilters"] | undefined | null},ResolverInputTypes["exports"]],
exportTypes?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["exportTypeFilters"] | undefined | null},ResolverInputTypes["exportTypes"]],
shop?: [{	id: number},ResolverInputTypes["shop"]],
shops?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["shopFilters"] | undefined | null},ResolverInputTypes["shops"]],
cert?: [{	id: number},ResolverInputTypes["cert"]],
certs?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["filters"] | undefined | null},ResolverInputTypes["certs"]],
eetReceipts?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["eetReceiptFilters"] | undefined | null},ResolverInputTypes["eetReceipts"]],
payment?: [{	id: number},ResolverInputTypes["payment"]],
payments?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["paymentFilters"] | undefined | null},ResolverInputTypes["payments"]],
paymentItem?: [{	id: number},ResolverInputTypes["paymentItem"]],
paymentItems?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["paymentItemsFilters"] | undefined | null},ResolverInputTypes["paymentItems"]],
paymentTypes?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["paymentTypeFilters"] | undefined | null},ResolverInputTypes["paymentTypes"]],
processStatuses?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["processStatusesFilters"] | undefined | null},ResolverInputTypes["processStatuses"]],
carriers?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["carriersFilters"] | undefined | null},ResolverInputTypes["carriers"]],
currencies?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["currenciesFilters"] | undefined | null},ResolverInputTypes["currencies"]],
package?: [{	id: string},ResolverInputTypes["package"]],
packages?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["packageFilters"] | undefined | null},ResolverInputTypes["packages"]],
stats?: [{	filters?: ResolverInputTypes["packageStatsFilters"] | undefined | null},ResolverInputTypes["packageStats"]],
disposal?: [{	id: string},ResolverInputTypes["disposal"]],
disposals?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["disposalFilters"] | undefined | null},ResolverInputTypes["disposals"]],
productDepotMetric?: [{	id: number},ResolverInputTypes["productDepotMetric"]],
productDepotMetrics?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["productDepotMetricFilters"] | undefined | null},ResolverInputTypes["productDepotMetrics"]],
file?: [{	id: number},ResolverInputTypes["file"]],
files?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["fileFilters"] | undefined | null},ResolverInputTypes["files"]],
	nextEan?:ResolverInputTypes["nextEan"],
statsCarrierUsage?: [{	from: ResolverInputTypes["DateTimeAsString"],	to: ResolverInputTypes["DateTimeAsString"],	checkout?: number | undefined | null,	status?: string | undefined | null},ResolverInputTypes["statsCarrierUsage"]],
statsPaymentSales?: [{	from: ResolverInputTypes["DateTimeAsString"],	to: ResolverInputTypes["DateTimeAsString"],	checkout?: number | undefined | null,	status?: string | undefined | null},ResolverInputTypes["statsPaymentSales"]],
statsBestsellers?: [{	from: ResolverInputTypes["DateTimeAsString"],	to: ResolverInputTypes["DateTimeAsString"],	checkout?: number | undefined | null,	status?: string | undefined | null,	results?: number | undefined | null,	sort?: ResolverInputTypes["statsBestsellersSort"] | undefined | null},ResolverInputTypes["statsBestsellers"]],
companyCarrier?: [{	id: string},ResolverInputTypes["companyCarrier"]],
companyCarriers?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["companyCarrierFilters"] | undefined | null},ResolverInputTypes["companyCarriers"]],
category?: [{	id: number},ResolverInputTypes["category"]],
categories?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["categoryFilters"] | undefined | null},ResolverInputTypes["categories"]],
parameter?: [{	id: number},ResolverInputTypes["parameter"]],
parameters?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["parametersFilters"] | undefined | null},ResolverInputTypes["parameters"]],
orderGroup?: [{	id: number},ResolverInputTypes["orderGroup"]],
orderGroups?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["orderGroupFilters"] | undefined | null},ResolverInputTypes["orderGroups"]],
voucher?: [{	id: number},ResolverInputTypes["voucher"]],
vouchers?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["voucherFilters"] | undefined | null},ResolverInputTypes["vouchers"]],
productPrices?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["productPriceFilters"] | undefined | null},ResolverInputTypes["productPrices"]],
priceLevel?: [{	id: number},ResolverInputTypes["priceLevel"]],
priceLevels?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["priceLevelFilters"] | undefined | null},ResolverInputTypes["priceLevels"]],
productParameter?: [{	id: number},ResolverInputTypes["productParameter"]],
productParameters?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["productParameterFilters"] | undefined | null},ResolverInputTypes["productParameters"]],
productPriceLevel?: [{	id: number},ResolverInputTypes["productPriceLevel"]],
productPriceLevels?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["productPriceLevelFilters"] | undefined | null},ResolverInputTypes["productPriceLevels"]],
tag?: [{	id: number},ResolverInputTypes["tag"]],
tags?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["tagFilters"] | undefined | null},ResolverInputTypes["tags"]],
tagTypes?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["tagTypeFilters"] | undefined | null},ResolverInputTypes["tagTypes"]],
productPack?: [{	id: number},ResolverInputTypes["productPack"]],
productPacks?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["productPackFilters"] | undefined | null},ResolverInputTypes["productPacks"]],
purchaseOrder?: [{	id: number},ResolverInputTypes["purchaseOrder"]],
purchaseOrders?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["purchaseOrderFilters"] | undefined | null},ResolverInputTypes["purchaseOrders"]],
purchaseOrderItem?: [{	id: number},ResolverInputTypes["purchaseOrderItem"]],
purchaseOrderItems?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["purchaseOrderItemFilters"] | undefined | null},ResolverInputTypes["purchaseOrderItems"]],
purchaseOrderStatuses?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["purchaseOrderStatusesFilters"] | undefined | null},ResolverInputTypes["purchaseOrderStatuses"]],
modules?: [{	page?: number | undefined | null,	sort?: string | undefined | null,	direction?: string | undefined | null,	filters?: ResolverInputTypes["modulesFilters"] | undefined | null},ResolverInputTypes["modules"]],
		__typename?: boolean | `@${string}`
}>;
	["user"]: AliasType<{
	data?:ResolverInputTypes["User"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["User"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	groups?:ResolverInputTypes["UserGroup"],
	roles?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	pin?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	customers?:ResolverInputTypes["Customer"],
	checkouts?:ResolverInputTypes["Checkout"],
	depots?:ResolverInputTypes["Depot"],
	locale?:boolean | `@${string}`,
	deletable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserGroup"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["Company"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	ic?:boolean | `@${string}`,
	dic?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	zip?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	currency?:ResolverInputTypes["Currency"],
	registrationNote?:boolean | `@${string}`,
	nextEan?:boolean | `@${string}`,
	billLogo?:boolean | `@${string}`,
	parent?:ResolverInputTypes["Company"],
	children?:ResolverInputTypes["Company"],
	carrierRelations?:ResolverInputTypes["CompanyCarrier"],
	moduleRelations?:ResolverInputTypes["CompanyModule"],
	payments?:ResolverInputTypes["Payment"],
	defaultVoucherValidity?:boolean | `@${string}`,
	pickingOnlyOneDepot?:boolean | `@${string}`,
	customOptions?:boolean | `@${string}`,
	batchExpirationMode?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	purchasePriceWithVat?:boolean | `@${string}`,
	tariff?:ResolverInputTypes["Tariff"],
	tariffExpirationDate?:boolean | `@${string}`,
	enabledLocking?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Currency"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	ratio?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompanyCarrier"]: AliasType<{
	id?:boolean | `@${string}`,
	enable?:boolean | `@${string}`,
	options?:boolean | `@${string}`,
	carrier?:ResolverInputTypes["Carrier"],
	checkout?:ResolverInputTypes["Checkout"],
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Carrier"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	tariffs?:ResolverInputTypes["CarrierTariff"],
	requiredShippingAddress?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CarrierTariff"]: AliasType<{
	id?:boolean | `@${string}`,
	const?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	cod?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Checkout"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	nextReservationNumber?:boolean | `@${string}`,
	nextBillNumber?:boolean | `@${string}`,
	billFooter?:boolean | `@${string}`,
	payments?:ResolverInputTypes["Payment"],
	depots?:ResolverInputTypes["Depot"],
	returnsDepot?:ResolverInputTypes["Depot"],
	currentClosing?:ResolverInputTypes["CheckoutClosing"],
	eetId?:boolean | `@${string}`,
	eetEnable?:boolean | `@${string}`,
	eetPlayground?:boolean | `@${string}`,
	eetVerificationMode?:boolean | `@${string}`,
	billWidth?:boolean | `@${string}`,
	billFontSize?:boolean | `@${string}`,
	billFontWeight?:boolean | `@${string}`,
	eventUrl?:boolean | `@${string}`,
	eventTypes?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	negativeReservation?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	users?:ResolverInputTypes["User"],
	autoPicking?:boolean | `@${string}`,
	autoPacking?:boolean | `@${string}`,
	autoDispatched?:boolean | `@${string}`,
	institution?:ResolverInputTypes["Institution"],
	position?:boolean | `@${string}`,
	deletable?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Payment"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	eetEnable?:boolean | `@${string}`,
	/** Expedovat i nezaplacené objednávky */
	dispatchUnpaid?:boolean | `@${string}`,
	type?:ResolverInputTypes["PaymentType"],
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["PaymentType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Depot"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	emailIn?:boolean | `@${string}`,
	unavailablesUrl?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	companyCarriers?:ResolverInputTypes["CompanyCarrier"],
	checkouts?:ResolverInputTypes["Checkout"],
	institution?:ResolverInputTypes["Institution"],
	users?:ResolverInputTypes["User"],
	position?:boolean | `@${string}`,
	deletable?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Institution"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	checkouts?:ResolverInputTypes["Checkout"],
	depots?:ResolverInputTypes["Depot"],
		__typename?: boolean | `@${string}`
}>;
	/** Representation of date and time in "Y-m-d H:i:s" format */
["DateTime"]:unknown;
	["CheckoutClosing"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	checkout?:ResolverInputTypes["Checkout"],
	dateOpen?:boolean | `@${string}`,
	amountOpen?:boolean | `@${string}`,
	amountRealOpen?:boolean | `@${string}`,
	userOpen?:ResolverInputTypes["User"],
	noteOpen?:boolean | `@${string}`,
	dateClosed?:boolean | `@${string}`,
	amountClosed?:boolean | `@${string}`,
	amountRealClosed?:boolean | `@${string}`,
	userClosed?:ResolverInputTypes["User"],
	noteClosed?:boolean | `@${string}`,
	orders?:ResolverInputTypes["Order"],
	profit?:boolean | `@${string}`,
	vatAllocations?:ResolverInputTypes["VatAllocation"],
	extraOperations?:ResolverInputTypes["CheckoutExtraOperation"],
	billUrl?:boolean | `@${string}`,
	enumeration?:boolean | `@${string}`,
	paymentSum?:ResolverInputTypes["paymentSum"],
		__typename?: boolean | `@${string}`
}>;
	["Order"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	status?:ResolverInputTypes["OrderStatus"],
	reservationNumber?:boolean | `@${string}`,
	billNumber?:boolean | `@${string}`,
	vs?:boolean | `@${string}`,
	dateCreated?:boolean | `@${string}`,
	dateBill?:boolean | `@${string}`,
	dateExpedition?:boolean | `@${string}`,
	dateDue?:boolean | `@${string}`,
	dateTax?:boolean | `@${string}`,
	items?:ResolverInputTypes["OrderItem"],
	paymentItems?:ResolverInputTypes["PaymentItem"],
	checkout?:ResolverInputTypes["Checkout"],
	checkoutClosing?:ResolverInputTypes["CheckoutClosing"],
	customer?:ResolverInputTypes["Customer"],
	note?:boolean | `@${string}`,
	privateNote?:boolean | `@${string}`,
	invoiceAddress?:ResolverInputTypes["Address"],
	shippingAddress?:ResolverInputTypes["Address"],
	relatedParent?:ResolverInputTypes["Order"],
	rounding?:boolean | `@${string}`,
	eetReceipt?:ResolverInputTypes["Receipt"],
	deleted?:boolean | `@${string}`,
	priceAll?:boolean | `@${string}`,
	priceAllWithoutVat?:boolean | `@${string}`,
	profit?:boolean | `@${string}`,
	vatAllocations?:ResolverInputTypes["VatAllocation"],
	/** DEPRECATED - Url PDF účtenky */
	billUrl?:boolean | `@${string}`,
	/** Url PDF faktury */
	invoiceUrl?:boolean | `@${string}`,
	/** Url PDF objednávky */
	reservationUrl?:boolean | `@${string}`,
	/** Url PDF účtenky */
	invoiceReceiptUrl?:boolean | `@${string}`,
	/** Url PDF účtenky-rezervace */
	reservationReceiptUrl?:boolean | `@${string}`,
	processStatus?:ResolverInputTypes["ProcessStatus"],
	processStatusUpdated?:boolean | `@${string}`,
	processStatusRelation?:ResolverInputTypes["OrderProcessStatus"],
	processStatusRelations?:ResolverInputTypes["OrderProcessStatus"],
	carrier?:ResolverInputTypes["Carrier"],
	packages?:ResolverInputTypes["Package"],
	boxes?:boolean | `@${string}`,
	isPaid?:boolean | `@${string}`,
	currency?:ResolverInputTypes["Currency"],
	files?:ResolverInputTypes["File"],
	quantityUnavailable?:boolean | `@${string}`,
	createdBy?:ResolverInputTypes["User"],
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
	movePacks?:ResolverInputTypes["ProductMovePack"],
	depots?:ResolverInputTypes["Depot"],
	isEditable?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Externí číslo */
	externalReference?:boolean | `@${string}`,
	group?:ResolverInputTypes["OrderGroup"],
	groupPosition?:boolean | `@${string}`,
	clearanceItems?:ResolverInputTypes["ClearanceItem"],
	/** Tagy */
	tags?:ResolverInputTypes["Tag"],
	/** Priorita */
	priority?:boolean | `@${string}`,
	/** Uzamčena */
	locked?:boolean | `@${string}`,
	/** Od kdy uzamčena */
	dateLocked?:boolean | `@${string}`,
	/** Kým uzamčena */
	lockedBy?:ResolverInputTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["OrderStatus"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OrderItem"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	ean?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
	sale?:boolean | `@${string}`,
	price?:boolean | `@${string}`,
	priceWithoutVat?:boolean | `@${string}`,
	priceAll?:boolean | `@${string}`,
	priceAllWithoutVat?:boolean | `@${string}`,
	vat?:ResolverInputTypes["Vat"],
	product?:ResolverInputTypes["Product"],
	serial?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	batch?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	profit?:boolean | `@${string}`,
	isForSubsequentSettlement?:boolean | `@${string}`,
	picked?:boolean | `@${string}`,
	packed?:boolean | `@${string}`,
	quantityUnavailable?:boolean | `@${string}`,
	moves?:ResolverInputTypes["ProductMove"],
	clearanceItems?:ResolverInputTypes["ClearanceItem"],
	voucher?:ResolverInputTypes["Voucher"],
	order?:ResolverInputTypes["Order"],
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Vat"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	percent?:boolean | `@${string}`,
	default?:boolean | `@${string}`,
	coefficient?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Representation of date and time in same string format as PHP DateTime class. */
["DateTimeAsString"]:unknown;
	["Product"]: AliasType<{
	id?:boolean | `@${string}`,
	/** Název */
	name?:boolean | `@${string}`,
	/** Název včetně názvu rodičovského produktu */
	fullName?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean2?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean3?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean4?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean5?:boolean | `@${string}`,
	/** Kód */
	code?:boolean | `@${string}`,
	/** Kód2 */
	code2?:boolean | `@${string}`,
	/** Kód3 */
	code3?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Prodejní cena */
	sellPrice?:boolean | `@${string}`,
	/** Prodejní cena bez DPH */
	sellPriceWithoutVat?:boolean | `@${string}`,
	/** Cena před slevou */
	beforeSellPrice?:boolean | `@${string}`,
	/** Aktuální prodejní cena - včetně započtených akčních cen */
	actualSellPrice?:boolean | `@${string}`,
	/** Aktuální prodejní cena bez DPH */
	actualSellPriceWithoutVat?:boolean | `@${string}`,
	/** Aktuální cena před slevou - včetně započtených akčních cen */
	actualBeforeSellPrice?:boolean | `@${string}`,
	/** Výchozí nákupní cena */
	purchasePrice?:boolean | `@${string}`,
	/** Výchozí nákupní měna */
	purchaseCurrency?:ResolverInputTypes["Currency"],
	/** Váha */
	weight?:boolean | `@${string}`,
	/** Rozměr X */
	dimensionX?:boolean | `@${string}`,
	/** Rozměr Y */
	dimensionY?:boolean | `@${string}`,
	/** Rozměr Z */
	dimensionZ?:boolean | `@${string}`,
	/** Země výroby */
	originCountry?:boolean | `@${string}`,
	/** HS kod */
	hsCode?:boolean | `@${string}`,
	/** Je produkt aktnivní? */
	enabled?:boolean | `@${string}`,
	/** DPH */
	vat?:ResolverInputTypes["Vat"],
	/** Výrobce */
	producer?:ResolverInputTypes["Producer"],
	/** Výchozí dodavatel */
	supplier?:ResolverInputTypes["Supplier"],
	/** Rodičovský produkt */
	parent?:ResolverInputTypes["Product"],
	/** Potomci / varianty produktu */
	children?:ResolverInputTypes["Product"],
	/** Deprecated: používejte productDepots */
	depots?:ResolverInputTypes["ProductDepot"],
	/** Skladové zásoby */
	productDepots?:ResolverInputTypes["ProductDepot"],
	/** Produkt je položka pro následné uplatnění (např. kupón) - pro EET */
	isForSubsequentSettlement?:boolean | `@${string}`,
	/** Hlavní obrázek */
	mainImage?:ResolverInputTypes["File"],
	/** Obrázky */
	images?:ResolverInputTypes["File"],
	/** Soubory (mimo obrázků) */
	files?:ResolverInputTypes["File"],
	/** Jedná se o set produktů (virtuální produkt) */
	isBundle?:boolean | `@${string}`,
	/** Křehký */
	isFragile?:boolean | `@${string}`,
	/** Nadrozměrný */
	isOversize?:boolean | `@${string}`,
	bundleParents?:ResolverInputTypes["ProductBundle"],
	bundleChildren?:ResolverInputTypes["ProductBundle"],
	/** Poznámka */
	note?:boolean | `@${string}`,
	/** Popis */
	description?:boolean | `@${string}`,
	/** Krátký popis */
	perex?:boolean | `@${string}`,
	/** Cokoli... */
	customData?:boolean | `@${string}`,
	/** Akční ceny */
	advancedPrices?:ResolverInputTypes["ProductPrice"],
	/** Počet nedostupných kusů v rezervaci */
	quantityUnavailable?:boolean | `@${string}`,
	/** Počet kusů skladem a všech skladech */
	quantityStock?:boolean | `@${string}`,
	/** Počet dostupných kusů a všech skladech */
	quantityAvailable?:boolean | `@${string}`,
	/** Počet kusů v rezervaci na všech skladech */
	quantityReservation?:boolean | `@${string}`,
	/** Počet kusů objednaný od dodavatele */
	quantityPurchase?:boolean | `@${string}`,
	/** Kategorie */
	categories?:ResolverInputTypes["Category"],
	/** Hlavní kategorie */
	mainCategory?:ResolverInputTypes["Category"],
	company?:ResolverInputTypes["Company"],
	/** Počty */
	quantities?:ResolverInputTypes["Quantity"],
	/** Metriky */
	metrics?:ResolverInputTypes["ProductDepotMetric"],
	/** Balení/Kartony */
	packs?:ResolverInputTypes["ProductPack"],
	/** Relace ProductParameter */
	productParameters?:ResolverInputTypes["ProductParameter"],
	/** Relace ProductPriceLevel */
	productPriceLevels?:ResolverInputTypes["ProductPriceLevel"],
	/** Tagy */
	tags?:ResolverInputTypes["Tag"],
	/** Položky k prodeji: jednotlivé expirace a šarže */
	sellItems?:ResolverInputTypes["SellItem"],
	/** Deprectable - use deletable. */
	isDeletable?:boolean | `@${string}`,
	/** Lze smazat */
	deletable?:boolean | `@${string}`,
	/** Eviduje expirace a šarže */
	enabledBatchExpiration?:boolean | `@${string}`,
	/** Eviduje sériová čísla */
	requiredSerialNumbers?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Producer"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["Supplier"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	deletable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductDepot"]: AliasType<{
	id?:boolean | `@${string}`,
	depot?:ResolverInputTypes["Depot"],
	product?:ResolverInputTypes["Product"],
	supplier?:ResolverInputTypes["Supplier"],
	purchasePrice?:boolean | `@${string}`,
	quantityStock?:boolean | `@${string}`,
	quantityReservation?:boolean | `@${string}`,
	quantityAvailable?:boolean | `@${string}`,
	quantityUnavailable?:boolean | `@${string}`,
	inventoryQuantityStock?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	batch?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	position1?:boolean | `@${string}`,
	position2?:boolean | `@${string}`,
	position3?:boolean | `@${string}`,
	clearanceItemId?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["File"]: AliasType<{
	id?:boolean | `@${string}`,
	originalFilename?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	main?:boolean | `@${string}`,
	mimeType?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	product?:ResolverInputTypes["Product"],
	order?:ResolverInputTypes["Order"],
	thumbnails?:ResolverInputTypes["FileThumbnail"],
		__typename?: boolean | `@${string}`
}>;
	["FileThumbnail"]: AliasType<{
	format?:boolean | `@${string}`,
	mimeType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductBundle"]: AliasType<{
	id?:boolean | `@${string}`,
	parent?:ResolverInputTypes["Product"],
	child?:ResolverInputTypes["Product"],
	/** Množství */
	quantity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductPrice"]: AliasType<{
	id?:boolean | `@${string}`,
	product?:ResolverInputTypes["Product"],
	sellPrice?:boolean | `@${string}`,
	available?:boolean | `@${string}`,
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	isActual?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Category"]: AliasType<{
	id?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	parent?:ResolverInputTypes["Category"],
	children?:ResolverInputTypes["Category"],
	hasChildren?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	treePath?:boolean | `@${string}`,
	/** Tagy */
	tags?:ResolverInputTypes["Tag"],
		__typename?: boolean | `@${string}`
}>;
	["Tag"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Quantity"]: AliasType<{
	depot?:ResolverInputTypes["Depot"],
	quantityAvailable?:boolean | `@${string}`,
	quantityReservation?:boolean | `@${string}`,
	quantityStock?:boolean | `@${string}`,
	quantityPurchase?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductDepotMetric"]: AliasType<{
	id?:boolean | `@${string}`,
	depot?:ResolverInputTypes["Depot"],
	product?:ResolverInputTypes["Product"],
	quantityMinimum?:boolean | `@${string}`,
	quantityOptimum?:boolean | `@${string}`,
	quantityMaximum?:boolean | `@${string}`,
	quantityStock?:boolean | `@${string}`,
	quantityPurchase?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductPack"]: AliasType<{
	id?:boolean | `@${string}`,
	/** Unikátní Ean 13 */
	ean?:boolean | `@${string}`,
	/** Kód */
	code?:boolean | `@${string}`,
	/** Poznámka */
	note?:boolean | `@${string}`,
	/** Množství */
	quantity?:boolean | `@${string}`,
	/** Produkt.id */
	product?:ResolverInputTypes["Product"],
	/** Externí ID */
	externalId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductParameter"]: AliasType<{
	id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	product?:ResolverInputTypes["Product"],
	parameter?:ResolverInputTypes["Parameter"],
		__typename?: boolean | `@${string}`
}>;
	/** String or Array */
["StringOrArray"]:unknown;
	["Parameter"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	enumValues?:boolean | `@${string}`,
	unit?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPriceLevel"]: AliasType<{
	id?:boolean | `@${string}`,
	sellPrice?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	product?:ResolverInputTypes["Product"],
	priceLevel?:ResolverInputTypes["PriceLevel"],
		__typename?: boolean | `@${string}`
}>;
	["PriceLevel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	isPercentage?:boolean | `@${string}`,
	percent?:boolean | `@${string}`,
	withVat?:boolean | `@${string}`,
	currency?:ResolverInputTypes["Currency"],
	externalId?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["SellItem"]: AliasType<{
	id?:boolean | `@${string}`,
	product?:ResolverInputTypes["Product"],
	quantityStock?:boolean | `@${string}`,
	quantityReservation?:boolean | `@${string}`,
	quantityAvailable?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	batch?:boolean | `@${string}`,
	productDepots?:ResolverInputTypes["ProductDepot"],
		__typename?: boolean | `@${string}`
}>;
	["ProductMove"]: AliasType<{
	id?:boolean | `@${string}`,
	pack?:ResolverInputTypes["ProductMovePack"],
	productDepotFrom?:ResolverInputTypes["ProductDepot"],
	productDepotFromQuantityStock?:boolean | `@${string}`,
	productDepotTo?:ResolverInputTypes["ProductDepot"],
	productDepotToQuantityStock?:boolean | `@${string}`,
	product?:ResolverInputTypes["Product"],
	amount?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
	deleted?:boolean | `@${string}`,
	quantityUnavailable?:boolean | `@${string}`,
	createdBy?:ResolverInputTypes["User"],
	orderItem?:ResolverInputTypes["OrderItem"],
	picked?:boolean | `@${string}`,
	packed?:boolean | `@${string}`,
	locked?:boolean | `@${string}`,
	purchasePrice?:boolean | `@${string}`,
	purchasePriceAll?:boolean | `@${string}`,
	purchasePriceWithVat?:boolean | `@${string}`,
	purchasePriceAllWithVat?:boolean | `@${string}`,
	purchaseOrderItem?:ResolverInputTypes["PurchaseOrderItem"],
	deletable?:boolean | `@${string}`,
	serialNumbers?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductMovePack"]: AliasType<{
	id?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	externalReference?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	type?:ResolverInputTypes["ProductMoveType"],
	purpose?:ResolverInputTypes["ProductMovePurpose"],
	moves?:ResolverInputTypes["ProductMove"],
	note?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	pdfWOPricesUrl?:boolean | `@${string}`,
	dateCreated?:boolean | `@${string}`,
	order?:ResolverInputTypes["Order"],
	checkout?:ResolverInputTypes["Checkout"],
	depotFrom?:ResolverInputTypes["Depot"],
	depotTo?:ResolverInputTypes["Depot"],
	incidentalCosts?:boolean | `@${string}`,
	purchasePrice?:boolean | `@${string}`,
	purchasePriceWithVat?:boolean | `@${string}`,
	purchaseOrder?:ResolverInputTypes["PurchaseOrder"],
	createdBy?:ResolverInputTypes["User"],
	files?:ResolverInputTypes["File"],
	/** Tagy */
	tags?:ResolverInputTypes["Tag"],
	company?:ResolverInputTypes["Company"],
	deletable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductMoveType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductMovePurpose"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PurchaseOrder"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	status?:ResolverInputTypes["PurchaseOrderStatus"],
	supplier?:ResolverInputTypes["Supplier"],
	depot?:ResolverInputTypes["Depot"],
	items?:ResolverInputTypes["PurchaseOrderItem"],
	files?:ResolverInputTypes["File"],
	/** Tagy */
	tags?:ResolverInputTypes["Tag"],
	number?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	privateNote?:boolean | `@${string}`,
	dateEstimatedArrival?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Externí reference */
	externalReference?:boolean | `@${string}`,
	/** Reference dodavatele */
	supplierReference?:boolean | `@${string}`,
	purchasePriceAll?:boolean | `@${string}`,
	purchasePriceAllWithVat?:boolean | `@${string}`,
	productMovePacks?:ResolverInputTypes["ProductMovePack"],
	pdfUrl?:boolean | `@${string}`,
	pdfWOPricesUrl?:boolean | `@${string}`,
	excelUrl?:boolean | `@${string}`,
	excelWOPricesUrl?:boolean | `@${string}`,
	createdBy?:ResolverInputTypes["User"],
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PurchaseOrderStatus"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PurchaseOrderItem"]: AliasType<{
	id?:boolean | `@${string}`,
	purchaseOrder?:ResolverInputTypes["PurchaseOrder"],
	currency?:ResolverInputTypes["Currency"],
	product?:ResolverInputTypes["Product"],
	status?:ResolverInputTypes["PurchaseOrderStatus"],
	quantity?:boolean | `@${string}`,
	purchasePrice?:boolean | `@${string}`,
	purchasePriceAll?:boolean | `@${string}`,
	purchasePriceWithVat?:boolean | `@${string}`,
	purchasePriceAllWithVat?:boolean | `@${string}`,
	productMoves?:ResolverInputTypes["ProductMove"],
	note?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Již naskladněný počet kusů */
	quantityIn?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ClearanceItem"]: AliasType<{
	id?:boolean | `@${string}`,
	product?:ResolverInputTypes["Product"],
	amount?:boolean | `@${string}`,
	quantityStock?:boolean | `@${string}`,
	quantityReservation?:boolean | `@${string}`,
	quantityAvailable?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	batch?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	position1?:boolean | `@${string}`,
	position2?:boolean | `@${string}`,
	position3?:boolean | `@${string}`,
	picked?:boolean | `@${string}`,
	packed?:boolean | `@${string}`,
	productMoves?:ResolverInputTypes["ProductMove"],
	productDepots?:ResolverInputTypes["ProductDepot"],
	orderItems?:ResolverInputTypes["OrderItem"],
	locked?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Voucher"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	product?:ResolverInputTypes["Product"],
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	discountType?:boolean | `@${string}`,
	discountPercent?:boolean | `@${string}`,
	discountValue?:boolean | `@${string}`,
	maxUse?:boolean | `@${string}`,
	validFrom?:boolean | `@${string}`,
	validTo?:boolean | `@${string}`,
	isValid?:boolean | `@${string}`,
	used?:boolean | `@${string}`,
	paymentItems?:ResolverInputTypes["Product"],
	orderItems?:ResolverInputTypes["Product"],
	enabled?:boolean | `@${string}`,
	isPayment?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PaymentItem"]: AliasType<{
	id?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	checkout?:ResolverInputTypes["Checkout"],
	payment?:ResolverInputTypes["Payment"],
	voucher?:ResolverInputTypes["Voucher"],
	dateCreated?:boolean | `@${string}`,
	dateCancelled?:boolean | `@${string}`,
	isPaid?:boolean | `@${string}`,
	datePaid?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Customer"]: AliasType<{
	id?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	companyName?:boolean | `@${string}`,
	addresses?:ResolverInputTypes["Address"],
	wholesale?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	consentRelations?:ResolverInputTypes["CustomerConsent"],
	birthday?:boolean | `@${string}`,
	users?:ResolverInputTypes["User"],
	minExpirationDays?:boolean | `@${string}`,
	priceLevel?:ResolverInputTypes["PriceLevel"],
	/** Tagy */
	tags?:ResolverInputTypes["Tag"],
	/** Cokoli... */
	customData?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Address"]: AliasType<{
	id?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	customer?:ResolverInputTypes["Customer"],
	companyName?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	zip?:boolean | `@${string}`,
	ic?:boolean | `@${string}`,
	dic?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	isStored?:boolean | `@${string}`,
	isBilling?:boolean | `@${string}`,
	zasilkovnaAddressId?:boolean | `@${string}`,
	branchId?:boolean | `@${string}`,
	/** Externí identifikátor */
	externalId?:boolean | `@${string}`,
	/** Poznámka */
	note?:boolean | `@${string}`,
	/** Cokoli... */
	customData?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerConsent"]: AliasType<{
	id?:boolean | `@${string}`,
	customer?:ResolverInputTypes["Customer"],
	consent?:ResolverInputTypes["Consent"],
	name?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Consent"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	externalId?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	updated?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["Receipt"]: AliasType<{
	id?:boolean | `@${string}`,
	dic?:boolean | `@${string}`,
	checkoutEetId?:boolean | `@${string}`,
	shopEetId?:boolean | `@${string}`,
	playground?:boolean | `@${string}`,
	verificationMode?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	dateCreated?:boolean | `@${string}`,
	totalPrice?:boolean | `@${string}`,
	priceZeroVat?:boolean | `@${string}`,
	priceStandardVat?:boolean | `@${string}`,
	vatStandard?:boolean | `@${string}`,
	priceFirstReducedVat?:boolean | `@${string}`,
	vatFirstReduced?:boolean | `@${string}`,
	priceSecondReducedVat?:boolean | `@${string}`,
	vatSecondReduced?:boolean | `@${string}`,
	priceForSubsequentSettlement?:boolean | `@${string}`,
	priceUsedSubsequentSettlement?:boolean | `@${string}`,
	fik?:boolean | `@${string}`,
	bkp?:boolean | `@${string}`,
	pkp?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VatAllocation"]: AliasType<{
	vat?:ResolverInputTypes["Vat"],
	priceWithoutVat?:boolean | `@${string}`,
	vatPrice?:boolean | `@${string}`,
	price?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProcessStatus"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OrderProcessStatus"]: AliasType<{
	status?:ResolverInputTypes["ProcessStatus"],
	note?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	createdBy?:ResolverInputTypes["User"],
	actual?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Package"]: AliasType<{
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	carrier?:ResolverInputTypes["Carrier"],
	tariff?:ResolverInputTypes["CarrierTariff"],
	items?:ResolverInputTypes["OrderItem"],
	statuses?:ResolverInputTypes["PackageStatus"],
	ticketUrl?:boolean | `@${string}`,
	sent?:boolean | `@${string}`,
	order?:ResolverInputTypes["Order"],
	disposal?:ResolverInputTypes["PackageDisposal"],
	weight?:boolean | `@${string}`,
	weightRequired?:boolean | `@${string}`,
	dimensionsRequired?:boolean | `@${string}`,
	dimensionX?:boolean | `@${string}`,
	dimensionY?:boolean | `@${string}`,
	dimensionZ?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	clearanceItems?:ResolverInputTypes["ClearanceItem"],
		__typename?: boolean | `@${string}`
}>;
	["PackageStatus"]: AliasType<{
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	package?:ResolverInputTypes["Package"],
	created?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PackageDisposal"]: AliasType<{
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	carrier?:ResolverInputTypes["Carrier"],
	packages?:ResolverInputTypes["Package"],
	ticketUrl?:boolean | `@${string}`,
	sent?:boolean | `@${string}`,
	files?:ResolverInputTypes["File"],
		__typename?: boolean | `@${string}`
}>;
	["OrderGroup"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
	orders?:ResolverInputTypes["Order"],
	user?:ResolverInputTypes["User"],
	userPosition?:boolean | `@${string}`,
	clearanceItems?:ResolverInputTypes["ClearanceItem"],
	/** Tagy */
	tags?:ResolverInputTypes["Tag"],
		__typename?: boolean | `@${string}`
}>;
	["CheckoutExtraOperation"]: AliasType<{
	id?:boolean | `@${string}`,
	dateCreated?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	user?:ResolverInputTypes["User"],
	checkout?:ResolverInputTypes["Checkout"],
	checkoutClosing?:ResolverInputTypes["CheckoutClosing"],
		__typename?: boolean | `@${string}`
}>;
	["paymentSum"]: AliasType<{
	payment?:ResolverInputTypes["Payment"],
	count?:boolean | `@${string}`,
	sum?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompanyModule"]: AliasType<{
	id?:boolean | `@${string}`,
	module?:ResolverInputTypes["Module"],
		__typename?: boolean | `@${string}`
}>;
	["Module"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Tariff"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["userMyProfile"]: AliasType<{
	data?:ResolverInputTypes["User"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["userFilters"]: {
	pin?: string | undefined | null,
	email?: string | undefined | null,
	fulltext?: string | undefined | null,
	groups?: Array<number | undefined | null> | undefined | null,
	roles?: Array<string | undefined | null> | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	enabled?: boolean | undefined | null
};
	["users"]: AliasType<{
	items?:ResolverInputTypes["User"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Paginator"]: AliasType<{
	current?:boolean | `@${string}`,
	currentItemCount?:boolean | `@${string}`,
	endPage?:boolean | `@${string}`,
	first?:boolean | `@${string}`,
	firstItemNumber?:boolean | `@${string}`,
	firstPageInRange?:boolean | `@${string}`,
	last?:boolean | `@${string}`,
	lastItemNumber?:boolean | `@${string}`,
	lastPageInRange?:boolean | `@${string}`,
	next?:boolean | `@${string}`,
	numItemsPerPage?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	pageRange?:boolean | `@${string}`,
	startPage?:boolean | `@${string}`,
	totalCount?:boolean | `@${string}`,
	pagesInRange?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["isUserEmailUnique"]: AliasType<{
	data?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["userGroup"]: AliasType<{
	data?:ResolverInputTypes["UserGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["userGroupFilters"]: {
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["userGroups"]: AliasType<{
	items?:ResolverInputTypes["UserGroup"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Role"]: AliasType<{
	name?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["product"]: AliasType<{
	data?:ResolverInputTypes["Product"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productFilters"]: {
	id?: number | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	name?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	codes?: Array<string | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	fulltext?: string | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	metricDepots?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null,
	defaultSuppliers?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	listType?: string | undefined | null,
	availability?: string | undefined | null,
	enabled?: boolean | undefined | null,
	isBundle?: boolean | undefined | null,
	expirationDateTo?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	hasBeforeSellPrice?: boolean | undefined | null,
	hasHsCode?: boolean | undefined | null,
	createdFrom?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	updatedFrom?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null,
	categories?: Array<number | undefined | null> | undefined | null,
	metrics?: string | undefined | null,
	enabledBatchExpiration?: boolean | undefined | null,
	requiredSerialNumbers?: boolean | undefined | null,
	company?: number | undefined | null
};
	["products"]: AliasType<{
	items?:ResolverInputTypes["Product"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productPurchasePrice"]: AliasType<{
	items?:ResolverInputTypes["ProductPurchasePrice"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductPurchasePrice"]: AliasType<{
	productDepot?:ResolverInputTypes["Depot"],
	quantity?:boolean | `@${string}`,
	purchasePrice?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productSellItems"]: AliasType<{
	items?:ResolverInputTypes["SellItem"],
		__typename?: boolean | `@${string}`
}>;
	["productMovePackFilters"]: {
	fulltext?: string | undefined | null,
	type?: string | undefined | null,
	depot?: number | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	depotFrom?: number | undefined | null,
	depotTo?: number | undefined | null,
	depotsFrom?: Array<number | undefined | null> | undefined | null,
	depotsTo?: Array<number | undefined | null> | undefined | null,
	number?: number | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	withoutCheckout?: boolean | undefined | null,
	product?: number | undefined | null,
	productFulltext?: string | undefined | null,
	order?: number | undefined | null,
	orderFulltext?: string | undefined | null,
	withOrder?: boolean | undefined | null,
	createdBy?: number | undefined | null,
	created?: ResolverInputTypes["created"] | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	externalReference?: string | undefined | null,
	purchaseOrder?: number | undefined | null,
	incidentalCosts?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["created"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["productMovePacks"]: AliasType<{
	items?:ResolverInputTypes["ProductMovePack"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productMoveFilters"]: {
	product?: number | undefined | null,
	products?: Array<number | undefined | null> | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	type?: string | undefined | null,
	depotFrom?: number | undefined | null,
	depotTo?: number | undefined | null,
	createdBy?: number | undefined | null,
	created?: ResolverInputTypes["created"] | undefined | null,
	expirationDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	withoutCheckout?: boolean | undefined | null
};
	["productMoves"]: AliasType<{
	items?:ResolverInputTypes["ProductMove"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productMovePack"]: AliasType<{
	data?:ResolverInputTypes["ProductMovePack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["institution"]: AliasType<{
	data?:ResolverInputTypes["Institution"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["institutionFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["institutions"]: AliasType<{
	items?:ResolverInputTypes["Institution"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["order"]: AliasType<{
	data?:ResolverInputTypes["Order"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["orderFilters"]: {
	fulltext?: string | undefined | null,
	reservationNumber?: number | undefined | null,
	billNumber?: number | undefined | null,
	notes?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	onlyDepots?: Array<number | undefined | null> | undefined | null,
	payments?: Array<number | undefined | null> | undefined | null,
	status?: string | undefined | null,
	processStatus?: string | undefined | null,
	processStatusChange?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	processStatusUpdated?: ResolverInputTypes["processStatusUpdated"] | undefined | null,
	isPaid?: boolean | undefined | null,
	carrier?: string | undefined | null,
	carriers?: Array<string | undefined | null> | undefined | null,
	deleted?: boolean | undefined | null,
	dateCreated?: ResolverInputTypes["dateCreated"] | undefined | null,
	dateBill?: ResolverInputTypes["dateBill"] | undefined | null,
	dateExpedition?: ResolverInputTypes["dateExpedition"] | undefined | null,
	dateDue?: ResolverInputTypes["dateDue"] | undefined | null,
	dateTax?: ResolverInputTypes["dateTax"] | undefined | null,
	updated?: ResolverInputTypes["updated"] | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	box?: string | undefined | null,
	item?: string | undefined | null,
	package?: string | undefined | null,
	customer?: number | undefined | null,
	customerFulltext?: string | undefined | null,
	shippingCountries?: Array<string | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	user?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null,
	hasAvailableProducts?: boolean | undefined | null,
	hasGroup?: boolean | undefined | null,
	group?: number | undefined | null,
	groups?: Array<number | undefined | null> | undefined | null,
	createdBy?: Array<number | undefined | null> | undefined | null,
	locked?: boolean | undefined | null,
	dateLocked?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	lockedBy?: Array<number | undefined | null> | undefined | null,
	priority?: number | undefined | null
};
	["processStatusUpdated"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["dateCreated"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["dateBill"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["dateExpedition"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["dateDue"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["dateTax"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["updated"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["orders"]: AliasType<{
	items?:ResolverInputTypes["Order"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["soldItemFilters"]: {
	productFulltext?: string | undefined | null,
	customerFulltext?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	payments?: Array<number | undefined | null> | undefined | null,
	status?: string | undefined | null,
	processStatus?: string | undefined | null,
	processStatusUpdated?: ResolverInputTypes["processStatusUpdated"] | undefined | null,
	carriers?: Array<string | undefined | null> | undefined | null,
	dateCreated?: ResolverInputTypes["dateCreated"] | undefined | null,
	dateBill?: ResolverInputTypes["dateBill"] | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	customer?: number | undefined | null,
	product?: number | undefined | null,
	shippingCountries?: Array<string | undefined | null> | undefined | null,
	orderTags?: Array<number | undefined | null> | undefined | null,
	productTags?: Array<number | undefined | null> | undefined | null
};
	["soldItems"]: AliasType<{
	items?:ResolverInputTypes["SoldItem"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["SoldItem"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	ean?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
	priceAll?:boolean | `@${string}`,
	priceAllWithoutVat?:boolean | `@${string}`,
	product?:ResolverInputTypes["Product"],
	profit?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["orderItemFilters"]: {
	status?: string | undefined | null,
	processStatus?: string | undefined | null,
	order?: number | undefined | null,
	productDepot?: number | undefined | null,
	carrier?: string | undefined | null
};
	["orderItems"]: AliasType<{
	items?:ResolverInputTypes["OrderItem"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["orderItem"]: AliasType<{
	data?:ResolverInputTypes["OrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["customer"]: AliasType<{
	data?:ResolverInputTypes["Customer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["customerFilters"]: {
	externalId?: string | undefined | null,
	email?: string | undefined | null,
	fulltext?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	user?: number | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	priceLevel?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["customers"]: AliasType<{
	items?:ResolverInputTypes["Customer"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["address"]: AliasType<{
	data?:ResolverInputTypes["Address"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["addressesFilters"]: {
	customer?: number | undefined | null,
	externalId?: string | undefined | null,
	isStored?: boolean | undefined | null,
	isBilling?: boolean | undefined | null,
	ic?: string | undefined | null,
	dic?: string | undefined | null,
	phone?: string | undefined | null,
	email?: string | undefined | null
};
	["addresses"]: AliasType<{
	items?:ResolverInputTypes["Address"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["checkout"]: AliasType<{
	data?:ResolverInputTypes["Checkout"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["checkoutFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	user?: number | undefined | null
};
	["checkouts"]: AliasType<{
	items?:ResolverInputTypes["Checkout"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["eventTypes"]: AliasType<{
	items?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["consent"]: AliasType<{
	data?:ResolverInputTypes["Consent"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["consentsFilters"]: {
	name?: string | undefined | null
};
	["consents"]: AliasType<{
	items?:ResolverInputTypes["Consent"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["checkoutExtraOperation"]: AliasType<{
	data?:ResolverInputTypes["CheckoutExtraOperation"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["checkoutExtraOperationFilters"]: {
	checkout?: number | undefined | null,
	checkoutClosing?: number | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null
};
	["checkoutExtraOperations"]: AliasType<{
	items?:ResolverInputTypes["CheckoutExtraOperation"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["checkoutClosing"]: AliasType<{
	data?:ResolverInputTypes["CheckoutClosing"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["checkoutClosingFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["checkoutClosings"]: AliasType<{
	items?:ResolverInputTypes["CheckoutClosing"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["vat"]: AliasType<{
	data?:ResolverInputTypes["Vat"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["vatFilters"]: {
	name?: string | undefined | null,
	percent?: number | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["vats"]: AliasType<{
	items?:ResolverInputTypes["Vat"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["depot"]: AliasType<{
	data?:ResolverInputTypes["Depot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["depotFilters"]: {
	companies?: Array<number | undefined | null> | undefined | null,
	name?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	user?: number | undefined | null
};
	["depots"]: AliasType<{
	items?:ResolverInputTypes["Depot"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["supplier"]: AliasType<{
	data?:ResolverInputTypes["Supplier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["supplierFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["suppliers"]: AliasType<{
	items?:ResolverInputTypes["Supplier"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["producer"]: AliasType<{
	data?:ResolverInputTypes["Producer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["producerFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["producers"]: AliasType<{
	items?:ResolverInputTypes["Producer"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["exportStockFilters"]: {
	depots?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null
};
	["exportStocks"]: AliasType<{
	items?:ResolverInputTypes["Stock"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Stock"]: AliasType<{
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	depots?:ResolverInputTypes["Depot"],
	suppliers?:ResolverInputTypes["Supplier"],
	producers?:ResolverInputTypes["Producer"],
	url?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportSaleFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null
};
	["exportSales"]: AliasType<{
	items?:ResolverInputTypes["Sale"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Sale"]: AliasType<{
	id?:boolean | `@${string}`,
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	checkouts?:ResolverInputTypes["Checkout"],
	suppliers?:ResolverInputTypes["Supplier"],
	producers?:ResolverInputTypes["Producer"],
	url?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportPurchaseFilters"]: {
	depots?: Array<number | undefined | null> | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null
};
	["exportPurchases"]: AliasType<{
	items?:ResolverInputTypes["Purchase"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["Purchase"]: AliasType<{
	id?:boolean | `@${string}`,
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	depots?:ResolverInputTypes["Depot"],
	checkouts?:ResolverInputTypes["Checkout"],
	suppliers?:ResolverInputTypes["Supplier"],
	producers?:ResolverInputTypes["Producer"],
	url?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportOrderFilters"]: {
	status?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null
};
	["exportOrders"]: AliasType<{
	items?:ResolverInputTypes["exportOrder"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["exportOrder"]: AliasType<{
	id?:boolean | `@${string}`,
	dateFrom?:boolean | `@${string}`,
	dateTo?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	status?:ResolverInputTypes["OrderStatus"],
	checkouts?:ResolverInputTypes["Checkout"],
	url?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportInventory"]: AliasType<{
	data?:ResolverInputTypes["Inventory"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Inventory"]: AliasType<{
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	depots?:ResolverInputTypes["Depot"],
	suppliers?:ResolverInputTypes["Supplier"],
	producers?:ResolverInputTypes["Producer"],
	url?:boolean | `@${string}`,
	files?:ResolverInputTypes["File"],
	approved?:boolean | `@${string}`,
	rejected?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	pmpIn?:ResolverInputTypes["ProductMovePack"],
	pmpOut?:ResolverInputTypes["ProductMovePack"],
		__typename?: boolean | `@${string}`
}>;
	["exportInventoryFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null,
	approved?: boolean | undefined | null,
	rejected?: boolean | undefined | null,
	finished?: boolean | undefined | null
};
	["exportInventories"]: AliasType<{
	items?:ResolverInputTypes["Inventory"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["export"]: AliasType<{
	data?:ResolverInputTypes["Export"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Export"]: AliasType<{
	id?:boolean | `@${string}`,
	file?:ResolverInputTypes["File"],
	generated?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	type?:ResolverInputTypes["ExportType"],
	filter?:boolean | `@${string}`,
	createdBy?:ResolverInputTypes["User"],
	note?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ExportType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	format?:boolean | `@${string}`,
	group?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["exportFilters"]: {
	types?: Array<string | undefined | null> | undefined | null,
	group?: string | undefined | null
};
	["exports"]: AliasType<{
	items?:ResolverInputTypes["Export"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["exportTypeFilters"]: {
	group?: string | undefined | null
};
	["exportTypes"]: AliasType<{
	items?:ResolverInputTypes["ExportType"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["shop"]: AliasType<{
	data?:ResolverInputTypes["Shop"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Shop"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	zip?:boolean | `@${string}`,
	eetId?:boolean | `@${string}`,
	cert?:ResolverInputTypes["Cert"],
	checkouts?:ResolverInputTypes["Checkout"],
	company?:ResolverInputTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["Cert"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	publicKey?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	company?:ResolverInputTypes["Company"],
		__typename?: boolean | `@${string}`
}>;
	["shopFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["shops"]: AliasType<{
	items?:ResolverInputTypes["Shop"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["cert"]: AliasType<{
	data?:ResolverInputTypes["Cert"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["filters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["certs"]: AliasType<{
	items?:ResolverInputTypes["Cert"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["eetReceiptFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null,
	number?: number | undefined | null,
	hasFik?: boolean | undefined | null,
	playground?: boolean | undefined | null,
	verificationMode?: boolean | undefined | null
};
	["eetReceipts"]: AliasType<{
	items?:ResolverInputTypes["Receipt"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["payment"]: AliasType<{
	data?:ResolverInputTypes["Payment"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["paymentFilters"]: {
	company?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["payments"]: AliasType<{
	items?:ResolverInputTypes["Payment"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["paymentItem"]: AliasType<{
	data?:ResolverInputTypes["PaymentItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["paymentItemsFilters"]: {
	order?: number | undefined | null,
	type?: string | undefined | null,
	payment?: number | undefined | null,
	externalId?: string | undefined | null
};
	["paymentItems"]: AliasType<{
	items?:ResolverInputTypes["PaymentItem"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["paymentTypeFilters"]: {
	const?: string | undefined | null
};
	["paymentTypes"]: AliasType<{
	items?:ResolverInputTypes["PaymentType"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["processStatusesFilters"]: {
	name?: string | undefined | null
};
	["processStatuses"]: AliasType<{
	items?:ResolverInputTypes["ProcessStatus"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["carriersFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["carriers"]: AliasType<{
	items?:ResolverInputTypes["Carrier"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["currenciesFilters"]: {
	name?: string | undefined | null
};
	["currencies"]: AliasType<{
	items?:ResolverInputTypes["Currency"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["package"]: AliasType<{
	data?:ResolverInputTypes["Package"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["packageFilters"]: {
	code?: string | undefined | null,
	carrier?: string | undefined | null,
	order?: number | undefined | null,
	disposal?: number | undefined | null,
	hasDisposal?: boolean | undefined | null,
	isSent?: boolean | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	sent?: string | undefined | null
};
	["packages"]: AliasType<{
	items?:ResolverInputTypes["Package"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["packageStatsFilters"]: {
	carrier?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	fromDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	toDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["packageStats"]: AliasType<{
	items?:ResolverInputTypes["PackageStats"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["PackageStats"]: AliasType<{
	company?:ResolverInputTypes["Company"],
	processStatus?:ResolverInputTypes["ProcessStatus"],
	packageAmount?:boolean | `@${string}`,
	orderAmount?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["disposal"]: AliasType<{
	data?:ResolverInputTypes["PackageDisposal"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["disposalFilters"]: {
	carrier?: string | undefined | null
};
	["disposals"]: AliasType<{
	items?:ResolverInputTypes["PackageDisposal"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productDepotMetric"]: AliasType<{
	data?:ResolverInputTypes["ProductDepotMetric"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productDepotMetricFilters"]: {
	product?: number | undefined | null,
	depot?: number | undefined | null
};
	["productDepotMetrics"]: AliasType<{
	items?:ResolverInputTypes["ProductDepotMetric"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["file"]: AliasType<{
	data?:ResolverInputTypes["File"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["fileFilters"]: {
	product?: number | undefined | null,
	order?: number | undefined | null
};
	["files"]: AliasType<{
	items?:ResolverInputTypes["File"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["nextEan"]: AliasType<{
	data?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["statsCarrierUsage"]: AliasType<{
	items?:ResolverInputTypes["CarrierUsage"],
		__typename?: boolean | `@${string}`
}>;
	["CarrierUsage"]: AliasType<{
	amount?:boolean | `@${string}`,
	carrier?:ResolverInputTypes["Carrier"],
		__typename?: boolean | `@${string}`
}>;
	["statsPaymentSales"]: AliasType<{
	items?:ResolverInputTypes["PaymentSales"],
		__typename?: boolean | `@${string}`
}>;
	["PaymentSales"]: AliasType<{
	amount?:boolean | `@${string}`,
	sales?:ResolverInputTypes["Price"],
	payment?:ResolverInputTypes["Payment"],
		__typename?: boolean | `@${string}`
}>;
	["Price"]: AliasType<{
	value?:boolean | `@${string}`,
	currency?:ResolverInputTypes["Currency"],
		__typename?: boolean | `@${string}`
}>;
	["statsBestsellersSort"]:statsBestsellersSort;
	["statsBestsellers"]: AliasType<{
	items?:ResolverInputTypes["Bestsellers"],
		__typename?: boolean | `@${string}`
}>;
	["Bestsellers"]: AliasType<{
	amount?:boolean | `@${string}`,
	sales?:ResolverInputTypes["Price"],
	product?:ResolverInputTypes["Product"],
		__typename?: boolean | `@${string}`
}>;
	["companyCarrier"]: AliasType<{
	data?:ResolverInputTypes["CompanyCarrier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["companyCarrierFilters"]: {
	carrier?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["companyCarriers"]: AliasType<{
	items?:ResolverInputTypes["CompanyCarrier"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["category"]: AliasType<{
	data?:ResolverInputTypes["Category"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["categoryFilters"]: {
	name?: string | undefined | null,
	parent?: number | undefined | null,
	hasParent?: boolean | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["categories"]: AliasType<{
	items?:ResolverInputTypes["Category"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["parameter"]: AliasType<{
	data?:ResolverInputTypes["Parameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["parametersFilters"]: {
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["parameters"]: AliasType<{
	items?:ResolverInputTypes["Parameter"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["orderGroup"]: AliasType<{
	data?:ResolverInputTypes["OrderGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["orderGroupFilters"]: {
	companies?: Array<number | undefined | null> | undefined | null,
	hasUser?: boolean | undefined | null,
	user?: number | undefined | null,
	name?: string | undefined | null,
	processStatus?: string | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["orderGroups"]: AliasType<{
	items?:ResolverInputTypes["OrderGroup"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["voucher"]: AliasType<{
	data?:ResolverInputTypes["Voucher"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["voucherFilters"]: {
	companies?: Array<number | undefined | null> | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	externalId?: string | undefined | null,
	discountType?: string | undefined | null,
	enabled?: boolean | undefined | null,
	isPayment?: boolean | undefined | null,
	isValid?: boolean | undefined | null,
	isUsed?: boolean | undefined | null,
	validDate?: ResolverInputTypes["voucherValidFilter"] | undefined | null,
	created?: ResolverInputTypes["voucherCreatedFilter"] | undefined | null
};
	["voucherValidFilter"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["voucherCreatedFilter"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["vouchers"]: AliasType<{
	items?:ResolverInputTypes["Voucher"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productPriceFilters"]: {
	product?: number | undefined | null
};
	["productPrices"]: AliasType<{
	items?:ResolverInputTypes["ProductPrice"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["priceLevel"]: AliasType<{
	data?:ResolverInputTypes["PriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["priceLevelFilters"]: {
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	isPercentage?: boolean | undefined | null,
	withVat?: boolean | undefined | null,
	currency?: string | undefined | null
};
	["priceLevels"]: AliasType<{
	items?:ResolverInputTypes["PriceLevel"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productParameter"]: AliasType<{
	data?:ResolverInputTypes["ProductParameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productParameterFilters"]: {
	product?: number | undefined | null,
	parameter?: number | undefined | null,
	value?: string | undefined | null,
	externalId?: string | undefined | null
};
	["productParameters"]: AliasType<{
	items?:ResolverInputTypes["ProductParameter"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["productPriceLevel"]: AliasType<{
	data?:ResolverInputTypes["ProductPriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productPriceLevelFilters"]: {
	product?: number | undefined | null,
	priceLevel?: number | undefined | null,
	externalId?: string | undefined | null
};
	["productPriceLevels"]: AliasType<{
	items?:ResolverInputTypes["ProductPriceLevel"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["tag"]: AliasType<{
	data?:ResolverInputTypes["Tag"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["tagFilters"]: {
	name?: string | undefined | null,
	type?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["tags"]: AliasType<{
	items?:ResolverInputTypes["Tag"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["tagTypeFilters"]: {
	const?: string | undefined | null
};
	["tagTypes"]: AliasType<{
	items?:ResolverInputTypes["TagType"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["TagType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productPack"]: AliasType<{
	data?:ResolverInputTypes["ProductPack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["productPackFilters"]: {
	product?: number | undefined | null,
	quantity?: number | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	externalId?: string | undefined | null
};
	["productPacks"]: AliasType<{
	items?:ResolverInputTypes["ProductPack"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrder"]: AliasType<{
	data?:ResolverInputTypes["PurchaseOrder"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrderFilters"]: {
	fulltext?: string | undefined | null,
	status?: string | undefined | null,
	showStocked?: boolean | undefined | null,
	supplier?: number | undefined | null,
	depot?: number | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	number?: number | undefined | null,
	externalId?: string | undefined | null,
	externalReference?: string | undefined | null,
	supplierReference?: string | undefined | null,
	createdBy?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null,
	updated?: ResolverInputTypes["updated"] | undefined | null,
	created?: ResolverInputTypes["created"] | undefined | null,
	dateEstimatedArrival?: ResolverInputTypes["dateEstimatedArrival"] | undefined | null,
	company?: number | undefined | null
};
	["dateEstimatedArrival"]: {
	left_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	right_date?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["purchaseOrders"]: AliasType<{
	items?:ResolverInputTypes["PurchaseOrder"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrderItem"]: AliasType<{
	data?:ResolverInputTypes["PurchaseOrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrderItemFilters"]: {
	fulltext?: string | undefined | null,
	purchaseOrder?: number | undefined | null,
	depot?: number | undefined | null,
	product?: number | undefined | null,
	currency?: string | undefined | null,
	externalId?: string | undefined | null,
	status?: string | undefined | null,
	supplier?: number | undefined | null,
	company?: number | undefined | null
};
	["purchaseOrderItems"]: AliasType<{
	items?:ResolverInputTypes["PurchaseOrderItem"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["purchaseOrderStatusesFilters"]: {
	name?: string | undefined | null
};
	["purchaseOrderStatuses"]: AliasType<{
	items?:ResolverInputTypes["PurchaseOrderStatus"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["modulesFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["modules"]: AliasType<{
	items?:ResolverInputTypes["Module"],
	paginator?:ResolverInputTypes["Paginator"],
		__typename?: boolean | `@${string}`
}>;
	["RootSchemaMutation"]: AliasType<{
createProduct?: [{	name: string,	parent?: number | undefined | null,	children?: Array<number | undefined | null> | undefined | null,	producer?: number | undefined | null,	supplier?: number | undefined | null,	ean?: string | undefined | null,	ean2?: string | undefined | null,	ean3?: string | undefined | null,	ean4?: string | undefined | null,	ean5?: string | undefined | null,	code?: string | undefined | null,	code2?: string | undefined | null,	code3?: string | undefined | null,	externalId?: string | undefined | null,	sellPrice?: string | undefined | null,	purchasePrice?: string | undefined | null,	purchaseCurrency?: string | undefined | null,	beforeSellPrice?: string | undefined | null,	weight?: string | undefined | null,	dimensionX?: number | undefined | null,	dimensionY?: number | undefined | null,	dimensionZ?: number | undefined | null,	originCountry?: string | undefined | null,	hsCode?: string | undefined | null,	enabled?: boolean | undefined | null,	vat?: number | undefined | null,	isForSubsequentSettlement?: boolean | undefined | null,	note?: string | undefined | null,	description?: string | undefined | null,	perex?: string | undefined | null,	isBundle?: boolean | undefined | null,	isFragile?: boolean | undefined | null,	isOversize?: boolean | undefined | null,	customData?: string | undefined | null,	mainCategory?: number | undefined | null,	mainImage?: number | undefined | null,	categories?: Array<number | undefined | null> | undefined | null,	tags?: Array<number | undefined | null> | undefined | null,	enabledBatchExpiration?: boolean | undefined | null,	requiredSerialNumbers?: boolean | undefined | null},ResolverInputTypes["createProduct"]],
updateProduct?: [{	id: number,	name?: string | undefined | null,	parent?: number | undefined | null,	children?: Array<number | undefined | null> | undefined | null,	producer?: number | undefined | null,	supplier?: number | undefined | null,	ean?: string | undefined | null,	ean2?: string | undefined | null,	ean3?: string | undefined | null,	ean4?: string | undefined | null,	ean5?: string | undefined | null,	code?: string | undefined | null,	code2?: string | undefined | null,	code3?: string | undefined | null,	externalId?: string | undefined | null,	sellPrice?: string | undefined | null,	purchasePrice?: string | undefined | null,	purchaseCurrency?: string | undefined | null,	beforeSellPrice?: string | undefined | null,	weight?: string | undefined | null,	dimensionX?: number | undefined | null,	dimensionY?: number | undefined | null,	dimensionZ?: number | undefined | null,	originCountry?: string | undefined | null,	hsCode?: string | undefined | null,	enabled?: boolean | undefined | null,	vat?: number | undefined | null,	isForSubsequentSettlement?: boolean | undefined | null,	note?: string | undefined | null,	description?: string | undefined | null,	perex?: string | undefined | null,	isBundle?: boolean | undefined | null,	isFragile?: boolean | undefined | null,	isOversize?: boolean | undefined | null,	customData?: string | undefined | null,	mainCategory?: number | undefined | null,	mainImage?: number | undefined | null,	categories?: Array<number | undefined | null> | undefined | null,	tags?: Array<number | undefined | null> | undefined | null,	enabledBatchExpiration?: boolean | undefined | null,	requiredSerialNumbers?: boolean | undefined | null},ResolverInputTypes["updateProduct"]],
deleteProduct?: [{	id: number},ResolverInputTypes["deleteProduct"]],
refreshProductDepots?: [{	id: number},ResolverInputTypes["refreshProductDepots"]],
createProductMovePack?: [{	type: string,	externalId?: string | undefined | null,	externalReference?: string | undefined | null,	purpose?: string | undefined | null,	note?: string | undefined | null,	order?: number | undefined | null,	checkout?: number | undefined | null,	purchaseOrder?: number | undefined | null,	incidentalCosts?: number | undefined | null,	tags?: Array<number | undefined | null> | undefined | null,	moves?: Array<ResolverInputTypes["createProductMove"] | undefined | null> | undefined | null},ResolverInputTypes["createProductMovePack"]],
updateProductMovePack?: [{	id: number,	externalId?: string | undefined | null,	externalReference?: string | undefined | null,	note?: string | undefined | null,	tags?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["updateProductMovePack"]],
deleteProductMovePack?: [{	id: number},ResolverInputTypes["deleteProductMovePack"]],
updateProductMove?: [{	id: number,	note?: string | undefined | null,	serialNumbers?: Array<string | undefined | null> | undefined | null},ResolverInputTypes["updateProductMove"]],
deleteProductMove?: [{	id: number},ResolverInputTypes["deleteProductMove"]],
createProductPrice?: [{	product: number,	sellPrice?: number | undefined | null,	available?: number | undefined | null,	dateFrom?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateTo?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	note?: string | undefined | null},ResolverInputTypes["createProductPrice"]],
updateProductPrice?: [{	id: number,	product: number,	sellPrice?: number | undefined | null,	available?: number | undefined | null,	dateFrom?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateTo?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	note?: string | undefined | null},ResolverInputTypes["updateProductPrice"]],
deleteProductPrice?: [{	id: number},ResolverInputTypes["deleteProductPrice"]],
createProductBundle?: [{	parent: number,	child: number,	quantity: number},ResolverInputTypes["createProductBundle"]],
updateProductBundle?: [{	id: number,	parent?: number | undefined | null,	child?: number | undefined | null,	quantity?: number | undefined | null},ResolverInputTypes["updateProductBundle"]],
deleteProductBundle?: [{	id: number},ResolverInputTypes["deleteProductBundle"]],
createProductDepotMetric?: [{	product: number,	depot: number,	quantityMinimum?: number | undefined | null,	quantityOptimum?: number | undefined | null,	quantityMaximum?: number | undefined | null},ResolverInputTypes["createProductDepotMetric"]],
updateProductDepotMetric?: [{	id: number,	quantityMinimum?: number | undefined | null,	quantityOptimum?: number | undefined | null,	quantityMaximum?: number | undefined | null},ResolverInputTypes["updateProductDepotMetric"]],
deleteProductDepotMetric?: [{	id: number},ResolverInputTypes["deleteProductDepotMetric"]],
createInstitution?: [{	name: string,	externalId?: string | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null,	depots?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["createInstitution"]],
updateInstitution?: [{	id: number,	name?: string | undefined | null,	externalId?: string | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null,	depots?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["updateInstitution"]],
deleteInstitution?: [{	id: number},ResolverInputTypes["deleteInstitution"]],
createOrder?: [{	reservationNumber?: number | undefined | null,	billNumber?: number | undefined | null,	vs?: number | undefined | null,	status?: string | undefined | null,	dateCreated?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateBill?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateExpedition?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateDue?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateTax?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	note?: string | undefined | null,	privateNote?: string | undefined | null,	checkout: number,	customer?: number | undefined | null,	currency?: string | undefined | null,	invoiceAddress?: number | undefined | null,	shippingAddress?: number | undefined | null,	items?: Array<ResolverInputTypes["createOrderItem_"] | undefined | null> | undefined | null,	paymentItems?: Array<ResolverInputTypes["createPaymentItem_"] | undefined | null> | undefined | null,	relatedParent?: number | undefined | null,	rounding?: number | undefined | null,	processStatusRelation?: ResolverInputTypes["processStatusRelation"] | undefined | null,	carrier?: string | undefined | null,	boxes?: Array<string | undefined | null> | undefined | null,	externalId?: string | undefined | null,	group?: number | undefined | null,	groupPosition?: number | undefined | null,	tags?: Array<number | undefined | null> | undefined | null,	priority?: number | undefined | null,	externalReference?: string | undefined | null,	locked?: boolean | undefined | null},ResolverInputTypes["createOrder"]],
updateOrder?: [{	id: number,	reservationNumber?: number | undefined | null,	billNumber?: number | undefined | null,	vs?: number | undefined | null,	status?: string | undefined | null,	dateCreated?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateBill?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateExpedition?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateDue?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateTax?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	note?: string | undefined | null,	privateNote?: string | undefined | null,	checkout?: number | undefined | null,	customer?: number | undefined | null,	currency?: string | undefined | null,	invoiceAddress?: number | undefined | null,	shippingAddress?: number | undefined | null,	items?: Array<ResolverInputTypes["updateOrderItem_"] | undefined | null> | undefined | null,	paymentItems?: Array<ResolverInputTypes["updatePaymentItem_"] | undefined | null> | undefined | null,	relatedParent?: number | undefined | null,	rounding?: number | undefined | null,	processStatusRelation?: ResolverInputTypes["processStatusRelation"] | undefined | null,	carrier?: string | undefined | null,	boxes?: Array<string | undefined | null> | undefined | null,	externalId?: string | undefined | null,	group?: number | undefined | null,	groupPosition?: number | undefined | null,	tags?: Array<number | undefined | null> | undefined | null,	priority?: number | undefined | null,	externalReference?: string | undefined | null,	locked?: boolean | undefined | null},ResolverInputTypes["updateOrder"]],
deleteReservation?: [{	id: number},ResolverInputTypes["deleteReservation"]],
createOrderItem?: [{	order?: number | undefined | null,	name?: string | undefined | null,	type?: string | undefined | null,	ean?: string | undefined | null,	code?: string | undefined | null,	quantity?: number | undefined | null,	note?: string | undefined | null,	price?: number | undefined | null,	sale?: number | undefined | null,	vat?: number | undefined | null,	product?: number | undefined | null,	serial?: string | undefined | null,	expirationDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	batch?: string | undefined | null,	isForSubsequentSettlement?: boolean | undefined | null,	picked?: boolean | undefined | null,	packed?: boolean | undefined | null,	voucher?: number | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createOrderItem"]],
updateOrderItem?: [{	id: number,	name?: string | undefined | null,	type?: string | undefined | null,	ean?: string | undefined | null,	code?: string | undefined | null,	quantity?: number | undefined | null,	note?: string | undefined | null,	price?: number | undefined | null,	sale?: number | undefined | null,	vat?: number | undefined | null,	product?: number | undefined | null,	serial?: string | undefined | null,	expirationDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	batch?: string | undefined | null,	isForSubsequentSettlement?: boolean | undefined | null,	picked?: boolean | undefined | null,	packed?: boolean | undefined | null,	voucher?: number | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateOrderItem"]],
deleteOrderItem?: [{	id: number},ResolverInputTypes["deleteOrderItem"]],
updateClearanceItem?: [{	id: string,	orderItem?: number | undefined | null,	orderGroup?: number | undefined | null,	package?: number | undefined | null,	order?: number | undefined | null,	picked?: number | undefined | null,	packed?: number | undefined | null,	locations?: Array<ResolverInputTypes["updateClearanceItemLocations"] | undefined | null> | undefined | null},ResolverInputTypes["updateClearanceItem"]],
createUser?: [{	email: string,	plainPassword?: string | undefined | null,	firstName: string,	lastName: string,	phone?: string | undefined | null,	enabled?: boolean | undefined | null,	groups?: Array<number | undefined | null> | undefined | null,	roles?: Array<string | undefined | null> | undefined | null,	pin?: string | undefined | null,	externalId?: string | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null,	depots?: Array<number | undefined | null> | undefined | null,	locale?: string | undefined | null},ResolverInputTypes["createUser"]],
updateUser?: [{	id: number,	email?: string | undefined | null,	plainPassword?: string | undefined | null,	firstName?: string | undefined | null,	lastName?: string | undefined | null,	phone?: string | undefined | null,	enabled?: boolean | undefined | null,	groups?: Array<number | undefined | null> | undefined | null,	roles?: Array<string | undefined | null> | undefined | null,	pin?: string | undefined | null,	externalId?: string | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null,	depots?: Array<number | undefined | null> | undefined | null,	locale?: string | undefined | null},ResolverInputTypes["updateUser"]],
deleteUser?: [{	id: number},ResolverInputTypes["deleteUser"]],
createUserGroup?: [{	name: string,	roles?: Array<string | undefined | null> | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createUserGroup"]],
updateUserGroup?: [{	id: number,	name?: string | undefined | null,	roles?: Array<string | undefined | null> | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateUserGroup"]],
deleteUserGroup?: [{	id: number},ResolverInputTypes["deleteUserGroup"]],
createCustomer?: [{	externalId?: string | undefined | null,	email: string,	plainPassword?: string | undefined | null,	firstName?: string | undefined | null,	lastName?: string | undefined | null,	companyName?: string | undefined | null,	phone?: string | undefined | null,	wholesale?: boolean | undefined | null,	note?: string | undefined | null,	birthday?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	users?: Array<number | undefined | null> | undefined | null,	minExpirationDays?: number | undefined | null,	priceLevel?: number | undefined | null,	tags?: Array<number | undefined | null> | undefined | null,	customData?: string | undefined | null},ResolverInputTypes["createCustomer"]],
updateCustomer?: [{	id: number,	externalId?: string | undefined | null,	email?: string | undefined | null,	plainPassword?: string | undefined | null,	firstName?: string | undefined | null,	lastName?: string | undefined | null,	companyName?: string | undefined | null,	phone?: string | undefined | null,	wholesale?: boolean | undefined | null,	note?: string | undefined | null,	birthday?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	users?: Array<number | undefined | null> | undefined | null,	minExpirationDays?: number | undefined | null,	priceLevel?: number | undefined | null,	tags?: Array<number | undefined | null> | undefined | null,	customData?: string | undefined | null},ResolverInputTypes["updateCustomer"]],
deleteCustomer?: [{	id: number},ResolverInputTypes["deleteCustomer"]],
createAddress?: [{	customer?: number | undefined | null,	companyName?: string | undefined | null,	firstName?: string | undefined | null,	lastName?: string | undefined | null,	street?: string | undefined | null,	city?: string | undefined | null,	country: string,	state?: string | undefined | null,	zip?: string | undefined | null,	ic?: string | undefined | null,	dic?: string | undefined | null,	phone?: string | undefined | null,	email?: string | undefined | null,	zasilkovnaAddressId?: string | undefined | null,	branchId?: string | undefined | null,	isStored?: boolean | undefined | null,	isBilling?: boolean | undefined | null,	externalId?: string | undefined | null,	note?: string | undefined | null,	customData?: string | undefined | null},ResolverInputTypes["createAddress"]],
updateAddress?: [{	id: number,	customer?: number | undefined | null,	companyName?: string | undefined | null,	firstName?: string | undefined | null,	lastName?: string | undefined | null,	street?: string | undefined | null,	city?: string | undefined | null,	country?: string | undefined | null,	state?: string | undefined | null,	zip?: string | undefined | null,	ic?: string | undefined | null,	dic?: string | undefined | null,	phone?: string | undefined | null,	email?: string | undefined | null,	zasilkovnaAddressId?: string | undefined | null,	branchId?: string | undefined | null,	isStored?: boolean | undefined | null,	isBilling?: boolean | undefined | null,	externalId?: string | undefined | null,	note?: string | undefined | null,	customData?: string | undefined | null},ResolverInputTypes["updateAddress"]],
deleteAddress?: [{	id: number},ResolverInputTypes["deleteAddress"]],
createCheckout?: [{	name: string,	amount?: string | undefined | null,	nextReservationNumber?: number | undefined | null,	nextBillNumber?: number | undefined | null,	billFooter?: string | undefined | null,	payments?: Array<number | undefined | null> | undefined | null,	depots?: Array<number | undefined | null> | undefined | null,	returnsDepot?: number | undefined | null,	shop?: number | undefined | null,	eetId?: number | undefined | null,	eetEnable?: boolean | undefined | null,	eetPlayground?: boolean | undefined | null,	eetVerificationMode?: boolean | undefined | null,	eventUrl?: string | undefined | null,	eventTypes?: Array<string | undefined | null> | undefined | null,	negativeReservation?: boolean | undefined | null,	externalId?: string | undefined | null,	users?: Array<number | undefined | null> | undefined | null,	autoPicking?: boolean | undefined | null,	autoPacking?: boolean | undefined | null,	autoDispatched?: boolean | undefined | null,	institution?: number | undefined | null,	position?: number | undefined | null},ResolverInputTypes["createCheckout"]],
updateCheckout?: [{	id: number,	name?: string | undefined | null,	amount?: string | undefined | null,	nextReservationNumber?: number | undefined | null,	nextBillNumber?: number | undefined | null,	billFooter?: string | undefined | null,	payments?: Array<number | undefined | null> | undefined | null,	depots?: Array<number | undefined | null> | undefined | null,	returnsDepot?: number | undefined | null,	shop?: number | undefined | null,	eetId?: number | undefined | null,	eetEnable?: boolean | undefined | null,	eetPlayground?: boolean | undefined | null,	eetVerificationMode?: boolean | undefined | null,	eventUrl?: string | undefined | null,	eventTypes?: Array<string | undefined | null> | undefined | null,	negativeReservation?: boolean | undefined | null,	externalId?: string | undefined | null,	users?: Array<number | undefined | null> | undefined | null,	autoPicking?: boolean | undefined | null,	autoPacking?: boolean | undefined | null,	autoDispatched?: boolean | undefined | null,	institution?: number | undefined | null,	position?: number | undefined | null},ResolverInputTypes["updateCheckout"]],
deleteCheckout?: [{	id: number},ResolverInputTypes["deleteCheckout"]],
createCheckoutExtraOperation?: [{	checkout: number,	dateCreated?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	amount: string,	note?: string | undefined | null},ResolverInputTypes["createCheckoutExtraOperation"]],
updateCheckoutExtraOperation?: [{	id: number,	checkout?: number | undefined | null,	dateCreated?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	amount?: string | undefined | null,	note?: string | undefined | null},ResolverInputTypes["updateCheckoutExtraOperation"]],
deleteCheckoutExtraOperation?: [{	id: number},ResolverInputTypes["deleteCheckoutExtraOperation"]],
createCheckoutClosing?: [{	checkout: number,	dateOpen: ResolverInputTypes["DateTimeAsString"],	amountOpen: string,	amountRealOpen?: string | undefined | null,	userOpen?: number | undefined | null,	noteOpen?: string | undefined | null,	dateClosed?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	amountClosed?: string | undefined | null,	amountRealClosed?: string | undefined | null,	userClosed?: number | undefined | null,	noteClosed?: string | undefined | null,	enumeration?: string | undefined | null},ResolverInputTypes["createCheckoutClosing"]],
updateCheckoutClosing?: [{	id: number,	checkout?: number | undefined | null,	dateOpen?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	amountOpen?: string | undefined | null,	amountRealOpen?: string | undefined | null,	userOpen?: number | undefined | null,	noteOpen?: string | undefined | null,	dateClosed?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	amountClosed?: string | undefined | null,	amountRealClosed?: string | undefined | null,	userClosed?: number | undefined | null,	noteClosed?: string | undefined | null,	enumeration?: string | undefined | null},ResolverInputTypes["updateCheckoutClosing"]],
deleteCheckoutClosing?: [{	id: number},ResolverInputTypes["deleteCheckoutClosing"]],
createVat?: [{	name: string,	percent: string,	default: boolean,	externalId?: string | undefined | null},ResolverInputTypes["createVat"]],
updateVat?: [{	id: number,	name?: string | undefined | null,	percent?: string | undefined | null,	default?: boolean | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateVat"]],
deleteVat?: [{	id: number},ResolverInputTypes["deleteVat"]],
createDepot?: [{	name: string,	emailIn?: string | undefined | null,	position?: number | undefined | null,	externalId?: string | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null,	institution?: number | undefined | null,	users?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["createDepot"]],
updateDepot?: [{	id: number,	name?: string | undefined | null,	emailIn?: string | undefined | null,	position?: number | undefined | null,	externalId?: string | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null,	institution?: number | undefined | null,	users?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["updateDepot"]],
deleteDepot?: [{	id: number},ResolverInputTypes["deleteDepot"]],
createSupplier?: [{	name: string,	externalId?: string | undefined | null},ResolverInputTypes["createSupplier"]],
updateSupplier?: [{	id: number,	name?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateSupplier"]],
deleteSupplier?: [{	id: number},ResolverInputTypes["deleteSupplier"]],
createProducer?: [{	name: string,	externalId?: string | undefined | null},ResolverInputTypes["createProducer"]],
updateProducer?: [{	id: number,	name?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateProducer"]],
deleteProducer?: [{	id: number},ResolverInputTypes["deleteProducer"]],
createExportStock?: [{	date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	depots?: Array<number | undefined | null> | undefined | null,	suppliers?: Array<number | undefined | null> | undefined | null,	producers?: Array<number | undefined | null> | undefined | null,	format?: string | undefined | null},ResolverInputTypes["createExportStock"]],
createExportSale?: [{	dateFrom: ResolverInputTypes["DateTimeAsString"],	dateTo: ResolverInputTypes["DateTimeAsString"],	checkouts?: Array<number | undefined | null> | undefined | null,	suppliers?: Array<number | undefined | null> | undefined | null,	producers?: Array<number | undefined | null> | undefined | null,	format?: string | undefined | null},ResolverInputTypes["createExportSale"]],
createExportPurchase?: [{	dateFrom: ResolverInputTypes["DateTimeAsString"],	dateTo: ResolverInputTypes["DateTimeAsString"],	depots?: Array<number | undefined | null> | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null,	suppliers?: Array<number | undefined | null> | undefined | null,	producers?: Array<number | undefined | null> | undefined | null,	format?: string | undefined | null},ResolverInputTypes["createExportPurchase"]],
createExportOrder?: [{	dateFrom: ResolverInputTypes["DateTimeAsString"],	dateTo: ResolverInputTypes["DateTimeAsString"],	status?: string | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null,	format?: string | undefined | null},ResolverInputTypes["createExportOrder"]],
createExportInventory?: [{	date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	depots?: Array<number | undefined | null> | undefined | null,	suppliers?: Array<number | undefined | null> | undefined | null,	producers?: Array<number | undefined | null> | undefined | null,	approved?: string | undefined | null,	rejected?: string | undefined | null},ResolverInputTypes["createExportInventory"]],
updateExportInventory?: [{	id: number,	date?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	depots?: Array<number | undefined | null> | undefined | null,	suppliers?: Array<number | undefined | null> | undefined | null,	producers?: Array<number | undefined | null> | undefined | null,	approved?: string | undefined | null,	rejected?: string | undefined | null},ResolverInputTypes["updateExportInventory"]],
refreshExportInventory?: [{	id: number},ResolverInputTypes["refreshExportInventory"]],
createExport?: [{	type: string,	note?: string | undefined | null,	filter?: string | undefined | null},ResolverInputTypes["createExport"]],
updateCompany?: [{	id: number,	name?: string | undefined | null,	ic?: string | undefined | null,	dic?: string | undefined | null,	phone?: string | undefined | null,	email?: string | undefined | null,	street?: string | undefined | null,	city?: string | undefined | null,	zip?: string | undefined | null,	country?: string | undefined | null,	registrationNote?: string | undefined | null,	nextEan?: number | undefined | null,	defaultVoucherValidity?: number | undefined | null,	batchExpirationMode?: string | undefined | null},ResolverInputTypes["updateCompany"]],
createShop?: [{	name: string,	street?: string | undefined | null,	city?: string | undefined | null,	country?: string | undefined | null,	zip?: string | undefined | null,	eetId?: number | undefined | null,	cert?: number | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["createShop"]],
updateShop?: [{	id: number,	name: string,	street?: string | undefined | null,	city?: string | undefined | null,	country?: string | undefined | null,	zip?: string | undefined | null,	eetId?: number | undefined | null,	cert?: number | undefined | null,	checkouts?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["updateShop"]],
deleteShop?: [{	id: number},ResolverInputTypes["deleteShop"]],
createCert?: [{	name: string,	password: string,	pkcs12: string},ResolverInputTypes["createCert"]],
updateCert?: [{	id: number,	name?: string | undefined | null},ResolverInputTypes["updateCert"]],
deleteCert?: [{	id: number},ResolverInputTypes["deleteCert"]],
createEetReceipt?: [{	checkout: number,	number: number,	dateCreated: string,	currency: string,	totalPrice: number,	priceZeroVat?: number | undefined | null,	priceStandardVat?: number | undefined | null,	vatStandard?: number | undefined | null,	priceFirstReducedVat?: number | undefined | null,	vatFirstReduced?: number | undefined | null,	priceSecondReducedVat?: number | undefined | null,	vatSecondReduced?: number | undefined | null,	priceForSubsequentSettlement?: number | undefined | null,	priceUsedSubsequentSettlement?: number | undefined | null},ResolverInputTypes["createEetReceipt"]],
sendEetReceipt?: [{	id: number},ResolverInputTypes["sendEetReceipt"]],
createPayment?: [{	name: string,	type?: string | undefined | null,	eetEnable?: boolean | undefined | null,	dispatchUnpaid?: boolean | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createPayment"]],
updatePayment?: [{	id: number,	name: string,	type?: string | undefined | null,	eetEnable?: boolean | undefined | null,	dispatchUnpaid?: boolean | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updatePayment"]],
deletePayment?: [{	id: number},ResolverInputTypes["deletePayment"]],
createPaymentItem?: [{	payment: number,	checkout?: number | undefined | null,	voucher?: number | undefined | null,	amount?: number | undefined | null,	dateCreated?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateCancelled?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	externalId?: string | undefined | null,	isPaid?: boolean | undefined | null,	datePaid?: ResolverInputTypes["DateTimeAsString"] | undefined | null},ResolverInputTypes["createPaymentItem"]],
updatePaymentItem?: [{	id: number,	payment?: number | undefined | null,	checkout?: number | undefined | null,	voucher?: number | undefined | null,	amount?: number | undefined | null,	dateCreated?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	dateCancelled?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	externalId?: string | undefined | null,	isPaid?: boolean | undefined | null,	datePaid?: ResolverInputTypes["DateTimeAsString"] | undefined | null},ResolverInputTypes["updatePaymentItem"]],
deletePaymentItem?: [{	id: number},ResolverInputTypes["deletePaymentItem"]],
createDevLog?: [{	name?: string | undefined | null,	content?: string | undefined | null},ResolverInputTypes["createDevLog"]],
createPackage?: [{	carrier?: string | undefined | null,	order?: number | undefined | null,	items?: Array<number | undefined | null> | undefined | null,	weight?: number | undefined | null,	dimensionX?: number | undefined | null,	dimensionY?: number | undefined | null,	dimensionZ?: number | undefined | null,	tariff?: number | undefined | null},ResolverInputTypes["createPackage"]],
updatePackage?: [{	id: number,	carrier?: string | undefined | null,	order?: number | undefined | null,	items?: Array<number | undefined | null> | undefined | null,	weight?: number | undefined | null,	dimensionX?: number | undefined | null,	dimensionY?: number | undefined | null,	dimensionZ?: number | undefined | null,	tariff?: number | undefined | null},ResolverInputTypes["updatePackage"]],
deletePackage?: [{	id: number},ResolverInputTypes["deletePackage"]],
resetPackage?: [{	id: number},ResolverInputTypes["resetPackage"]],
sendPackage?: [{	id: number},ResolverInputTypes["sendPackage"]],
createDisposal?: [{	company?: number | undefined | null,	carrier?: string | undefined | null,	packages?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["createDisposal"]],
updateDisposal?: [{	id: number,	company?: number | undefined | null,	carrier?: string | undefined | null,	packages?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["updateDisposal"]],
deleteDisposal?: [{	id: number},ResolverInputTypes["deleteDisposal"]],
sendDisposal?: [{	id: string},ResolverInputTypes["sendDisposal"]],
createFile?: [{	text: string,	originalFilename: string,	mimeType: string,	base64Data: string,	product?: number | undefined | null,	order?: number | undefined | null,	inventory?: number | undefined | null,	productMovePack?: number | undefined | null,	disposal?: number | undefined | null,	purchaseOrder?: number | undefined | null},ResolverInputTypes["createFile"]],
updateFile?: [{	id: number,	text?: string | undefined | null,	originalFilename?: string | undefined | null,	mimeType?: string | undefined | null,	base64Data?: string | undefined | null,	product?: number | undefined | null,	order?: number | undefined | null,	inventory?: number | undefined | null,	productMovePack?: number | undefined | null,	disposal?: number | undefined | null,	purchaseOrder?: number | undefined | null},ResolverInputTypes["updateFile"]],
deleteFile?: [{	id: number},ResolverInputTypes["deleteFile"]],
createCompanyCarrier?: [{	carrier: string,	checkout?: number | undefined | null,	options?: string | undefined | null,	externalId?: string | undefined | null,	enable?: boolean | undefined | null},ResolverInputTypes["createCompanyCarrier"]],
updateCompanyCarrier?: [{	id: number,	carrier?: string | undefined | null,	checkout?: number | undefined | null,	options?: string | undefined | null,	externalId?: string | undefined | null,	enable?: boolean | undefined | null},ResolverInputTypes["updateCompanyCarrier"]],
deleteCompanyCarrier?: [{	id: number},ResolverInputTypes["deleteCompanyCarrier"]],
createConsent?: [{	name: string,	body?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createConsent"]],
updateConsent?: [{	id: number,	name?: string | undefined | null,	body?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateConsent"]],
deleteConsent?: [{	id: number},ResolverInputTypes["deleteConsent"]],
createCustomerConsent?: [{	customer: number,	consent: number,	externalId?: string | undefined | null},ResolverInputTypes["createCustomerConsent"]],
deleteCustomerConsent?: [{	id: number},ResolverInputTypes["deleteCustomerConsent"]],
updateProductDepot?: [{	id: number,	position1?: string | undefined | null,	position2?: string | undefined | null,	position3?: string | undefined | null,	purchasePrice?: number | undefined | null,	supplier?: number | undefined | null,	batch?: string | undefined | null,	expirationDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	inventoryQuantityStock?: number | undefined | null},ResolverInputTypes["updateProductDepot"]],
createCategory?: [{	name: string,	text?: string | undefined | null,	parent?: number | undefined | null,	externalId?: string | undefined | null,	position?: number | undefined | null,	tags?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["createCategory"]],
updateCategory?: [{	id: number,	name: string,	text?: string | undefined | null,	parent?: number | undefined | null,	externalId?: string | undefined | null,	position?: number | undefined | null,	tags?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["updateCategory"]],
deleteCategory?: [{	id: number},ResolverInputTypes["deleteCategory"]],
createParameter?: [{	name: string,	type?: string | undefined | null,	enumValues?: Array<string | undefined | null> | undefined | null,	unit?: string | undefined | null,	text?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createParameter"]],
updateParameter?: [{	id: number,	name: string,	type?: string | undefined | null,	enumValues?: Array<string | undefined | null> | undefined | null,	unit?: string | undefined | null,	text?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateParameter"]],
deleteParameter?: [{	id: number},ResolverInputTypes["deleteParameter"]],
createOrderGroup?: [{	name: string,	user?: number | undefined | null,	userPosition?: number | undefined | null,	tags?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["createOrderGroup"]],
updateOrderGroup?: [{	id: number,	name?: string | undefined | null,	user?: number | undefined | null,	userPosition?: number | undefined | null,	tags?: Array<number | undefined | null> | undefined | null},ResolverInputTypes["updateOrderGroup"]],
deleteOrderGroup?: [{	id: number},ResolverInputTypes["deleteOrderGroup"]],
createVoucher?: [{	name: string,	code: string,	discountType: string,	discountPercent?: number | undefined | null,	discountValue?: number | undefined | null,	maxUse?: number | undefined | null,	validFrom?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	validTo?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	enabled?: boolean | undefined | null,	externalId?: string | undefined | null,	isPayment?: boolean | undefined | null},ResolverInputTypes["createVoucher"]],
updateVoucher?: [{	id: number,	name?: string | undefined | null,	code?: string | undefined | null,	discountType?: string | undefined | null,	discountPercent?: number | undefined | null,	discountValue?: number | undefined | null,	maxUse?: number | undefined | null,	validFrom?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	validTo?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	enabled?: boolean | undefined | null,	externalId?: string | undefined | null,	isPayment?: boolean | undefined | null},ResolverInputTypes["updateVoucher"]],
deleteVoucher?: [{	id: number},ResolverInputTypes["deleteVoucher"]],
createPriceLevel?: [{	name: string,	isPercentage?: boolean | undefined | null,	percent?: number | undefined | null,	withVat?: boolean | undefined | null,	currency?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createPricePriceLevel"]],
updatePriceLevel?: [{	id: number,	name?: string | undefined | null,	isPercentage?: boolean | undefined | null,	percent?: number | undefined | null,	withVat?: boolean | undefined | null,	currency?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updatePriceLevel"]],
deletePriceLevel?: [{	id: number},ResolverInputTypes["deletePriceLevel"]],
createProductParameter?: [{	product: number,	parameter: number,	value: ResolverInputTypes["StringOrArray"],	externalId?: string | undefined | null},ResolverInputTypes["createProductParameter"]],
updateProductParameter?: [{	id: number,	product: number,	parameter: number,	value?: ResolverInputTypes["StringOrArray"] | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateProductParameter"]],
deleteProductParameter?: [{	id: number},ResolverInputTypes["deleteProductParameter"]],
createProductPriceLevel?: [{	product: number,	priceLevel: number,	sellPrice?: number | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createProductPriceLevel"]],
updateProductPriceLevel?: [{	id: number,	product: number,	priceLevel: number,	sellPrice?: number | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateProductPriceLevel"]],
deleteProductPriceLevel?: [{	id: number},ResolverInputTypes["deleteProductPriceLevel"]],
createTag?: [{	name: string,	type: string,	color?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createTag"]],
updateTag?: [{	id: number,	name?: string | undefined | null,	type?: string | undefined | null,	color?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateTag"]],
deleteTag?: [{	id: number},ResolverInputTypes["deleteTag"]],
createProductPack?: [{	product: number,	quantity: number,	ean?: string | undefined | null,	code?: string | undefined | null,	note?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createProductPack"]],
updateProductPack?: [{	id: number,	product: number,	quantity: number,	ean?: string | undefined | null,	code?: string | undefined | null,	note?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["updateProductPack"]],
deleteProductPack?: [{	id: number},ResolverInputTypes["deleteProductPack"]],
createPurchaseOrder?: [{	supplier: number,	depot: number,	note?: string | undefined | null,	privateNote?: string | undefined | null,	dateEstimatedArrival?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	items: Array<ResolverInputTypes["createPurchaseOrderItem_"] | undefined | null>,	tags?: Array<number | undefined | null> | undefined | null,	files?: Array<number | undefined | null> | undefined | null,	externalId?: string | undefined | null,	externalReference?: string | undefined | null,	supplierReference?: string | undefined | null},ResolverInputTypes["createPurchaseOrder"]],
updatePurchaseOrder?: [{	id: number,	supplier?: number | undefined | null,	depot?: number | undefined | null,	note?: string | undefined | null,	privateNote?: string | undefined | null,	dateEstimatedArrival?: ResolverInputTypes["DateTimeAsString"] | undefined | null,	items?: Array<ResolverInputTypes["createPurchaseOrderItem_"] | undefined | null> | undefined | null,	tags?: Array<number | undefined | null> | undefined | null,	files?: Array<number | undefined | null> | undefined | null,	externalId?: string | undefined | null,	externalReference?: string | undefined | null,	supplierReference?: string | undefined | null,	status?: string | undefined | null},ResolverInputTypes["updatePurchaseOrder"]],
deletePurchaseOrder?: [{	id: number},ResolverInputTypes["deletePurchaseOrder"]],
createPurchaseOrderItem?: [{	purchaseOrder: number,	currency: string,	product: number,	quantity: number,	purchasePrice?: number | undefined | null,	note?: string | undefined | null,	externalId?: string | undefined | null},ResolverInputTypes["createPurchaseOrderItem"]],
updatePurchaseOrderItem?: [{	id: number,	currency?: string | undefined | null,	product?: number | undefined | null,	quantity?: number | undefined | null,	purchasePrice?: number | undefined | null,	note?: string | undefined | null,	externalId?: string | undefined | null,	status?: string | undefined | null},ResolverInputTypes["updatePurchaseOrderItem"]],
deletePurchaseOrderItem?: [{	id: number},ResolverInputTypes["deletePurchaseOrderItem"]],
		__typename?: boolean | `@${string}`
}>;
	["createProduct"]: AliasType<{
	data?:ResolverInputTypes["Product"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProduct"]: AliasType<{
	data?:ResolverInputTypes["Product"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProduct"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["refreshProductDepots"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductMove"]: {
	product?: number | undefined | null,
	depotFrom?: number | undefined | null,
	depotTo?: number | undefined | null,
	productDepot?: number | undefined | null,
	supplier?: number | undefined | null,
	amount: number,
	purchasePrice?: number | undefined | null,
	purchaseCurrency?: string | undefined | null,
	purchaseCurrencyDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	purchaseOrderItem?: number | undefined | null,
	expirationDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	note?: string | undefined | null,
	orderItem?: number | undefined | null,
	serialNumbers?: Array<string | undefined | null> | undefined | null
};
	["createProductMovePack"]: AliasType<{
	data?:ResolverInputTypes["ProductMovePack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductMovePack"]: AliasType<{
	data?:ResolverInputTypes["ProductMovePack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductMovePack"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductMove"]: AliasType<{
	data?:ResolverInputTypes["ProductMove"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductMove"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductPrice"]: AliasType<{
	data?:ResolverInputTypes["ProductPrice"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductPrice"]: AliasType<{
	data?:ResolverInputTypes["ProductPrice"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductPrice"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductBundle"]: AliasType<{
	data?:ResolverInputTypes["ProductBundle"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductBundle"]: AliasType<{
	data?:ResolverInputTypes["ProductBundle"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductBundle"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductDepotMetric"]: AliasType<{
	data?:ResolverInputTypes["ProductDepotMetric"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductDepotMetric"]: AliasType<{
	data?:ResolverInputTypes["ProductDepotMetric"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductDepotMetric"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createInstitution"]: AliasType<{
	data?:ResolverInputTypes["Institution"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateInstitution"]: AliasType<{
	data?:ResolverInputTypes["Institution"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteInstitution"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createOrderItem_"]: {
	name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	price?: number | undefined | null,
	sale?: number | undefined | null,
	vat?: number | undefined | null,
	product?: number | undefined | null,
	serial?: string | undefined | null,
	expirationDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	note?: string | undefined | null,
	isForSubsequentSettlement?: boolean | undefined | null,
	picked?: boolean | undefined | null,
	packed?: boolean | undefined | null,
	voucher?: number | undefined | null,
	externalId?: string | undefined | null
};
	["createPaymentItem_"]: {
	payment: number,
	checkout?: number | undefined | null,
	voucher?: number | undefined | null,
	amount: number,
	dateCreated?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	dateCancelled?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	externalId?: string | undefined | null,
	isPaid?: boolean | undefined | null,
	datePaid?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["processStatusRelation"]: {
	status?: string | undefined | null,
	note?: string | undefined | null
};
	["createOrder"]: AliasType<{
	data?:ResolverInputTypes["Order"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateOrderItem_"]: {
	id?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	price?: string | undefined | null,
	sale?: string | undefined | null,
	vat?: number | undefined | null,
	product?: number | undefined | null,
	serial?: string | undefined | null,
	expirationDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	note?: string | undefined | null,
	isForSubsequentSettlement?: boolean | undefined | null,
	picked?: boolean | undefined | null,
	packed?: boolean | undefined | null,
	voucher?: number | undefined | null,
	externalId?: string | undefined | null
};
	["updatePaymentItem_"]: {
	payment?: number | undefined | null,
	checkout?: number | undefined | null,
	voucher?: number | undefined | null,
	amount?: string | undefined | null,
	dateCreated?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	dateCancelled?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	externalId?: string | undefined | null,
	isPaid?: boolean | undefined | null,
	datePaid?: ResolverInputTypes["DateTimeAsString"] | undefined | null
};
	["updateOrder"]: AliasType<{
	data?:ResolverInputTypes["Order"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteReservation"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createOrderItem"]: AliasType<{
	data?:ResolverInputTypes["OrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateOrderItem"]: AliasType<{
	data?:ResolverInputTypes["OrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteOrderItem"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateClearanceItemLocations"]: {
	amount: number,
	depot?: number | undefined | null,
	productDepot?: number | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	expirationDate?: ResolverInputTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	locked?: boolean | undefined | null
};
	["updateClearanceItem"]: AliasType<{
	data?:ResolverInputTypes["ClearanceItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createUser"]: AliasType<{
	data?:ResolverInputTypes["User"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateUser"]: AliasType<{
	data?:ResolverInputTypes["User"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteUser"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createUserGroup"]: AliasType<{
	data?:ResolverInputTypes["UserGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateUserGroup"]: AliasType<{
	data?:ResolverInputTypes["UserGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteUserGroup"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCustomer"]: AliasType<{
	data?:ResolverInputTypes["Customer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCustomer"]: AliasType<{
	data?:ResolverInputTypes["Customer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCustomer"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createAddress"]: AliasType<{
	data?:ResolverInputTypes["Address"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateAddress"]: AliasType<{
	data?:ResolverInputTypes["Address"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteAddress"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCheckout"]: AliasType<{
	data?:ResolverInputTypes["Checkout"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCheckout"]: AliasType<{
	data?:ResolverInputTypes["Checkout"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCheckout"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCheckoutExtraOperation"]: AliasType<{
	data?:ResolverInputTypes["CheckoutExtraOperation"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCheckoutExtraOperation"]: AliasType<{
	data?:ResolverInputTypes["CheckoutExtraOperation"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCheckoutExtraOperation"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCheckoutClosing"]: AliasType<{
	data?:ResolverInputTypes["CheckoutClosing"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCheckoutClosing"]: AliasType<{
	data?:ResolverInputTypes["CheckoutClosing"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCheckoutClosing"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createVat"]: AliasType<{
	data?:ResolverInputTypes["Vat"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateVat"]: AliasType<{
	data?:ResolverInputTypes["Vat"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteVat"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createDepot"]: AliasType<{
	data?:ResolverInputTypes["Depot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateDepot"]: AliasType<{
	data?:ResolverInputTypes["Depot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteDepot"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createSupplier"]: AliasType<{
	data?:ResolverInputTypes["Supplier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateSupplier"]: AliasType<{
	data?:ResolverInputTypes["Supplier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteSupplier"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProducer"]: AliasType<{
	data?:ResolverInputTypes["Producer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProducer"]: AliasType<{
	data?:ResolverInputTypes["Producer"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProducer"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportStock"]: AliasType<{
	data?:ResolverInputTypes["Stock"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportSale"]: AliasType<{
	data?:ResolverInputTypes["Sale"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportPurchase"]: AliasType<{
	data?:ResolverInputTypes["Purchase"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportOrder"]: AliasType<{
	data?:ResolverInputTypes["exportOrder"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExportInventory"]: AliasType<{
	data?:ResolverInputTypes["Inventory"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateExportInventory"]: AliasType<{
	data?:ResolverInputTypes["Inventory"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["refreshExportInventory"]: AliasType<{
	data?:ResolverInputTypes["Inventory"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createExport"]: AliasType<{
	data?:ResolverInputTypes["Export"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCompany"]: AliasType<{
	data?:ResolverInputTypes["Company"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createShop"]: AliasType<{
	data?:ResolverInputTypes["Shop"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateShop"]: AliasType<{
	data?:ResolverInputTypes["Shop"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteShop"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCert"]: AliasType<{
	data?:ResolverInputTypes["Cert"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCert"]: AliasType<{
	data?:ResolverInputTypes["Depot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCert"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createEetReceipt"]: AliasType<{
	data?:ResolverInputTypes["Receipt"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["sendEetReceipt"]: AliasType<{
	data?:ResolverInputTypes["Receipt"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPayment"]: AliasType<{
	data?:ResolverInputTypes["Payment"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePayment"]: AliasType<{
	data?:ResolverInputTypes["Payment"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePayment"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPaymentItem"]: AliasType<{
	data?:ResolverInputTypes["PaymentItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePaymentItem"]: AliasType<{
	data?:ResolverInputTypes["PaymentItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePaymentItem"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createDevLog"]: AliasType<{
	data?:ResolverInputTypes["DevLog"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DevLog"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	content?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPackage"]: AliasType<{
	data?:ResolverInputTypes["Package"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePackage"]: AliasType<{
	data?:ResolverInputTypes["Package"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePackage"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["resetPackage"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["sendPackage"]: AliasType<{
	data?:ResolverInputTypes["Package"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createDisposal"]: AliasType<{
	data?:ResolverInputTypes["PackageDisposal"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateDisposal"]: AliasType<{
	data?:ResolverInputTypes["PackageDisposal"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteDisposal"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["sendDisposal"]: AliasType<{
	data?:ResolverInputTypes["PackageDisposal"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createFile"]: AliasType<{
	data?:ResolverInputTypes["File"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateFile"]: AliasType<{
	data?:ResolverInputTypes["File"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteFile"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCompanyCarrier"]: AliasType<{
	data?:ResolverInputTypes["CompanyCarrier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCompanyCarrier"]: AliasType<{
	data?:ResolverInputTypes["CompanyCarrier"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCompanyCarrier"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createConsent"]: AliasType<{
	data?:ResolverInputTypes["Consent"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateConsent"]: AliasType<{
	data?:ResolverInputTypes["Consent"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteConsent"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCustomerConsent"]: AliasType<{
	data?:ResolverInputTypes["CustomerConsent"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCustomerConsent"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductDepot"]: AliasType<{
	data?:ResolverInputTypes["ProductDepot"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createCategory"]: AliasType<{
	data?:ResolverInputTypes["Category"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateCategory"]: AliasType<{
	data?:ResolverInputTypes["Category"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteCategory"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createParameter"]: AliasType<{
	data?:ResolverInputTypes["Parameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateParameter"]: AliasType<{
	data?:ResolverInputTypes["Parameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteParameter"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createOrderGroup"]: AliasType<{
	data?:ResolverInputTypes["OrderGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateOrderGroup"]: AliasType<{
	data?:ResolverInputTypes["OrderGroup"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteOrderGroup"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createVoucher"]: AliasType<{
	data?:ResolverInputTypes["Voucher"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateVoucher"]: AliasType<{
	data?:ResolverInputTypes["Voucher"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteVoucher"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPricePriceLevel"]: AliasType<{
	data?:ResolverInputTypes["PriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePriceLevel"]: AliasType<{
	data?:ResolverInputTypes["PriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePriceLevel"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductParameter"]: AliasType<{
	data?:ResolverInputTypes["ProductParameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductParameter"]: AliasType<{
	data?:ResolverInputTypes["ProductParameter"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductParameter"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductPriceLevel"]: AliasType<{
	data?:ResolverInputTypes["ProductPriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductPriceLevel"]: AliasType<{
	data?:ResolverInputTypes["ProductPriceLevel"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductPriceLevel"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createTag"]: AliasType<{
	data?:ResolverInputTypes["Tag"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateTag"]: AliasType<{
	data?:ResolverInputTypes["Tag"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteTag"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createProductPack"]: AliasType<{
	data?:ResolverInputTypes["ProductPack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updateProductPack"]: AliasType<{
	data?:ResolverInputTypes["ProductPack"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deleteProductPack"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPurchaseOrderItem_"]: {
	product: number,
	currency: string,
	quantity: number,
	purchasePrice?: number | undefined | null,
	note?: string | undefined | null,
	externalId?: string | undefined | null
};
	["createPurchaseOrder"]: AliasType<{
	data?:ResolverInputTypes["PurchaseOrder"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePurchaseOrder"]: AliasType<{
	data?:ResolverInputTypes["PurchaseOrder"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePurchaseOrder"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["createPurchaseOrderItem"]: AliasType<{
	data?:ResolverInputTypes["PurchaseOrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["updatePurchaseOrderItem"]: AliasType<{
	data?:ResolverInputTypes["PurchaseOrderItem"],
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["deletePurchaseOrderItem"]: AliasType<{
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ID"]:unknown
  }

export type ModelTypes = {
    ["schema"]: {
	query?: ModelTypes["RootSchemaQuery"] | undefined | null,
	mutation?: ModelTypes["RootSchemaMutation"] | undefined | null
};
	["RootSchemaQuery"]: {
		user?: ModelTypes["user"] | undefined | null,
	userMyProfile?: ModelTypes["userMyProfile"] | undefined | null,
	users?: ModelTypes["users"] | undefined | null,
	isUserEmailUnique?: ModelTypes["isUserEmailUnique"] | undefined | null,
	userGroup?: ModelTypes["userGroup"] | undefined | null,
	userGroups?: ModelTypes["userGroups"] | undefined | null,
	roles?: Array<ModelTypes["Role"] | undefined | null> | undefined | null,
	product?: ModelTypes["product"] | undefined | null,
	products?: ModelTypes["products"] | undefined | null,
	productPurchasePrice?: ModelTypes["productPurchasePrice"] | undefined | null,
	productSellItems?: ModelTypes["productSellItems"] | undefined | null,
	productMovePacks?: ModelTypes["productMovePacks"] | undefined | null,
	productMoves?: ModelTypes["productMoves"] | undefined | null,
	productMovePack?: ModelTypes["productMovePack"] | undefined | null,
	institution?: ModelTypes["institution"] | undefined | null,
	institutions?: ModelTypes["institutions"] | undefined | null,
	order?: ModelTypes["order"] | undefined | null,
	orders?: ModelTypes["orders"] | undefined | null,
	soldItems?: ModelTypes["soldItems"] | undefined | null,
	orderItems?: ModelTypes["orderItems"] | undefined | null,
	orderItem?: ModelTypes["orderItem"] | undefined | null,
	customer?: ModelTypes["customer"] | undefined | null,
	customers?: ModelTypes["customers"] | undefined | null,
	address?: ModelTypes["address"] | undefined | null,
	addresses?: ModelTypes["addresses"] | undefined | null,
	checkout?: ModelTypes["checkout"] | undefined | null,
	checkouts?: ModelTypes["checkouts"] | undefined | null,
	eventTypes?: ModelTypes["eventTypes"] | undefined | null,
	consent?: ModelTypes["consent"] | undefined | null,
	consents?: ModelTypes["consents"] | undefined | null,
	checkoutExtraOperation?: ModelTypes["checkoutExtraOperation"] | undefined | null,
	checkoutExtraOperations?: ModelTypes["checkoutExtraOperations"] | undefined | null,
	checkoutClosing?: ModelTypes["checkoutClosing"] | undefined | null,
	checkoutClosings?: ModelTypes["checkoutClosings"] | undefined | null,
	vat?: ModelTypes["vat"] | undefined | null,
	vats?: ModelTypes["vats"] | undefined | null,
	depot?: ModelTypes["depot"] | undefined | null,
	depots?: ModelTypes["depots"] | undefined | null,
	supplier?: ModelTypes["supplier"] | undefined | null,
	suppliers?: ModelTypes["suppliers"] | undefined | null,
	producer?: ModelTypes["producer"] | undefined | null,
	producers?: ModelTypes["producers"] | undefined | null,
	exportStocks?: ModelTypes["exportStocks"] | undefined | null,
	exportSales?: ModelTypes["exportSales"] | undefined | null,
	exportPurchases?: ModelTypes["exportPurchases"] | undefined | null,
	exportOrders?: ModelTypes["exportOrders"] | undefined | null,
	exportInventory?: ModelTypes["exportInventory"] | undefined | null,
	exportInventories?: ModelTypes["exportInventories"] | undefined | null,
	export?: ModelTypes["export"] | undefined | null,
	exports?: ModelTypes["exports"] | undefined | null,
	exportTypes?: ModelTypes["exportTypes"] | undefined | null,
	shop?: ModelTypes["shop"] | undefined | null,
	shops?: ModelTypes["shops"] | undefined | null,
	cert?: ModelTypes["cert"] | undefined | null,
	certs?: ModelTypes["certs"] | undefined | null,
	eetReceipts?: ModelTypes["eetReceipts"] | undefined | null,
	payment?: ModelTypes["payment"] | undefined | null,
	payments?: ModelTypes["payments"] | undefined | null,
	paymentItem?: ModelTypes["paymentItem"] | undefined | null,
	paymentItems?: ModelTypes["paymentItems"] | undefined | null,
	paymentTypes?: ModelTypes["paymentTypes"] | undefined | null,
	processStatuses?: ModelTypes["processStatuses"] | undefined | null,
	carriers?: ModelTypes["carriers"] | undefined | null,
	currencies?: ModelTypes["currencies"] | undefined | null,
	package?: ModelTypes["package"] | undefined | null,
	packages?: ModelTypes["packages"] | undefined | null,
	stats?: ModelTypes["packageStats"] | undefined | null,
	disposal?: ModelTypes["disposal"] | undefined | null,
	disposals?: ModelTypes["disposals"] | undefined | null,
	productDepotMetric?: ModelTypes["productDepotMetric"] | undefined | null,
	productDepotMetrics?: ModelTypes["productDepotMetrics"] | undefined | null,
	file?: ModelTypes["file"] | undefined | null,
	files?: ModelTypes["files"] | undefined | null,
	nextEan?: ModelTypes["nextEan"] | undefined | null,
	statsCarrierUsage?: ModelTypes["statsCarrierUsage"] | undefined | null,
	statsPaymentSales?: ModelTypes["statsPaymentSales"] | undefined | null,
	statsBestsellers?: ModelTypes["statsBestsellers"] | undefined | null,
	companyCarrier?: ModelTypes["companyCarrier"] | undefined | null,
	companyCarriers?: ModelTypes["companyCarriers"] | undefined | null,
	category?: ModelTypes["category"] | undefined | null,
	categories?: ModelTypes["categories"] | undefined | null,
	parameter?: ModelTypes["parameter"] | undefined | null,
	parameters?: ModelTypes["parameters"] | undefined | null,
	orderGroup?: ModelTypes["orderGroup"] | undefined | null,
	orderGroups?: ModelTypes["orderGroups"] | undefined | null,
	voucher?: ModelTypes["voucher"] | undefined | null,
	vouchers?: ModelTypes["vouchers"] | undefined | null,
	productPrices?: ModelTypes["productPrices"] | undefined | null,
	priceLevel?: ModelTypes["priceLevel"] | undefined | null,
	priceLevels?: ModelTypes["priceLevels"] | undefined | null,
	productParameter?: ModelTypes["productParameter"] | undefined | null,
	productParameters?: ModelTypes["productParameters"] | undefined | null,
	productPriceLevel?: ModelTypes["productPriceLevel"] | undefined | null,
	productPriceLevels?: ModelTypes["productPriceLevels"] | undefined | null,
	tag?: ModelTypes["tag"] | undefined | null,
	tags?: ModelTypes["tags"] | undefined | null,
	tagTypes?: ModelTypes["tagTypes"] | undefined | null,
	productPack?: ModelTypes["productPack"] | undefined | null,
	productPacks?: ModelTypes["productPacks"] | undefined | null,
	purchaseOrder?: ModelTypes["purchaseOrder"] | undefined | null,
	purchaseOrders?: ModelTypes["purchaseOrders"] | undefined | null,
	purchaseOrderItem?: ModelTypes["purchaseOrderItem"] | undefined | null,
	purchaseOrderItems?: ModelTypes["purchaseOrderItems"] | undefined | null,
	purchaseOrderStatuses?: ModelTypes["purchaseOrderStatuses"] | undefined | null,
	modules?: ModelTypes["modules"] | undefined | null
};
	["user"]: {
		data?: ModelTypes["User"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["User"]: {
		id?: number | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	phone?: string | undefined | null,
	groups?: Array<ModelTypes["UserGroup"] | undefined | null> | undefined | null,
	roles?: Array<string | undefined | null> | undefined | null,
	enabled?: boolean | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	pin?: string | undefined | null,
	externalId?: string | undefined | null,
	customers?: Array<ModelTypes["Customer"] | undefined | null> | undefined | null,
	checkouts?: Array<ModelTypes["Checkout"] | undefined | null> | undefined | null,
	depots?: Array<ModelTypes["Depot"] | undefined | null> | undefined | null,
	locale?: string | undefined | null,
	deletable?: boolean | undefined | null
};
	["UserGroup"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	roles?: Array<string | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null
};
	["Company"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	ic?: string | undefined | null,
	dic?: string | undefined | null,
	phone?: string | undefined | null,
	email?: string | undefined | null,
	street?: string | undefined | null,
	city?: string | undefined | null,
	zip?: string | undefined | null,
	country?: string | undefined | null,
	currency?: ModelTypes["Currency"] | undefined | null,
	registrationNote?: string | undefined | null,
	nextEan?: string | undefined | null,
	billLogo?: string | undefined | null,
	parent?: ModelTypes["Company"] | undefined | null,
	children?: Array<ModelTypes["Company"] | undefined | null> | undefined | null,
	carrierRelations?: Array<ModelTypes["CompanyCarrier"] | undefined | null> | undefined | null,
	moduleRelations?: Array<ModelTypes["CompanyModule"] | undefined | null> | undefined | null,
	payments?: Array<ModelTypes["Payment"] | undefined | null> | undefined | null,
	defaultVoucherValidity?: number | undefined | null,
	pickingOnlyOneDepot?: boolean | undefined | null,
	customOptions?: string | undefined | null,
	batchExpirationMode?: string | undefined | null,
	externalId?: string | undefined | null,
	purchasePriceWithVat?: boolean | undefined | null,
	tariff?: ModelTypes["Tariff"] | undefined | null,
	tariffExpirationDate?: ModelTypes["DateTime"] | undefined | null,
	enabledLocking?: boolean | undefined | null
};
	["Currency"]: {
		id?: string | undefined | null,
	name?: string | undefined | null,
	ratio?: number | undefined | null
};
	["CompanyCarrier"]: {
		id?: number | undefined | null,
	enable?: boolean | undefined | null,
	options?: string | undefined | null,
	carrier?: ModelTypes["Carrier"] | undefined | null,
	checkout?: ModelTypes["Checkout"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null
};
	["Carrier"]: {
		id?: string | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	position?: number | undefined | null,
	tariffs?: Array<ModelTypes["CarrierTariff"] | undefined | null> | undefined | null,
	requiredShippingAddress?: boolean | undefined | null
};
	["CarrierTariff"]: {
		id?: number | undefined | null,
	const?: string | undefined | null,
	name?: string | undefined | null,
	cod?: boolean | undefined | null,
	position?: number | undefined | null
};
	["Checkout"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	amount?: number | undefined | null,
	nextReservationNumber?: number | undefined | null,
	nextBillNumber?: number | undefined | null,
	billFooter?: string | undefined | null,
	payments?: Array<ModelTypes["Payment"] | undefined | null> | undefined | null,
	depots?: Array<ModelTypes["Depot"] | undefined | null> | undefined | null,
	returnsDepot?: ModelTypes["Depot"] | undefined | null,
	currentClosing?: ModelTypes["CheckoutClosing"] | undefined | null,
	eetId?: number | undefined | null,
	eetEnable?: boolean | undefined | null,
	eetPlayground?: boolean | undefined | null,
	eetVerificationMode?: boolean | undefined | null,
	billWidth?: number | undefined | null,
	billFontSize?: number | undefined | null,
	billFontWeight?: string | undefined | null,
	eventUrl?: string | undefined | null,
	eventTypes?: Array<string | undefined | null> | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	negativeReservation?: boolean | undefined | null,
	externalId?: string | undefined | null,
	users?: Array<ModelTypes["User"] | undefined | null> | undefined | null,
	autoPicking?: boolean | undefined | null,
	autoPacking?: boolean | undefined | null,
	autoDispatched?: boolean | undefined | null,
	institution?: ModelTypes["Institution"] | undefined | null,
	position?: number | undefined | null,
	deletable?: boolean | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null
};
	["Payment"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	eetEnable?: boolean | undefined | null,
	/** Expedovat i nezaplacené objednávky */
	dispatchUnpaid?: boolean | undefined | null,
	type?: ModelTypes["PaymentType"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null
};
	["PaymentType"]: {
		id?: string | undefined | null,
	name?: string | undefined | null
};
	["Depot"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	emailIn?: string | undefined | null,
	unavailablesUrl?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	companyCarriers?: Array<ModelTypes["CompanyCarrier"] | undefined | null> | undefined | null,
	checkouts?: Array<ModelTypes["Checkout"] | undefined | null> | undefined | null,
	institution?: ModelTypes["Institution"] | undefined | null,
	users?: Array<ModelTypes["User"] | undefined | null> | undefined | null,
	position?: number | undefined | null,
	deletable?: boolean | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null
};
	["Institution"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	checkouts?: Array<ModelTypes["Checkout"] | undefined | null> | undefined | null,
	depots?: Array<ModelTypes["Depot"] | undefined | null> | undefined | null
};
	/** Representation of date and time in "Y-m-d H:i:s" format */
["DateTime"]:any;
	["CheckoutClosing"]: {
		id?: number | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	checkout?: ModelTypes["Checkout"] | undefined | null,
	dateOpen?: ModelTypes["DateTime"] | undefined | null,
	amountOpen?: number | undefined | null,
	amountRealOpen?: number | undefined | null,
	userOpen?: ModelTypes["User"] | undefined | null,
	noteOpen?: string | undefined | null,
	dateClosed?: ModelTypes["DateTime"] | undefined | null,
	amountClosed?: number | undefined | null,
	amountRealClosed?: number | undefined | null,
	userClosed?: ModelTypes["User"] | undefined | null,
	noteClosed?: string | undefined | null,
	orders?: Array<ModelTypes["Order"] | undefined | null> | undefined | null,
	profit?: number | undefined | null,
	vatAllocations?: Array<ModelTypes["VatAllocation"] | undefined | null> | undefined | null,
	extraOperations?: Array<ModelTypes["CheckoutExtraOperation"] | undefined | null> | undefined | null,
	billUrl?: string | undefined | null,
	enumeration?: string | undefined | null,
	paymentSum?: Array<ModelTypes["paymentSum"] | undefined | null> | undefined | null
};
	["Order"]: {
		id?: number | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	status?: ModelTypes["OrderStatus"] | undefined | null,
	reservationNumber?: number | undefined | null,
	billNumber?: number | undefined | null,
	vs?: number | undefined | null,
	dateCreated?: ModelTypes["DateTime"] | undefined | null,
	dateBill?: ModelTypes["DateTime"] | undefined | null,
	dateExpedition?: ModelTypes["DateTime"] | undefined | null,
	dateDue?: ModelTypes["DateTime"] | undefined | null,
	dateTax?: ModelTypes["DateTime"] | undefined | null,
	items?: Array<ModelTypes["OrderItem"] | undefined | null> | undefined | null,
	paymentItems?: Array<ModelTypes["PaymentItem"] | undefined | null> | undefined | null,
	checkout?: ModelTypes["Checkout"] | undefined | null,
	checkoutClosing?: ModelTypes["CheckoutClosing"] | undefined | null,
	customer?: ModelTypes["Customer"] | undefined | null,
	note?: string | undefined | null,
	privateNote?: string | undefined | null,
	invoiceAddress?: ModelTypes["Address"] | undefined | null,
	shippingAddress?: ModelTypes["Address"] | undefined | null,
	relatedParent?: ModelTypes["Order"] | undefined | null,
	rounding?: number | undefined | null,
	eetReceipt?: ModelTypes["Receipt"] | undefined | null,
	deleted?: ModelTypes["DateTime"] | undefined | null,
	priceAll?: number | undefined | null,
	priceAllWithoutVat?: number | undefined | null,
	profit?: number | undefined | null,
	vatAllocations?: Array<ModelTypes["VatAllocation"] | undefined | null> | undefined | null,
	/** DEPRECATED - Url PDF účtenky */
	billUrl?: string | undefined | null,
	/** Url PDF faktury */
	invoiceUrl?: string | undefined | null,
	/** Url PDF objednávky */
	reservationUrl?: string | undefined | null,
	/** Url PDF účtenky */
	invoiceReceiptUrl?: string | undefined | null,
	/** Url PDF účtenky-rezervace */
	reservationReceiptUrl?: string | undefined | null,
	processStatus?: ModelTypes["ProcessStatus"] | undefined | null,
	processStatusUpdated?: ModelTypes["DateTime"] | undefined | null,
	processStatusRelation?: ModelTypes["OrderProcessStatus"] | undefined | null,
	processStatusRelations?: Array<ModelTypes["OrderProcessStatus"] | undefined | null> | undefined | null,
	carrier?: ModelTypes["Carrier"] | undefined | null,
	packages?: Array<ModelTypes["Package"] | undefined | null> | undefined | null,
	boxes?: Array<string | undefined | null> | undefined | null,
	isPaid?: boolean | undefined | null,
	currency?: ModelTypes["Currency"] | undefined | null,
	files?: Array<ModelTypes["File"] | undefined | null> | undefined | null,
	quantityUnavailable?: number | undefined | null,
	createdBy?: ModelTypes["User"] | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null,
	movePacks?: Array<ModelTypes["ProductMovePack"] | undefined | null> | undefined | null,
	depots?: Array<ModelTypes["Depot"] | undefined | null> | undefined | null,
	isEditable?: boolean | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Externí číslo */
	externalReference?: string | undefined | null,
	group?: ModelTypes["OrderGroup"] | undefined | null,
	groupPosition?: number | undefined | null,
	clearanceItems?: Array<ModelTypes["ClearanceItem"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<ModelTypes["Tag"] | undefined | null> | undefined | null,
	/** Priorita */
	priority?: number | undefined | null,
	/** Uzamčena */
	locked?: boolean | undefined | null,
	/** Od kdy uzamčena */
	dateLocked?: ModelTypes["DateTimeAsString"] | undefined | null,
	/** Kým uzamčena */
	lockedBy?: ModelTypes["User"] | undefined | null
};
	["OrderStatus"]: {
		id?: string | undefined | null,
	name?: string | undefined | null
};
	["OrderItem"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	sale?: number | undefined | null,
	price?: number | undefined | null,
	priceWithoutVat?: number | undefined | null,
	priceAll?: number | undefined | null,
	priceAllWithoutVat?: number | undefined | null,
	vat?: ModelTypes["Vat"] | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	serial?: string | undefined | null,
	expirationDate?: ModelTypes["DateTime"] | undefined | null,
	batch?: string | undefined | null,
	note?: string | undefined | null,
	profit?: number | undefined | null,
	isForSubsequentSettlement?: boolean | undefined | null,
	picked?: boolean | undefined | null,
	packed?: boolean | undefined | null,
	quantityUnavailable?: number | undefined | null,
	moves?: Array<ModelTypes["ProductMove"] | undefined | null> | undefined | null,
	clearanceItems?: Array<ModelTypes["ClearanceItem"] | undefined | null> | undefined | null,
	voucher?: ModelTypes["Voucher"] | undefined | null,
	order?: ModelTypes["Order"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null
};
	["Vat"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	percent?: number | undefined | null,
	default?: boolean | undefined | null,
	coefficient?: number | undefined | null,
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	created?: ModelTypes["DateTimeAsString"] | undefined | null,
	updated?: ModelTypes["DateTimeAsString"] | undefined | null
};
	/** Representation of date and time in same string format as PHP DateTime class. */
["DateTimeAsString"]:any;
	["Product"]: {
		id?: number | undefined | null,
	/** Název */
	name?: string | undefined | null,
	/** Název včetně názvu rodičovského produktu */
	fullName?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean2?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean3?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean4?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean5?: string | undefined | null,
	/** Kód */
	code?: string | undefined | null,
	/** Kód2 */
	code2?: string | undefined | null,
	/** Kód3 */
	code3?: string | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Prodejní cena */
	sellPrice?: number | undefined | null,
	/** Prodejní cena bez DPH */
	sellPriceWithoutVat?: number | undefined | null,
	/** Cena před slevou */
	beforeSellPrice?: number | undefined | null,
	/** Aktuální prodejní cena - včetně započtených akčních cen */
	actualSellPrice?: number | undefined | null,
	/** Aktuální prodejní cena bez DPH */
	actualSellPriceWithoutVat?: number | undefined | null,
	/** Aktuální cena před slevou - včetně započtených akčních cen */
	actualBeforeSellPrice?: number | undefined | null,
	/** Výchozí nákupní cena */
	purchasePrice?: number | undefined | null,
	/** Výchozí nákupní měna */
	purchaseCurrency?: ModelTypes["Currency"] | undefined | null,
	/** Váha */
	weight?: number | undefined | null,
	/** Rozměr X */
	dimensionX?: number | undefined | null,
	/** Rozměr Y */
	dimensionY?: number | undefined | null,
	/** Rozměr Z */
	dimensionZ?: number | undefined | null,
	/** Země výroby */
	originCountry?: string | undefined | null,
	/** HS kod */
	hsCode?: string | undefined | null,
	/** Je produkt aktnivní? */
	enabled?: boolean | undefined | null,
	/** DPH */
	vat?: ModelTypes["Vat"] | undefined | null,
	/** Výrobce */
	producer?: ModelTypes["Producer"] | undefined | null,
	/** Výchozí dodavatel */
	supplier?: ModelTypes["Supplier"] | undefined | null,
	/** Rodičovský produkt */
	parent?: ModelTypes["Product"] | undefined | null,
	/** Potomci / varianty produktu */
	children?: Array<ModelTypes["Product"] | undefined | null> | undefined | null,
	/** Deprecated: používejte productDepots */
	depots?: Array<ModelTypes["ProductDepot"] | undefined | null> | undefined | null,
	/** Skladové zásoby */
	productDepots?: Array<ModelTypes["ProductDepot"] | undefined | null> | undefined | null,
	/** Produkt je položka pro následné uplatnění (např. kupón) - pro EET */
	isForSubsequentSettlement?: boolean | undefined | null,
	/** Hlavní obrázek */
	mainImage?: ModelTypes["File"] | undefined | null,
	/** Obrázky */
	images?: Array<ModelTypes["File"] | undefined | null> | undefined | null,
	/** Soubory (mimo obrázků) */
	files?: Array<ModelTypes["File"] | undefined | null> | undefined | null,
	/** Jedná se o set produktů (virtuální produkt) */
	isBundle?: boolean | undefined | null,
	/** Křehký */
	isFragile?: boolean | undefined | null,
	/** Nadrozměrný */
	isOversize?: boolean | undefined | null,
	bundleParents?: Array<ModelTypes["ProductBundle"] | undefined | null> | undefined | null,
	bundleChildren?: Array<ModelTypes["ProductBundle"] | undefined | null> | undefined | null,
	/** Poznámka */
	note?: string | undefined | null,
	/** Popis */
	description?: string | undefined | null,
	/** Krátký popis */
	perex?: string | undefined | null,
	/** Cokoli... */
	customData?: string | undefined | null,
	/** Akční ceny */
	advancedPrices?: Array<ModelTypes["ProductPrice"] | undefined | null> | undefined | null,
	/** Počet nedostupných kusů v rezervaci */
	quantityUnavailable?: number | undefined | null,
	/** Počet kusů skladem a všech skladech */
	quantityStock?: number | undefined | null,
	/** Počet dostupných kusů a všech skladech */
	quantityAvailable?: number | undefined | null,
	/** Počet kusů v rezervaci na všech skladech */
	quantityReservation?: number | undefined | null,
	/** Počet kusů objednaný od dodavatele */
	quantityPurchase?: number | undefined | null,
	/** Kategorie */
	categories?: Array<ModelTypes["Category"] | undefined | null> | undefined | null,
	/** Hlavní kategorie */
	mainCategory?: ModelTypes["Category"] | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	/** Počty */
	quantities?: Array<ModelTypes["Quantity"] | undefined | null> | undefined | null,
	/** Metriky */
	metrics?: Array<ModelTypes["ProductDepotMetric"] | undefined | null> | undefined | null,
	/** Balení/Kartony */
	packs?: Array<ModelTypes["ProductPack"] | undefined | null> | undefined | null,
	/** Relace ProductParameter */
	productParameters?: Array<ModelTypes["ProductParameter"] | undefined | null> | undefined | null,
	/** Relace ProductPriceLevel */
	productPriceLevels?: Array<ModelTypes["ProductPriceLevel"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<ModelTypes["Tag"] | undefined | null> | undefined | null,
	/** Položky k prodeji: jednotlivé expirace a šarže */
	sellItems?: Array<ModelTypes["SellItem"] | undefined | null> | undefined | null,
	/** Deprectable - use deletable. */
	isDeletable?: boolean | undefined | null,
	/** Lze smazat */
	deletable?: boolean | undefined | null,
	/** Eviduje expirace a šarže */
	enabledBatchExpiration?: boolean | undefined | null,
	/** Eviduje sériová čísla */
	requiredSerialNumbers?: boolean | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null
};
	["Producer"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null
};
	["Supplier"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	deletable?: boolean | undefined | null
};
	["ProductDepot"]: {
		id?: number | undefined | null,
	depot?: ModelTypes["Depot"] | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	supplier?: ModelTypes["Supplier"] | undefined | null,
	purchasePrice?: number | undefined | null,
	quantityStock?: number | undefined | null,
	quantityReservation?: number | undefined | null,
	quantityAvailable?: number | undefined | null,
	quantityUnavailable?: number | undefined | null,
	inventoryQuantityStock?: number | undefined | null,
	expirationDate?: ModelTypes["DateTime"] | undefined | null,
	batch?: string | undefined | null,
	position?: string | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	clearanceItemId?: string | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null
};
	["File"]: {
		id?: number | undefined | null,
	originalFilename?: string | undefined | null,
	text?: string | undefined | null,
	main?: boolean | undefined | null,
	mimeType?: string | undefined | null,
	size?: number | undefined | null,
	url?: string | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	order?: ModelTypes["Order"] | undefined | null,
	thumbnails?: Array<ModelTypes["FileThumbnail"] | undefined | null> | undefined | null
};
	["FileThumbnail"]: {
		format?: string | undefined | null,
	mimeType?: string | undefined | null,
	url?: string | undefined | null
};
	["ProductBundle"]: {
		id?: number | undefined | null,
	parent?: ModelTypes["Product"] | undefined | null,
	child?: ModelTypes["Product"] | undefined | null,
	/** Množství */
	quantity?: number | undefined | null
};
	["ProductPrice"]: {
		id?: number | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	sellPrice?: number | undefined | null,
	available?: number | undefined | null,
	dateFrom?: ModelTypes["DateTime"] | undefined | null,
	dateTo?: ModelTypes["DateTime"] | undefined | null,
	isActual?: boolean | undefined | null,
	note?: string | undefined | null
};
	["Category"]: {
		id?: number | undefined | null,
	externalId?: string | undefined | null,
	name?: string | undefined | null,
	text?: string | undefined | null,
	parent?: ModelTypes["Category"] | undefined | null,
	children?: Array<ModelTypes["Category"] | undefined | null> | undefined | null,
	hasChildren?: boolean | undefined | null,
	position?: number | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	treePath?: Array<number | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<ModelTypes["Tag"] | undefined | null> | undefined | null
};
	["Tag"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	color?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	created?: ModelTypes["DateTimeAsString"] | undefined | null,
	updated?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["Quantity"]: {
		depot?: ModelTypes["Depot"] | undefined | null,
	quantityAvailable?: number | undefined | null,
	quantityReservation?: number | undefined | null,
	quantityStock?: number | undefined | null,
	quantityPurchase?: number | undefined | null
};
	["ProductDepotMetric"]: {
		id?: number | undefined | null,
	depot?: ModelTypes["Depot"] | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	quantityMinimum?: number | undefined | null,
	quantityOptimum?: number | undefined | null,
	quantityMaximum?: number | undefined | null,
	quantityStock?: number | undefined | null,
	quantityPurchase?: number | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null
};
	["ProductPack"]: {
		id?: number | undefined | null,
	/** Unikátní Ean 13 */
	ean?: string | undefined | null,
	/** Kód */
	code?: string | undefined | null,
	/** Poznámka */
	note?: string | undefined | null,
	/** Množství */
	quantity?: number | undefined | null,
	/** Produkt.id */
	product?: ModelTypes["Product"] | undefined | null,
	/** Externí ID */
	externalId?: string | undefined | null
};
	["ProductParameter"]: {
		id?: number | undefined | null,
	value?: ModelTypes["StringOrArray"] | undefined | null,
	externalId?: string | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	parameter?: ModelTypes["Parameter"] | undefined | null
};
	/** String or Array */
["StringOrArray"]:any;
	["Parameter"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	enumValues?: Array<string | undefined | null> | undefined | null,
	unit?: string | undefined | null,
	text?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null
};
	["ProductPriceLevel"]: {
		id?: number | undefined | null,
	sellPrice?: number | undefined | null,
	externalId?: string | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	priceLevel?: ModelTypes["PriceLevel"] | undefined | null
};
	["PriceLevel"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	isPercentage?: boolean | undefined | null,
	percent?: number | undefined | null,
	withVat?: boolean | undefined | null,
	currency?: ModelTypes["Currency"] | undefined | null,
	externalId?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null
};
	["SellItem"]: {
		id?: string | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	quantityStock?: number | undefined | null,
	quantityReservation?: number | undefined | null,
	quantityAvailable?: number | undefined | null,
	expirationDate?: ModelTypes["DateTime"] | undefined | null,
	batch?: string | undefined | null,
	productDepots?: Array<ModelTypes["ProductDepot"] | undefined | null> | undefined | null
};
	["ProductMove"]: {
		id?: number | undefined | null,
	pack?: ModelTypes["ProductMovePack"] | undefined | null,
	productDepotFrom?: ModelTypes["ProductDepot"] | undefined | null,
	productDepotFromQuantityStock?: number | undefined | null,
	productDepotTo?: ModelTypes["ProductDepot"] | undefined | null,
	productDepotToQuantityStock?: number | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	amount?: number | undefined | null,
	note?: string | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null,
	deleted?: ModelTypes["DateTime"] | undefined | null,
	quantityUnavailable?: number | undefined | null,
	createdBy?: ModelTypes["User"] | undefined | null,
	orderItem?: ModelTypes["OrderItem"] | undefined | null,
	picked?: number | undefined | null,
	packed?: number | undefined | null,
	locked?: boolean | undefined | null,
	purchasePrice?: number | undefined | null,
	purchasePriceAll?: number | undefined | null,
	purchasePriceWithVat?: number | undefined | null,
	purchasePriceAllWithVat?: number | undefined | null,
	purchaseOrderItem?: ModelTypes["PurchaseOrderItem"] | undefined | null,
	deletable?: boolean | undefined | null,
	serialNumbers?: Array<string | undefined | null> | undefined | null
};
	["ProductMovePack"]: {
		id?: number | undefined | null,
	externalId?: string | undefined | null,
	externalReference?: string | undefined | null,
	number?: number | undefined | null,
	type?: ModelTypes["ProductMoveType"] | undefined | null,
	purpose?: ModelTypes["ProductMovePurpose"] | undefined | null,
	moves?: Array<ModelTypes["ProductMove"] | undefined | null> | undefined | null,
	note?: string | undefined | null,
	url?: string | undefined | null,
	pdfWOPricesUrl?: string | undefined | null,
	dateCreated?: ModelTypes["DateTime"] | undefined | null,
	order?: ModelTypes["Order"] | undefined | null,
	checkout?: ModelTypes["Checkout"] | undefined | null,
	depotFrom?: ModelTypes["Depot"] | undefined | null,
	depotTo?: ModelTypes["Depot"] | undefined | null,
	incidentalCosts?: number | undefined | null,
	purchasePrice?: number | undefined | null,
	purchasePriceWithVat?: number | undefined | null,
	purchaseOrder?: ModelTypes["PurchaseOrder"] | undefined | null,
	createdBy?: ModelTypes["User"] | undefined | null,
	files?: Array<ModelTypes["File"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<ModelTypes["Tag"] | undefined | null> | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	deletable?: boolean | undefined | null
};
	["ProductMoveType"]: {
		id?: string | undefined | null,
	name?: string | undefined | null
};
	["ProductMovePurpose"]: {
		id?: string | undefined | null,
	name?: string | undefined | null
};
	["PurchaseOrder"]: {
		id?: number | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	status?: ModelTypes["PurchaseOrderStatus"] | undefined | null,
	supplier?: ModelTypes["Supplier"] | undefined | null,
	depot?: ModelTypes["Depot"] | undefined | null,
	items?: Array<ModelTypes["PurchaseOrderItem"] | undefined | null> | undefined | null,
	files?: Array<ModelTypes["File"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<ModelTypes["Tag"] | undefined | null> | undefined | null,
	number?: string | undefined | null,
	note?: string | undefined | null,
	privateNote?: string | undefined | null,
	dateEstimatedArrival?: ModelTypes["DateTime"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Externí reference */
	externalReference?: string | undefined | null,
	/** Reference dodavatele */
	supplierReference?: string | undefined | null,
	purchasePriceAll?: number | undefined | null,
	purchasePriceAllWithVat?: number | undefined | null,
	productMovePacks?: Array<ModelTypes["ProductMovePack"] | undefined | null> | undefined | null,
	pdfUrl?: string | undefined | null,
	pdfWOPricesUrl?: string | undefined | null,
	excelUrl?: string | undefined | null,
	excelWOPricesUrl?: string | undefined | null,
	createdBy?: ModelTypes["User"] | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null
};
	["PurchaseOrderStatus"]: {
		id?: string | undefined | null,
	name?: string | undefined | null,
	position?: number | undefined | null
};
	["PurchaseOrderItem"]: {
		id?: number | undefined | null,
	purchaseOrder?: ModelTypes["PurchaseOrder"] | undefined | null,
	currency?: ModelTypes["Currency"] | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	status?: ModelTypes["PurchaseOrderStatus"] | undefined | null,
	quantity?: number | undefined | null,
	purchasePrice?: number | undefined | null,
	purchasePriceAll?: number | undefined | null,
	purchasePriceWithVat?: number | undefined | null,
	purchasePriceAllWithVat?: number | undefined | null,
	productMoves?: Array<ModelTypes["ProductMove"] | undefined | null> | undefined | null,
	note?: string | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Již naskladněný počet kusů */
	quantityIn?: number | undefined | null
};
	["ClearanceItem"]: {
		id?: string | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	amount?: number | undefined | null,
	quantityStock?: number | undefined | null,
	quantityReservation?: number | undefined | null,
	quantityAvailable?: number | undefined | null,
	expirationDate?: ModelTypes["DateTime"] | undefined | null,
	batch?: string | undefined | null,
	position?: string | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	picked?: number | undefined | null,
	packed?: number | undefined | null,
	productMoves?: Array<ModelTypes["ProductMove"] | undefined | null> | undefined | null,
	productDepots?: Array<ModelTypes["ProductDepot"] | undefined | null> | undefined | null,
	orderItems?: Array<ModelTypes["OrderItem"] | undefined | null> | undefined | null,
	locked?: boolean | undefined | null
};
	["Voucher"]: {
		id?: number | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	externalId?: string | undefined | null,
	discountType?: string | undefined | null,
	discountPercent?: number | undefined | null,
	discountValue?: number | undefined | null,
	maxUse?: number | undefined | null,
	validFrom?: ModelTypes["DateTimeAsString"] | undefined | null,
	validTo?: ModelTypes["DateTimeAsString"] | undefined | null,
	isValid?: boolean | undefined | null,
	used?: number | undefined | null,
	paymentItems?: Array<ModelTypes["Product"] | undefined | null> | undefined | null,
	orderItems?: Array<ModelTypes["Product"] | undefined | null> | undefined | null,
	enabled?: boolean | undefined | null,
	isPayment?: boolean | undefined | null
};
	["PaymentItem"]: {
		id?: number | undefined | null,
	amount?: number | undefined | null,
	checkout?: ModelTypes["Checkout"] | undefined | null,
	payment?: ModelTypes["Payment"] | undefined | null,
	voucher?: ModelTypes["Voucher"] | undefined | null,
	dateCreated?: ModelTypes["DateTime"] | undefined | null,
	dateCancelled?: ModelTypes["DateTime"] | undefined | null,
	isPaid?: boolean | undefined | null,
	datePaid?: ModelTypes["DateTime"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null
};
	["Customer"]: {
		id?: number | undefined | null,
	externalId?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	companyName?: string | undefined | null,
	addresses?: Array<ModelTypes["Address"] | undefined | null> | undefined | null,
	wholesale?: boolean | undefined | null,
	note?: string | undefined | null,
	consentRelations?: Array<ModelTypes["CustomerConsent"] | undefined | null> | undefined | null,
	birthday?: ModelTypes["DateTime"] | undefined | null,
	users?: Array<ModelTypes["User"] | undefined | null> | undefined | null,
	minExpirationDays?: number | undefined | null,
	priceLevel?: ModelTypes["PriceLevel"] | undefined | null,
	/** Tagy */
	tags?: Array<ModelTypes["Tag"] | undefined | null> | undefined | null,
	/** Cokoli... */
	customData?: string | undefined | null
};
	["Address"]: {
		id?: number | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	customer?: ModelTypes["Customer"] | undefined | null,
	companyName?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	street?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	state?: string | undefined | null,
	zip?: string | undefined | null,
	ic?: string | undefined | null,
	dic?: string | undefined | null,
	phone?: string | undefined | null,
	email?: string | undefined | null,
	isStored?: boolean | undefined | null,
	isBilling?: boolean | undefined | null,
	zasilkovnaAddressId?: string | undefined | null,
	branchId?: string | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Poznámka */
	note?: string | undefined | null,
	/** Cokoli... */
	customData?: string | undefined | null
};
	["CustomerConsent"]: {
		id?: number | undefined | null,
	customer?: ModelTypes["Customer"] | undefined | null,
	consent?: ModelTypes["Consent"] | undefined | null,
	name?: string | undefined | null,
	body?: string | undefined | null,
	externalId?: string | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null
};
	["Consent"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	body?: string | undefined | null,
	externalId?: string | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	updated?: ModelTypes["DateTime"] | undefined | null,
	company?: ModelTypes["Company"] | undefined | null
};
	["Receipt"]: {
		id?: number | undefined | null,
	dic?: string | undefined | null,
	checkoutEetId?: number | undefined | null,
	shopEetId?: number | undefined | null,
	playground?: boolean | undefined | null,
	verificationMode?: boolean | undefined | null,
	number?: number | undefined | null,
	dateCreated?: ModelTypes["DateTime"] | undefined | null,
	totalPrice?: number | undefined | null,
	priceZeroVat?: number | undefined | null,
	priceStandardVat?: number | undefined | null,
	vatStandard?: number | undefined | null,
	priceFirstReducedVat?: number | undefined | null,
	vatFirstReduced?: number | undefined | null,
	priceSecondReducedVat?: number | undefined | null,
	vatSecondReduced?: number | undefined | null,
	priceForSubsequentSettlement?: number | undefined | null,
	priceUsedSubsequentSettlement?: number | undefined | null,
	fik?: string | undefined | null,
	bkp?: string | undefined | null,
	pkp?: string | undefined | null
};
	["VatAllocation"]: {
		vat?: ModelTypes["Vat"] | undefined | null,
	priceWithoutVat?: number | undefined | null,
	vatPrice?: number | undefined | null,
	price?: number | undefined | null
};
	["ProcessStatus"]: {
		id?: string | undefined | null,
	name?: string | undefined | null,
	position?: number | undefined | null
};
	["OrderProcessStatus"]: {
		status?: ModelTypes["ProcessStatus"] | undefined | null,
	note?: string | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	createdBy?: ModelTypes["User"] | undefined | null,
	actual?: boolean | undefined | null
};
	["Package"]: {
		id?: number | undefined | null,
	code?: string | undefined | null,
	carrier?: ModelTypes["Carrier"] | undefined | null,
	tariff?: ModelTypes["CarrierTariff"] | undefined | null,
	items?: Array<ModelTypes["OrderItem"] | undefined | null> | undefined | null,
	statuses?: Array<ModelTypes["PackageStatus"] | undefined | null> | undefined | null,
	ticketUrl?: string | undefined | null,
	sent?: ModelTypes["DateTime"] | undefined | null,
	order?: ModelTypes["Order"] | undefined | null,
	disposal?: ModelTypes["PackageDisposal"] | undefined | null,
	weight?: number | undefined | null,
	weightRequired?: boolean | undefined | null,
	dimensionsRequired?: boolean | undefined | null,
	dimensionX?: number | undefined | null,
	dimensionY?: number | undefined | null,
	dimensionZ?: number | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	clearanceItems?: Array<ModelTypes["ClearanceItem"] | undefined | null> | undefined | null
};
	["PackageStatus"]: {
		id?: number | undefined | null,
	code?: string | undefined | null,
	text?: string | undefined | null,
	package?: ModelTypes["Package"] | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null
};
	["PackageDisposal"]: {
		id?: number | undefined | null,
	code?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	carrier?: ModelTypes["Carrier"] | undefined | null,
	packages?: Array<ModelTypes["Package"] | undefined | null> | undefined | null,
	ticketUrl?: string | undefined | null,
	sent?: ModelTypes["DateTime"] | undefined | null,
	files?: Array<ModelTypes["File"] | undefined | null> | undefined | null
};
	["OrderGroup"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	company?: ModelTypes["Company"] | undefined | null,
	orders?: Array<ModelTypes["Order"] | undefined | null> | undefined | null,
	user?: ModelTypes["User"] | undefined | null,
	userPosition?: number | undefined | null,
	clearanceItems?: Array<ModelTypes["ClearanceItem"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<ModelTypes["Tag"] | undefined | null> | undefined | null
};
	["CheckoutExtraOperation"]: {
		id?: number | undefined | null,
	dateCreated?: ModelTypes["DateTime"] | undefined | null,
	amount?: number | undefined | null,
	note?: string | undefined | null,
	user?: ModelTypes["User"] | undefined | null,
	checkout?: ModelTypes["Checkout"] | undefined | null,
	checkoutClosing?: ModelTypes["CheckoutClosing"] | undefined | null
};
	["paymentSum"]: {
		payment?: ModelTypes["Payment"] | undefined | null,
	count?: number | undefined | null,
	sum?: number | undefined | null
};
	["CompanyModule"]: {
		id?: number | undefined | null,
	module?: ModelTypes["Module"] | undefined | null
};
	["Module"]: {
		id?: string | undefined | null,
	name?: string | undefined | null
};
	["Tariff"]: {
		id?: string | undefined | null,
	name?: string | undefined | null
};
	["userMyProfile"]: {
		data?: ModelTypes["User"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["userFilters"]: {
	pin?: string | undefined | null,
	email?: string | undefined | null,
	fulltext?: string | undefined | null,
	groups?: Array<number | undefined | null> | undefined | null,
	roles?: Array<string | undefined | null> | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	enabled?: boolean | undefined | null
};
	["users"]: {
		items?: Array<ModelTypes["User"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["Paginator"]: {
		current?: number | undefined | null,
	currentItemCount?: number | undefined | null,
	endPage?: number | undefined | null,
	first?: number | undefined | null,
	firstItemNumber?: number | undefined | null,
	firstPageInRange?: number | undefined | null,
	last?: number | undefined | null,
	lastItemNumber?: number | undefined | null,
	lastPageInRange?: number | undefined | null,
	next?: number | undefined | null,
	numItemsPerPage?: number | undefined | null,
	pageCount?: number | undefined | null,
	pageRange?: number | undefined | null,
	startPage?: number | undefined | null,
	totalCount?: number | undefined | null,
	pagesInRange?: Array<number | undefined | null> | undefined | null
};
	["isUserEmailUnique"]: {
		data?: boolean | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["userGroup"]: {
		data?: ModelTypes["UserGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["userGroupFilters"]: {
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["userGroups"]: {
		items?: Array<ModelTypes["UserGroup"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["Role"]: {
		name?: string | undefined | null,
	role?: string | undefined | null
};
	["product"]: {
		data?: ModelTypes["Product"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productFilters"]: {
	id?: number | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	name?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	codes?: Array<string | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	fulltext?: string | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	metricDepots?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null,
	defaultSuppliers?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	listType?: string | undefined | null,
	availability?: string | undefined | null,
	enabled?: boolean | undefined | null,
	isBundle?: boolean | undefined | null,
	expirationDateTo?: ModelTypes["DateTimeAsString"] | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	hasBeforeSellPrice?: boolean | undefined | null,
	hasHsCode?: boolean | undefined | null,
	createdFrom?: ModelTypes["DateTimeAsString"] | undefined | null,
	updatedFrom?: ModelTypes["DateTimeAsString"] | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null,
	categories?: Array<number | undefined | null> | undefined | null,
	metrics?: string | undefined | null,
	enabledBatchExpiration?: boolean | undefined | null,
	requiredSerialNumbers?: boolean | undefined | null,
	company?: number | undefined | null
};
	["products"]: {
		items?: Array<ModelTypes["Product"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["productPurchasePrice"]: {
		items?: Array<ModelTypes["ProductPurchasePrice"] | undefined | null> | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["ProductPurchasePrice"]: {
		productDepot?: ModelTypes["Depot"] | undefined | null,
	quantity?: number | undefined | null,
	purchasePrice?: number | undefined | null
};
	["productSellItems"]: {
		items?: Array<ModelTypes["SellItem"] | undefined | null> | undefined | null
};
	["productMovePackFilters"]: {
	fulltext?: string | undefined | null,
	type?: string | undefined | null,
	depot?: number | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	depotFrom?: number | undefined | null,
	depotTo?: number | undefined | null,
	depotsFrom?: Array<number | undefined | null> | undefined | null,
	depotsTo?: Array<number | undefined | null> | undefined | null,
	number?: number | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	withoutCheckout?: boolean | undefined | null,
	product?: number | undefined | null,
	productFulltext?: string | undefined | null,
	order?: number | undefined | null,
	orderFulltext?: string | undefined | null,
	withOrder?: boolean | undefined | null,
	createdBy?: number | undefined | null,
	created?: ModelTypes["created"] | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	externalReference?: string | undefined | null,
	purchaseOrder?: number | undefined | null,
	incidentalCosts?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["created"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["productMovePacks"]: {
		items?: Array<ModelTypes["ProductMovePack"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["productMoveFilters"]: {
	product?: number | undefined | null,
	products?: Array<number | undefined | null> | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	type?: string | undefined | null,
	depotFrom?: number | undefined | null,
	depotTo?: number | undefined | null,
	createdBy?: number | undefined | null,
	created?: ModelTypes["created"] | undefined | null,
	expirationDate?: ModelTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	withoutCheckout?: boolean | undefined | null
};
	["productMoves"]: {
		items?: Array<ModelTypes["ProductMove"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["productMovePack"]: {
		data?: ModelTypes["ProductMovePack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["institution"]: {
		data?: ModelTypes["Institution"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["institutionFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["institutions"]: {
		items?: Array<ModelTypes["Institution"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["order"]: {
		data?: ModelTypes["Order"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["orderFilters"]: {
	fulltext?: string | undefined | null,
	reservationNumber?: number | undefined | null,
	billNumber?: number | undefined | null,
	notes?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	onlyDepots?: Array<number | undefined | null> | undefined | null,
	payments?: Array<number | undefined | null> | undefined | null,
	status?: string | undefined | null,
	processStatus?: string | undefined | null,
	processStatusChange?: ModelTypes["DateTimeAsString"] | undefined | null,
	processStatusUpdated?: ModelTypes["processStatusUpdated"] | undefined | null,
	isPaid?: boolean | undefined | null,
	carrier?: string | undefined | null,
	carriers?: Array<string | undefined | null> | undefined | null,
	deleted?: boolean | undefined | null,
	dateCreated?: ModelTypes["dateCreated"] | undefined | null,
	dateBill?: ModelTypes["dateBill"] | undefined | null,
	dateExpedition?: ModelTypes["dateExpedition"] | undefined | null,
	dateDue?: ModelTypes["dateDue"] | undefined | null,
	dateTax?: ModelTypes["dateTax"] | undefined | null,
	updated?: ModelTypes["updated"] | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	box?: string | undefined | null,
	item?: string | undefined | null,
	package?: string | undefined | null,
	customer?: number | undefined | null,
	customerFulltext?: string | undefined | null,
	shippingCountries?: Array<string | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	user?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null,
	hasAvailableProducts?: boolean | undefined | null,
	hasGroup?: boolean | undefined | null,
	group?: number | undefined | null,
	groups?: Array<number | undefined | null> | undefined | null,
	createdBy?: Array<number | undefined | null> | undefined | null,
	locked?: boolean | undefined | null,
	dateLocked?: ModelTypes["DateTimeAsString"] | undefined | null,
	lockedBy?: Array<number | undefined | null> | undefined | null,
	priority?: number | undefined | null
};
	["processStatusUpdated"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["dateCreated"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["dateBill"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["dateExpedition"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["dateDue"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["dateTax"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["updated"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["orders"]: {
		items?: Array<ModelTypes["Order"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["soldItemFilters"]: {
	productFulltext?: string | undefined | null,
	customerFulltext?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	payments?: Array<number | undefined | null> | undefined | null,
	status?: string | undefined | null,
	processStatus?: string | undefined | null,
	processStatusUpdated?: ModelTypes["processStatusUpdated"] | undefined | null,
	carriers?: Array<string | undefined | null> | undefined | null,
	dateCreated?: ModelTypes["dateCreated"] | undefined | null,
	dateBill?: ModelTypes["dateBill"] | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	customer?: number | undefined | null,
	product?: number | undefined | null,
	shippingCountries?: Array<string | undefined | null> | undefined | null,
	orderTags?: Array<number | undefined | null> | undefined | null,
	productTags?: Array<number | undefined | null> | undefined | null
};
	["soldItems"]: {
		items?: Array<ModelTypes["SoldItem"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["SoldItem"]: {
		name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	priceAll?: number | undefined | null,
	priceAllWithoutVat?: number | undefined | null,
	product?: ModelTypes["Product"] | undefined | null,
	profit?: number | undefined | null
};
	["orderItemFilters"]: {
	status?: string | undefined | null,
	processStatus?: string | undefined | null,
	order?: number | undefined | null,
	productDepot?: number | undefined | null,
	carrier?: string | undefined | null
};
	["orderItems"]: {
		items?: Array<ModelTypes["OrderItem"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["orderItem"]: {
		data?: ModelTypes["OrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["customer"]: {
		data?: ModelTypes["Customer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["customerFilters"]: {
	externalId?: string | undefined | null,
	email?: string | undefined | null,
	fulltext?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	user?: number | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	priceLevel?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["customers"]: {
		items?: Array<ModelTypes["Customer"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["address"]: {
		data?: ModelTypes["Address"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["addressesFilters"]: {
	customer?: number | undefined | null,
	externalId?: string | undefined | null,
	isStored?: boolean | undefined | null,
	isBilling?: boolean | undefined | null,
	ic?: string | undefined | null,
	dic?: string | undefined | null,
	phone?: string | undefined | null,
	email?: string | undefined | null
};
	["addresses"]: {
		items?: Array<ModelTypes["Address"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["checkout"]: {
		data?: ModelTypes["Checkout"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["checkoutFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	user?: number | undefined | null
};
	["checkouts"]: {
		items?: Array<ModelTypes["Checkout"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["eventTypes"]: {
		items?: Array<string | undefined | null> | undefined | null
};
	["consent"]: {
		data?: ModelTypes["Consent"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["consentsFilters"]: {
	name?: string | undefined | null
};
	["consents"]: {
		items?: Array<ModelTypes["Consent"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["checkoutExtraOperation"]: {
		data?: ModelTypes["CheckoutExtraOperation"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["checkoutExtraOperationFilters"]: {
	checkout?: number | undefined | null,
	checkoutClosing?: number | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null
};
	["checkoutExtraOperations"]: {
		items?: Array<ModelTypes["CheckoutExtraOperation"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["checkoutClosing"]: {
		data?: ModelTypes["CheckoutClosing"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["checkoutClosingFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["checkoutClosings"]: {
		items?: Array<ModelTypes["CheckoutClosing"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["vat"]: {
		data?: ModelTypes["Vat"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["vatFilters"]: {
	name?: string | undefined | null,
	percent?: number | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["vats"]: {
		items?: Array<ModelTypes["Vat"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["depot"]: {
		data?: ModelTypes["Depot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["depotFilters"]: {
	companies?: Array<number | undefined | null> | undefined | null,
	name?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	user?: number | undefined | null
};
	["depots"]: {
		items?: Array<ModelTypes["Depot"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["supplier"]: {
		data?: ModelTypes["Supplier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["supplierFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["suppliers"]: {
		items?: Array<ModelTypes["Supplier"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["producer"]: {
		data?: ModelTypes["Producer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["producerFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["producers"]: {
		items?: Array<ModelTypes["Producer"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["exportStockFilters"]: {
	depots?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null
};
	["exportStocks"]: {
		items?: Array<ModelTypes["Stock"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["Stock"]: {
		id?: number | undefined | null,
	date?: ModelTypes["DateTime"] | undefined | null,
	generated?: ModelTypes["DateTime"] | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	depots?: Array<ModelTypes["Depot"] | undefined | null> | undefined | null,
	suppliers?: Array<ModelTypes["Supplier"] | undefined | null> | undefined | null,
	producers?: Array<ModelTypes["Producer"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	format?: string | undefined | null
};
	["exportSaleFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null
};
	["exportSales"]: {
		items?: Array<ModelTypes["Sale"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["Sale"]: {
		id?: number | undefined | null,
	dateFrom?: ModelTypes["DateTime"] | undefined | null,
	dateTo?: ModelTypes["DateTime"] | undefined | null,
	generated?: ModelTypes["DateTime"] | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	checkouts?: Array<ModelTypes["Checkout"] | undefined | null> | undefined | null,
	suppliers?: Array<ModelTypes["Supplier"] | undefined | null> | undefined | null,
	producers?: Array<ModelTypes["Producer"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	format?: string | undefined | null
};
	["exportPurchaseFilters"]: {
	depots?: Array<number | undefined | null> | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null
};
	["exportPurchases"]: {
		items?: Array<ModelTypes["Purchase"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["Purchase"]: {
		id?: number | undefined | null,
	dateFrom?: ModelTypes["DateTime"] | undefined | null,
	dateTo?: ModelTypes["DateTime"] | undefined | null,
	generated?: ModelTypes["DateTime"] | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	depots?: Array<ModelTypes["Depot"] | undefined | null> | undefined | null,
	checkouts?: Array<ModelTypes["Checkout"] | undefined | null> | undefined | null,
	suppliers?: Array<ModelTypes["Supplier"] | undefined | null> | undefined | null,
	producers?: Array<ModelTypes["Producer"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	format?: string | undefined | null
};
	["exportOrderFilters"]: {
	status?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null
};
	["exportOrders"]: {
		items?: Array<ModelTypes["exportOrder"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["exportOrder"]: {
		id?: number | undefined | null,
	dateFrom?: ModelTypes["DateTime"] | undefined | null,
	dateTo?: ModelTypes["DateTime"] | undefined | null,
	generated?: ModelTypes["DateTime"] | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	status?: ModelTypes["OrderStatus"] | undefined | null,
	checkouts?: Array<ModelTypes["Checkout"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	format?: string | undefined | null
};
	["exportInventory"]: {
		data?: ModelTypes["Inventory"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["Inventory"]: {
		id?: number | undefined | null,
	date?: ModelTypes["DateTime"] | undefined | null,
	generated?: ModelTypes["DateTime"] | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	depots?: Array<ModelTypes["Depot"] | undefined | null> | undefined | null,
	suppliers?: Array<ModelTypes["Supplier"] | undefined | null> | undefined | null,
	producers?: Array<ModelTypes["Producer"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	files?: Array<ModelTypes["File"] | undefined | null> | undefined | null,
	approved?: ModelTypes["DateTime"] | undefined | null,
	rejected?: ModelTypes["DateTime"] | undefined | null,
	finished?: ModelTypes["DateTime"] | undefined | null,
	pmpIn?: ModelTypes["ProductMovePack"] | undefined | null,
	pmpOut?: ModelTypes["ProductMovePack"] | undefined | null
};
	["exportInventoryFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null,
	approved?: boolean | undefined | null,
	rejected?: boolean | undefined | null,
	finished?: boolean | undefined | null
};
	["exportInventories"]: {
		items?: Array<ModelTypes["Inventory"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["export"]: {
		data?: ModelTypes["Export"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["Export"]: {
		id?: number | undefined | null,
	file?: ModelTypes["File"] | undefined | null,
	generated?: ModelTypes["DateTime"] | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null,
	url?: string | undefined | null,
	type?: ModelTypes["ExportType"] | undefined | null,
	filter?: string | undefined | null,
	createdBy?: ModelTypes["User"] | undefined | null,
	note?: string | undefined | null
};
	["ExportType"]: {
		id?: string | undefined | null,
	name?: string | undefined | null,
	format?: string | undefined | null,
	group?: string | undefined | null
};
	["exportFilters"]: {
	types?: Array<string | undefined | null> | undefined | null,
	group?: string | undefined | null
};
	["exports"]: {
		items?: Array<ModelTypes["Export"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["exportTypeFilters"]: {
	group?: string | undefined | null
};
	["exportTypes"]: {
		items?: Array<ModelTypes["ExportType"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["shop"]: {
		data?: ModelTypes["Shop"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["Shop"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	street?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	zip?: string | undefined | null,
	eetId?: number | undefined | null,
	cert?: ModelTypes["Cert"] | undefined | null,
	checkouts?: Array<ModelTypes["Checkout"] | undefined | null> | undefined | null,
	company?: ModelTypes["Company"] | undefined | null
};
	["Cert"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	publicKey?: string | undefined | null,
	expirationDate?: ModelTypes["DateTime"] | undefined | null,
	company?: ModelTypes["Company"] | undefined | null
};
	["shopFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["shops"]: {
		items?: Array<ModelTypes["Shop"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["cert"]: {
		data?: ModelTypes["Cert"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["filters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["certs"]: {
		items?: Array<ModelTypes["Cert"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["eetReceiptFilters"]: {
	checkouts?: Array<number | undefined | null> | undefined | null,
	number?: number | undefined | null,
	hasFik?: boolean | undefined | null,
	playground?: boolean | undefined | null,
	verificationMode?: boolean | undefined | null
};
	["eetReceipts"]: {
		items?: Array<ModelTypes["Receipt"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["payment"]: {
		data?: ModelTypes["Payment"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["paymentFilters"]: {
	company?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["payments"]: {
		items?: Array<ModelTypes["Payment"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["paymentItem"]: {
		data?: ModelTypes["PaymentItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["paymentItemsFilters"]: {
	order?: number | undefined | null,
	type?: string | undefined | null,
	payment?: number | undefined | null,
	externalId?: string | undefined | null
};
	["paymentItems"]: {
		items?: Array<ModelTypes["PaymentItem"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["paymentTypeFilters"]: {
	const?: string | undefined | null
};
	["paymentTypes"]: {
		items?: Array<ModelTypes["PaymentType"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["processStatusesFilters"]: {
	name?: string | undefined | null
};
	["processStatuses"]: {
		items?: Array<ModelTypes["ProcessStatus"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["carriersFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["carriers"]: {
		items?: Array<ModelTypes["Carrier"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["currenciesFilters"]: {
	name?: string | undefined | null
};
	["currencies"]: {
		items?: Array<ModelTypes["Currency"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["package"]: {
		data?: ModelTypes["Package"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["packageFilters"]: {
	code?: string | undefined | null,
	carrier?: string | undefined | null,
	order?: number | undefined | null,
	disposal?: number | undefined | null,
	hasDisposal?: boolean | undefined | null,
	isSent?: boolean | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	sent?: string | undefined | null
};
	["packages"]: {
		items?: Array<ModelTypes["Package"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["packageStatsFilters"]: {
	carrier?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	fromDate?: ModelTypes["DateTimeAsString"] | undefined | null,
	toDate?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["packageStats"]: {
		items?: Array<ModelTypes["PackageStats"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["PackageStats"]: {
		company?: ModelTypes["Company"] | undefined | null,
	processStatus?: ModelTypes["ProcessStatus"] | undefined | null,
	packageAmount?: number | undefined | null,
	orderAmount?: number | undefined | null,
	country?: string | undefined | null
};
	["disposal"]: {
		data?: ModelTypes["PackageDisposal"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["disposalFilters"]: {
	carrier?: string | undefined | null
};
	["disposals"]: {
		items?: Array<ModelTypes["PackageDisposal"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["productDepotMetric"]: {
		data?: ModelTypes["ProductDepotMetric"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productDepotMetricFilters"]: {
	product?: number | undefined | null,
	depot?: number | undefined | null
};
	["productDepotMetrics"]: {
		items?: Array<ModelTypes["ProductDepotMetric"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["file"]: {
		data?: ModelTypes["File"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["fileFilters"]: {
	product?: number | undefined | null,
	order?: number | undefined | null
};
	["files"]: {
		items?: Array<ModelTypes["File"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["nextEan"]: {
		data?: string | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["statsCarrierUsage"]: {
		items?: Array<ModelTypes["CarrierUsage"] | undefined | null> | undefined | null
};
	["CarrierUsage"]: {
		amount?: number | undefined | null,
	carrier?: ModelTypes["Carrier"] | undefined | null
};
	["statsPaymentSales"]: {
		items?: Array<ModelTypes["PaymentSales"] | undefined | null> | undefined | null
};
	["PaymentSales"]: {
		amount?: number | undefined | null,
	sales?: Array<ModelTypes["Price"] | undefined | null> | undefined | null,
	payment?: ModelTypes["Payment"] | undefined | null
};
	["Price"]: {
		value?: number | undefined | null,
	currency?: ModelTypes["Currency"] | undefined | null
};
	["statsBestsellersSort"]:statsBestsellersSort;
	["statsBestsellers"]: {
		items?: Array<ModelTypes["Bestsellers"] | undefined | null> | undefined | null
};
	["Bestsellers"]: {
		amount?: number | undefined | null,
	sales?: Array<ModelTypes["Price"] | undefined | null> | undefined | null,
	product?: ModelTypes["Product"] | undefined | null
};
	["companyCarrier"]: {
		data?: ModelTypes["CompanyCarrier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["companyCarrierFilters"]: {
	carrier?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["companyCarriers"]: {
		items?: Array<ModelTypes["CompanyCarrier"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["category"]: {
		data?: ModelTypes["Category"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["categoryFilters"]: {
	name?: string | undefined | null,
	parent?: number | undefined | null,
	hasParent?: boolean | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["categories"]: {
		items?: Array<ModelTypes["Category"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["parameter"]: {
		data?: ModelTypes["Parameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["parametersFilters"]: {
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["parameters"]: {
		items?: Array<ModelTypes["Parameter"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["orderGroup"]: {
		data?: ModelTypes["OrderGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["orderGroupFilters"]: {
	companies?: Array<number | undefined | null> | undefined | null,
	hasUser?: boolean | undefined | null,
	user?: number | undefined | null,
	name?: string | undefined | null,
	processStatus?: string | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["orderGroups"]: {
		items?: Array<ModelTypes["OrderGroup"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["voucher"]: {
		data?: ModelTypes["Voucher"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["voucherFilters"]: {
	companies?: Array<number | undefined | null> | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	externalId?: string | undefined | null,
	discountType?: string | undefined | null,
	enabled?: boolean | undefined | null,
	isPayment?: boolean | undefined | null,
	isValid?: boolean | undefined | null,
	isUsed?: boolean | undefined | null,
	validDate?: ModelTypes["voucherValidFilter"] | undefined | null,
	created?: ModelTypes["voucherCreatedFilter"] | undefined | null
};
	["voucherValidFilter"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["voucherCreatedFilter"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["vouchers"]: {
		items?: Array<ModelTypes["Voucher"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["productPriceFilters"]: {
	product?: number | undefined | null
};
	["productPrices"]: {
		items?: Array<ModelTypes["ProductPrice"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["priceLevel"]: {
		data?: ModelTypes["PriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["priceLevelFilters"]: {
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	isPercentage?: boolean | undefined | null,
	withVat?: boolean | undefined | null,
	currency?: string | undefined | null
};
	["priceLevels"]: {
		items?: Array<ModelTypes["PriceLevel"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["productParameter"]: {
		data?: ModelTypes["ProductParameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productParameterFilters"]: {
	product?: number | undefined | null,
	parameter?: number | undefined | null,
	value?: string | undefined | null,
	externalId?: string | undefined | null
};
	["productParameters"]: {
		items?: Array<ModelTypes["ProductParameter"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["productPriceLevel"]: {
		data?: ModelTypes["ProductPriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productPriceLevelFilters"]: {
	product?: number | undefined | null,
	priceLevel?: number | undefined | null,
	externalId?: string | undefined | null
};
	["productPriceLevels"]: {
		items?: Array<ModelTypes["ProductPriceLevel"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["tag"]: {
		data?: ModelTypes["Tag"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["tagFilters"]: {
	name?: string | undefined | null,
	type?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["tags"]: {
		items?: Array<ModelTypes["Tag"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["tagTypeFilters"]: {
	const?: string | undefined | null
};
	["tagTypes"]: {
		items?: Array<ModelTypes["TagType"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["TagType"]: {
		id?: string | undefined | null,
	name?: string | undefined | null
};
	["productPack"]: {
		data?: ModelTypes["ProductPack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productPackFilters"]: {
	product?: number | undefined | null,
	quantity?: number | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	externalId?: string | undefined | null
};
	["productPacks"]: {
		items?: Array<ModelTypes["ProductPack"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["purchaseOrder"]: {
		data?: ModelTypes["PurchaseOrder"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["purchaseOrderFilters"]: {
	fulltext?: string | undefined | null,
	status?: string | undefined | null,
	showStocked?: boolean | undefined | null,
	supplier?: number | undefined | null,
	depot?: number | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	number?: number | undefined | null,
	externalId?: string | undefined | null,
	externalReference?: string | undefined | null,
	supplierReference?: string | undefined | null,
	createdBy?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null,
	updated?: ModelTypes["updated"] | undefined | null,
	created?: ModelTypes["created"] | undefined | null,
	dateEstimatedArrival?: ModelTypes["dateEstimatedArrival"] | undefined | null,
	company?: number | undefined | null
};
	["dateEstimatedArrival"]: {
	left_date?: ModelTypes["DateTimeAsString"] | undefined | null,
	right_date?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["purchaseOrders"]: {
		items?: Array<ModelTypes["PurchaseOrder"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["purchaseOrderItem"]: {
		data?: ModelTypes["PurchaseOrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["purchaseOrderItemFilters"]: {
	fulltext?: string | undefined | null,
	purchaseOrder?: number | undefined | null,
	depot?: number | undefined | null,
	product?: number | undefined | null,
	currency?: string | undefined | null,
	externalId?: string | undefined | null,
	status?: string | undefined | null,
	supplier?: number | undefined | null,
	company?: number | undefined | null
};
	["purchaseOrderItems"]: {
		items?: Array<ModelTypes["PurchaseOrderItem"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["purchaseOrderStatusesFilters"]: {
	name?: string | undefined | null
};
	["purchaseOrderStatuses"]: {
		items?: Array<ModelTypes["PurchaseOrderStatus"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["modulesFilters"]: {
	name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["modules"]: {
		items?: Array<ModelTypes["Module"] | undefined | null> | undefined | null,
	paginator?: ModelTypes["Paginator"] | undefined | null
};
	["RootSchemaMutation"]: {
		createProduct?: ModelTypes["createProduct"] | undefined | null,
	updateProduct?: ModelTypes["updateProduct"] | undefined | null,
	deleteProduct?: ModelTypes["deleteProduct"] | undefined | null,
	refreshProductDepots?: ModelTypes["refreshProductDepots"] | undefined | null,
	createProductMovePack?: ModelTypes["createProductMovePack"] | undefined | null,
	updateProductMovePack?: ModelTypes["updateProductMovePack"] | undefined | null,
	deleteProductMovePack?: ModelTypes["deleteProductMovePack"] | undefined | null,
	updateProductMove?: ModelTypes["updateProductMove"] | undefined | null,
	deleteProductMove?: ModelTypes["deleteProductMove"] | undefined | null,
	createProductPrice?: ModelTypes["createProductPrice"] | undefined | null,
	updateProductPrice?: ModelTypes["updateProductPrice"] | undefined | null,
	deleteProductPrice?: ModelTypes["deleteProductPrice"] | undefined | null,
	createProductBundle?: ModelTypes["createProductBundle"] | undefined | null,
	updateProductBundle?: ModelTypes["updateProductBundle"] | undefined | null,
	deleteProductBundle?: ModelTypes["deleteProductBundle"] | undefined | null,
	createProductDepotMetric?: ModelTypes["createProductDepotMetric"] | undefined | null,
	updateProductDepotMetric?: ModelTypes["updateProductDepotMetric"] | undefined | null,
	deleteProductDepotMetric?: ModelTypes["deleteProductDepotMetric"] | undefined | null,
	createInstitution?: ModelTypes["createInstitution"] | undefined | null,
	updateInstitution?: ModelTypes["updateInstitution"] | undefined | null,
	deleteInstitution?: ModelTypes["deleteInstitution"] | undefined | null,
	createOrder?: ModelTypes["createOrder"] | undefined | null,
	updateOrder?: ModelTypes["updateOrder"] | undefined | null,
	deleteReservation?: ModelTypes["deleteReservation"] | undefined | null,
	createOrderItem?: ModelTypes["createOrderItem"] | undefined | null,
	updateOrderItem?: ModelTypes["updateOrderItem"] | undefined | null,
	deleteOrderItem?: ModelTypes["deleteOrderItem"] | undefined | null,
	updateClearanceItem?: ModelTypes["updateClearanceItem"] | undefined | null,
	createUser?: ModelTypes["createUser"] | undefined | null,
	updateUser?: ModelTypes["updateUser"] | undefined | null,
	deleteUser?: ModelTypes["deleteUser"] | undefined | null,
	createUserGroup?: ModelTypes["createUserGroup"] | undefined | null,
	updateUserGroup?: ModelTypes["updateUserGroup"] | undefined | null,
	deleteUserGroup?: ModelTypes["deleteUserGroup"] | undefined | null,
	createCustomer?: ModelTypes["createCustomer"] | undefined | null,
	updateCustomer?: ModelTypes["updateCustomer"] | undefined | null,
	deleteCustomer?: ModelTypes["deleteCustomer"] | undefined | null,
	createAddress?: ModelTypes["createAddress"] | undefined | null,
	updateAddress?: ModelTypes["updateAddress"] | undefined | null,
	deleteAddress?: ModelTypes["deleteAddress"] | undefined | null,
	createCheckout?: ModelTypes["createCheckout"] | undefined | null,
	updateCheckout?: ModelTypes["updateCheckout"] | undefined | null,
	deleteCheckout?: ModelTypes["deleteCheckout"] | undefined | null,
	createCheckoutExtraOperation?: ModelTypes["createCheckoutExtraOperation"] | undefined | null,
	updateCheckoutExtraOperation?: ModelTypes["updateCheckoutExtraOperation"] | undefined | null,
	deleteCheckoutExtraOperation?: ModelTypes["deleteCheckoutExtraOperation"] | undefined | null,
	createCheckoutClosing?: ModelTypes["createCheckoutClosing"] | undefined | null,
	updateCheckoutClosing?: ModelTypes["updateCheckoutClosing"] | undefined | null,
	deleteCheckoutClosing?: ModelTypes["deleteCheckoutClosing"] | undefined | null,
	createVat?: ModelTypes["createVat"] | undefined | null,
	updateVat?: ModelTypes["updateVat"] | undefined | null,
	deleteVat?: ModelTypes["deleteVat"] | undefined | null,
	createDepot?: ModelTypes["createDepot"] | undefined | null,
	updateDepot?: ModelTypes["updateDepot"] | undefined | null,
	deleteDepot?: ModelTypes["deleteDepot"] | undefined | null,
	createSupplier?: ModelTypes["createSupplier"] | undefined | null,
	updateSupplier?: ModelTypes["updateSupplier"] | undefined | null,
	deleteSupplier?: ModelTypes["deleteSupplier"] | undefined | null,
	createProducer?: ModelTypes["createProducer"] | undefined | null,
	updateProducer?: ModelTypes["updateProducer"] | undefined | null,
	deleteProducer?: ModelTypes["deleteProducer"] | undefined | null,
	createExportStock?: ModelTypes["createExportStock"] | undefined | null,
	createExportSale?: ModelTypes["createExportSale"] | undefined | null,
	createExportPurchase?: ModelTypes["createExportPurchase"] | undefined | null,
	createExportOrder?: ModelTypes["createExportOrder"] | undefined | null,
	createExportInventory?: ModelTypes["createExportInventory"] | undefined | null,
	updateExportInventory?: ModelTypes["updateExportInventory"] | undefined | null,
	refreshExportInventory?: ModelTypes["refreshExportInventory"] | undefined | null,
	createExport?: ModelTypes["createExport"] | undefined | null,
	updateCompany?: ModelTypes["updateCompany"] | undefined | null,
	createShop?: ModelTypes["createShop"] | undefined | null,
	updateShop?: ModelTypes["updateShop"] | undefined | null,
	deleteShop?: ModelTypes["deleteShop"] | undefined | null,
	createCert?: ModelTypes["createCert"] | undefined | null,
	updateCert?: ModelTypes["updateCert"] | undefined | null,
	deleteCert?: ModelTypes["deleteCert"] | undefined | null,
	createEetReceipt?: ModelTypes["createEetReceipt"] | undefined | null,
	sendEetReceipt?: ModelTypes["sendEetReceipt"] | undefined | null,
	createPayment?: ModelTypes["createPayment"] | undefined | null,
	updatePayment?: ModelTypes["updatePayment"] | undefined | null,
	deletePayment?: ModelTypes["deletePayment"] | undefined | null,
	createPaymentItem?: ModelTypes["createPaymentItem"] | undefined | null,
	updatePaymentItem?: ModelTypes["updatePaymentItem"] | undefined | null,
	deletePaymentItem?: ModelTypes["deletePaymentItem"] | undefined | null,
	createDevLog?: ModelTypes["createDevLog"] | undefined | null,
	createPackage?: ModelTypes["createPackage"] | undefined | null,
	updatePackage?: ModelTypes["updatePackage"] | undefined | null,
	deletePackage?: ModelTypes["deletePackage"] | undefined | null,
	resetPackage?: ModelTypes["resetPackage"] | undefined | null,
	sendPackage?: ModelTypes["sendPackage"] | undefined | null,
	createDisposal?: ModelTypes["createDisposal"] | undefined | null,
	updateDisposal?: ModelTypes["updateDisposal"] | undefined | null,
	deleteDisposal?: ModelTypes["deleteDisposal"] | undefined | null,
	sendDisposal?: ModelTypes["sendDisposal"] | undefined | null,
	createFile?: ModelTypes["createFile"] | undefined | null,
	updateFile?: ModelTypes["updateFile"] | undefined | null,
	deleteFile?: ModelTypes["deleteFile"] | undefined | null,
	createCompanyCarrier?: ModelTypes["createCompanyCarrier"] | undefined | null,
	updateCompanyCarrier?: ModelTypes["updateCompanyCarrier"] | undefined | null,
	deleteCompanyCarrier?: ModelTypes["deleteCompanyCarrier"] | undefined | null,
	createConsent?: ModelTypes["createConsent"] | undefined | null,
	updateConsent?: ModelTypes["updateConsent"] | undefined | null,
	deleteConsent?: ModelTypes["deleteConsent"] | undefined | null,
	createCustomerConsent?: ModelTypes["createCustomerConsent"] | undefined | null,
	deleteCustomerConsent?: ModelTypes["deleteCustomerConsent"] | undefined | null,
	updateProductDepot?: ModelTypes["updateProductDepot"] | undefined | null,
	createCategory?: ModelTypes["createCategory"] | undefined | null,
	updateCategory?: ModelTypes["updateCategory"] | undefined | null,
	deleteCategory?: ModelTypes["deleteCategory"] | undefined | null,
	createParameter?: ModelTypes["createParameter"] | undefined | null,
	updateParameter?: ModelTypes["updateParameter"] | undefined | null,
	deleteParameter?: ModelTypes["deleteParameter"] | undefined | null,
	createOrderGroup?: ModelTypes["createOrderGroup"] | undefined | null,
	updateOrderGroup?: ModelTypes["updateOrderGroup"] | undefined | null,
	deleteOrderGroup?: ModelTypes["deleteOrderGroup"] | undefined | null,
	createVoucher?: ModelTypes["createVoucher"] | undefined | null,
	updateVoucher?: ModelTypes["updateVoucher"] | undefined | null,
	deleteVoucher?: ModelTypes["deleteVoucher"] | undefined | null,
	createPriceLevel?: ModelTypes["createPricePriceLevel"] | undefined | null,
	updatePriceLevel?: ModelTypes["updatePriceLevel"] | undefined | null,
	deletePriceLevel?: ModelTypes["deletePriceLevel"] | undefined | null,
	createProductParameter?: ModelTypes["createProductParameter"] | undefined | null,
	updateProductParameter?: ModelTypes["updateProductParameter"] | undefined | null,
	deleteProductParameter?: ModelTypes["deleteProductParameter"] | undefined | null,
	createProductPriceLevel?: ModelTypes["createProductPriceLevel"] | undefined | null,
	updateProductPriceLevel?: ModelTypes["updateProductPriceLevel"] | undefined | null,
	deleteProductPriceLevel?: ModelTypes["deleteProductPriceLevel"] | undefined | null,
	createTag?: ModelTypes["createTag"] | undefined | null,
	updateTag?: ModelTypes["updateTag"] | undefined | null,
	deleteTag?: ModelTypes["deleteTag"] | undefined | null,
	createProductPack?: ModelTypes["createProductPack"] | undefined | null,
	updateProductPack?: ModelTypes["updateProductPack"] | undefined | null,
	deleteProductPack?: ModelTypes["deleteProductPack"] | undefined | null,
	createPurchaseOrder?: ModelTypes["createPurchaseOrder"] | undefined | null,
	updatePurchaseOrder?: ModelTypes["updatePurchaseOrder"] | undefined | null,
	deletePurchaseOrder?: ModelTypes["deletePurchaseOrder"] | undefined | null,
	createPurchaseOrderItem?: ModelTypes["createPurchaseOrderItem"] | undefined | null,
	updatePurchaseOrderItem?: ModelTypes["updatePurchaseOrderItem"] | undefined | null,
	deletePurchaseOrderItem?: ModelTypes["deletePurchaseOrderItem"] | undefined | null
};
	["createProduct"]: {
		data?: ModelTypes["Product"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProduct"]: {
		data?: ModelTypes["Product"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProduct"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["refreshProductDepots"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createProductMove"]: {
	product?: number | undefined | null,
	depotFrom?: number | undefined | null,
	depotTo?: number | undefined | null,
	productDepot?: number | undefined | null,
	supplier?: number | undefined | null,
	amount: number,
	purchasePrice?: number | undefined | null,
	purchaseCurrency?: string | undefined | null,
	purchaseCurrencyDate?: ModelTypes["DateTimeAsString"] | undefined | null,
	purchaseOrderItem?: number | undefined | null,
	expirationDate?: ModelTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	note?: string | undefined | null,
	orderItem?: number | undefined | null,
	serialNumbers?: Array<string | undefined | null> | undefined | null
};
	["createProductMovePack"]: {
		data?: ModelTypes["ProductMovePack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductMovePack"]: {
		data?: ModelTypes["ProductMovePack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductMovePack"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductMove"]: {
		data?: ModelTypes["ProductMove"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductMove"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createProductPrice"]: {
		data?: ModelTypes["ProductPrice"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductPrice"]: {
		data?: ModelTypes["ProductPrice"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductPrice"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createProductBundle"]: {
		data?: ModelTypes["ProductBundle"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductBundle"]: {
		data?: ModelTypes["ProductBundle"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductBundle"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createProductDepotMetric"]: {
		data?: ModelTypes["ProductDepotMetric"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductDepotMetric"]: {
		data?: ModelTypes["ProductDepotMetric"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductDepotMetric"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createInstitution"]: {
		data?: ModelTypes["Institution"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateInstitution"]: {
		data?: ModelTypes["Institution"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteInstitution"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createOrderItem_"]: {
	name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	price?: number | undefined | null,
	sale?: number | undefined | null,
	vat?: number | undefined | null,
	product?: number | undefined | null,
	serial?: string | undefined | null,
	expirationDate?: ModelTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	note?: string | undefined | null,
	isForSubsequentSettlement?: boolean | undefined | null,
	picked?: boolean | undefined | null,
	packed?: boolean | undefined | null,
	voucher?: number | undefined | null,
	externalId?: string | undefined | null
};
	["createPaymentItem_"]: {
	payment: number,
	checkout?: number | undefined | null,
	voucher?: number | undefined | null,
	amount: number,
	dateCreated?: ModelTypes["DateTimeAsString"] | undefined | null,
	dateCancelled?: ModelTypes["DateTimeAsString"] | undefined | null,
	externalId?: string | undefined | null,
	isPaid?: boolean | undefined | null,
	datePaid?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["processStatusRelation"]: {
	status?: string | undefined | null,
	note?: string | undefined | null
};
	["createOrder"]: {
		data?: ModelTypes["Order"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateOrderItem_"]: {
	id?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	price?: string | undefined | null,
	sale?: string | undefined | null,
	vat?: number | undefined | null,
	product?: number | undefined | null,
	serial?: string | undefined | null,
	expirationDate?: ModelTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	note?: string | undefined | null,
	isForSubsequentSettlement?: boolean | undefined | null,
	picked?: boolean | undefined | null,
	packed?: boolean | undefined | null,
	voucher?: number | undefined | null,
	externalId?: string | undefined | null
};
	["updatePaymentItem_"]: {
	payment?: number | undefined | null,
	checkout?: number | undefined | null,
	voucher?: number | undefined | null,
	amount?: string | undefined | null,
	dateCreated?: ModelTypes["DateTimeAsString"] | undefined | null,
	dateCancelled?: ModelTypes["DateTimeAsString"] | undefined | null,
	externalId?: string | undefined | null,
	isPaid?: boolean | undefined | null,
	datePaid?: ModelTypes["DateTimeAsString"] | undefined | null
};
	["updateOrder"]: {
		data?: ModelTypes["Order"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteReservation"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createOrderItem"]: {
		data?: ModelTypes["OrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateOrderItem"]: {
		data?: ModelTypes["OrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteOrderItem"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["updateClearanceItemLocations"]: {
	amount: number,
	depot?: number | undefined | null,
	productDepot?: number | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	expirationDate?: ModelTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	locked?: boolean | undefined | null
};
	["updateClearanceItem"]: {
		data?: ModelTypes["ClearanceItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createUser"]: {
		data?: ModelTypes["User"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateUser"]: {
		data?: ModelTypes["User"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteUser"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createUserGroup"]: {
		data?: ModelTypes["UserGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateUserGroup"]: {
		data?: ModelTypes["UserGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteUserGroup"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createCustomer"]: {
		data?: ModelTypes["Customer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCustomer"]: {
		data?: ModelTypes["Customer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCustomer"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createAddress"]: {
		data?: ModelTypes["Address"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateAddress"]: {
		data?: ModelTypes["Address"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteAddress"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createCheckout"]: {
		data?: ModelTypes["Checkout"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCheckout"]: {
		data?: ModelTypes["Checkout"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCheckout"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createCheckoutExtraOperation"]: {
		data?: ModelTypes["CheckoutExtraOperation"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCheckoutExtraOperation"]: {
		data?: ModelTypes["CheckoutExtraOperation"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCheckoutExtraOperation"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createCheckoutClosing"]: {
		data?: ModelTypes["CheckoutClosing"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCheckoutClosing"]: {
		data?: ModelTypes["CheckoutClosing"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCheckoutClosing"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createVat"]: {
		data?: ModelTypes["Vat"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateVat"]: {
		data?: ModelTypes["Vat"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteVat"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createDepot"]: {
		data?: ModelTypes["Depot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateDepot"]: {
		data?: ModelTypes["Depot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteDepot"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createSupplier"]: {
		data?: ModelTypes["Supplier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateSupplier"]: {
		data?: ModelTypes["Supplier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteSupplier"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createProducer"]: {
		data?: ModelTypes["Producer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProducer"]: {
		data?: ModelTypes["Producer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProducer"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createExportStock"]: {
		data?: ModelTypes["Stock"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExportSale"]: {
		data?: ModelTypes["Sale"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExportPurchase"]: {
		data?: ModelTypes["Purchase"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExportOrder"]: {
		data?: ModelTypes["exportOrder"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExportInventory"]: {
		data?: ModelTypes["Inventory"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateExportInventory"]: {
		data?: ModelTypes["Inventory"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["refreshExportInventory"]: {
		data?: ModelTypes["Inventory"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExport"]: {
		data?: ModelTypes["Export"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCompany"]: {
		data?: ModelTypes["Company"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createShop"]: {
		data?: ModelTypes["Shop"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateShop"]: {
		data?: ModelTypes["Shop"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteShop"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createCert"]: {
		data?: ModelTypes["Cert"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCert"]: {
		data?: ModelTypes["Depot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCert"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createEetReceipt"]: {
		data?: ModelTypes["Receipt"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["sendEetReceipt"]: {
		data?: ModelTypes["Receipt"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createPayment"]: {
		data?: ModelTypes["Payment"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePayment"]: {
		data?: ModelTypes["Payment"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePayment"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createPaymentItem"]: {
		data?: ModelTypes["PaymentItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePaymentItem"]: {
		data?: ModelTypes["PaymentItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePaymentItem"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createDevLog"]: {
		data?: ModelTypes["DevLog"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["DevLog"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	content?: string | undefined | null,
	created?: ModelTypes["DateTime"] | undefined | null
};
	["createPackage"]: {
		data?: ModelTypes["Package"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePackage"]: {
		data?: ModelTypes["Package"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePackage"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["resetPackage"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["sendPackage"]: {
		data?: ModelTypes["Package"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createDisposal"]: {
		data?: ModelTypes["PackageDisposal"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateDisposal"]: {
		data?: ModelTypes["PackageDisposal"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteDisposal"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["sendDisposal"]: {
		data?: ModelTypes["PackageDisposal"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createFile"]: {
		data?: ModelTypes["File"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateFile"]: {
		data?: ModelTypes["File"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteFile"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createCompanyCarrier"]: {
		data?: ModelTypes["CompanyCarrier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCompanyCarrier"]: {
		data?: ModelTypes["CompanyCarrier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCompanyCarrier"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createConsent"]: {
		data?: ModelTypes["Consent"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateConsent"]: {
		data?: ModelTypes["Consent"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteConsent"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createCustomerConsent"]: {
		data?: ModelTypes["CustomerConsent"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCustomerConsent"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductDepot"]: {
		data?: ModelTypes["ProductDepot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createCategory"]: {
		data?: ModelTypes["Category"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCategory"]: {
		data?: ModelTypes["Category"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCategory"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createParameter"]: {
		data?: ModelTypes["Parameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateParameter"]: {
		data?: ModelTypes["Parameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteParameter"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createOrderGroup"]: {
		data?: ModelTypes["OrderGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateOrderGroup"]: {
		data?: ModelTypes["OrderGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteOrderGroup"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createVoucher"]: {
		data?: ModelTypes["Voucher"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateVoucher"]: {
		data?: ModelTypes["Voucher"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteVoucher"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createPricePriceLevel"]: {
		data?: ModelTypes["PriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePriceLevel"]: {
		data?: ModelTypes["PriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePriceLevel"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createProductParameter"]: {
		data?: ModelTypes["ProductParameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductParameter"]: {
		data?: ModelTypes["ProductParameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductParameter"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createProductPriceLevel"]: {
		data?: ModelTypes["ProductPriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductPriceLevel"]: {
		data?: ModelTypes["ProductPriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductPriceLevel"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createTag"]: {
		data?: ModelTypes["Tag"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateTag"]: {
		data?: ModelTypes["Tag"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteTag"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createProductPack"]: {
		data?: ModelTypes["ProductPack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductPack"]: {
		data?: ModelTypes["ProductPack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductPack"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createPurchaseOrderItem_"]: {
	product: number,
	currency: string,
	quantity: number,
	purchasePrice?: number | undefined | null,
	note?: string | undefined | null,
	externalId?: string | undefined | null
};
	["createPurchaseOrder"]: {
		data?: ModelTypes["PurchaseOrder"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePurchaseOrder"]: {
		data?: ModelTypes["PurchaseOrder"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePurchaseOrder"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["createPurchaseOrderItem"]: {
		data?: ModelTypes["PurchaseOrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePurchaseOrderItem"]: {
		data?: ModelTypes["PurchaseOrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePurchaseOrderItem"]: {
		errors?: Array<string | undefined | null> | undefined | null
};
	["ID"]:any
    }

export type GraphQLTypes = {
    ["RootSchemaQuery"]: {
	__typename: "RootSchemaQuery",
	user?: GraphQLTypes["user"] | undefined | null,
	userMyProfile?: GraphQLTypes["userMyProfile"] | undefined | null,
	users?: GraphQLTypes["users"] | undefined | null,
	isUserEmailUnique?: GraphQLTypes["isUserEmailUnique"] | undefined | null,
	userGroup?: GraphQLTypes["userGroup"] | undefined | null,
	userGroups?: GraphQLTypes["userGroups"] | undefined | null,
	roles?: Array<GraphQLTypes["Role"] | undefined | null> | undefined | null,
	product?: GraphQLTypes["product"] | undefined | null,
	products?: GraphQLTypes["products"] | undefined | null,
	productPurchasePrice?: GraphQLTypes["productPurchasePrice"] | undefined | null,
	productSellItems?: GraphQLTypes["productSellItems"] | undefined | null,
	productMovePacks?: GraphQLTypes["productMovePacks"] | undefined | null,
	productMoves?: GraphQLTypes["productMoves"] | undefined | null,
	productMovePack?: GraphQLTypes["productMovePack"] | undefined | null,
	institution?: GraphQLTypes["institution"] | undefined | null,
	institutions?: GraphQLTypes["institutions"] | undefined | null,
	order?: GraphQLTypes["order"] | undefined | null,
	orders?: GraphQLTypes["orders"] | undefined | null,
	soldItems?: GraphQLTypes["soldItems"] | undefined | null,
	orderItems?: GraphQLTypes["orderItems"] | undefined | null,
	orderItem?: GraphQLTypes["orderItem"] | undefined | null,
	customer?: GraphQLTypes["customer"] | undefined | null,
	customers?: GraphQLTypes["customers"] | undefined | null,
	address?: GraphQLTypes["address"] | undefined | null,
	addresses?: GraphQLTypes["addresses"] | undefined | null,
	checkout?: GraphQLTypes["checkout"] | undefined | null,
	checkouts?: GraphQLTypes["checkouts"] | undefined | null,
	eventTypes?: GraphQLTypes["eventTypes"] | undefined | null,
	consent?: GraphQLTypes["consent"] | undefined | null,
	consents?: GraphQLTypes["consents"] | undefined | null,
	checkoutExtraOperation?: GraphQLTypes["checkoutExtraOperation"] | undefined | null,
	checkoutExtraOperations?: GraphQLTypes["checkoutExtraOperations"] | undefined | null,
	checkoutClosing?: GraphQLTypes["checkoutClosing"] | undefined | null,
	checkoutClosings?: GraphQLTypes["checkoutClosings"] | undefined | null,
	vat?: GraphQLTypes["vat"] | undefined | null,
	vats?: GraphQLTypes["vats"] | undefined | null,
	depot?: GraphQLTypes["depot"] | undefined | null,
	depots?: GraphQLTypes["depots"] | undefined | null,
	supplier?: GraphQLTypes["supplier"] | undefined | null,
	suppliers?: GraphQLTypes["suppliers"] | undefined | null,
	producer?: GraphQLTypes["producer"] | undefined | null,
	producers?: GraphQLTypes["producers"] | undefined | null,
	exportStocks?: GraphQLTypes["exportStocks"] | undefined | null,
	exportSales?: GraphQLTypes["exportSales"] | undefined | null,
	exportPurchases?: GraphQLTypes["exportPurchases"] | undefined | null,
	exportOrders?: GraphQLTypes["exportOrders"] | undefined | null,
	exportInventory?: GraphQLTypes["exportInventory"] | undefined | null,
	exportInventories?: GraphQLTypes["exportInventories"] | undefined | null,
	export?: GraphQLTypes["export"] | undefined | null,
	exports?: GraphQLTypes["exports"] | undefined | null,
	exportTypes?: GraphQLTypes["exportTypes"] | undefined | null,
	shop?: GraphQLTypes["shop"] | undefined | null,
	shops?: GraphQLTypes["shops"] | undefined | null,
	cert?: GraphQLTypes["cert"] | undefined | null,
	certs?: GraphQLTypes["certs"] | undefined | null,
	eetReceipts?: GraphQLTypes["eetReceipts"] | undefined | null,
	payment?: GraphQLTypes["payment"] | undefined | null,
	payments?: GraphQLTypes["payments"] | undefined | null,
	paymentItem?: GraphQLTypes["paymentItem"] | undefined | null,
	paymentItems?: GraphQLTypes["paymentItems"] | undefined | null,
	paymentTypes?: GraphQLTypes["paymentTypes"] | undefined | null,
	processStatuses?: GraphQLTypes["processStatuses"] | undefined | null,
	carriers?: GraphQLTypes["carriers"] | undefined | null,
	currencies?: GraphQLTypes["currencies"] | undefined | null,
	package?: GraphQLTypes["package"] | undefined | null,
	packages?: GraphQLTypes["packages"] | undefined | null,
	stats?: GraphQLTypes["packageStats"] | undefined | null,
	disposal?: GraphQLTypes["disposal"] | undefined | null,
	disposals?: GraphQLTypes["disposals"] | undefined | null,
	productDepotMetric?: GraphQLTypes["productDepotMetric"] | undefined | null,
	productDepotMetrics?: GraphQLTypes["productDepotMetrics"] | undefined | null,
	file?: GraphQLTypes["file"] | undefined | null,
	files?: GraphQLTypes["files"] | undefined | null,
	nextEan?: GraphQLTypes["nextEan"] | undefined | null,
	statsCarrierUsage?: GraphQLTypes["statsCarrierUsage"] | undefined | null,
	statsPaymentSales?: GraphQLTypes["statsPaymentSales"] | undefined | null,
	statsBestsellers?: GraphQLTypes["statsBestsellers"] | undefined | null,
	companyCarrier?: GraphQLTypes["companyCarrier"] | undefined | null,
	companyCarriers?: GraphQLTypes["companyCarriers"] | undefined | null,
	category?: GraphQLTypes["category"] | undefined | null,
	categories?: GraphQLTypes["categories"] | undefined | null,
	parameter?: GraphQLTypes["parameter"] | undefined | null,
	parameters?: GraphQLTypes["parameters"] | undefined | null,
	orderGroup?: GraphQLTypes["orderGroup"] | undefined | null,
	orderGroups?: GraphQLTypes["orderGroups"] | undefined | null,
	voucher?: GraphQLTypes["voucher"] | undefined | null,
	vouchers?: GraphQLTypes["vouchers"] | undefined | null,
	productPrices?: GraphQLTypes["productPrices"] | undefined | null,
	priceLevel?: GraphQLTypes["priceLevel"] | undefined | null,
	priceLevels?: GraphQLTypes["priceLevels"] | undefined | null,
	productParameter?: GraphQLTypes["productParameter"] | undefined | null,
	productParameters?: GraphQLTypes["productParameters"] | undefined | null,
	productPriceLevel?: GraphQLTypes["productPriceLevel"] | undefined | null,
	productPriceLevels?: GraphQLTypes["productPriceLevels"] | undefined | null,
	tag?: GraphQLTypes["tag"] | undefined | null,
	tags?: GraphQLTypes["tags"] | undefined | null,
	tagTypes?: GraphQLTypes["tagTypes"] | undefined | null,
	productPack?: GraphQLTypes["productPack"] | undefined | null,
	productPacks?: GraphQLTypes["productPacks"] | undefined | null,
	purchaseOrder?: GraphQLTypes["purchaseOrder"] | undefined | null,
	purchaseOrders?: GraphQLTypes["purchaseOrders"] | undefined | null,
	purchaseOrderItem?: GraphQLTypes["purchaseOrderItem"] | undefined | null,
	purchaseOrderItems?: GraphQLTypes["purchaseOrderItems"] | undefined | null,
	purchaseOrderStatuses?: GraphQLTypes["purchaseOrderStatuses"] | undefined | null,
	modules?: GraphQLTypes["modules"] | undefined | null
};
	["user"]: {
	__typename: "user",
	data?: GraphQLTypes["User"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["User"]: {
	__typename: "User",
	id?: number | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	phone?: string | undefined | null,
	groups?: Array<GraphQLTypes["UserGroup"] | undefined | null> | undefined | null,
	roles?: Array<string | undefined | null> | undefined | null,
	enabled?: boolean | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	pin?: string | undefined | null,
	externalId?: string | undefined | null,
	customers?: Array<GraphQLTypes["Customer"] | undefined | null> | undefined | null,
	checkouts?: Array<GraphQLTypes["Checkout"] | undefined | null> | undefined | null,
	depots?: Array<GraphQLTypes["Depot"] | undefined | null> | undefined | null,
	locale?: string | undefined | null,
	deletable?: boolean | undefined | null
};
	["UserGroup"]: {
	__typename: "UserGroup",
	id?: number | undefined | null,
	name?: string | undefined | null,
	roles?: Array<string | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null
};
	["Company"]: {
	__typename: "Company",
	id?: number | undefined | null,
	name?: string | undefined | null,
	ic?: string | undefined | null,
	dic?: string | undefined | null,
	phone?: string | undefined | null,
	email?: string | undefined | null,
	street?: string | undefined | null,
	city?: string | undefined | null,
	zip?: string | undefined | null,
	country?: string | undefined | null,
	currency?: GraphQLTypes["Currency"] | undefined | null,
	registrationNote?: string | undefined | null,
	nextEan?: string | undefined | null,
	billLogo?: string | undefined | null,
	parent?: GraphQLTypes["Company"] | undefined | null,
	children?: Array<GraphQLTypes["Company"] | undefined | null> | undefined | null,
	carrierRelations?: Array<GraphQLTypes["CompanyCarrier"] | undefined | null> | undefined | null,
	moduleRelations?: Array<GraphQLTypes["CompanyModule"] | undefined | null> | undefined | null,
	payments?: Array<GraphQLTypes["Payment"] | undefined | null> | undefined | null,
	defaultVoucherValidity?: number | undefined | null,
	pickingOnlyOneDepot?: boolean | undefined | null,
	customOptions?: string | undefined | null,
	batchExpirationMode?: string | undefined | null,
	externalId?: string | undefined | null,
	purchasePriceWithVat?: boolean | undefined | null,
	tariff?: GraphQLTypes["Tariff"] | undefined | null,
	tariffExpirationDate?: GraphQLTypes["DateTime"] | undefined | null,
	enabledLocking?: boolean | undefined | null
};
	["Currency"]: {
	__typename: "Currency",
	id?: string | undefined | null,
	name?: string | undefined | null,
	ratio?: number | undefined | null
};
	["CompanyCarrier"]: {
	__typename: "CompanyCarrier",
	id?: number | undefined | null,
	enable?: boolean | undefined | null,
	options?: string | undefined | null,
	carrier?: GraphQLTypes["Carrier"] | undefined | null,
	checkout?: GraphQLTypes["Checkout"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null
};
	["Carrier"]: {
	__typename: "Carrier",
	id?: string | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	position?: number | undefined | null,
	tariffs?: Array<GraphQLTypes["CarrierTariff"] | undefined | null> | undefined | null,
	requiredShippingAddress?: boolean | undefined | null
};
	["CarrierTariff"]: {
	__typename: "CarrierTariff",
	id?: number | undefined | null,
	const?: string | undefined | null,
	name?: string | undefined | null,
	cod?: boolean | undefined | null,
	position?: number | undefined | null
};
	["Checkout"]: {
	__typename: "Checkout",
	id?: number | undefined | null,
	name?: string | undefined | null,
	amount?: number | undefined | null,
	nextReservationNumber?: number | undefined | null,
	nextBillNumber?: number | undefined | null,
	billFooter?: string | undefined | null,
	payments?: Array<GraphQLTypes["Payment"] | undefined | null> | undefined | null,
	depots?: Array<GraphQLTypes["Depot"] | undefined | null> | undefined | null,
	returnsDepot?: GraphQLTypes["Depot"] | undefined | null,
	currentClosing?: GraphQLTypes["CheckoutClosing"] | undefined | null,
	eetId?: number | undefined | null,
	eetEnable?: boolean | undefined | null,
	eetPlayground?: boolean | undefined | null,
	eetVerificationMode?: boolean | undefined | null,
	billWidth?: number | undefined | null,
	billFontSize?: number | undefined | null,
	billFontWeight?: string | undefined | null,
	eventUrl?: string | undefined | null,
	eventTypes?: Array<string | undefined | null> | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	negativeReservation?: boolean | undefined | null,
	externalId?: string | undefined | null,
	users?: Array<GraphQLTypes["User"] | undefined | null> | undefined | null,
	autoPicking?: boolean | undefined | null,
	autoPacking?: boolean | undefined | null,
	autoDispatched?: boolean | undefined | null,
	institution?: GraphQLTypes["Institution"] | undefined | null,
	position?: number | undefined | null,
	deletable?: boolean | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null
};
	["Payment"]: {
	__typename: "Payment",
	id?: number | undefined | null,
	name?: string | undefined | null,
	eetEnable?: boolean | undefined | null,
	/** Expedovat i nezaplacené objednávky */
	dispatchUnpaid?: boolean | undefined | null,
	type?: GraphQLTypes["PaymentType"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null
};
	["PaymentType"]: {
	__typename: "PaymentType",
	id?: string | undefined | null,
	name?: string | undefined | null
};
	["Depot"]: {
	__typename: "Depot",
	id?: number | undefined | null,
	name?: string | undefined | null,
	emailIn?: string | undefined | null,
	unavailablesUrl?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	companyCarriers?: Array<GraphQLTypes["CompanyCarrier"] | undefined | null> | undefined | null,
	checkouts?: Array<GraphQLTypes["Checkout"] | undefined | null> | undefined | null,
	institution?: GraphQLTypes["Institution"] | undefined | null,
	users?: Array<GraphQLTypes["User"] | undefined | null> | undefined | null,
	position?: number | undefined | null,
	deletable?: boolean | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null
};
	["Institution"]: {
	__typename: "Institution",
	id?: number | undefined | null,
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	checkouts?: Array<GraphQLTypes["Checkout"] | undefined | null> | undefined | null,
	depots?: Array<GraphQLTypes["Depot"] | undefined | null> | undefined | null
};
	/** Representation of date and time in "Y-m-d H:i:s" format */
["DateTime"]: "scalar" & { name: "DateTime" };
	["CheckoutClosing"]: {
	__typename: "CheckoutClosing",
	id?: number | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	checkout?: GraphQLTypes["Checkout"] | undefined | null,
	dateOpen?: GraphQLTypes["DateTime"] | undefined | null,
	amountOpen?: number | undefined | null,
	amountRealOpen?: number | undefined | null,
	userOpen?: GraphQLTypes["User"] | undefined | null,
	noteOpen?: string | undefined | null,
	dateClosed?: GraphQLTypes["DateTime"] | undefined | null,
	amountClosed?: number | undefined | null,
	amountRealClosed?: number | undefined | null,
	userClosed?: GraphQLTypes["User"] | undefined | null,
	noteClosed?: string | undefined | null,
	orders?: Array<GraphQLTypes["Order"] | undefined | null> | undefined | null,
	profit?: number | undefined | null,
	vatAllocations?: Array<GraphQLTypes["VatAllocation"] | undefined | null> | undefined | null,
	extraOperations?: Array<GraphQLTypes["CheckoutExtraOperation"] | undefined | null> | undefined | null,
	billUrl?: string | undefined | null,
	enumeration?: string | undefined | null,
	paymentSum?: Array<GraphQLTypes["paymentSum"] | undefined | null> | undefined | null
};
	["Order"]: {
	__typename: "Order",
	id?: number | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	status?: GraphQLTypes["OrderStatus"] | undefined | null,
	reservationNumber?: number | undefined | null,
	billNumber?: number | undefined | null,
	vs?: number | undefined | null,
	dateCreated?: GraphQLTypes["DateTime"] | undefined | null,
	dateBill?: GraphQLTypes["DateTime"] | undefined | null,
	dateExpedition?: GraphQLTypes["DateTime"] | undefined | null,
	dateDue?: GraphQLTypes["DateTime"] | undefined | null,
	dateTax?: GraphQLTypes["DateTime"] | undefined | null,
	items?: Array<GraphQLTypes["OrderItem"] | undefined | null> | undefined | null,
	paymentItems?: Array<GraphQLTypes["PaymentItem"] | undefined | null> | undefined | null,
	checkout?: GraphQLTypes["Checkout"] | undefined | null,
	checkoutClosing?: GraphQLTypes["CheckoutClosing"] | undefined | null,
	customer?: GraphQLTypes["Customer"] | undefined | null,
	note?: string | undefined | null,
	privateNote?: string | undefined | null,
	invoiceAddress?: GraphQLTypes["Address"] | undefined | null,
	shippingAddress?: GraphQLTypes["Address"] | undefined | null,
	relatedParent?: GraphQLTypes["Order"] | undefined | null,
	rounding?: number | undefined | null,
	eetReceipt?: GraphQLTypes["Receipt"] | undefined | null,
	deleted?: GraphQLTypes["DateTime"] | undefined | null,
	priceAll?: number | undefined | null,
	priceAllWithoutVat?: number | undefined | null,
	profit?: number | undefined | null,
	vatAllocations?: Array<GraphQLTypes["VatAllocation"] | undefined | null> | undefined | null,
	/** DEPRECATED - Url PDF účtenky */
	billUrl?: string | undefined | null,
	/** Url PDF faktury */
	invoiceUrl?: string | undefined | null,
	/** Url PDF objednávky */
	reservationUrl?: string | undefined | null,
	/** Url PDF účtenky */
	invoiceReceiptUrl?: string | undefined | null,
	/** Url PDF účtenky-rezervace */
	reservationReceiptUrl?: string | undefined | null,
	processStatus?: GraphQLTypes["ProcessStatus"] | undefined | null,
	processStatusUpdated?: GraphQLTypes["DateTime"] | undefined | null,
	processStatusRelation?: GraphQLTypes["OrderProcessStatus"] | undefined | null,
	processStatusRelations?: Array<GraphQLTypes["OrderProcessStatus"] | undefined | null> | undefined | null,
	carrier?: GraphQLTypes["Carrier"] | undefined | null,
	packages?: Array<GraphQLTypes["Package"] | undefined | null> | undefined | null,
	boxes?: Array<string | undefined | null> | undefined | null,
	isPaid?: boolean | undefined | null,
	currency?: GraphQLTypes["Currency"] | undefined | null,
	files?: Array<GraphQLTypes["File"] | undefined | null> | undefined | null,
	quantityUnavailable?: number | undefined | null,
	createdBy?: GraphQLTypes["User"] | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null,
	movePacks?: Array<GraphQLTypes["ProductMovePack"] | undefined | null> | undefined | null,
	depots?: Array<GraphQLTypes["Depot"] | undefined | null> | undefined | null,
	isEditable?: boolean | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Externí číslo */
	externalReference?: string | undefined | null,
	group?: GraphQLTypes["OrderGroup"] | undefined | null,
	groupPosition?: number | undefined | null,
	clearanceItems?: Array<GraphQLTypes["ClearanceItem"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<GraphQLTypes["Tag"] | undefined | null> | undefined | null,
	/** Priorita */
	priority?: number | undefined | null,
	/** Uzamčena */
	locked?: boolean | undefined | null,
	/** Od kdy uzamčena */
	dateLocked?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	/** Kým uzamčena */
	lockedBy?: GraphQLTypes["User"] | undefined | null
};
	["OrderStatus"]: {
	__typename: "OrderStatus",
	id?: string | undefined | null,
	name?: string | undefined | null
};
	["OrderItem"]: {
	__typename: "OrderItem",
	id?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	sale?: number | undefined | null,
	price?: number | undefined | null,
	priceWithoutVat?: number | undefined | null,
	priceAll?: number | undefined | null,
	priceAllWithoutVat?: number | undefined | null,
	vat?: GraphQLTypes["Vat"] | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	serial?: string | undefined | null,
	expirationDate?: GraphQLTypes["DateTime"] | undefined | null,
	batch?: string | undefined | null,
	note?: string | undefined | null,
	profit?: number | undefined | null,
	isForSubsequentSettlement?: boolean | undefined | null,
	picked?: boolean | undefined | null,
	packed?: boolean | undefined | null,
	quantityUnavailable?: number | undefined | null,
	moves?: Array<GraphQLTypes["ProductMove"] | undefined | null> | undefined | null,
	clearanceItems?: Array<GraphQLTypes["ClearanceItem"] | undefined | null> | undefined | null,
	voucher?: GraphQLTypes["Voucher"] | undefined | null,
	order?: GraphQLTypes["Order"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null
};
	["Vat"]: {
	__typename: "Vat",
	id?: number | undefined | null,
	name?: string | undefined | null,
	percent?: number | undefined | null,
	default?: boolean | undefined | null,
	coefficient?: number | undefined | null,
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	created?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	updated?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	/** Representation of date and time in same string format as PHP DateTime class. */
["DateTimeAsString"]: "scalar" & { name: "DateTimeAsString" };
	["Product"]: {
	__typename: "Product",
	id?: number | undefined | null,
	/** Název */
	name?: string | undefined | null,
	/** Název včetně názvu rodičovského produktu */
	fullName?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean2?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean3?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean4?: string | undefined | null,
	/** Unikátní Ean 13 */
	ean5?: string | undefined | null,
	/** Kód */
	code?: string | undefined | null,
	/** Kód2 */
	code2?: string | undefined | null,
	/** Kód3 */
	code3?: string | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Prodejní cena */
	sellPrice?: number | undefined | null,
	/** Prodejní cena bez DPH */
	sellPriceWithoutVat?: number | undefined | null,
	/** Cena před slevou */
	beforeSellPrice?: number | undefined | null,
	/** Aktuální prodejní cena - včetně započtených akčních cen */
	actualSellPrice?: number | undefined | null,
	/** Aktuální prodejní cena bez DPH */
	actualSellPriceWithoutVat?: number | undefined | null,
	/** Aktuální cena před slevou - včetně započtených akčních cen */
	actualBeforeSellPrice?: number | undefined | null,
	/** Výchozí nákupní cena */
	purchasePrice?: number | undefined | null,
	/** Výchozí nákupní měna */
	purchaseCurrency?: GraphQLTypes["Currency"] | undefined | null,
	/** Váha */
	weight?: number | undefined | null,
	/** Rozměr X */
	dimensionX?: number | undefined | null,
	/** Rozměr Y */
	dimensionY?: number | undefined | null,
	/** Rozměr Z */
	dimensionZ?: number | undefined | null,
	/** Země výroby */
	originCountry?: string | undefined | null,
	/** HS kod */
	hsCode?: string | undefined | null,
	/** Je produkt aktnivní? */
	enabled?: boolean | undefined | null,
	/** DPH */
	vat?: GraphQLTypes["Vat"] | undefined | null,
	/** Výrobce */
	producer?: GraphQLTypes["Producer"] | undefined | null,
	/** Výchozí dodavatel */
	supplier?: GraphQLTypes["Supplier"] | undefined | null,
	/** Rodičovský produkt */
	parent?: GraphQLTypes["Product"] | undefined | null,
	/** Potomci / varianty produktu */
	children?: Array<GraphQLTypes["Product"] | undefined | null> | undefined | null,
	/** Deprecated: používejte productDepots */
	depots?: Array<GraphQLTypes["ProductDepot"] | undefined | null> | undefined | null,
	/** Skladové zásoby */
	productDepots?: Array<GraphQLTypes["ProductDepot"] | undefined | null> | undefined | null,
	/** Produkt je položka pro následné uplatnění (např. kupón) - pro EET */
	isForSubsequentSettlement?: boolean | undefined | null,
	/** Hlavní obrázek */
	mainImage?: GraphQLTypes["File"] | undefined | null,
	/** Obrázky */
	images?: Array<GraphQLTypes["File"] | undefined | null> | undefined | null,
	/** Soubory (mimo obrázků) */
	files?: Array<GraphQLTypes["File"] | undefined | null> | undefined | null,
	/** Jedná se o set produktů (virtuální produkt) */
	isBundle?: boolean | undefined | null,
	/** Křehký */
	isFragile?: boolean | undefined | null,
	/** Nadrozměrný */
	isOversize?: boolean | undefined | null,
	bundleParents?: Array<GraphQLTypes["ProductBundle"] | undefined | null> | undefined | null,
	bundleChildren?: Array<GraphQLTypes["ProductBundle"] | undefined | null> | undefined | null,
	/** Poznámka */
	note?: string | undefined | null,
	/** Popis */
	description?: string | undefined | null,
	/** Krátký popis */
	perex?: string | undefined | null,
	/** Cokoli... */
	customData?: string | undefined | null,
	/** Akční ceny */
	advancedPrices?: Array<GraphQLTypes["ProductPrice"] | undefined | null> | undefined | null,
	/** Počet nedostupných kusů v rezervaci */
	quantityUnavailable?: number | undefined | null,
	/** Počet kusů skladem a všech skladech */
	quantityStock?: number | undefined | null,
	/** Počet dostupných kusů a všech skladech */
	quantityAvailable?: number | undefined | null,
	/** Počet kusů v rezervaci na všech skladech */
	quantityReservation?: number | undefined | null,
	/** Počet kusů objednaný od dodavatele */
	quantityPurchase?: number | undefined | null,
	/** Kategorie */
	categories?: Array<GraphQLTypes["Category"] | undefined | null> | undefined | null,
	/** Hlavní kategorie */
	mainCategory?: GraphQLTypes["Category"] | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	/** Počty */
	quantities?: Array<GraphQLTypes["Quantity"] | undefined | null> | undefined | null,
	/** Metriky */
	metrics?: Array<GraphQLTypes["ProductDepotMetric"] | undefined | null> | undefined | null,
	/** Balení/Kartony */
	packs?: Array<GraphQLTypes["ProductPack"] | undefined | null> | undefined | null,
	/** Relace ProductParameter */
	productParameters?: Array<GraphQLTypes["ProductParameter"] | undefined | null> | undefined | null,
	/** Relace ProductPriceLevel */
	productPriceLevels?: Array<GraphQLTypes["ProductPriceLevel"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<GraphQLTypes["Tag"] | undefined | null> | undefined | null,
	/** Položky k prodeji: jednotlivé expirace a šarže */
	sellItems?: Array<GraphQLTypes["SellItem"] | undefined | null> | undefined | null,
	/** Deprectable - use deletable. */
	isDeletable?: boolean | undefined | null,
	/** Lze smazat */
	deletable?: boolean | undefined | null,
	/** Eviduje expirace a šarže */
	enabledBatchExpiration?: boolean | undefined | null,
	/** Eviduje sériová čísla */
	requiredSerialNumbers?: boolean | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null
};
	["Producer"]: {
	__typename: "Producer",
	id?: number | undefined | null,
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null
};
	["Supplier"]: {
	__typename: "Supplier",
	id?: number | undefined | null,
	name?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	deletable?: boolean | undefined | null
};
	["ProductDepot"]: {
	__typename: "ProductDepot",
	id?: number | undefined | null,
	depot?: GraphQLTypes["Depot"] | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	supplier?: GraphQLTypes["Supplier"] | undefined | null,
	purchasePrice?: number | undefined | null,
	quantityStock?: number | undefined | null,
	quantityReservation?: number | undefined | null,
	quantityAvailable?: number | undefined | null,
	quantityUnavailable?: number | undefined | null,
	inventoryQuantityStock?: number | undefined | null,
	expirationDate?: GraphQLTypes["DateTime"] | undefined | null,
	batch?: string | undefined | null,
	position?: string | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	clearanceItemId?: string | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null
};
	["File"]: {
	__typename: "File",
	id?: number | undefined | null,
	originalFilename?: string | undefined | null,
	text?: string | undefined | null,
	main?: boolean | undefined | null,
	mimeType?: string | undefined | null,
	size?: number | undefined | null,
	url?: string | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	order?: GraphQLTypes["Order"] | undefined | null,
	thumbnails?: Array<GraphQLTypes["FileThumbnail"] | undefined | null> | undefined | null
};
	["FileThumbnail"]: {
	__typename: "FileThumbnail",
	format?: string | undefined | null,
	mimeType?: string | undefined | null,
	url?: string | undefined | null
};
	["ProductBundle"]: {
	__typename: "ProductBundle",
	id?: number | undefined | null,
	parent?: GraphQLTypes["Product"] | undefined | null,
	child?: GraphQLTypes["Product"] | undefined | null,
	/** Množství */
	quantity?: number | undefined | null
};
	["ProductPrice"]: {
	__typename: "ProductPrice",
	id?: number | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	sellPrice?: number | undefined | null,
	available?: number | undefined | null,
	dateFrom?: GraphQLTypes["DateTime"] | undefined | null,
	dateTo?: GraphQLTypes["DateTime"] | undefined | null,
	isActual?: boolean | undefined | null,
	note?: string | undefined | null
};
	["Category"]: {
	__typename: "Category",
	id?: number | undefined | null,
	externalId?: string | undefined | null,
	name?: string | undefined | null,
	text?: string | undefined | null,
	parent?: GraphQLTypes["Category"] | undefined | null,
	children?: Array<GraphQLTypes["Category"] | undefined | null> | undefined | null,
	hasChildren?: boolean | undefined | null,
	position?: number | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	treePath?: Array<number | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<GraphQLTypes["Tag"] | undefined | null> | undefined | null
};
	["Tag"]: {
	__typename: "Tag",
	id?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	color?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	created?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	updated?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["Quantity"]: {
	__typename: "Quantity",
	depot?: GraphQLTypes["Depot"] | undefined | null,
	quantityAvailable?: number | undefined | null,
	quantityReservation?: number | undefined | null,
	quantityStock?: number | undefined | null,
	quantityPurchase?: number | undefined | null
};
	["ProductDepotMetric"]: {
	__typename: "ProductDepotMetric",
	id?: number | undefined | null,
	depot?: GraphQLTypes["Depot"] | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	quantityMinimum?: number | undefined | null,
	quantityOptimum?: number | undefined | null,
	quantityMaximum?: number | undefined | null,
	quantityStock?: number | undefined | null,
	quantityPurchase?: number | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null
};
	["ProductPack"]: {
	__typename: "ProductPack",
	id?: number | undefined | null,
	/** Unikátní Ean 13 */
	ean?: string | undefined | null,
	/** Kód */
	code?: string | undefined | null,
	/** Poznámka */
	note?: string | undefined | null,
	/** Množství */
	quantity?: number | undefined | null,
	/** Produkt.id */
	product?: GraphQLTypes["Product"] | undefined | null,
	/** Externí ID */
	externalId?: string | undefined | null
};
	["ProductParameter"]: {
	__typename: "ProductParameter",
	id?: number | undefined | null,
	value?: GraphQLTypes["StringOrArray"] | undefined | null,
	externalId?: string | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	parameter?: GraphQLTypes["Parameter"] | undefined | null
};
	/** String or Array */
["StringOrArray"]: "scalar" & { name: "StringOrArray" };
	["Parameter"]: {
	__typename: "Parameter",
	id?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	enumValues?: Array<string | undefined | null> | undefined | null,
	unit?: string | undefined | null,
	text?: string | undefined | null,
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null
};
	["ProductPriceLevel"]: {
	__typename: "ProductPriceLevel",
	id?: number | undefined | null,
	sellPrice?: number | undefined | null,
	externalId?: string | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	priceLevel?: GraphQLTypes["PriceLevel"] | undefined | null
};
	["PriceLevel"]: {
	__typename: "PriceLevel",
	id?: number | undefined | null,
	name?: string | undefined | null,
	isPercentage?: boolean | undefined | null,
	percent?: number | undefined | null,
	withVat?: boolean | undefined | null,
	currency?: GraphQLTypes["Currency"] | undefined | null,
	externalId?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null
};
	["SellItem"]: {
	__typename: "SellItem",
	id?: string | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	quantityStock?: number | undefined | null,
	quantityReservation?: number | undefined | null,
	quantityAvailable?: number | undefined | null,
	expirationDate?: GraphQLTypes["DateTime"] | undefined | null,
	batch?: string | undefined | null,
	productDepots?: Array<GraphQLTypes["ProductDepot"] | undefined | null> | undefined | null
};
	["ProductMove"]: {
	__typename: "ProductMove",
	id?: number | undefined | null,
	pack?: GraphQLTypes["ProductMovePack"] | undefined | null,
	productDepotFrom?: GraphQLTypes["ProductDepot"] | undefined | null,
	productDepotFromQuantityStock?: number | undefined | null,
	productDepotTo?: GraphQLTypes["ProductDepot"] | undefined | null,
	productDepotToQuantityStock?: number | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	amount?: number | undefined | null,
	note?: string | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null,
	deleted?: GraphQLTypes["DateTime"] | undefined | null,
	quantityUnavailable?: number | undefined | null,
	createdBy?: GraphQLTypes["User"] | undefined | null,
	orderItem?: GraphQLTypes["OrderItem"] | undefined | null,
	picked?: number | undefined | null,
	packed?: number | undefined | null,
	locked?: boolean | undefined | null,
	purchasePrice?: number | undefined | null,
	purchasePriceAll?: number | undefined | null,
	purchasePriceWithVat?: number | undefined | null,
	purchasePriceAllWithVat?: number | undefined | null,
	purchaseOrderItem?: GraphQLTypes["PurchaseOrderItem"] | undefined | null,
	deletable?: boolean | undefined | null,
	serialNumbers?: Array<string | undefined | null> | undefined | null
};
	["ProductMovePack"]: {
	__typename: "ProductMovePack",
	id?: number | undefined | null,
	externalId?: string | undefined | null,
	externalReference?: string | undefined | null,
	number?: number | undefined | null,
	type?: GraphQLTypes["ProductMoveType"] | undefined | null,
	purpose?: GraphQLTypes["ProductMovePurpose"] | undefined | null,
	moves?: Array<GraphQLTypes["ProductMove"] | undefined | null> | undefined | null,
	note?: string | undefined | null,
	url?: string | undefined | null,
	pdfWOPricesUrl?: string | undefined | null,
	dateCreated?: GraphQLTypes["DateTime"] | undefined | null,
	order?: GraphQLTypes["Order"] | undefined | null,
	checkout?: GraphQLTypes["Checkout"] | undefined | null,
	depotFrom?: GraphQLTypes["Depot"] | undefined | null,
	depotTo?: GraphQLTypes["Depot"] | undefined | null,
	incidentalCosts?: number | undefined | null,
	purchasePrice?: number | undefined | null,
	purchasePriceWithVat?: number | undefined | null,
	purchaseOrder?: GraphQLTypes["PurchaseOrder"] | undefined | null,
	createdBy?: GraphQLTypes["User"] | undefined | null,
	files?: Array<GraphQLTypes["File"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<GraphQLTypes["Tag"] | undefined | null> | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	deletable?: boolean | undefined | null
};
	["ProductMoveType"]: {
	__typename: "ProductMoveType",
	id?: string | undefined | null,
	name?: string | undefined | null
};
	["ProductMovePurpose"]: {
	__typename: "ProductMovePurpose",
	id?: string | undefined | null,
	name?: string | undefined | null
};
	["PurchaseOrder"]: {
	__typename: "PurchaseOrder",
	id?: number | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	status?: GraphQLTypes["PurchaseOrderStatus"] | undefined | null,
	supplier?: GraphQLTypes["Supplier"] | undefined | null,
	depot?: GraphQLTypes["Depot"] | undefined | null,
	items?: Array<GraphQLTypes["PurchaseOrderItem"] | undefined | null> | undefined | null,
	files?: Array<GraphQLTypes["File"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<GraphQLTypes["Tag"] | undefined | null> | undefined | null,
	number?: string | undefined | null,
	note?: string | undefined | null,
	privateNote?: string | undefined | null,
	dateEstimatedArrival?: GraphQLTypes["DateTime"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Externí reference */
	externalReference?: string | undefined | null,
	/** Reference dodavatele */
	supplierReference?: string | undefined | null,
	purchasePriceAll?: number | undefined | null,
	purchasePriceAllWithVat?: number | undefined | null,
	productMovePacks?: Array<GraphQLTypes["ProductMovePack"] | undefined | null> | undefined | null,
	pdfUrl?: string | undefined | null,
	pdfWOPricesUrl?: string | undefined | null,
	excelUrl?: string | undefined | null,
	excelWOPricesUrl?: string | undefined | null,
	createdBy?: GraphQLTypes["User"] | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null
};
	["PurchaseOrderStatus"]: {
	__typename: "PurchaseOrderStatus",
	id?: string | undefined | null,
	name?: string | undefined | null,
	position?: number | undefined | null
};
	["PurchaseOrderItem"]: {
	__typename: "PurchaseOrderItem",
	id?: number | undefined | null,
	purchaseOrder?: GraphQLTypes["PurchaseOrder"] | undefined | null,
	currency?: GraphQLTypes["Currency"] | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	status?: GraphQLTypes["PurchaseOrderStatus"] | undefined | null,
	quantity?: number | undefined | null,
	purchasePrice?: number | undefined | null,
	purchasePriceAll?: number | undefined | null,
	purchasePriceWithVat?: number | undefined | null,
	purchasePriceAllWithVat?: number | undefined | null,
	productMoves?: Array<GraphQLTypes["ProductMove"] | undefined | null> | undefined | null,
	note?: string | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Již naskladněný počet kusů */
	quantityIn?: number | undefined | null
};
	["ClearanceItem"]: {
	__typename: "ClearanceItem",
	id?: string | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	amount?: number | undefined | null,
	quantityStock?: number | undefined | null,
	quantityReservation?: number | undefined | null,
	quantityAvailable?: number | undefined | null,
	expirationDate?: GraphQLTypes["DateTime"] | undefined | null,
	batch?: string | undefined | null,
	position?: string | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	picked?: number | undefined | null,
	packed?: number | undefined | null,
	productMoves?: Array<GraphQLTypes["ProductMove"] | undefined | null> | undefined | null,
	productDepots?: Array<GraphQLTypes["ProductDepot"] | undefined | null> | undefined | null,
	orderItems?: Array<GraphQLTypes["OrderItem"] | undefined | null> | undefined | null,
	locked?: boolean | undefined | null
};
	["Voucher"]: {
	__typename: "Voucher",
	id?: number | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	externalId?: string | undefined | null,
	discountType?: string | undefined | null,
	discountPercent?: number | undefined | null,
	discountValue?: number | undefined | null,
	maxUse?: number | undefined | null,
	validFrom?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	validTo?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	isValid?: boolean | undefined | null,
	used?: number | undefined | null,
	paymentItems?: Array<GraphQLTypes["Product"] | undefined | null> | undefined | null,
	orderItems?: Array<GraphQLTypes["Product"] | undefined | null> | undefined | null,
	enabled?: boolean | undefined | null,
	isPayment?: boolean | undefined | null
};
	["PaymentItem"]: {
	__typename: "PaymentItem",
	id?: number | undefined | null,
	amount?: number | undefined | null,
	checkout?: GraphQLTypes["Checkout"] | undefined | null,
	payment?: GraphQLTypes["Payment"] | undefined | null,
	voucher?: GraphQLTypes["Voucher"] | undefined | null,
	dateCreated?: GraphQLTypes["DateTime"] | undefined | null,
	dateCancelled?: GraphQLTypes["DateTime"] | undefined | null,
	isPaid?: boolean | undefined | null,
	datePaid?: GraphQLTypes["DateTime"] | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null
};
	["Customer"]: {
	__typename: "Customer",
	id?: number | undefined | null,
	externalId?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	companyName?: string | undefined | null,
	addresses?: Array<GraphQLTypes["Address"] | undefined | null> | undefined | null,
	wholesale?: boolean | undefined | null,
	note?: string | undefined | null,
	consentRelations?: Array<GraphQLTypes["CustomerConsent"] | undefined | null> | undefined | null,
	birthday?: GraphQLTypes["DateTime"] | undefined | null,
	users?: Array<GraphQLTypes["User"] | undefined | null> | undefined | null,
	minExpirationDays?: number | undefined | null,
	priceLevel?: GraphQLTypes["PriceLevel"] | undefined | null,
	/** Tagy */
	tags?: Array<GraphQLTypes["Tag"] | undefined | null> | undefined | null,
	/** Cokoli... */
	customData?: string | undefined | null
};
	["Address"]: {
	__typename: "Address",
	id?: number | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	customer?: GraphQLTypes["Customer"] | undefined | null,
	companyName?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	street?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	state?: string | undefined | null,
	zip?: string | undefined | null,
	ic?: string | undefined | null,
	dic?: string | undefined | null,
	phone?: string | undefined | null,
	email?: string | undefined | null,
	isStored?: boolean | undefined | null,
	isBilling?: boolean | undefined | null,
	zasilkovnaAddressId?: string | undefined | null,
	branchId?: string | undefined | null,
	/** Externí identifikátor */
	externalId?: string | undefined | null,
	/** Poznámka */
	note?: string | undefined | null,
	/** Cokoli... */
	customData?: string | undefined | null
};
	["CustomerConsent"]: {
	__typename: "CustomerConsent",
	id?: number | undefined | null,
	customer?: GraphQLTypes["Customer"] | undefined | null,
	consent?: GraphQLTypes["Consent"] | undefined | null,
	name?: string | undefined | null,
	body?: string | undefined | null,
	externalId?: string | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null
};
	["Consent"]: {
	__typename: "Consent",
	id?: number | undefined | null,
	name?: string | undefined | null,
	body?: string | undefined | null,
	externalId?: string | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	updated?: GraphQLTypes["DateTime"] | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null
};
	["Receipt"]: {
	__typename: "Receipt",
	id?: number | undefined | null,
	dic?: string | undefined | null,
	checkoutEetId?: number | undefined | null,
	shopEetId?: number | undefined | null,
	playground?: boolean | undefined | null,
	verificationMode?: boolean | undefined | null,
	number?: number | undefined | null,
	dateCreated?: GraphQLTypes["DateTime"] | undefined | null,
	totalPrice?: number | undefined | null,
	priceZeroVat?: number | undefined | null,
	priceStandardVat?: number | undefined | null,
	vatStandard?: number | undefined | null,
	priceFirstReducedVat?: number | undefined | null,
	vatFirstReduced?: number | undefined | null,
	priceSecondReducedVat?: number | undefined | null,
	vatSecondReduced?: number | undefined | null,
	priceForSubsequentSettlement?: number | undefined | null,
	priceUsedSubsequentSettlement?: number | undefined | null,
	fik?: string | undefined | null,
	bkp?: string | undefined | null,
	pkp?: string | undefined | null
};
	["VatAllocation"]: {
	__typename: "VatAllocation",
	vat?: GraphQLTypes["Vat"] | undefined | null,
	priceWithoutVat?: number | undefined | null,
	vatPrice?: number | undefined | null,
	price?: number | undefined | null
};
	["ProcessStatus"]: {
	__typename: "ProcessStatus",
	id?: string | undefined | null,
	name?: string | undefined | null,
	position?: number | undefined | null
};
	["OrderProcessStatus"]: {
	__typename: "OrderProcessStatus",
	status?: GraphQLTypes["ProcessStatus"] | undefined | null,
	note?: string | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	createdBy?: GraphQLTypes["User"] | undefined | null,
	actual?: boolean | undefined | null
};
	["Package"]: {
	__typename: "Package",
	id?: number | undefined | null,
	code?: string | undefined | null,
	carrier?: GraphQLTypes["Carrier"] | undefined | null,
	tariff?: GraphQLTypes["CarrierTariff"] | undefined | null,
	items?: Array<GraphQLTypes["OrderItem"] | undefined | null> | undefined | null,
	statuses?: Array<GraphQLTypes["PackageStatus"] | undefined | null> | undefined | null,
	ticketUrl?: string | undefined | null,
	sent?: GraphQLTypes["DateTime"] | undefined | null,
	order?: GraphQLTypes["Order"] | undefined | null,
	disposal?: GraphQLTypes["PackageDisposal"] | undefined | null,
	weight?: number | undefined | null,
	weightRequired?: boolean | undefined | null,
	dimensionsRequired?: boolean | undefined | null,
	dimensionX?: number | undefined | null,
	dimensionY?: number | undefined | null,
	dimensionZ?: number | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	clearanceItems?: Array<GraphQLTypes["ClearanceItem"] | undefined | null> | undefined | null
};
	["PackageStatus"]: {
	__typename: "PackageStatus",
	id?: number | undefined | null,
	code?: string | undefined | null,
	text?: string | undefined | null,
	package?: GraphQLTypes["Package"] | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null
};
	["PackageDisposal"]: {
	__typename: "PackageDisposal",
	id?: number | undefined | null,
	code?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	carrier?: GraphQLTypes["Carrier"] | undefined | null,
	packages?: Array<GraphQLTypes["Package"] | undefined | null> | undefined | null,
	ticketUrl?: string | undefined | null,
	sent?: GraphQLTypes["DateTime"] | undefined | null,
	files?: Array<GraphQLTypes["File"] | undefined | null> | undefined | null
};
	["OrderGroup"]: {
	__typename: "OrderGroup",
	id?: number | undefined | null,
	name?: string | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null,
	orders?: Array<GraphQLTypes["Order"] | undefined | null> | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	userPosition?: number | undefined | null,
	clearanceItems?: Array<GraphQLTypes["ClearanceItem"] | undefined | null> | undefined | null,
	/** Tagy */
	tags?: Array<GraphQLTypes["Tag"] | undefined | null> | undefined | null
};
	["CheckoutExtraOperation"]: {
	__typename: "CheckoutExtraOperation",
	id?: number | undefined | null,
	dateCreated?: GraphQLTypes["DateTime"] | undefined | null,
	amount?: number | undefined | null,
	note?: string | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	checkout?: GraphQLTypes["Checkout"] | undefined | null,
	checkoutClosing?: GraphQLTypes["CheckoutClosing"] | undefined | null
};
	["paymentSum"]: {
	__typename: "paymentSum",
	payment?: GraphQLTypes["Payment"] | undefined | null,
	count?: number | undefined | null,
	sum?: number | undefined | null
};
	["CompanyModule"]: {
	__typename: "CompanyModule",
	id?: number | undefined | null,
	module?: GraphQLTypes["Module"] | undefined | null
};
	["Module"]: {
	__typename: "Module",
	id?: string | undefined | null,
	name?: string | undefined | null
};
	["Tariff"]: {
	__typename: "Tariff",
	id?: string | undefined | null,
	name?: string | undefined | null
};
	["userMyProfile"]: {
	__typename: "userMyProfile",
	data?: GraphQLTypes["User"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["userFilters"]: {
		pin?: string | undefined | null,
	email?: string | undefined | null,
	fulltext?: string | undefined | null,
	groups?: Array<number | undefined | null> | undefined | null,
	roles?: Array<string | undefined | null> | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	enabled?: boolean | undefined | null
};
	["users"]: {
	__typename: "users",
	items?: Array<GraphQLTypes["User"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["Paginator"]: {
	__typename: "Paginator",
	current?: number | undefined | null,
	currentItemCount?: number | undefined | null,
	endPage?: number | undefined | null,
	first?: number | undefined | null,
	firstItemNumber?: number | undefined | null,
	firstPageInRange?: number | undefined | null,
	last?: number | undefined | null,
	lastItemNumber?: number | undefined | null,
	lastPageInRange?: number | undefined | null,
	next?: number | undefined | null,
	numItemsPerPage?: number | undefined | null,
	pageCount?: number | undefined | null,
	pageRange?: number | undefined | null,
	startPage?: number | undefined | null,
	totalCount?: number | undefined | null,
	pagesInRange?: Array<number | undefined | null> | undefined | null
};
	["isUserEmailUnique"]: {
	__typename: "isUserEmailUnique",
	data?: boolean | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["userGroup"]: {
	__typename: "userGroup",
	data?: GraphQLTypes["UserGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["userGroupFilters"]: {
		name?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["userGroups"]: {
	__typename: "userGroups",
	items?: Array<GraphQLTypes["UserGroup"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["Role"]: {
	__typename: "Role",
	name?: string | undefined | null,
	role?: string | undefined | null
};
	["product"]: {
	__typename: "product",
	data?: GraphQLTypes["Product"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productFilters"]: {
		id?: number | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	name?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	codes?: Array<string | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	fulltext?: string | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	metricDepots?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null,
	defaultSuppliers?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	listType?: string | undefined | null,
	availability?: string | undefined | null,
	enabled?: boolean | undefined | null,
	isBundle?: boolean | undefined | null,
	expirationDateTo?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	hasBeforeSellPrice?: boolean | undefined | null,
	hasHsCode?: boolean | undefined | null,
	createdFrom?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	updatedFrom?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null,
	categories?: Array<number | undefined | null> | undefined | null,
	metrics?: string | undefined | null,
	enabledBatchExpiration?: boolean | undefined | null,
	requiredSerialNumbers?: boolean | undefined | null,
	company?: number | undefined | null
};
	["products"]: {
	__typename: "products",
	items?: Array<GraphQLTypes["Product"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["productPurchasePrice"]: {
	__typename: "productPurchasePrice",
	items?: Array<GraphQLTypes["ProductPurchasePrice"] | undefined | null> | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["ProductPurchasePrice"]: {
	__typename: "ProductPurchasePrice",
	productDepot?: GraphQLTypes["Depot"] | undefined | null,
	quantity?: number | undefined | null,
	purchasePrice?: number | undefined | null
};
	["productSellItems"]: {
	__typename: "productSellItems",
	items?: Array<GraphQLTypes["SellItem"] | undefined | null> | undefined | null
};
	["productMovePackFilters"]: {
		fulltext?: string | undefined | null,
	type?: string | undefined | null,
	depot?: number | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	depotFrom?: number | undefined | null,
	depotTo?: number | undefined | null,
	depotsFrom?: Array<number | undefined | null> | undefined | null,
	depotsTo?: Array<number | undefined | null> | undefined | null,
	number?: number | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	withoutCheckout?: boolean | undefined | null,
	product?: number | undefined | null,
	productFulltext?: string | undefined | null,
	order?: number | undefined | null,
	orderFulltext?: string | undefined | null,
	withOrder?: boolean | undefined | null,
	createdBy?: number | undefined | null,
	created?: GraphQLTypes["created"] | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	externalReference?: string | undefined | null,
	purchaseOrder?: number | undefined | null,
	incidentalCosts?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["created"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["productMovePacks"]: {
	__typename: "productMovePacks",
	items?: Array<GraphQLTypes["ProductMovePack"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["productMoveFilters"]: {
		product?: number | undefined | null,
	products?: Array<number | undefined | null> | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	type?: string | undefined | null,
	depotFrom?: number | undefined | null,
	depotTo?: number | undefined | null,
	createdBy?: number | undefined | null,
	created?: GraphQLTypes["created"] | undefined | null,
	expirationDate?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	withoutCheckout?: boolean | undefined | null
};
	["productMoves"]: {
	__typename: "productMoves",
	items?: Array<GraphQLTypes["ProductMove"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["productMovePack"]: {
	__typename: "productMovePack",
	data?: GraphQLTypes["ProductMovePack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["institution"]: {
	__typename: "institution",
	data?: GraphQLTypes["Institution"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["institutionFilters"]: {
		name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["institutions"]: {
	__typename: "institutions",
	items?: Array<GraphQLTypes["Institution"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["order"]: {
	__typename: "order",
	data?: GraphQLTypes["Order"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["orderFilters"]: {
		fulltext?: string | undefined | null,
	reservationNumber?: number | undefined | null,
	billNumber?: number | undefined | null,
	notes?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	onlyDepots?: Array<number | undefined | null> | undefined | null,
	payments?: Array<number | undefined | null> | undefined | null,
	status?: string | undefined | null,
	processStatus?: string | undefined | null,
	processStatusChange?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	processStatusUpdated?: GraphQLTypes["processStatusUpdated"] | undefined | null,
	isPaid?: boolean | undefined | null,
	carrier?: string | undefined | null,
	carriers?: Array<string | undefined | null> | undefined | null,
	deleted?: boolean | undefined | null,
	dateCreated?: GraphQLTypes["dateCreated"] | undefined | null,
	dateBill?: GraphQLTypes["dateBill"] | undefined | null,
	dateExpedition?: GraphQLTypes["dateExpedition"] | undefined | null,
	dateDue?: GraphQLTypes["dateDue"] | undefined | null,
	dateTax?: GraphQLTypes["dateTax"] | undefined | null,
	updated?: GraphQLTypes["updated"] | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	box?: string | undefined | null,
	item?: string | undefined | null,
	package?: string | undefined | null,
	customer?: number | undefined | null,
	customerFulltext?: string | undefined | null,
	shippingCountries?: Array<string | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	user?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null,
	hasAvailableProducts?: boolean | undefined | null,
	hasGroup?: boolean | undefined | null,
	group?: number | undefined | null,
	groups?: Array<number | undefined | null> | undefined | null,
	createdBy?: Array<number | undefined | null> | undefined | null,
	locked?: boolean | undefined | null,
	dateLocked?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	lockedBy?: Array<number | undefined | null> | undefined | null,
	priority?: number | undefined | null
};
	["processStatusUpdated"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["dateCreated"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["dateBill"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["dateExpedition"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["dateDue"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["dateTax"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["updated"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["orders"]: {
	__typename: "orders",
	items?: Array<GraphQLTypes["Order"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["soldItemFilters"]: {
		productFulltext?: string | undefined | null,
	customerFulltext?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	payments?: Array<number | undefined | null> | undefined | null,
	status?: string | undefined | null,
	processStatus?: string | undefined | null,
	processStatusUpdated?: GraphQLTypes["processStatusUpdated"] | undefined | null,
	carriers?: Array<string | undefined | null> | undefined | null,
	dateCreated?: GraphQLTypes["dateCreated"] | undefined | null,
	dateBill?: GraphQLTypes["dateBill"] | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	customer?: number | undefined | null,
	product?: number | undefined | null,
	shippingCountries?: Array<string | undefined | null> | undefined | null,
	orderTags?: Array<number | undefined | null> | undefined | null,
	productTags?: Array<number | undefined | null> | undefined | null
};
	["soldItems"]: {
	__typename: "soldItems",
	items?: Array<GraphQLTypes["SoldItem"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["SoldItem"]: {
	__typename: "SoldItem",
	name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	priceAll?: number | undefined | null,
	priceAllWithoutVat?: number | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null,
	profit?: number | undefined | null
};
	["orderItemFilters"]: {
		status?: string | undefined | null,
	processStatus?: string | undefined | null,
	order?: number | undefined | null,
	productDepot?: number | undefined | null,
	carrier?: string | undefined | null
};
	["orderItems"]: {
	__typename: "orderItems",
	items?: Array<GraphQLTypes["OrderItem"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["orderItem"]: {
	__typename: "orderItem",
	data?: GraphQLTypes["OrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["customer"]: {
	__typename: "customer",
	data?: GraphQLTypes["Customer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["customerFilters"]: {
		externalId?: string | undefined | null,
	email?: string | undefined | null,
	fulltext?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	user?: number | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	priceLevel?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["customers"]: {
	__typename: "customers",
	items?: Array<GraphQLTypes["Customer"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["address"]: {
	__typename: "address",
	data?: GraphQLTypes["Address"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["addressesFilters"]: {
		customer?: number | undefined | null,
	externalId?: string | undefined | null,
	isStored?: boolean | undefined | null,
	isBilling?: boolean | undefined | null,
	ic?: string | undefined | null,
	dic?: string | undefined | null,
	phone?: string | undefined | null,
	email?: string | undefined | null
};
	["addresses"]: {
	__typename: "addresses",
	items?: Array<GraphQLTypes["Address"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["checkout"]: {
	__typename: "checkout",
	data?: GraphQLTypes["Checkout"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["checkoutFilters"]: {
		name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	user?: number | undefined | null
};
	["checkouts"]: {
	__typename: "checkouts",
	items?: Array<GraphQLTypes["Checkout"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["eventTypes"]: {
	__typename: "eventTypes",
	items?: Array<string | undefined | null> | undefined | null
};
	["consent"]: {
	__typename: "consent",
	data?: GraphQLTypes["Consent"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["consentsFilters"]: {
		name?: string | undefined | null
};
	["consents"]: {
	__typename: "consents",
	items?: Array<GraphQLTypes["Consent"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["checkoutExtraOperation"]: {
	__typename: "checkoutExtraOperation",
	data?: GraphQLTypes["CheckoutExtraOperation"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["checkoutExtraOperationFilters"]: {
		checkout?: number | undefined | null,
	checkoutClosing?: number | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null
};
	["checkoutExtraOperations"]: {
	__typename: "checkoutExtraOperations",
	items?: Array<GraphQLTypes["CheckoutExtraOperation"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["checkoutClosing"]: {
	__typename: "checkoutClosing",
	data?: GraphQLTypes["CheckoutClosing"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["checkoutClosingFilters"]: {
		checkouts?: Array<number | undefined | null> | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["checkoutClosings"]: {
	__typename: "checkoutClosings",
	items?: Array<GraphQLTypes["CheckoutClosing"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["vat"]: {
	__typename: "vat",
	data?: GraphQLTypes["Vat"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["vatFilters"]: {
		name?: string | undefined | null,
	percent?: number | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["vats"]: {
	__typename: "vats",
	items?: Array<GraphQLTypes["Vat"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["depot"]: {
	__typename: "depot",
	data?: GraphQLTypes["Depot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["depotFilters"]: {
		companies?: Array<number | undefined | null> | undefined | null,
	name?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	user?: number | undefined | null
};
	["depots"]: {
	__typename: "depots",
	items?: Array<GraphQLTypes["Depot"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["supplier"]: {
	__typename: "supplier",
	data?: GraphQLTypes["Supplier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["supplierFilters"]: {
		name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["suppliers"]: {
	__typename: "suppliers",
	items?: Array<GraphQLTypes["Supplier"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["producer"]: {
	__typename: "producer",
	data?: GraphQLTypes["Producer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["producerFilters"]: {
		name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["producers"]: {
	__typename: "producers",
	items?: Array<GraphQLTypes["Producer"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["exportStockFilters"]: {
		depots?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null
};
	["exportStocks"]: {
	__typename: "exportStocks",
	items?: Array<GraphQLTypes["Stock"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["Stock"]: {
	__typename: "Stock",
	id?: number | undefined | null,
	date?: GraphQLTypes["DateTime"] | undefined | null,
	generated?: GraphQLTypes["DateTime"] | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	depots?: Array<GraphQLTypes["Depot"] | undefined | null> | undefined | null,
	suppliers?: Array<GraphQLTypes["Supplier"] | undefined | null> | undefined | null,
	producers?: Array<GraphQLTypes["Producer"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	format?: string | undefined | null
};
	["exportSaleFilters"]: {
		checkouts?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null
};
	["exportSales"]: {
	__typename: "exportSales",
	items?: Array<GraphQLTypes["Sale"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["Sale"]: {
	__typename: "Sale",
	id?: number | undefined | null,
	dateFrom?: GraphQLTypes["DateTime"] | undefined | null,
	dateTo?: GraphQLTypes["DateTime"] | undefined | null,
	generated?: GraphQLTypes["DateTime"] | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	checkouts?: Array<GraphQLTypes["Checkout"] | undefined | null> | undefined | null,
	suppliers?: Array<GraphQLTypes["Supplier"] | undefined | null> | undefined | null,
	producers?: Array<GraphQLTypes["Producer"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	format?: string | undefined | null
};
	["exportPurchaseFilters"]: {
		depots?: Array<number | undefined | null> | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null
};
	["exportPurchases"]: {
	__typename: "exportPurchases",
	items?: Array<GraphQLTypes["Purchase"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["Purchase"]: {
	__typename: "Purchase",
	id?: number | undefined | null,
	dateFrom?: GraphQLTypes["DateTime"] | undefined | null,
	dateTo?: GraphQLTypes["DateTime"] | undefined | null,
	generated?: GraphQLTypes["DateTime"] | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	depots?: Array<GraphQLTypes["Depot"] | undefined | null> | undefined | null,
	checkouts?: Array<GraphQLTypes["Checkout"] | undefined | null> | undefined | null,
	suppliers?: Array<GraphQLTypes["Supplier"] | undefined | null> | undefined | null,
	producers?: Array<GraphQLTypes["Producer"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	format?: string | undefined | null
};
	["exportOrderFilters"]: {
		status?: string | undefined | null,
	checkouts?: Array<number | undefined | null> | undefined | null
};
	["exportOrders"]: {
	__typename: "exportOrders",
	items?: Array<GraphQLTypes["exportOrder"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["exportOrder"]: {
	__typename: "exportOrder",
	id?: number | undefined | null,
	dateFrom?: GraphQLTypes["DateTime"] | undefined | null,
	dateTo?: GraphQLTypes["DateTime"] | undefined | null,
	generated?: GraphQLTypes["DateTime"] | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	status?: GraphQLTypes["OrderStatus"] | undefined | null,
	checkouts?: Array<GraphQLTypes["Checkout"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	format?: string | undefined | null
};
	["exportInventory"]: {
	__typename: "exportInventory",
	data?: GraphQLTypes["Inventory"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["Inventory"]: {
	__typename: "Inventory",
	id?: number | undefined | null,
	date?: GraphQLTypes["DateTime"] | undefined | null,
	generated?: GraphQLTypes["DateTime"] | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	depots?: Array<GraphQLTypes["Depot"] | undefined | null> | undefined | null,
	suppliers?: Array<GraphQLTypes["Supplier"] | undefined | null> | undefined | null,
	producers?: Array<GraphQLTypes["Producer"] | undefined | null> | undefined | null,
	url?: string | undefined | null,
	files?: Array<GraphQLTypes["File"] | undefined | null> | undefined | null,
	approved?: GraphQLTypes["DateTime"] | undefined | null,
	rejected?: GraphQLTypes["DateTime"] | undefined | null,
	finished?: GraphQLTypes["DateTime"] | undefined | null,
	pmpIn?: GraphQLTypes["ProductMovePack"] | undefined | null,
	pmpOut?: GraphQLTypes["ProductMovePack"] | undefined | null
};
	["exportInventoryFilters"]: {
		checkouts?: Array<number | undefined | null> | undefined | null,
	producers?: Array<number | undefined | null> | undefined | null,
	suppliers?: Array<number | undefined | null> | undefined | null,
	approved?: boolean | undefined | null,
	rejected?: boolean | undefined | null,
	finished?: boolean | undefined | null
};
	["exportInventories"]: {
	__typename: "exportInventories",
	items?: Array<GraphQLTypes["Inventory"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["export"]: {
	__typename: "export",
	data?: GraphQLTypes["Export"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["Export"]: {
	__typename: "Export",
	id?: number | undefined | null,
	file?: GraphQLTypes["File"] | undefined | null,
	generated?: GraphQLTypes["DateTime"] | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null,
	url?: string | undefined | null,
	type?: GraphQLTypes["ExportType"] | undefined | null,
	filter?: string | undefined | null,
	createdBy?: GraphQLTypes["User"] | undefined | null,
	note?: string | undefined | null
};
	["ExportType"]: {
	__typename: "ExportType",
	id?: string | undefined | null,
	name?: string | undefined | null,
	format?: string | undefined | null,
	group?: string | undefined | null
};
	["exportFilters"]: {
		types?: Array<string | undefined | null> | undefined | null,
	group?: string | undefined | null
};
	["exports"]: {
	__typename: "exports",
	items?: Array<GraphQLTypes["Export"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["exportTypeFilters"]: {
		group?: string | undefined | null
};
	["exportTypes"]: {
	__typename: "exportTypes",
	items?: Array<GraphQLTypes["ExportType"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["shop"]: {
	__typename: "shop",
	data?: GraphQLTypes["Shop"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["Shop"]: {
	__typename: "Shop",
	id?: number | undefined | null,
	name?: string | undefined | null,
	street?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	zip?: string | undefined | null,
	eetId?: number | undefined | null,
	cert?: GraphQLTypes["Cert"] | undefined | null,
	checkouts?: Array<GraphQLTypes["Checkout"] | undefined | null> | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null
};
	["Cert"]: {
	__typename: "Cert",
	id?: number | undefined | null,
	name?: string | undefined | null,
	publicKey?: string | undefined | null,
	expirationDate?: GraphQLTypes["DateTime"] | undefined | null,
	company?: GraphQLTypes["Company"] | undefined | null
};
	["shopFilters"]: {
		name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["shops"]: {
	__typename: "shops",
	items?: Array<GraphQLTypes["Shop"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["cert"]: {
	__typename: "cert",
	data?: GraphQLTypes["Cert"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["filters"]: {
		name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["certs"]: {
	__typename: "certs",
	items?: Array<GraphQLTypes["Cert"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["eetReceiptFilters"]: {
		checkouts?: Array<number | undefined | null> | undefined | null,
	number?: number | undefined | null,
	hasFik?: boolean | undefined | null,
	playground?: boolean | undefined | null,
	verificationMode?: boolean | undefined | null
};
	["eetReceipts"]: {
	__typename: "eetReceipts",
	items?: Array<GraphQLTypes["Receipt"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["payment"]: {
	__typename: "payment",
	data?: GraphQLTypes["Payment"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["paymentFilters"]: {
		company?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["payments"]: {
	__typename: "payments",
	items?: Array<GraphQLTypes["Payment"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["paymentItem"]: {
	__typename: "paymentItem",
	data?: GraphQLTypes["PaymentItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["paymentItemsFilters"]: {
		order?: number | undefined | null,
	type?: string | undefined | null,
	payment?: number | undefined | null,
	externalId?: string | undefined | null
};
	["paymentItems"]: {
	__typename: "paymentItems",
	items?: Array<GraphQLTypes["PaymentItem"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["paymentTypeFilters"]: {
		const?: string | undefined | null
};
	["paymentTypes"]: {
	__typename: "paymentTypes",
	items?: Array<GraphQLTypes["PaymentType"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["processStatusesFilters"]: {
		name?: string | undefined | null
};
	["processStatuses"]: {
	__typename: "processStatuses",
	items?: Array<GraphQLTypes["ProcessStatus"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["carriersFilters"]: {
		name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["carriers"]: {
	__typename: "carriers",
	items?: Array<GraphQLTypes["Carrier"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["currenciesFilters"]: {
		name?: string | undefined | null
};
	["currencies"]: {
	__typename: "currencies",
	items?: Array<GraphQLTypes["Currency"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["package"]: {
	__typename: "package",
	data?: GraphQLTypes["Package"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["packageFilters"]: {
		code?: string | undefined | null,
	carrier?: string | undefined | null,
	order?: number | undefined | null,
	disposal?: number | undefined | null,
	hasDisposal?: boolean | undefined | null,
	isSent?: boolean | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	sent?: string | undefined | null
};
	["packages"]: {
	__typename: "packages",
	items?: Array<GraphQLTypes["Package"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["packageStatsFilters"]: {
		carrier?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	fromDate?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	toDate?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["packageStats"]: {
	__typename: "packageStats",
	items?: Array<GraphQLTypes["PackageStats"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["PackageStats"]: {
	__typename: "PackageStats",
	company?: GraphQLTypes["Company"] | undefined | null,
	processStatus?: GraphQLTypes["ProcessStatus"] | undefined | null,
	packageAmount?: number | undefined | null,
	orderAmount?: number | undefined | null,
	country?: string | undefined | null
};
	["disposal"]: {
	__typename: "disposal",
	data?: GraphQLTypes["PackageDisposal"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["disposalFilters"]: {
		carrier?: string | undefined | null
};
	["disposals"]: {
	__typename: "disposals",
	items?: Array<GraphQLTypes["PackageDisposal"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["productDepotMetric"]: {
	__typename: "productDepotMetric",
	data?: GraphQLTypes["ProductDepotMetric"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productDepotMetricFilters"]: {
		product?: number | undefined | null,
	depot?: number | undefined | null
};
	["productDepotMetrics"]: {
	__typename: "productDepotMetrics",
	items?: Array<GraphQLTypes["ProductDepotMetric"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["file"]: {
	__typename: "file",
	data?: GraphQLTypes["File"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["fileFilters"]: {
		product?: number | undefined | null,
	order?: number | undefined | null
};
	["files"]: {
	__typename: "files",
	items?: Array<GraphQLTypes["File"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["nextEan"]: {
	__typename: "nextEan",
	data?: string | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["statsCarrierUsage"]: {
	__typename: "statsCarrierUsage",
	items?: Array<GraphQLTypes["CarrierUsage"] | undefined | null> | undefined | null
};
	["CarrierUsage"]: {
	__typename: "CarrierUsage",
	amount?: number | undefined | null,
	carrier?: GraphQLTypes["Carrier"] | undefined | null
};
	["statsPaymentSales"]: {
	__typename: "statsPaymentSales",
	items?: Array<GraphQLTypes["PaymentSales"] | undefined | null> | undefined | null
};
	["PaymentSales"]: {
	__typename: "PaymentSales",
	amount?: number | undefined | null,
	sales?: Array<GraphQLTypes["Price"] | undefined | null> | undefined | null,
	payment?: GraphQLTypes["Payment"] | undefined | null
};
	["Price"]: {
	__typename: "Price",
	value?: number | undefined | null,
	currency?: GraphQLTypes["Currency"] | undefined | null
};
	["statsBestsellersSort"]: statsBestsellersSort;
	["statsBestsellers"]: {
	__typename: "statsBestsellers",
	items?: Array<GraphQLTypes["Bestsellers"] | undefined | null> | undefined | null
};
	["Bestsellers"]: {
	__typename: "Bestsellers",
	amount?: number | undefined | null,
	sales?: Array<GraphQLTypes["Price"] | undefined | null> | undefined | null,
	product?: GraphQLTypes["Product"] | undefined | null
};
	["companyCarrier"]: {
	__typename: "companyCarrier",
	data?: GraphQLTypes["CompanyCarrier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["companyCarrierFilters"]: {
		carrier?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null
};
	["companyCarriers"]: {
	__typename: "companyCarriers",
	items?: Array<GraphQLTypes["CompanyCarrier"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["category"]: {
	__typename: "category",
	data?: GraphQLTypes["Category"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["categoryFilters"]: {
		name?: string | undefined | null,
	parent?: number | undefined | null,
	hasParent?: boolean | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null,
	externalId?: string | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["categories"]: {
	__typename: "categories",
	items?: Array<GraphQLTypes["Category"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["parameter"]: {
	__typename: "parameter",
	data?: GraphQLTypes["Parameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["parametersFilters"]: {
		name?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["parameters"]: {
	__typename: "parameters",
	items?: Array<GraphQLTypes["Parameter"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["orderGroup"]: {
	__typename: "orderGroup",
	data?: GraphQLTypes["OrderGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["orderGroupFilters"]: {
		companies?: Array<number | undefined | null> | undefined | null,
	hasUser?: boolean | undefined | null,
	user?: number | undefined | null,
	name?: string | undefined | null,
	processStatus?: string | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null
};
	["orderGroups"]: {
	__typename: "orderGroups",
	items?: Array<GraphQLTypes["OrderGroup"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["voucher"]: {
	__typename: "voucher",
	data?: GraphQLTypes["Voucher"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["voucherFilters"]: {
		companies?: Array<number | undefined | null> | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	externalId?: string | undefined | null,
	discountType?: string | undefined | null,
	enabled?: boolean | undefined | null,
	isPayment?: boolean | undefined | null,
	isValid?: boolean | undefined | null,
	isUsed?: boolean | undefined | null,
	validDate?: GraphQLTypes["voucherValidFilter"] | undefined | null,
	created?: GraphQLTypes["voucherCreatedFilter"] | undefined | null
};
	["voucherValidFilter"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["voucherCreatedFilter"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["vouchers"]: {
	__typename: "vouchers",
	items?: Array<GraphQLTypes["Voucher"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["productPriceFilters"]: {
		product?: number | undefined | null
};
	["productPrices"]: {
	__typename: "productPrices",
	items?: Array<GraphQLTypes["ProductPrice"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["priceLevel"]: {
	__typename: "priceLevel",
	data?: GraphQLTypes["PriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["priceLevelFilters"]: {
		name?: string | undefined | null,
	externalId?: string | undefined | null,
	isPercentage?: boolean | undefined | null,
	withVat?: boolean | undefined | null,
	currency?: string | undefined | null
};
	["priceLevels"]: {
	__typename: "priceLevels",
	items?: Array<GraphQLTypes["PriceLevel"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["productParameter"]: {
	__typename: "productParameter",
	data?: GraphQLTypes["ProductParameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productParameterFilters"]: {
		product?: number | undefined | null,
	parameter?: number | undefined | null,
	value?: string | undefined | null,
	externalId?: string | undefined | null
};
	["productParameters"]: {
	__typename: "productParameters",
	items?: Array<GraphQLTypes["ProductParameter"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["productPriceLevel"]: {
	__typename: "productPriceLevel",
	data?: GraphQLTypes["ProductPriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productPriceLevelFilters"]: {
		product?: number | undefined | null,
	priceLevel?: number | undefined | null,
	externalId?: string | undefined | null
};
	["productPriceLevels"]: {
	__typename: "productPriceLevels",
	items?: Array<GraphQLTypes["ProductPriceLevel"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["tag"]: {
	__typename: "tag",
	data?: GraphQLTypes["Tag"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["tagFilters"]: {
		name?: string | undefined | null,
	type?: string | undefined | null,
	externalId?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["tags"]: {
	__typename: "tags",
	items?: Array<GraphQLTypes["Tag"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["tagTypeFilters"]: {
		const?: string | undefined | null
};
	["tagTypes"]: {
	__typename: "tagTypes",
	items?: Array<GraphQLTypes["TagType"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["TagType"]: {
	__typename: "TagType",
	id?: string | undefined | null,
	name?: string | undefined | null
};
	["productPack"]: {
	__typename: "productPack",
	data?: GraphQLTypes["ProductPack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["productPackFilters"]: {
		product?: number | undefined | null,
	quantity?: number | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	externalId?: string | undefined | null
};
	["productPacks"]: {
	__typename: "productPacks",
	items?: Array<GraphQLTypes["ProductPack"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["purchaseOrder"]: {
	__typename: "purchaseOrder",
	data?: GraphQLTypes["PurchaseOrder"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["purchaseOrderFilters"]: {
		fulltext?: string | undefined | null,
	status?: string | undefined | null,
	showStocked?: boolean | undefined | null,
	supplier?: number | undefined | null,
	depot?: number | undefined | null,
	depots?: Array<number | undefined | null> | undefined | null,
	number?: number | undefined | null,
	externalId?: string | undefined | null,
	externalReference?: string | undefined | null,
	supplierReference?: string | undefined | null,
	createdBy?: number | undefined | null,
	tags?: Array<number | undefined | null> | undefined | null,
	updated?: GraphQLTypes["updated"] | undefined | null,
	created?: GraphQLTypes["created"] | undefined | null,
	dateEstimatedArrival?: GraphQLTypes["dateEstimatedArrival"] | undefined | null,
	company?: number | undefined | null
};
	["dateEstimatedArrival"]: {
		left_date?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	right_date?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["purchaseOrders"]: {
	__typename: "purchaseOrders",
	items?: Array<GraphQLTypes["PurchaseOrder"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["purchaseOrderItem"]: {
	__typename: "purchaseOrderItem",
	data?: GraphQLTypes["PurchaseOrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["purchaseOrderItemFilters"]: {
		fulltext?: string | undefined | null,
	purchaseOrder?: number | undefined | null,
	depot?: number | undefined | null,
	product?: number | undefined | null,
	currency?: string | undefined | null,
	externalId?: string | undefined | null,
	status?: string | undefined | null,
	supplier?: number | undefined | null,
	company?: number | undefined | null
};
	["purchaseOrderItems"]: {
	__typename: "purchaseOrderItems",
	items?: Array<GraphQLTypes["PurchaseOrderItem"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["purchaseOrderStatusesFilters"]: {
		name?: string | undefined | null
};
	["purchaseOrderStatuses"]: {
	__typename: "purchaseOrderStatuses",
	items?: Array<GraphQLTypes["PurchaseOrderStatus"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["modulesFilters"]: {
		name?: string | undefined | null,
	companies?: Array<number | undefined | null> | undefined | null
};
	["modules"]: {
	__typename: "modules",
	items?: Array<GraphQLTypes["Module"] | undefined | null> | undefined | null,
	paginator?: GraphQLTypes["Paginator"] | undefined | null
};
	["RootSchemaMutation"]: {
	__typename: "RootSchemaMutation",
	createProduct?: GraphQLTypes["createProduct"] | undefined | null,
	updateProduct?: GraphQLTypes["updateProduct"] | undefined | null,
	deleteProduct?: GraphQLTypes["deleteProduct"] | undefined | null,
	refreshProductDepots?: GraphQLTypes["refreshProductDepots"] | undefined | null,
	createProductMovePack?: GraphQLTypes["createProductMovePack"] | undefined | null,
	updateProductMovePack?: GraphQLTypes["updateProductMovePack"] | undefined | null,
	deleteProductMovePack?: GraphQLTypes["deleteProductMovePack"] | undefined | null,
	updateProductMove?: GraphQLTypes["updateProductMove"] | undefined | null,
	deleteProductMove?: GraphQLTypes["deleteProductMove"] | undefined | null,
	createProductPrice?: GraphQLTypes["createProductPrice"] | undefined | null,
	updateProductPrice?: GraphQLTypes["updateProductPrice"] | undefined | null,
	deleteProductPrice?: GraphQLTypes["deleteProductPrice"] | undefined | null,
	createProductBundle?: GraphQLTypes["createProductBundle"] | undefined | null,
	updateProductBundle?: GraphQLTypes["updateProductBundle"] | undefined | null,
	deleteProductBundle?: GraphQLTypes["deleteProductBundle"] | undefined | null,
	createProductDepotMetric?: GraphQLTypes["createProductDepotMetric"] | undefined | null,
	updateProductDepotMetric?: GraphQLTypes["updateProductDepotMetric"] | undefined | null,
	deleteProductDepotMetric?: GraphQLTypes["deleteProductDepotMetric"] | undefined | null,
	createInstitution?: GraphQLTypes["createInstitution"] | undefined | null,
	updateInstitution?: GraphQLTypes["updateInstitution"] | undefined | null,
	deleteInstitution?: GraphQLTypes["deleteInstitution"] | undefined | null,
	createOrder?: GraphQLTypes["createOrder"] | undefined | null,
	updateOrder?: GraphQLTypes["updateOrder"] | undefined | null,
	deleteReservation?: GraphQLTypes["deleteReservation"] | undefined | null,
	createOrderItem?: GraphQLTypes["createOrderItem"] | undefined | null,
	updateOrderItem?: GraphQLTypes["updateOrderItem"] | undefined | null,
	deleteOrderItem?: GraphQLTypes["deleteOrderItem"] | undefined | null,
	updateClearanceItem?: GraphQLTypes["updateClearanceItem"] | undefined | null,
	createUser?: GraphQLTypes["createUser"] | undefined | null,
	updateUser?: GraphQLTypes["updateUser"] | undefined | null,
	deleteUser?: GraphQLTypes["deleteUser"] | undefined | null,
	createUserGroup?: GraphQLTypes["createUserGroup"] | undefined | null,
	updateUserGroup?: GraphQLTypes["updateUserGroup"] | undefined | null,
	deleteUserGroup?: GraphQLTypes["deleteUserGroup"] | undefined | null,
	createCustomer?: GraphQLTypes["createCustomer"] | undefined | null,
	updateCustomer?: GraphQLTypes["updateCustomer"] | undefined | null,
	deleteCustomer?: GraphQLTypes["deleteCustomer"] | undefined | null,
	createAddress?: GraphQLTypes["createAddress"] | undefined | null,
	updateAddress?: GraphQLTypes["updateAddress"] | undefined | null,
	deleteAddress?: GraphQLTypes["deleteAddress"] | undefined | null,
	createCheckout?: GraphQLTypes["createCheckout"] | undefined | null,
	updateCheckout?: GraphQLTypes["updateCheckout"] | undefined | null,
	deleteCheckout?: GraphQLTypes["deleteCheckout"] | undefined | null,
	createCheckoutExtraOperation?: GraphQLTypes["createCheckoutExtraOperation"] | undefined | null,
	updateCheckoutExtraOperation?: GraphQLTypes["updateCheckoutExtraOperation"] | undefined | null,
	deleteCheckoutExtraOperation?: GraphQLTypes["deleteCheckoutExtraOperation"] | undefined | null,
	createCheckoutClosing?: GraphQLTypes["createCheckoutClosing"] | undefined | null,
	updateCheckoutClosing?: GraphQLTypes["updateCheckoutClosing"] | undefined | null,
	deleteCheckoutClosing?: GraphQLTypes["deleteCheckoutClosing"] | undefined | null,
	createVat?: GraphQLTypes["createVat"] | undefined | null,
	updateVat?: GraphQLTypes["updateVat"] | undefined | null,
	deleteVat?: GraphQLTypes["deleteVat"] | undefined | null,
	createDepot?: GraphQLTypes["createDepot"] | undefined | null,
	updateDepot?: GraphQLTypes["updateDepot"] | undefined | null,
	deleteDepot?: GraphQLTypes["deleteDepot"] | undefined | null,
	createSupplier?: GraphQLTypes["createSupplier"] | undefined | null,
	updateSupplier?: GraphQLTypes["updateSupplier"] | undefined | null,
	deleteSupplier?: GraphQLTypes["deleteSupplier"] | undefined | null,
	createProducer?: GraphQLTypes["createProducer"] | undefined | null,
	updateProducer?: GraphQLTypes["updateProducer"] | undefined | null,
	deleteProducer?: GraphQLTypes["deleteProducer"] | undefined | null,
	createExportStock?: GraphQLTypes["createExportStock"] | undefined | null,
	createExportSale?: GraphQLTypes["createExportSale"] | undefined | null,
	createExportPurchase?: GraphQLTypes["createExportPurchase"] | undefined | null,
	createExportOrder?: GraphQLTypes["createExportOrder"] | undefined | null,
	createExportInventory?: GraphQLTypes["createExportInventory"] | undefined | null,
	updateExportInventory?: GraphQLTypes["updateExportInventory"] | undefined | null,
	refreshExportInventory?: GraphQLTypes["refreshExportInventory"] | undefined | null,
	createExport?: GraphQLTypes["createExport"] | undefined | null,
	updateCompany?: GraphQLTypes["updateCompany"] | undefined | null,
	createShop?: GraphQLTypes["createShop"] | undefined | null,
	updateShop?: GraphQLTypes["updateShop"] | undefined | null,
	deleteShop?: GraphQLTypes["deleteShop"] | undefined | null,
	createCert?: GraphQLTypes["createCert"] | undefined | null,
	updateCert?: GraphQLTypes["updateCert"] | undefined | null,
	deleteCert?: GraphQLTypes["deleteCert"] | undefined | null,
	createEetReceipt?: GraphQLTypes["createEetReceipt"] | undefined | null,
	sendEetReceipt?: GraphQLTypes["sendEetReceipt"] | undefined | null,
	createPayment?: GraphQLTypes["createPayment"] | undefined | null,
	updatePayment?: GraphQLTypes["updatePayment"] | undefined | null,
	deletePayment?: GraphQLTypes["deletePayment"] | undefined | null,
	createPaymentItem?: GraphQLTypes["createPaymentItem"] | undefined | null,
	updatePaymentItem?: GraphQLTypes["updatePaymentItem"] | undefined | null,
	deletePaymentItem?: GraphQLTypes["deletePaymentItem"] | undefined | null,
	createDevLog?: GraphQLTypes["createDevLog"] | undefined | null,
	createPackage?: GraphQLTypes["createPackage"] | undefined | null,
	updatePackage?: GraphQLTypes["updatePackage"] | undefined | null,
	deletePackage?: GraphQLTypes["deletePackage"] | undefined | null,
	resetPackage?: GraphQLTypes["resetPackage"] | undefined | null,
	sendPackage?: GraphQLTypes["sendPackage"] | undefined | null,
	createDisposal?: GraphQLTypes["createDisposal"] | undefined | null,
	updateDisposal?: GraphQLTypes["updateDisposal"] | undefined | null,
	deleteDisposal?: GraphQLTypes["deleteDisposal"] | undefined | null,
	sendDisposal?: GraphQLTypes["sendDisposal"] | undefined | null,
	createFile?: GraphQLTypes["createFile"] | undefined | null,
	updateFile?: GraphQLTypes["updateFile"] | undefined | null,
	deleteFile?: GraphQLTypes["deleteFile"] | undefined | null,
	createCompanyCarrier?: GraphQLTypes["createCompanyCarrier"] | undefined | null,
	updateCompanyCarrier?: GraphQLTypes["updateCompanyCarrier"] | undefined | null,
	deleteCompanyCarrier?: GraphQLTypes["deleteCompanyCarrier"] | undefined | null,
	createConsent?: GraphQLTypes["createConsent"] | undefined | null,
	updateConsent?: GraphQLTypes["updateConsent"] | undefined | null,
	deleteConsent?: GraphQLTypes["deleteConsent"] | undefined | null,
	createCustomerConsent?: GraphQLTypes["createCustomerConsent"] | undefined | null,
	deleteCustomerConsent?: GraphQLTypes["deleteCustomerConsent"] | undefined | null,
	updateProductDepot?: GraphQLTypes["updateProductDepot"] | undefined | null,
	createCategory?: GraphQLTypes["createCategory"] | undefined | null,
	updateCategory?: GraphQLTypes["updateCategory"] | undefined | null,
	deleteCategory?: GraphQLTypes["deleteCategory"] | undefined | null,
	createParameter?: GraphQLTypes["createParameter"] | undefined | null,
	updateParameter?: GraphQLTypes["updateParameter"] | undefined | null,
	deleteParameter?: GraphQLTypes["deleteParameter"] | undefined | null,
	createOrderGroup?: GraphQLTypes["createOrderGroup"] | undefined | null,
	updateOrderGroup?: GraphQLTypes["updateOrderGroup"] | undefined | null,
	deleteOrderGroup?: GraphQLTypes["deleteOrderGroup"] | undefined | null,
	createVoucher?: GraphQLTypes["createVoucher"] | undefined | null,
	updateVoucher?: GraphQLTypes["updateVoucher"] | undefined | null,
	deleteVoucher?: GraphQLTypes["deleteVoucher"] | undefined | null,
	createPriceLevel?: GraphQLTypes["createPricePriceLevel"] | undefined | null,
	updatePriceLevel?: GraphQLTypes["updatePriceLevel"] | undefined | null,
	deletePriceLevel?: GraphQLTypes["deletePriceLevel"] | undefined | null,
	createProductParameter?: GraphQLTypes["createProductParameter"] | undefined | null,
	updateProductParameter?: GraphQLTypes["updateProductParameter"] | undefined | null,
	deleteProductParameter?: GraphQLTypes["deleteProductParameter"] | undefined | null,
	createProductPriceLevel?: GraphQLTypes["createProductPriceLevel"] | undefined | null,
	updateProductPriceLevel?: GraphQLTypes["updateProductPriceLevel"] | undefined | null,
	deleteProductPriceLevel?: GraphQLTypes["deleteProductPriceLevel"] | undefined | null,
	createTag?: GraphQLTypes["createTag"] | undefined | null,
	updateTag?: GraphQLTypes["updateTag"] | undefined | null,
	deleteTag?: GraphQLTypes["deleteTag"] | undefined | null,
	createProductPack?: GraphQLTypes["createProductPack"] | undefined | null,
	updateProductPack?: GraphQLTypes["updateProductPack"] | undefined | null,
	deleteProductPack?: GraphQLTypes["deleteProductPack"] | undefined | null,
	createPurchaseOrder?: GraphQLTypes["createPurchaseOrder"] | undefined | null,
	updatePurchaseOrder?: GraphQLTypes["updatePurchaseOrder"] | undefined | null,
	deletePurchaseOrder?: GraphQLTypes["deletePurchaseOrder"] | undefined | null,
	createPurchaseOrderItem?: GraphQLTypes["createPurchaseOrderItem"] | undefined | null,
	updatePurchaseOrderItem?: GraphQLTypes["updatePurchaseOrderItem"] | undefined | null,
	deletePurchaseOrderItem?: GraphQLTypes["deletePurchaseOrderItem"] | undefined | null
};
	["createProduct"]: {
	__typename: "createProduct",
	data?: GraphQLTypes["Product"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProduct"]: {
	__typename: "updateProduct",
	data?: GraphQLTypes["Product"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProduct"]: {
	__typename: "deleteProduct",
	errors?: Array<string | undefined | null> | undefined | null
};
	["refreshProductDepots"]: {
	__typename: "refreshProductDepots",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createProductMove"]: {
		product?: number | undefined | null,
	depotFrom?: number | undefined | null,
	depotTo?: number | undefined | null,
	productDepot?: number | undefined | null,
	supplier?: number | undefined | null,
	amount: number,
	purchasePrice?: number | undefined | null,
	purchaseCurrency?: string | undefined | null,
	purchaseCurrencyDate?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	purchaseOrderItem?: number | undefined | null,
	expirationDate?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	note?: string | undefined | null,
	orderItem?: number | undefined | null,
	serialNumbers?: Array<string | undefined | null> | undefined | null
};
	["createProductMovePack"]: {
	__typename: "createProductMovePack",
	data?: GraphQLTypes["ProductMovePack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductMovePack"]: {
	__typename: "updateProductMovePack",
	data?: GraphQLTypes["ProductMovePack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductMovePack"]: {
	__typename: "deleteProductMovePack",
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductMove"]: {
	__typename: "updateProductMove",
	data?: GraphQLTypes["ProductMove"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductMove"]: {
	__typename: "deleteProductMove",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createProductPrice"]: {
	__typename: "createProductPrice",
	data?: GraphQLTypes["ProductPrice"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductPrice"]: {
	__typename: "updateProductPrice",
	data?: GraphQLTypes["ProductPrice"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductPrice"]: {
	__typename: "deleteProductPrice",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createProductBundle"]: {
	__typename: "createProductBundle",
	data?: GraphQLTypes["ProductBundle"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductBundle"]: {
	__typename: "updateProductBundle",
	data?: GraphQLTypes["ProductBundle"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductBundle"]: {
	__typename: "deleteProductBundle",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createProductDepotMetric"]: {
	__typename: "createProductDepotMetric",
	data?: GraphQLTypes["ProductDepotMetric"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductDepotMetric"]: {
	__typename: "updateProductDepotMetric",
	data?: GraphQLTypes["ProductDepotMetric"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductDepotMetric"]: {
	__typename: "deleteProductDepotMetric",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createInstitution"]: {
	__typename: "createInstitution",
	data?: GraphQLTypes["Institution"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateInstitution"]: {
	__typename: "updateInstitution",
	data?: GraphQLTypes["Institution"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteInstitution"]: {
	__typename: "deleteInstitution",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createOrderItem_"]: {
		name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	price?: number | undefined | null,
	sale?: number | undefined | null,
	vat?: number | undefined | null,
	product?: number | undefined | null,
	serial?: string | undefined | null,
	expirationDate?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	note?: string | undefined | null,
	isForSubsequentSettlement?: boolean | undefined | null,
	picked?: boolean | undefined | null,
	packed?: boolean | undefined | null,
	voucher?: number | undefined | null,
	externalId?: string | undefined | null
};
	["createPaymentItem_"]: {
		payment: number,
	checkout?: number | undefined | null,
	voucher?: number | undefined | null,
	amount: number,
	dateCreated?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	dateCancelled?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	externalId?: string | undefined | null,
	isPaid?: boolean | undefined | null,
	datePaid?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["processStatusRelation"]: {
		status?: string | undefined | null,
	note?: string | undefined | null
};
	["createOrder"]: {
	__typename: "createOrder",
	data?: GraphQLTypes["Order"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateOrderItem_"]: {
		id?: number | undefined | null,
	name?: string | undefined | null,
	type?: string | undefined | null,
	ean?: string | undefined | null,
	code?: string | undefined | null,
	quantity?: number | undefined | null,
	price?: string | undefined | null,
	sale?: string | undefined | null,
	vat?: number | undefined | null,
	product?: number | undefined | null,
	serial?: string | undefined | null,
	expirationDate?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	note?: string | undefined | null,
	isForSubsequentSettlement?: boolean | undefined | null,
	picked?: boolean | undefined | null,
	packed?: boolean | undefined | null,
	voucher?: number | undefined | null,
	externalId?: string | undefined | null
};
	["updatePaymentItem_"]: {
		payment?: number | undefined | null,
	checkout?: number | undefined | null,
	voucher?: number | undefined | null,
	amount?: string | undefined | null,
	dateCreated?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	dateCancelled?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	externalId?: string | undefined | null,
	isPaid?: boolean | undefined | null,
	datePaid?: GraphQLTypes["DateTimeAsString"] | undefined | null
};
	["updateOrder"]: {
	__typename: "updateOrder",
	data?: GraphQLTypes["Order"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteReservation"]: {
	__typename: "deleteReservation",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createOrderItem"]: {
	__typename: "createOrderItem",
	data?: GraphQLTypes["OrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateOrderItem"]: {
	__typename: "updateOrderItem",
	data?: GraphQLTypes["OrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteOrderItem"]: {
	__typename: "deleteOrderItem",
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateClearanceItemLocations"]: {
		amount: number,
	depot?: number | undefined | null,
	productDepot?: number | undefined | null,
	position1?: string | undefined | null,
	position2?: string | undefined | null,
	position3?: string | undefined | null,
	expirationDate?: GraphQLTypes["DateTimeAsString"] | undefined | null,
	batch?: string | undefined | null,
	locked?: boolean | undefined | null
};
	["updateClearanceItem"]: {
	__typename: "updateClearanceItem",
	data?: GraphQLTypes["ClearanceItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createUser"]: {
	__typename: "createUser",
	data?: GraphQLTypes["User"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateUser"]: {
	__typename: "updateUser",
	data?: GraphQLTypes["User"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteUser"]: {
	__typename: "deleteUser",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createUserGroup"]: {
	__typename: "createUserGroup",
	data?: GraphQLTypes["UserGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateUserGroup"]: {
	__typename: "updateUserGroup",
	data?: GraphQLTypes["UserGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteUserGroup"]: {
	__typename: "deleteUserGroup",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createCustomer"]: {
	__typename: "createCustomer",
	data?: GraphQLTypes["Customer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCustomer"]: {
	__typename: "updateCustomer",
	data?: GraphQLTypes["Customer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCustomer"]: {
	__typename: "deleteCustomer",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createAddress"]: {
	__typename: "createAddress",
	data?: GraphQLTypes["Address"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateAddress"]: {
	__typename: "updateAddress",
	data?: GraphQLTypes["Address"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteAddress"]: {
	__typename: "deleteAddress",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createCheckout"]: {
	__typename: "createCheckout",
	data?: GraphQLTypes["Checkout"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCheckout"]: {
	__typename: "updateCheckout",
	data?: GraphQLTypes["Checkout"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCheckout"]: {
	__typename: "deleteCheckout",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createCheckoutExtraOperation"]: {
	__typename: "createCheckoutExtraOperation",
	data?: GraphQLTypes["CheckoutExtraOperation"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCheckoutExtraOperation"]: {
	__typename: "updateCheckoutExtraOperation",
	data?: GraphQLTypes["CheckoutExtraOperation"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCheckoutExtraOperation"]: {
	__typename: "deleteCheckoutExtraOperation",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createCheckoutClosing"]: {
	__typename: "createCheckoutClosing",
	data?: GraphQLTypes["CheckoutClosing"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCheckoutClosing"]: {
	__typename: "updateCheckoutClosing",
	data?: GraphQLTypes["CheckoutClosing"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCheckoutClosing"]: {
	__typename: "deleteCheckoutClosing",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createVat"]: {
	__typename: "createVat",
	data?: GraphQLTypes["Vat"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateVat"]: {
	__typename: "updateVat",
	data?: GraphQLTypes["Vat"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteVat"]: {
	__typename: "deleteVat",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createDepot"]: {
	__typename: "createDepot",
	data?: GraphQLTypes["Depot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateDepot"]: {
	__typename: "updateDepot",
	data?: GraphQLTypes["Depot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteDepot"]: {
	__typename: "deleteDepot",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createSupplier"]: {
	__typename: "createSupplier",
	data?: GraphQLTypes["Supplier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateSupplier"]: {
	__typename: "updateSupplier",
	data?: GraphQLTypes["Supplier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteSupplier"]: {
	__typename: "deleteSupplier",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createProducer"]: {
	__typename: "createProducer",
	data?: GraphQLTypes["Producer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProducer"]: {
	__typename: "updateProducer",
	data?: GraphQLTypes["Producer"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProducer"]: {
	__typename: "deleteProducer",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExportStock"]: {
	__typename: "createExportStock",
	data?: GraphQLTypes["Stock"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExportSale"]: {
	__typename: "createExportSale",
	data?: GraphQLTypes["Sale"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExportPurchase"]: {
	__typename: "createExportPurchase",
	data?: GraphQLTypes["Purchase"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExportOrder"]: {
	__typename: "createExportOrder",
	data?: GraphQLTypes["exportOrder"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExportInventory"]: {
	__typename: "createExportInventory",
	data?: GraphQLTypes["Inventory"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateExportInventory"]: {
	__typename: "updateExportInventory",
	data?: GraphQLTypes["Inventory"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["refreshExportInventory"]: {
	__typename: "refreshExportInventory",
	data?: GraphQLTypes["Inventory"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createExport"]: {
	__typename: "createExport",
	data?: GraphQLTypes["Export"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCompany"]: {
	__typename: "updateCompany",
	data?: GraphQLTypes["Company"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createShop"]: {
	__typename: "createShop",
	data?: GraphQLTypes["Shop"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateShop"]: {
	__typename: "updateShop",
	data?: GraphQLTypes["Shop"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteShop"]: {
	__typename: "deleteShop",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createCert"]: {
	__typename: "createCert",
	data?: GraphQLTypes["Cert"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCert"]: {
	__typename: "updateCert",
	data?: GraphQLTypes["Depot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCert"]: {
	__typename: "deleteCert",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createEetReceipt"]: {
	__typename: "createEetReceipt",
	data?: GraphQLTypes["Receipt"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["sendEetReceipt"]: {
	__typename: "sendEetReceipt",
	data?: GraphQLTypes["Receipt"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createPayment"]: {
	__typename: "createPayment",
	data?: GraphQLTypes["Payment"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePayment"]: {
	__typename: "updatePayment",
	data?: GraphQLTypes["Payment"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePayment"]: {
	__typename: "deletePayment",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createPaymentItem"]: {
	__typename: "createPaymentItem",
	data?: GraphQLTypes["PaymentItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePaymentItem"]: {
	__typename: "updatePaymentItem",
	data?: GraphQLTypes["PaymentItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePaymentItem"]: {
	__typename: "deletePaymentItem",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createDevLog"]: {
	__typename: "createDevLog",
	data?: GraphQLTypes["DevLog"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["DevLog"]: {
	__typename: "DevLog",
	id?: number | undefined | null,
	name?: string | undefined | null,
	content?: string | undefined | null,
	created?: GraphQLTypes["DateTime"] | undefined | null
};
	["createPackage"]: {
	__typename: "createPackage",
	data?: GraphQLTypes["Package"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePackage"]: {
	__typename: "updatePackage",
	data?: GraphQLTypes["Package"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePackage"]: {
	__typename: "deletePackage",
	errors?: Array<string | undefined | null> | undefined | null
};
	["resetPackage"]: {
	__typename: "resetPackage",
	errors?: Array<string | undefined | null> | undefined | null
};
	["sendPackage"]: {
	__typename: "sendPackage",
	data?: GraphQLTypes["Package"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createDisposal"]: {
	__typename: "createDisposal",
	data?: GraphQLTypes["PackageDisposal"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateDisposal"]: {
	__typename: "updateDisposal",
	data?: GraphQLTypes["PackageDisposal"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteDisposal"]: {
	__typename: "deleteDisposal",
	errors?: Array<string | undefined | null> | undefined | null
};
	["sendDisposal"]: {
	__typename: "sendDisposal",
	data?: GraphQLTypes["PackageDisposal"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createFile"]: {
	__typename: "createFile",
	data?: GraphQLTypes["File"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateFile"]: {
	__typename: "updateFile",
	data?: GraphQLTypes["File"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteFile"]: {
	__typename: "deleteFile",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createCompanyCarrier"]: {
	__typename: "createCompanyCarrier",
	data?: GraphQLTypes["CompanyCarrier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCompanyCarrier"]: {
	__typename: "updateCompanyCarrier",
	data?: GraphQLTypes["CompanyCarrier"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCompanyCarrier"]: {
	__typename: "deleteCompanyCarrier",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createConsent"]: {
	__typename: "createConsent",
	data?: GraphQLTypes["Consent"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateConsent"]: {
	__typename: "updateConsent",
	data?: GraphQLTypes["Consent"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteConsent"]: {
	__typename: "deleteConsent",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createCustomerConsent"]: {
	__typename: "createCustomerConsent",
	data?: GraphQLTypes["CustomerConsent"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCustomerConsent"]: {
	__typename: "deleteCustomerConsent",
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductDepot"]: {
	__typename: "updateProductDepot",
	data?: GraphQLTypes["ProductDepot"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["createCategory"]: {
	__typename: "createCategory",
	data?: GraphQLTypes["Category"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateCategory"]: {
	__typename: "updateCategory",
	data?: GraphQLTypes["Category"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteCategory"]: {
	__typename: "deleteCategory",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createParameter"]: {
	__typename: "createParameter",
	data?: GraphQLTypes["Parameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateParameter"]: {
	__typename: "updateParameter",
	data?: GraphQLTypes["Parameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteParameter"]: {
	__typename: "deleteParameter",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createOrderGroup"]: {
	__typename: "createOrderGroup",
	data?: GraphQLTypes["OrderGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateOrderGroup"]: {
	__typename: "updateOrderGroup",
	data?: GraphQLTypes["OrderGroup"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteOrderGroup"]: {
	__typename: "deleteOrderGroup",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createVoucher"]: {
	__typename: "createVoucher",
	data?: GraphQLTypes["Voucher"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateVoucher"]: {
	__typename: "updateVoucher",
	data?: GraphQLTypes["Voucher"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteVoucher"]: {
	__typename: "deleteVoucher",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createPricePriceLevel"]: {
	__typename: "createPricePriceLevel",
	data?: GraphQLTypes["PriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePriceLevel"]: {
	__typename: "updatePriceLevel",
	data?: GraphQLTypes["PriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePriceLevel"]: {
	__typename: "deletePriceLevel",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createProductParameter"]: {
	__typename: "createProductParameter",
	data?: GraphQLTypes["ProductParameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductParameter"]: {
	__typename: "updateProductParameter",
	data?: GraphQLTypes["ProductParameter"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductParameter"]: {
	__typename: "deleteProductParameter",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createProductPriceLevel"]: {
	__typename: "createProductPriceLevel",
	data?: GraphQLTypes["ProductPriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductPriceLevel"]: {
	__typename: "updateProductPriceLevel",
	data?: GraphQLTypes["ProductPriceLevel"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductPriceLevel"]: {
	__typename: "deleteProductPriceLevel",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createTag"]: {
	__typename: "createTag",
	data?: GraphQLTypes["Tag"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateTag"]: {
	__typename: "updateTag",
	data?: GraphQLTypes["Tag"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteTag"]: {
	__typename: "deleteTag",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createProductPack"]: {
	__typename: "createProductPack",
	data?: GraphQLTypes["ProductPack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updateProductPack"]: {
	__typename: "updateProductPack",
	data?: GraphQLTypes["ProductPack"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deleteProductPack"]: {
	__typename: "deleteProductPack",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createPurchaseOrderItem_"]: {
		product: number,
	currency: string,
	quantity: number,
	purchasePrice?: number | undefined | null,
	note?: string | undefined | null,
	externalId?: string | undefined | null
};
	["createPurchaseOrder"]: {
	__typename: "createPurchaseOrder",
	data?: GraphQLTypes["PurchaseOrder"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePurchaseOrder"]: {
	__typename: "updatePurchaseOrder",
	data?: GraphQLTypes["PurchaseOrder"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePurchaseOrder"]: {
	__typename: "deletePurchaseOrder",
	errors?: Array<string | undefined | null> | undefined | null
};
	["createPurchaseOrderItem"]: {
	__typename: "createPurchaseOrderItem",
	data?: GraphQLTypes["PurchaseOrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["updatePurchaseOrderItem"]: {
	__typename: "updatePurchaseOrderItem",
	data?: GraphQLTypes["PurchaseOrderItem"] | undefined | null,
	errors?: Array<string | undefined | null> | undefined | null
};
	["deletePurchaseOrderItem"]: {
	__typename: "deletePurchaseOrderItem",
	errors?: Array<string | undefined | null> | undefined | null
};
	["ID"]: "scalar" & { name: "ID" }
    }
export enum statsBestsellersSort {
	amount = "amount",
	sales = "sales"
}

type ZEUS_VARIABLES = {
	["DateTime"]: ValueTypes["DateTime"];
	["DateTimeAsString"]: ValueTypes["DateTimeAsString"];
	["StringOrArray"]: ValueTypes["StringOrArray"];
	["userFilters"]: ValueTypes["userFilters"];
	["userGroupFilters"]: ValueTypes["userGroupFilters"];
	["productFilters"]: ValueTypes["productFilters"];
	["productMovePackFilters"]: ValueTypes["productMovePackFilters"];
	["created"]: ValueTypes["created"];
	["productMoveFilters"]: ValueTypes["productMoveFilters"];
	["institutionFilters"]: ValueTypes["institutionFilters"];
	["orderFilters"]: ValueTypes["orderFilters"];
	["processStatusUpdated"]: ValueTypes["processStatusUpdated"];
	["dateCreated"]: ValueTypes["dateCreated"];
	["dateBill"]: ValueTypes["dateBill"];
	["dateExpedition"]: ValueTypes["dateExpedition"];
	["dateDue"]: ValueTypes["dateDue"];
	["dateTax"]: ValueTypes["dateTax"];
	["updated"]: ValueTypes["updated"];
	["soldItemFilters"]: ValueTypes["soldItemFilters"];
	["orderItemFilters"]: ValueTypes["orderItemFilters"];
	["customerFilters"]: ValueTypes["customerFilters"];
	["addressesFilters"]: ValueTypes["addressesFilters"];
	["checkoutFilters"]: ValueTypes["checkoutFilters"];
	["consentsFilters"]: ValueTypes["consentsFilters"];
	["checkoutExtraOperationFilters"]: ValueTypes["checkoutExtraOperationFilters"];
	["checkoutClosingFilters"]: ValueTypes["checkoutClosingFilters"];
	["vatFilters"]: ValueTypes["vatFilters"];
	["depotFilters"]: ValueTypes["depotFilters"];
	["supplierFilters"]: ValueTypes["supplierFilters"];
	["producerFilters"]: ValueTypes["producerFilters"];
	["exportStockFilters"]: ValueTypes["exportStockFilters"];
	["exportSaleFilters"]: ValueTypes["exportSaleFilters"];
	["exportPurchaseFilters"]: ValueTypes["exportPurchaseFilters"];
	["exportOrderFilters"]: ValueTypes["exportOrderFilters"];
	["exportInventoryFilters"]: ValueTypes["exportInventoryFilters"];
	["exportFilters"]: ValueTypes["exportFilters"];
	["exportTypeFilters"]: ValueTypes["exportTypeFilters"];
	["shopFilters"]: ValueTypes["shopFilters"];
	["filters"]: ValueTypes["filters"];
	["eetReceiptFilters"]: ValueTypes["eetReceiptFilters"];
	["paymentFilters"]: ValueTypes["paymentFilters"];
	["paymentItemsFilters"]: ValueTypes["paymentItemsFilters"];
	["paymentTypeFilters"]: ValueTypes["paymentTypeFilters"];
	["processStatusesFilters"]: ValueTypes["processStatusesFilters"];
	["carriersFilters"]: ValueTypes["carriersFilters"];
	["currenciesFilters"]: ValueTypes["currenciesFilters"];
	["packageFilters"]: ValueTypes["packageFilters"];
	["packageStatsFilters"]: ValueTypes["packageStatsFilters"];
	["disposalFilters"]: ValueTypes["disposalFilters"];
	["productDepotMetricFilters"]: ValueTypes["productDepotMetricFilters"];
	["fileFilters"]: ValueTypes["fileFilters"];
	["statsBestsellersSort"]: ValueTypes["statsBestsellersSort"];
	["companyCarrierFilters"]: ValueTypes["companyCarrierFilters"];
	["categoryFilters"]: ValueTypes["categoryFilters"];
	["parametersFilters"]: ValueTypes["parametersFilters"];
	["orderGroupFilters"]: ValueTypes["orderGroupFilters"];
	["voucherFilters"]: ValueTypes["voucherFilters"];
	["voucherValidFilter"]: ValueTypes["voucherValidFilter"];
	["voucherCreatedFilter"]: ValueTypes["voucherCreatedFilter"];
	["productPriceFilters"]: ValueTypes["productPriceFilters"];
	["priceLevelFilters"]: ValueTypes["priceLevelFilters"];
	["productParameterFilters"]: ValueTypes["productParameterFilters"];
	["productPriceLevelFilters"]: ValueTypes["productPriceLevelFilters"];
	["tagFilters"]: ValueTypes["tagFilters"];
	["tagTypeFilters"]: ValueTypes["tagTypeFilters"];
	["productPackFilters"]: ValueTypes["productPackFilters"];
	["purchaseOrderFilters"]: ValueTypes["purchaseOrderFilters"];
	["dateEstimatedArrival"]: ValueTypes["dateEstimatedArrival"];
	["purchaseOrderItemFilters"]: ValueTypes["purchaseOrderItemFilters"];
	["purchaseOrderStatusesFilters"]: ValueTypes["purchaseOrderStatusesFilters"];
	["modulesFilters"]: ValueTypes["modulesFilters"];
	["createProductMove"]: ValueTypes["createProductMove"];
	["createOrderItem_"]: ValueTypes["createOrderItem_"];
	["createPaymentItem_"]: ValueTypes["createPaymentItem_"];
	["processStatusRelation"]: ValueTypes["processStatusRelation"];
	["updateOrderItem_"]: ValueTypes["updateOrderItem_"];
	["updatePaymentItem_"]: ValueTypes["updatePaymentItem_"];
	["updateClearanceItemLocations"]: ValueTypes["updateClearanceItemLocations"];
	["createPurchaseOrderItem_"]: ValueTypes["createPurchaseOrderItem_"];
	["ID"]: ValueTypes["ID"];
}